// 不同国家对应的行业，首位是最新行业列表，之后的是为了兼容旧数据回显
export const tradeData = {
  Singapore: [
    // 最新的
    [
      {
        value: "[01111]Growing of leafy and fruit vegetables (non-hydroponics)",
        zh: "[01111]Growing of leafy and fruit vegetables (non-hydroponics) / 非水培叶菜和果菜种植",
        en: "[01111]Growing of leafy and fruit vegetables (non-hydroponics)",
      },
      {
        value: "[01112]Growing of mushrooms (non-hydroponics)",
        zh: "[01112]Growing of mushrooms (non-hydroponics) / 非水培食用菌种植",
        en: "[01112]Growing of mushrooms (non-hydroponics)",
      },
      {
        value: "[01119]Growing of food crops (non-hydroponics) n.e.c.",
        zh: "[01119]Growing of food crops (non-hydroponics) n.e.c. / 非水培粮食作物种植（其他）",
        en: "[01119]Growing of food crops (non-hydroponics) n.e.c.",
      },
      {
        value: "[01120]Growing of leafy and fruit vegetables (hydroponics)",
        zh: "[01120]Growing of leafy and fruit vegetables (hydroponics) / 水培叶菜和果菜种植",
        en: "[01120]Growing of leafy and fruit vegetables (hydroponics)",
      },
      {
        value: "[01130]Growing of fruits and nuts (except legumes)",
        zh: "[01130]Growing of fruits and nuts (except legumes) / 种植水果和坚果（不包括豆类）",
        en: "[01130]Growing of fruits and nuts (except legumes)",
      },
      {
        value: "[01141]Growing of orchids",
        zh: "[01141]Growing of orchids / 兰花种植",
        en: "[01141]Growing of orchids",
      },
      {
        value: "[01142]Growing of ornamental plants",
        zh: "[01142]Growing of ornamental plants / 观赏植物种植",
        en: "[01142]Growing of ornamental plants",
      },
      {
        value: "[01149]Growing of nursery products n.e.c.",
        zh: "[01149]Growing of nursery products n.e.c. / 苗圃产品种植（其他）",
        en: "[01149]Growing of nursery products n.e.c.",
      },
      {
        value: "[01190]Growing of other crops",
        zh: "[01190]Growing of other crops / 其他作物种植",
        en: "[01190]Growing of other crops",
      },
      {
        value: "[01410]Cattle and goat farms (for livestock and milk production)",
        zh: "[01410]Cattle and goat farms (for livestock and milk production) / 牛和山羊农场（用于牲畜和牛奶生产）",
        en: "[01410]Cattle and goat farms (for livestock and milk production)",
      },
      {
        value: "[01421]Rearing of poultry (except layer farms)",
        zh: "[01421]Rearing of poultry (except layer farms) / 家禽饲养（不包括蛋鸡农场）",
        en: "[01421]Rearing of poultry (except layer farms)",
      },
      {
        value: "[01422]Layer farms (chickens reared for eggs)",
        zh: "[01422]Layer farms (chickens reared for eggs) / 蛋鸡养殖",
        en: "[01422]Layer farms (chickens reared for eggs)",
      },
      {
        value: "[01491]Dog breeding",
        zh: "[01491]Dog breeding / 犬类繁殖",
        en: "[01491]Dog breeding",
      },
      {
        value: "[01492]Bird breeding",
        zh: "[01492]Bird breeding / 鸟类繁殖",
        en: "[01492]Bird breeding",
      },
      {
        value: "[01499]Other animal production n.e.c.",
        zh: "[01499]Other animal production n.e.c. / 其他动物生产活动",
        en: "[01499]Other animal production n.e.c.",
      },
      {
        value: "[01500]Growing of crops combined with animal production (mixed farming)",
        zh: "[01500]Growing of crops combined with animal production (mixed farming) / 种植业与动物生产相结合（混合农业）",
        en: "[01500]Growing of crops combined with animal production (mixed farming)",
      },
      {
        value: "[01600]Agricultural and animal husbandry service activities (except veterinary activities)",
        zh: "[01600]Agricultural and animal husbandry service activities (except veterinary activities) / 农业和畜牧业服务活动（兽医活动除外）",
        en: "[01600]Agricultural and animal husbandry service activities (except veterinary activities)",
      },
      {
        value: "[02000]Forestry, logging and related service activities",
        zh: "[02000]Forestry, logging and related service activities / 林业、伐木及相关服务活动",
        en: "[02000]Forestry, logging and related service activities",
      },
      {
        value: "[03101]Ocean, coastal and kelong fishing",
        zh: "[03101]Ocean, coastal and kelong fishing / 海洋、沿海及海上渔场捕鱼",
        en: "[03101]Ocean, coastal and kelong fishing",
      },
      {
        value: "[03109]Fishing n.e.c.",
        zh: "[03109]Fishing n.e.c. / 其他未列明的渔业",
        en: "[03109]Fishing n.e.c.",
      },
      {
        value: "[03201]Food fish farms and food fish hatcheries",
        zh: "[03201]Food fish farms and food fish hatcheries / 食用鱼养殖场和食用鱼孵化场",
        en: "[03201]Food fish farms and food fish hatcheries",
      },
      {
        value: "[03202]Ornamental fish farms and ornamental fish hatcheries",
        zh: "[03202]Ornamental fish farms and ornamental fish hatcheries / 观赏鱼养殖场和观赏鱼孵化场",
        en: "[03202]Ornamental fish farms and ornamental fish hatcheries",
      },
      {
        value: "[03209]Aquaculture n.e.c.",
        zh: "[03209]Aquaculture n.e.c. / 其他水产养殖",
        en: "[03209]Aquaculture n.e.c.",
      },
      {
        value: "[08101]Stone quarrying",
        zh: "[08101]Stone quarrying / 石材开采",
        en: "[08101]Stone quarrying",
      },
      {
        value: "[08102]Quarrying of sand and clay",
        zh: "[08102]Quarrying of sand and clay / 沙子和粘土开采",
        en: "[08102]Quarrying of sand and clay",
      },
      {
        value: "[08900]Other mining and quarrying",
        zh: "[08900]Other mining and quarrying / 其他采矿和采石",
        en: "[08900]Other mining and quarrying",
      },
      {
        value: "[09001]Crude petroleum and natural gas production",
        zh: "[09001]Crude petroleum and natural gas production / 原油和天然气生产",
        en: "[09001]Crude petroleum and natural gas production",
      },
      {
        value:
          "[09002]Service activities incidental to oil and gas extraction (except surveying and engineering design and consultancy services supporting mining, oil and gas extraction and offshore exploration activities)",
        zh: "[09002]Service activities incidental to oil and gas extraction (except surveying and engineering design and consultancy services supporting mining, oil and gas extraction and offshore exploration activities) / 石油和天然气开采相关的服务活动（不包括支持采矿、石油和天然气开采以及海上勘探活动的测量、工程设计和咨询服务）",
        en: "[09002]Service activities incidental to oil and gas extraction (except surveying and engineering design and consultancy services supporting mining, oil and gas extraction and offshore exploration activities)",
      },
      {
        value: "[10101]Slaughtering of livestock and poultry",
        zh: "[10101]Slaughtering of livestock and poultry / 牲畜和家禽的屠宰",
        en: "[10101]Slaughtering of livestock and poultry",
      },
      {
        value: "[10102]Manufacture of sausage",
        zh: "[10102]Manufacture of sausage / 香肠的制造",
        en: "[10102]Manufacture of sausage",
      },
      {
        value: "[10103]Preparing, canning and preserving of livestock and livestock products",
        zh: "[10103]Preparing, canning and preserving of livestock and livestock products / 牲畜和牲畜产品的准备、罐装和保存",
        en: "[10103]Preparing, canning and preserving of livestock and livestock products",
      },
      {
        value: "[10104]Preparing, canning and preserving of poultry and poultry products",
        zh: "[10104]Preparing, canning and preserving of poultry and poultry products / 家禽和家禽产品的准备、罐装和保存",
        en: "[10104]Preparing, canning and preserving of poultry and poultry products",
      },
      {
        value: "[10109]Processing and preserving of meat and meat products n.e.c.",
        zh: "[10109]Processing and preserving of meat and meat products n.e.c. / 肉类和肉制品的加工和保存",
        en: "[10109]Processing and preserving of meat and meat products n.e.c.",
      },
      {
        value: "[10200]Processing and preserving of seafood",
        zh: "[10200]Processing and preserving of seafood / 海鲜加工与保藏",
        en: "[10200]Processing and preserving of seafood",
      },
      {
        value: "[10301]Manufacture of jams",
        zh: "[10301]Manufacture of jams / 果酱制造",
        en: "[10301]Manufacture of jams",
      },
      {
        value: "[10302]Other canning and preserving of fruits and fruit juices",
        zh: "[10302]Other canning and preserving of fruits and fruit juices / 其他水果和果汁的罐头与保藏",
        en: "[10302]Other canning and preserving of fruits and fruit juices",
      },
      {
        value: "[10303]Other canning and preserving of vegetables and vegetable juices",
        zh: "[10303]Other canning and preserving of vegetables and vegetable juices / 其他蔬菜和蔬菜汁的罐头与保藏",
        en: "[10303]Other canning and preserving of vegetables and vegetable juices",
      },
      {
        value: "[10401]Manufacture of edible vegetable and animal oils and fats",
        zh: "[10401]Manufacture of edible vegetable and animal oils and fats / 食用植物和动物油脂制造",
        en: "[10401]Manufacture of edible vegetable and animal oils and fats",
      },
      {
        value: "[10402]Manufacture of inedible vegetable and animal oils and fats",
        zh: "[10402]Manufacture of inedible vegetable and animal oils and fats / 非食用植物和动物油脂制造",
        en: "[10402]Manufacture of inedible vegetable and animal oils and fats",
      },
      {
        value: "[10409]Manufacture of vegetable and animal oils and fats n.e.c.",
        zh: "[10409]Manufacture of vegetable and animal oils and fats n.e.c. / 制造植物和动物油脂",
        en: "[10409]Manufacture of vegetable and animal oils and fats n.e.c.",
      },
      {
        value: "[10501]Manufacture of condensed and evaporated milk; pasteurising and bottling of fluid milk",
        zh: "[10501]Manufacture of condensed and evaporated milk; pasteurising and bottling of fluid milk / 浓缩和蒸发乳的制造；液态奶的巴氏杀菌和装瓶",
        en: "[10501]Manufacture of condensed and evaporated milk; pasteurising and bottling of fluid milk",
      },
      {
        value: "[10502]Manufacture of milk powder",
        zh: "[10502]Manufacture of milk powder / 奶粉制造",
        en: "[10502]Manufacture of milk powder",
      },
      {
        value: "[10503]Manufacture of ice-cream",
        zh: "[10503]Manufacture of ice-cream / 冰淇淋制造",
        en: "[10503]Manufacture of ice-cream",
      },
      {
        value: "[10509]Manufacture of dairy products n.e.c.",
        zh: "[10509]Manufacture of dairy products n.e.c. / 其他乳制品制造",
        en: "[10509]Manufacture of dairy products n.e.c.",
      },
      {
        value: "[10611]Rice milling",
        zh: "[10611]Rice milling / 大米加工",
        en: "[10611]Rice milling",
      },
      {
        value: "[10612]Wheat milling",
        zh: "[10612]Wheat milling / 小麦磨粉",
        en: "[10612]Wheat milling",
      },
      {
        value: "[10619]Manufacture of grain mill products n.e.c.",
        zh: "[10619]Manufacture of grain mill products n.e.c. / 谷物磨制产品制造",
        en: "[10619]Manufacture of grain mill products n.e.c.",
      },
      {
        value: "[10620]Manufacture of starches and starch products",
        zh: "[10620]Manufacture of starches and starch products / 淀粉及其制品的制造",
        en: "[10620]Manufacture of starches and starch products",
      },
      {
        value: "[10711]Manufacture of biscuits",
        zh: "[10711]Manufacture of biscuits / 饼干制造",
        en: "[10711]Manufacture of biscuits",
      },
      {
        value: "[10712]Manufacture of bread, cakes and confectionery (except frozen bakery products)",
        zh: "[10712]Manufacture of bread, cakes and confectionery (except frozen bakery products) / 面包、糕点及糖果制造（不包括冷冻烘焙产品）",
        en: "[10712]Manufacture of bread, cakes and confectionery (except frozen bakery products)",
      },
      {
        value: "[10719]Manufacture of bakery products n.e.c.",
        zh: "[10719]Manufacture of bakery products n.e.c. / 其他烘焙产品制造",
        en: "[10719]Manufacture of bakery products n.e.c.",
      },
      {
        value: "[10720]Manufacture of sugar and sugar products",
        zh: "[10720]Manufacture of sugar and sugar products / 糖及糖制品制造",
        en: "[10720]Manufacture of sugar and sugar products",
      },
      {
        value: "[10731]Manufacture of cocoa and chocolate powder from beans",
        zh: "[10731]Manufacture of cocoa and chocolate powder from beans / 从豆类制造可可和巧克力粉",
        en: "[10731]Manufacture of cocoa and chocolate powder from beans",
      },
      {
        value: "[10732]Manufacture of chocolate and chocolate products",
        zh: "[10732]Manufacture of chocolate and chocolate products / 巧克力和巧克力制品制造",
        en: "[10732]Manufacture of chocolate and chocolate products",
      },
      {
        value: "[10733]Manufacture of non-chocolate confectionery",
        zh: "[10733]Manufacture of non-chocolate confectionery / 非巧克力糖果制造",
        en: "[10733]Manufacture of non-chocolate confectionery",
      },
      {
        value: "[10740]Manufacture of macaroni, noodles, vermicelli and other related products",
        zh: "[10740]Manufacture of macaroni, noodles, vermicelli and other related products / 通心粉、面条、细面条及其他相关产品制造",
        en: "[10740]Manufacture of macaroni, noodles, vermicelli and other related products",
      },
      {
        value: "[10750]Manufacture of prepared meals and dishes",
        zh: "[10750]Manufacture of prepared meals and dishes / 预制餐和菜肴制造",
        en: "[10750]Manufacture of prepared meals and dishes",
      },
      {
        value: "[10761]Manufacture of instant beverages",
        zh: "[10761]Manufacture of instant beverages / 即饮饮料的制造",
        en: "[10761]Manufacture of instant beverages",
      },
      {
        value: "[10762]Processing of coffee seeds",
        zh: "[10762]Processing of coffee seeds / 咖啡豆的加工",
        en: "[10762]Processing of coffee seeds",
      },
      {
        value: "[10763]Manufacture of coffee powder",
        zh: "[10763]Manufacture of coffee powder / 咖啡粉的制造",
        en: "[10763]Manufacture of coffee powder",
      },
      {
        value: "[10764]Manufacture of tea; processing of tea leaves",
        zh: "[10764]Manufacture of tea; processing of tea leaves / 茶的制造；茶叶的加工",
        en: "[10764]Manufacture of tea; processing of tea leaves",
      },
      {
        value: "[10791]Manufacture of sauces",
        zh: "[10791]Manufacture of sauces / 酱料的制造",
        en: "[10791]Manufacture of sauces",
      },
      {
        value: "[10792]Manufacture of soya bean products (except soy-based meat alternatives, sauce and milk)",
        zh: "[10792]Manufacture of soya bean products (except soy-based meat alternatives, sauce and milk) / 大豆制品的制造（不包括基于大豆的肉类替代品、酱料和奶制品）",
        en: "[10792]Manufacture of soya bean products (except soy-based meat alternatives, sauce and milk)",
      },
      {
        value: "[10793]Manufacture and processing of spices",
        zh: "[10793]Manufacture and processing of spices / 香料的制造和加工",
        en: "[10793]Manufacture and processing of spices",
      },
      {
        value: "[10794]Manufacture of chips, crackers and other titbits (except biscuits and confectionery)",
        zh: "[10794]Manufacture of chips, crackers and other titbits (except biscuits and confectionery) / 薯片、饼干及其他小吃（不包括饼干和糖果）的制造",
        en: "[10794]Manufacture of chips, crackers and other titbits (except biscuits and confectionery)",
      },
      {
        value: "[10795]Manufacture of plant-based/microbial-fermented/cell-cultivated food products",
        zh: "[10795]Manufacture of plant-based/microbial-fermented/cell-cultivated food products / 植物基/微生物发酵/细胞培养食品的制造",
        en: "[10795]Manufacture of plant-based/microbial-fermented/cell-cultivated food products",
      },
      {
        value: "[10799]Manufacture of other food products n.e.c. (except food chemicals and additives)",
        zh: "[10799]Manufacture of other food products n.e.c. (except food chemicals and additives) / 其他未列明食品制造（不包括食品化学添加剂）",
        en: "[10799]Manufacture of other food products n.e.c. (except food chemicals and additives)",
      },
      {
        value: "[10800]Manufacture of prepared animal feeds",
        zh: "[10800]Manufacture of prepared animal feeds / 制造配制动物饲料",
        en: "[10800]Manufacture of prepared animal feeds",
      },
      {
        value: "[11010]Distilling, rectifying and blending of spirits; ethyl alcohol production from fermented materials",
        zh: "[11010]Distilling, rectifying and blending of spirits; ethyl alcohol production from fermented materials / 蒸馏、精馏和混合酒精饮料；发酵物料生产乙醇",
        en: "[11010]Distilling, rectifying and blending of spirits; ethyl alcohol production from fermented materials",
      },
      {
        value: "[11020]Manufacture of wines",
        zh: "[11020]Manufacture of wines / 葡萄酒制造",
        en: "[11020]Manufacture of wines",
      },
      {
        value: "[11030]Manufacture of malt liquors and malt",
        zh: "[11030]Manufacture of malt liquors and malt / 麦芽酒和麦芽的制造",
        en: "[11030]Manufacture of malt liquors and malt",
      },
      {
        value: "[11041]Manufacture of soft drinks and mineral waters",
        zh: "[11041]Manufacture of soft drinks and mineral waters / 软饮料和矿泉水的制造",
        en: "[11041]Manufacture of soft drinks and mineral waters",
      },
      {
        value: "[11042]Manufacture of cordials, syrups and composite concentrates for beverages",
        zh: "[11042]Manufacture of cordials, syrups and composite concentrates for beverages / 饮料用甜酒、糖浆和复合浓缩物的制造",
        en: "[11042]Manufacture of cordials, syrups and composite concentrates for beverages",
      },
      {
        value: "[11043]Manufacture of ice (except dry ice)",
        zh: "[11043]Manufacture of ice (except dry ice) / 制冰（不包括干冰）",
        en: "[11043]Manufacture of ice (except dry ice)",
      },
      {
        value: "[12001]Manufacture of cigarettes",
        zh: "[12001]Manufacture of cigarettes / 香烟制造",
        en: "[12001]Manufacture of cigarettes",
      },
      {
        value: "[12009]Manufacture of tobacco products n.e.c.",
        zh: "[12009]Manufacture of tobacco products n.e.c. / 其他烟草制品制造",
        en: "[12009]Manufacture of tobacco products n.e.c.",
      },
      {
        value: "[13100]Spinning, weaving and finishing of textiles",
        zh: "[13100]Spinning, weaving and finishing of textiles / 纺纱、织造和纺织品后整理",
        en: "[13100]Spinning, weaving and finishing of textiles",
      },
      {
        value: "[13910]Manufacture of knitted and crocheted fabrics and laces",
        zh: "[13910]Manufacture of knitted and crocheted fabrics and laces / 针织和钩织面料及蕾丝制造",
        en: "[13910]Manufacture of knitted and crocheted fabrics and laces",
      },
      {
        value: "[13921]Manufacture of made-up household textile articles",
        zh: "[13921]Manufacture of made-up household textile articles / 家用纺织品成形制造",
        en: "[13921]Manufacture of made-up household textile articles",
      },
      {
        value: "[13929]Manufacture of made-up textile articles n.e.c  (except apparel)",
        zh: "[13929]Manufacture of made-up textile articles n.e.c  (except apparel) / 其他纺织品的制造（服装除外）",
        en: "[13929]Manufacture of made-up textile articles n.e.c  (except apparel)",
      },
      {
        value: "[13930]Manufacture of carpets and rugs",
        zh: "[13930]Manufacture of carpets and rugs / 地毯和小地毯的制造",
        en: "[13930]Manufacture of carpets and rugs",
      },
      {
        value: "[13940]Manufacture of cordage, rope, twine and netting",
        zh: "[13940]Manufacture of cordage, rope, twine and netting / 绳索、绳索、线和网的制造",
        en: "[13940]Manufacture of cordage, rope, twine and netting",
      },
      {
        value: "[13990]Manufacture of other textiles n.e.c.",
        zh: "[13990]Manufacture of other textiles n.e.c. / 其他纺织品的制造",
        en: "[13990]Manufacture of other textiles n.e.c.",
      },
      {
        value: "[14101]Manufacture of outer garments",
        zh: "[14101]Manufacture of outer garments / 外衣制造",
        en: "[14101]Manufacture of outer garments",
      },
      {
        value: "[14102]Manufacture of brassieres and other undergarments",
        zh: "[14102]Manufacture of brassieres and other undergarments / 胸罩和其他内衣制造",
        en: "[14102]Manufacture of brassieres and other undergarments",
      },
      {
        value: "[14103]Tailoring and dressmaking to individual order",
        zh: "[14103]Tailoring and dressmaking to individual order / 按订单定制的裁缝和女装制作",
        en: "[14103]Tailoring and dressmaking to individual order",
      },
      {
        value: "[14109]Manufacture of wearing apparel n.e.c. (except fur apparel)",
        zh: "[14109]Manufacture of wearing apparel n.e.c. (except fur apparel) / 其他未列明的服装制造（不包括毛皮服装）",
        en: "[14109]Manufacture of wearing apparel n.e.c. (except fur apparel)",
      },
      {
        value: "[14200]Manufacture of fur apparel and articles of fur",
        zh: "[14200]Manufacture of fur apparel and articles of fur / 毛皮服装及毛皮制品制造",
        en: "[14200]Manufacture of fur apparel and articles of fur",
      },
      {
        value: "[15110]Tanning and dressing of leather; dressing and dyeing of fur",
        zh: "[15110]Tanning and dressing of leather; dressing and dyeing of fur / 皮革的鞣制和整饰；毛皮的整理和染色",
        en: "[15110]Tanning and dressing of leather; dressing and dyeing of fur",
      },
      {
        value: "[15121]Manufacture of luggage, bags, brief cases and the like",
        zh: "[15121]Manufacture of luggage, bags, brief cases and the like / 制造行李箱、包、公文包等",
        en: "[15121]Manufacture of luggage, bags, brief cases and the like",
      },
      {
        value: "[15122]Manufacture of handbags",
        zh: "[15122]Manufacture of handbags / 制造手提包",
        en: "[15122]Manufacture of handbags",
      },
      {
        value: "[15129]Manufacture of saddlery, harness and articles of leather n.e.c.",
        zh: "[15129]Manufacture of saddlery, harness and articles of leather n.e.c. / 马具、鞍具及其它皮革制品的制造",
        en: "[15129]Manufacture of saddlery, harness and articles of leather n.e.c.",
      },
      {
        value: "[15200]Manufacture of footwear",
        zh: "[15200]Manufacture of footwear / 制造鞋靴",
        en: "[15200]Manufacture of footwear",
      },
      {
        value: "[16101]Sawmilling",
        zh: "[16101]Sawmilling / 锯木",
        en: "[16101]Sawmilling",
      },
      {
        value: "[16102]Preservation of wood",
        zh: "[16102]Preservation of wood / 木材防腐",
        en: "[16102]Preservation of wood",
      },
      {
        value: "[16109]Sawmilling and planing of wood n.e.c.",
        zh: "[16109]Sawmilling and planing of wood n.e.c. / 木材锯切和刨光等其他未列明的活动",
        en: "[16109]Sawmilling and planing of wood n.e.c.",
      },
      {
        value: "[16211]Manufacture of plywood and veneer",
        zh: "[16211]Manufacture of plywood and veneer / 胶合板和胶合板制造",
        en: "[16211]Manufacture of plywood and veneer",
      },
      {
        value: "[16219]Manufacture of laminboard, particle board and other panels and boards n.e.c.",
        zh: "[16219]Manufacture of laminboard, particle board and other panels and boards n.e.c. / 胶合板、刨花板和其他板材及木板的制造",
        en: "[16219]Manufacture of laminboard, particle board and other panels and boards n.e.c.",
      },
      {
        value: "[16291]Manufacture of wooden window, door and other millwork (except prefabricated wooden building structures)",
        zh: "[16291]Manufacture of wooden window, door and other millwork (except prefabricated wooden building structures) / 木制窗户、门及其它木制品（预制木结构建筑除外）的制造",
        en: "[16291]Manufacture of wooden window, door and other millwork (except prefabricated wooden building structures)",
      },
      {
        value: "[16292]Manufacture of household and kitchen wooden ware (except wooden footwear)",
        zh: "[16292]Manufacture of household and kitchen wooden ware (except wooden footwear) / 家庭及厨房用木制品（不包括木制鞋类）的制造",
        en: "[16292]Manufacture of household and kitchen wooden ware (except wooden footwear)",
      },
      {
        value: "[16293]Manufacture of wooden containers",
        zh: "[16293]Manufacture of wooden containers / 木制容器的制造",
        en: "[16293]Manufacture of wooden containers",
      },
      {
        value: "[16294]Rattan processing",
        zh: "[16294]Rattan processing / 藤材加工",
        en: "[16294]Rattan processing",
      },
      {
        value: "[16299]Manufacture of other products of wood and articles of cork, straw and plaiting materials n.e.c.",
        zh: "[16299]Manufacture of other products of wood and articles of cork, straw and plaiting materials n.e.c. / 其他木材、软木、草及编织材料制品的制造",
        en: "[16299]Manufacture of other products of wood and articles of cork, straw and plaiting materials n.e.c.",
      },
      {
        value: "[17010]Manufacture of pulp, paper and paperboard",
        zh: "[17010]Manufacture of pulp, paper and paperboard / 纸浆、纸及纸板的制造",
        en: "[17010]Manufacture of pulp, paper and paperboard",
      },
      {
        value: "[17021]Manufacture of corrugated paper and paperboard",
        zh: "[17021]Manufacture of corrugated paper and paperboard / 瓦楞纸和纸板的制造",
        en: "[17021]Manufacture of corrugated paper and paperboard",
      },
      {
        value: "[17022]Manufacture of containers and boxes of paper and paperboard",
        zh: "[17022]Manufacture of containers and boxes of paper and paperboard / 纸和纸板制容器及盒子的制造",
        en: "[17022]Manufacture of containers and boxes of paper and paperboard",
      },
      {
        value: "[17091]Manufacture of joss paper and other related ceremonial paper products",
        zh: "[17091]Manufacture of joss paper and other related ceremonial paper products / 制造纸钱和其他相关仪式用纸制品",
        en: "[17091]Manufacture of joss paper and other related ceremonial paper products",
      },
      {
        value: "[17092]Manufacture of sanitary towels, toilet paper, paper towels, disposable diapers and related paper products",
        zh: "[17092]Manufacture of sanitary towels, toilet paper, paper towels, disposable diapers and related paper products / 制造卫生巾、卫生纸、纸巾、一次性尿布及相关纸制品",
        en: "[17092]Manufacture of sanitary towels, toilet paper, paper towels, disposable diapers and related paper products",
      },
      {
        value: "[17093]Manufacture of paper cups, plates and utensils",
        zh: "[17093]Manufacture of paper cups, plates and utensils / 制造纸杯、纸盘和餐具",
        en: "[17093]Manufacture of paper cups, plates and utensils",
      },
      {
        value: "[17094]Manufacture of unprinted cards, envelopes and stationery",
        zh: "[17094]Manufacture of unprinted cards, envelopes and stationery / 制造未印刷的卡片、信封和文具",
        en: "[17094]Manufacture of unprinted cards, envelopes and stationery",
      },
      {
        value: "[17099]Manufacture of other articles of paper and paperboard n.e.c.",
        zh: "[17099]Manufacture of other articles of paper and paperboard n.e.c. / 制造其他纸和纸板制品",
        en: "[17099]Manufacture of other articles of paper and paperboard n.e.c.",
      },
      {
        value: "[18111]Printing of periodicals, books and magazines",
        zh: "[18111]Printing of periodicals, books and magazines / 印刷期刊、书籍和杂志",
        en: "[18111]Printing of periodicals, books and magazines",
      },
      {
        value: "[18112]Commercial printing",
        zh: "[18112]Commercial printing / 商业印刷",
        en: "[18112]Commercial printing",
      },
      {
        value: "[18113]Silk screen/metal printing",
        zh: "[18113]Silk screen/metal printing / 丝网/金属印刷",
        en: "[18113]Silk screen/metal printing",
      },
      {
        value: "[18121]Bookbinding",
        zh: "[18121]Bookbinding / 装订书籍",
        en: "[18121]Bookbinding",
      },
      {
        value: "[18122]Colour separation",
        zh: "[18122]Colour separation / 色彩分离",
        en: "[18122]Colour separation",
      },
      {
        value: "[18129]Service activities related to printing n.e.c.",
        zh: "[18129]Service activities related to printing n.e.c. / 与印刷相关的服务活动，不包括其他",
        en: "[18129]Service activities related to printing n.e.c.",
      },
      {
        value: "[18200]Reproduction of recorded media/phonograph records/magnetic tapes/compact discs/non-customised software",
        zh: "[18200]Reproduction of recorded media/phonograph records/magnetic tapes/compact discs/non-customised software / 录制媒体/唱片/磁带/光盘/非定制软件的复制",
        en: "[18200]Reproduction of recorded media/phonograph records/magnetic tapes/compact discs/non-customised software",
      },
      {
        value: "[19100]Manufacture of coke oven products",
        zh: "[19100]Manufacture of coke oven products / 焦炉产品制造",
        en: "[19100]Manufacture of coke oven products",
      },
      {
        value: "[19201]Petroleum refineries",
        zh: "[19201]Petroleum refineries / 石油炼制",
        en: "[19201]Petroleum refineries",
      },
      {
        value: "[19202]Manufacture of petroleum lubricating oil",
        zh: "[19202]Manufacture of petroleum lubricating oil / 石油润滑油制造",
        en: "[19202]Manufacture of petroleum lubricating oil",
      },
      {
        value: "[19209]Manufacture of refined petroleum products n.e.c.",
        zh: "[19209]Manufacture of refined petroleum products n.e.c. / 其他精炼石油产品的制造",
        en: "[19209]Manufacture of refined petroleum products n.e.c.",
      },
      {
        value: "[20111]Manufacture of industrial gases and dry ice",
        zh: "[20111]Manufacture of industrial gases and dry ice / 工业气体和干冰的制造",
        en: "[20111]Manufacture of industrial gases and dry ice",
      },
      {
        value: "[20112]Manufacture of basic industrial acids and alkalis",
        zh: "[20112]Manufacture of basic industrial acids and alkalis / 基本工业酸和碱的制造",
        en: "[20112]Manufacture of basic industrial acids and alkalis",
      },
      {
        value: "[20113]Manufacture of basic chemicals (except fertilisers and nitrogen)",
        zh: "[20113]Manufacture of basic chemicals (except fertilisers and nitrogen) / 基本化学品（肥料和氮除外）的制造",
        en: "[20113]Manufacture of basic chemicals (except fertilisers and nitrogen)",
      },
      {
        value: "[20114]Manufacture of solvents",
        zh: "[20114]Manufacture of solvents / 溶剂的制造",
        en: "[20114]Manufacture of solvents",
      },
      {
        value: "[20119]Manufacture of basic chemicals n.e.c.",
        zh: "[20119]Manufacture of basic chemicals n.e.c. / 基本化学品（未特指的）的制造",
        en: "[20119]Manufacture of basic chemicals n.e.c.",
      },
      {
        value: "[20120]Manufacture of fertilisers and nitrogen compounds",
        zh: "[20120]Manufacture of fertilisers and nitrogen compounds / 肥料和氮化合物的制造",
        en: "[20120]Manufacture of fertilisers and nitrogen compounds",
      },
      {
        value: "[20131]Manufacture of petrochemical primary products",
        zh: "[20131]Manufacture of petrochemical primary products / 石油化工初级产品的制造",
        en: "[20131]Manufacture of petrochemical primary products",
      },
      {
        value: "[20132]Manufacture of derivatives and intermediates produced from basic building blocks",
        zh: "[20132]Manufacture of derivatives and intermediates produced from basic building blocks / 基本构件生产的衍生物和中间体的制造",
        en: "[20132]Manufacture of derivatives and intermediates produced from basic building blocks",
      },
      {
        value: "[20133]Manufacture of synthetic rubber",
        zh: "[20133]Manufacture of synthetic rubber / 合成橡胶的制造",
        en: "[20133]Manufacture of synthetic rubber",
      },
      {
        value: "[20210]Manufacture of pesticides and other agro-chemical products",
        zh: "[20210]Manufacture of pesticides and other agro-chemical products / 制造农药和其他农业化学品",
        en: "[20210]Manufacture of pesticides and other agro-chemical products",
      },
      {
        value: "[20221]Manufacture of paints",
        zh: "[20221]Manufacture of paints / 涂料制造",
        en: "[20221]Manufacture of paints",
      },
      {
        value: "[20222]Manufacture of varnishes and lacquers",
        zh: "[20222]Manufacture of varnishes and lacquers / 清漆和漆的制造",
        en: "[20222]Manufacture of varnishes and lacquers",
      },
      {
        value: "[20223]Manufacture of printing ink, prepared pigments and dyes",
        zh: "[20223]Manufacture of printing ink, prepared pigments and dyes / 印刷油墨、预配颜料和染料的制造",
        en: "[20223]Manufacture of printing ink, prepared pigments and dyes",
      },
      {
        value: "[20229]Manufacture of paints, varnishes and similar coatings, printing ink and mastics n.e.c.",
        zh: "[20229]Manufacture of paints, varnishes and similar coatings, printing ink and mastics n.e.c. / 制造涂料、清漆、类似涂层、印刷油墨和腻子",
        en: "[20229]Manufacture of paints, varnishes and similar coatings, printing ink and mastics n.e.c.",
      },
      {
        value: "[20231]Manufacture of soap, detergents, washing and other cleaning preparations",
        zh: "[20231]Manufacture of soap, detergents, washing and other cleaning preparations / 肥皂、洗涤剂、洗涤和其他清洁剂的制造",
        en: "[20231]Manufacture of soap, detergents, washing and other cleaning preparations",
      },
      {
        value: "[20232]Manufacture of perfumes and fragrances",
        zh: "[20232]Manufacture of perfumes and fragrances / 香水和香料的制造",
        en: "[20232]Manufacture of perfumes and fragrances",
      },
      {
        value: "[20233]Manufacture of cosmetics and toiletries",
        zh: "[20233]Manufacture of cosmetics and toiletries / 化妆品和洗浴用品制造",
        en: "[20233]Manufacture of cosmetics and toiletries",
      },
      {
        value: "[20234]Manufacture of waxes and polishes and deodorising preparations",
        zh: "[20234]Manufacture of waxes and polishes and deodorising preparations / 蜡烛、抛光剂和除臭剂的制造",
        en: "[20234]Manufacture of waxes and polishes and deodorising preparations",
      },
      {
        value: "[20241]Manufacture of food chemicals and additives",
        zh: "[20241]Manufacture of food chemicals and additives / 食品化学品和添加剂制造",
        en: "[20241]Manufacture of food chemicals and additives",
      },
      {
        value: "[20242]Manufacture of additives for mineral oil",
        zh: "[20242]Manufacture of additives for mineral oil / 矿物油添加剂的制造",
        en: "[20242]Manufacture of additives for mineral oil",
      },
      {
        value: "[20249]Manufacture of additives n.e.c.",
        zh: "[20249]Manufacture of additives n.e.c. / 其他未列明的添加剂制造",
        en: "[20249]Manufacture of additives n.e.c.",
      },
      {
        value: "[20291]Manufacture of epoxy moulding compounds and phenolic moulding compounds",
        zh: "[20291]Manufacture of epoxy moulding compounds and phenolic moulding compounds / 制造环氧模塑料和酚醛模塑料",
        en: "[20291]Manufacture of epoxy moulding compounds and phenolic moulding compounds",
      },
      {
        value: "[20292]Manufacture of ultrapure electronic chemicals, materials and laminates",
        zh: "[20292]Manufacture of ultrapure electronic chemicals, materials and laminates / 制造超纯电子化学品、材料及层压板",
        en: "[20292]Manufacture of ultrapure electronic chemicals, materials and laminates",
      },
      {
        value: "[20293]Manufacture of water treatment, waste treatment and oilfield chemicals",
        zh: "[20293]Manufacture of water treatment, waste treatment and oilfield chemicals / 制造水处理、废物处理和油田化学品",
        en: "[20293]Manufacture of water treatment, waste treatment and oilfield chemicals",
      },
      {
        value: "[20294]Manufacture of writing and drawing inks",
        zh: "[20294]Manufacture of writing and drawing inks / 制造书写和绘图墨水",
        en: "[20294]Manufacture of writing and drawing inks",
      },
      {
        value: "[20295]Manufacture of photographic film, paper, plate and chemicals",
        zh: "[20295]Manufacture of photographic film, paper, plate and chemicals / 制造摄影胶片、纸张、板和化学品",
        en: "[20295]Manufacture of photographic film, paper, plate and chemicals",
      },
      {
        value: "[20296]Manufacture of adhesives and sealants",
        zh: "[20296]Manufacture of adhesives and sealants / 制造粘合剂和密封剂",
        en: "[20296]Manufacture of adhesives and sealants",
      },
      {
        value: "[20297]Manufacture of catalysts and catalyst regeneration",
        zh: "[20297]Manufacture of catalysts and catalyst regeneration / 催化剂及催化剂再生制造",
        en: "[20297]Manufacture of catalysts and catalyst regeneration",
      },
      {
        value: "[20298]Manufacture of biofuels",
        zh: "[20298]Manufacture of biofuels / 生物燃料制造",
        en: "[20298]Manufacture of biofuels",
      },
      {
        value: "[20299]Manufacture of other chemical products n.e.c.",
        zh: "[20299]Manufacture of other chemical products n.e.c. / 其他化学产品制造",
        en: "[20299]Manufacture of other chemical products n.e.c.",
      },
      {
        value: "[20300]Manufacture of man-made fibres (except glass)",
        zh: "[20300]Manufacture of man-made fibres (except glass) / 人造纤维（玻璃除外）制造",
        en: "[20300]Manufacture of man-made fibres (except glass)",
      },
      {
        value: "[21011]Manufacture of pharmaceutical intermediates and fine chemicals for human use",
        zh: "[21011]Manufacture of pharmaceutical intermediates and fine chemicals for human use / 人用药品中间体和精细化工品制造",
        en: "[21011]Manufacture of pharmaceutical intermediates and fine chemicals for human use",
      },
      {
        value: "[21012]Manufacture of pharmaceutical products and preparations for human use",
        zh: "[21012]Manufacture of pharmaceutical products and preparations for human use / 人用药品及制剂制造",
        en: "[21012]Manufacture of pharmaceutical products and preparations for human use",
      },
      {
        value: "[21013]Manufacture of pharmaceutical products for veterinary use",
        zh: "[21013]Manufacture of pharmaceutical products for veterinary use / 兽用药品制造",
        en: "[21013]Manufacture of pharmaceutical products for veterinary use",
      },
      {
        value: "[21021]Manufacture of vaccines for human use",
        zh: "[21021]Manufacture of vaccines for human use / 人用疫苗制造",
        en: "[21021]Manufacture of vaccines for human use",
      },
      {
        value: "[21022]Manufacture of other biological products and preparations for human use",
        zh: "[21022]Manufacture of other biological products and preparations for human use / 其他生物制品和人类使用的制剂的制造",
        en: "[21022]Manufacture of other biological products and preparations for human use",
      },
      {
        value: "[21023]Manufacture of biological products and preparations for veterinary use",
        zh: "[21023]Manufacture of biological products and preparations for veterinary use / 兽用生物制品和制剂的制造",
        en: "[21023]Manufacture of biological products and preparations for veterinary use",
      },
      {
        value: "[21030]Manufacture of Traditional Chinese Medicine",
        zh: "[21030]Manufacture of Traditional Chinese Medicine / 轮胎和管的制造，橡胶轮胎翻新和重建",
        en: "[21030]Manufacture of Traditional Chinese Medicine",
      },
      {
        value: "[22111]Processing, grading and packing of rubber; processing of rubber latex",
        zh: "[22111]Processing, grading and packing of rubber; processing of rubber latex / 橡胶的加工、分级和包装；橡胶乳液的加工",
        en: "[22111]Processing, grading and packing of rubber; processing of rubber latex",
      },
      {
        value: "[22119]Processing of natural gums n.e.c.",
        zh: "[22119]Processing of natural gums n.e.c. / 其他天然树脂的加工",
        en: "[22119]Processing of natural gums n.e.c.",
      },
      {
        value: "[22121]Manufacture of tyres and tubes",
        zh: "[22121]Manufacture of tyres and tubes / 轮胎和内胎的制造",
        en: "[22121]Manufacture of tyres and tubes",
      },
      {
        value: "[22122]Retreading and vulcanising of tyres",
        zh: "[22122]Retreading and vulcanising of tyres / 轮胎翻新和硫化",
        en: "[22122]Retreading and vulcanising of tyres",
      },
      {
        value: "[22191]Manufacture of foam rubber products (except foam rubber mattresses)",
        zh: "[22191]Manufacture of foam rubber products (except foam rubber mattresses) / 泡沫橡胶制品（不包括泡沫橡胶床垫）的制造",
        en: "[22191]Manufacture of foam rubber products (except foam rubber mattresses)",
      },
      {
        value: "[22192]Manufacture of rubber automotive parts",
        zh: "[22192]Manufacture of rubber automotive parts / 橡胶汽车零部件的制造",
        en: "[22192]Manufacture of rubber automotive parts",
      },
      {
        value: "[22193]Manufacture of industrial and mechanical rubber goods",
        zh: "[22193]Manufacture of industrial and mechanical rubber goods / 工业和机械橡胶制品的制造",
        en: "[22193]Manufacture of industrial and mechanical rubber goods",
      },
      {
        value: "[22194]Manufacture of rubber floorings",
        zh: "[22194]Manufacture of rubber floorings / 橡胶地板的制造",
        en: "[22194]Manufacture of rubber floorings",
      },
      {
        value: "[22199]Manufacture of other rubber products n.e.c. (except rubber footwear and toys)",
        zh: "[22199]Manufacture of other rubber products n.e.c. (except rubber footwear and toys) / 其他橡胶制品（不包括橡胶鞋类和玩具）的制造",
        en: "[22199]Manufacture of other rubber products n.e.c. (except rubber footwear and toys)",
      },
      {
        value: "[22211]Manufacture of plastic tableware, household and kitchen ware (except disposable utensils)",
        zh: "[22211]Manufacture of plastic tableware, household and kitchen ware (except disposable utensils) / 塑料餐具、家用及厨房用具（不包括一次性餐具）的制造",
        en: "[22211]Manufacture of plastic tableware, household and kitchen ware (except disposable utensils)",
      },
      {
        value: "[22212]Manufacture of styrofoam and plastic disposable utensils",
        zh: "[22212]Manufacture of styrofoam and plastic disposable utensils / 聚苯乙烯和塑料一次性餐具的制造",
        en: "[22212]Manufacture of styrofoam and plastic disposable utensils",
      },
      {
        value: "[22213]Manufacture of plastic sheet, film and articles thereof",
        zh: "[22213]Manufacture of plastic sheet, film and articles thereof / 塑料板、薄膜及其制品的制造",
        en: "[22213]Manufacture of plastic sheet, film and articles thereof",
      },
      {
        value: "[22214]Manufacture of plastic bottles, boxes and containers (except for household use)",
        zh: "[22214]Manufacture of plastic bottles, boxes and containers (except for household use) / 塑料瓶、盒子及容器（不包括家用）的制造",
        en: "[22214]Manufacture of plastic bottles, boxes and containers (except for household use)",
      },
      {
        value: "[22215]Manufacture of plastic pipes and tubes",
        zh: "[22215]Manufacture of plastic pipes and tubes / 塑料管道和管材的制造",
        en: "[22215]Manufacture of plastic pipes and tubes",
      },
      {
        value: "[22216]Manufacture of plastic precision engineering parts",
        zh: "[22216]Manufacture of plastic precision engineering parts / 塑料精密工程部件的制造",
        en: "[22216]Manufacture of plastic precision engineering parts",
      },
      {
        value: "[22217]Manufacture of PVC files, holders and albums",
        zh: "[22217]Manufacture of PVC files, holders and albums / PVC文件夹、夹子和相册的制造",
        en: "[22217]Manufacture of PVC files, holders and albums",
      },
      {
        value: "[22218]Manufacture of plastic cable ties",
        zh: "[22218]Manufacture of plastic cable ties / 塑料扎带的制造",
        en: "[22218]Manufacture of plastic cable ties",
      },
      {
        value: "[22219]Manufacture of plastic products n.e.c. (except plastic footwear and toys)",
        zh: "[22219]Manufacture of plastic products n.e.c. (except plastic footwear and toys) / 其他塑料制品的制造（不包括塑料鞋和玩具）",
        en: "[22219]Manufacture of plastic products n.e.c. (except plastic footwear and toys)",
      },
      {
        value: "[22220]Plastic product services",
        zh: "[22220]Plastic product services / 塑料制品服务",
        en: "[22220]Plastic product services",
      },
      {
        value: "[23100]Manufacture of glass and glass products",
        zh: "[23100]Manufacture of glass and glass products / 玻璃及玻璃制品制造",
        en: "[23100]Manufacture of glass and glass products",
      },
      {
        value: "[23910]Manufacture of clay products",
        zh: "[23910]Manufacture of clay products / 粘土制品制造",
        en: "[23910]Manufacture of clay products",
      },
      {
        value: "[23930]Manufacture of other porcelain and ceramic products",
        zh: "[23930]Manufacture of other porcelain and ceramic products / 其他瓷器及陶瓷制品制造",
        en: "[23930]Manufacture of other porcelain and ceramic products",
      },
      {
        value: "[23940]Manufacture of cement, lime and plaster",
        zh: "[23940]Manufacture of cement, lime and plaster / 水泥、石灰和石膏的制造",
        en: "[23940]Manufacture of cement, lime and plaster",
      },
      {
        value: "[23951]Manufacture of ready-mix concrete",
        zh: "[23951]Manufacture of ready-mix concrete / 预拌混凝土的制造",
        en: "[23951]Manufacture of ready-mix concrete",
      },
      {
        value: "[23959]Manufacture of articles of concrete, cement and plaster n.e.c. (except precast concrete components)",
        zh: "[23959]Manufacture of articles of concrete, cement and plaster n.e.c. (except precast concrete components) / 混凝土、水泥和石膏制品的制造（预制混凝土构件除外）",
        en: "[23959]Manufacture of articles of concrete, cement and plaster n.e.c. (except precast concrete components)",
      },
      {
        value: "[23960]Cutting, shaping and finishing of stone",
        zh: "[23960]Cutting, shaping and finishing of stone / 石材的切割、成形和精加工",
        en: "[23960]Cutting, shaping and finishing of stone",
      },
      {
        value: "[23991]Manufacture of fibreglass and fibreglass products",
        zh: "[23991]Manufacture of fibreglass and fibreglass products / 玻璃纤维及其制品的制造",
        en: "[23991]Manufacture of fibreglass and fibreglass products",
      },
      {
        value: "[23992]Manufacture of other insulation products",
        zh: "[23992]Manufacture of other insulation products / 其他隔热产品制造",
        en: "[23992]Manufacture of other insulation products",
      },
      {
        value: "[23993]Manufacture of non-structural pre-cast components",
        zh: "[23993]Manufacture of non-structural pre-cast components / 非结构性预制件制造",
        en: "[23993]Manufacture of non-structural pre-cast components",
      },
      {
        value: "[23994]Manufacture of asphalt premix",
        zh: "[23994]Manufacture of asphalt premix / 沥青预拌料制造",
        en: "[23994]Manufacture of asphalt premix",
      },
      {
        value: "[23999]Manufacture of other non-metallic mineral products n.e.c.",
        zh: "[23999]Manufacture of other non-metallic mineral products n.e.c. / 其他非金属矿物制品制造",
        en: "[23999]Manufacture of other non-metallic mineral products n.e.c.",
      },
      {
        value: "[24101]Iron and steel rolling mills",
        zh: "[24101]Iron and steel rolling mills / 轧钢和钢加工",
        en: "[24101]Iron and steel rolling mills",
      },
      {
        value: "[24102]Manufacture of ferrous metal alloys",
        zh: "[24102]Manufacture of ferrous metal alloys / 黑色金属合金制造",
        en: "[24102]Manufacture of ferrous metal alloys",
      },
      {
        value: "[24109]Manufacture of basic iron and steel n.e.c.",
        zh: "[24109]Manufacture of basic iron and steel n.e.c. / 基本钢铁制造",
        en: "[24109]Manufacture of basic iron and steel n.e.c.",
      },
      {
        value: "[24201]Manufacture of non-ferrous metal alloys",
        zh: "[24201]Manufacture of non-ferrous metal alloys / 有色金属合金的制造",
        en: "[24201]Manufacture of non-ferrous metal alloys",
      },
      {
        value: "[24209]Manufacture of basic precious and non-ferrous metals n.e.c.",
        zh: "[24209]Manufacture of basic precious and non-ferrous metals n.e.c. / 其他基本贵金属和有色金属的制造",
        en: "[24209]Manufacture of basic precious and non-ferrous metals n.e.c.",
      },
      {
        value: "[24310]Iron and steel foundries",
        zh: "[24310]Iron and steel foundries / 铁和钢铸造厂",
        en: "[24310]Iron and steel foundries",
      },
      {
        value: "[24320]Non-ferrous metal foundries",
        zh: "[24320]Non-ferrous metal foundries / 有色金属铸造厂",
        en: "[24320]Non-ferrous metal foundries",
      },
      {
        value: "[25111]Manufacture of metal doors, window and door frames, grilles and gratings",
        zh: "[25111]Manufacture of metal doors, window and door frames, grilles and gratings / 金属门、窗框、格栅和格子板制造",
        en: "[25111]Manufacture of metal doors, window and door frames, grilles and gratings",
      },
      {
        value: "[25112]Manufacture of metal strips and slabs",
        zh: "[25112]Manufacture of metal strips and slabs / 金属带材和板块制造",
        en: "[25112]Manufacture of metal strips and slabs",
      },
      {
        value: "[25113]Manufacture of metal pipes and tubes",
        zh: "[25113]Manufacture of metal pipes and tubes / 金属管和管材制造",
        en: "[25113]Manufacture of metal pipes and tubes",
      },
      {
        value: "[25114]Manufacture of steel structural component",
        zh: "[25114]Manufacture of steel structural component / 钢结构组件制造",
        en: "[25114]Manufacture of steel structural component",
      },
      {
        value: "[25119]Manufacture of structural metal products n.e.c.",
        zh: "[25119]Manufacture of structural metal products n.e.c. / 其他金属结构产品制造",
        en: "[25119]Manufacture of structural metal products n.e.c.",
      },
      {
        value: "[25120]Manufacture/repair of tanks, reservoirs and containers of metal",
        zh: "[25120]Manufacture/repair of tanks, reservoirs and containers of metal / 金属制储罐、容器及类似品的制造与修理",
        en: "[25120]Manufacture/repair of tanks, reservoirs and containers of metal",
      },
      {
        value: "[25131]Manufacture/repair of heating boilers, radiators and correctors",
        zh: "[25131]Manufacture/repair of heating boilers, radiators and correctors / 加热锅炉、散热器及校正器的制造与修理",
        en: "[25131]Manufacture/repair of heating boilers, radiators and correctors",
      },
      {
        value: "[25139]Manufacture/repair of steam generators n.e.c. (except central heating hot water boilers)",
        zh: "[25139]Manufacture/repair of steam generators n.e.c. (except central heating hot water boilers) / 蒸汽发生器的制造/修理（不包括中央供暖热水锅炉）",
        en: "[25139]Manufacture/repair of steam generators n.e.c. (except central heating hot water boilers)",
      },
      {
        value: "[25200]Manufacture/repair of weapons and ammunition",
        zh: "[25200]Manufacture/repair of weapons and ammunition / 武器和弹药的制造/修理",
        en: "[25200]Manufacture/repair of weapons and ammunition",
      },
      {
        value: "[25911]Iron and steel and non-ferrous forgings",
        zh: "[25911]Iron and steel and non-ferrous forgings / 铁和钢以及有色金属锻造",
        en: "[25911]Iron and steel and non-ferrous forgings",
      },
      {
        value: "[25912]Manufacture of leadframe",
        zh: "[25912]Manufacture of leadframe / 引线框架的制造",
        en: "[25912]Manufacture of leadframe",
      },
      {
        value: "[25913]Metal stampings (except metal caps)",
        zh: "[25913]Metal stampings (except metal caps) / 金属冲压件（不包括金属盖）",
        en: "[25913]Metal stampings (except metal caps)",
      },
      {
        value: "[25919]Pressing and roll-forming of metal and powder metallurgy n.e.c.",
        zh: "[25919]Pressing and roll-forming of metal and powder metallurgy n.e.c. / 金属压制和滚制以及粉末冶金（不包括其他）",
        en: "[25919]Pressing and roll-forming of metal and powder metallurgy n.e.c.",
      },
      {
        value: "[25921]Electroplating and plating of metals and formed products",
        zh: "[25921]Electroplating and plating of metals and formed products / 金属及其成型产品的电镀和镀层",
        en: "[25921]Electroplating and plating of metals and formed products",
      },
      {
        value: "[25922]Polishing of metals and formed products",
        zh: "[25922]Polishing of metals and formed products / 金属及其成型产品的抛光",
        en: "[25922]Polishing of metals and formed products",
      },
      {
        value: "[25923]Rustproofing of metals and formed products",
        zh: "[25923]Rustproofing of metals and formed products / 金属及其成型产品的防锈处理",
        en: "[25923]Rustproofing of metals and formed products",
      },
      {
        value: "[25924]Heat treatment for metals",
        zh: "[25924]Heat treatment for metals / 金属的热处理",
        en: "[25924]Heat treatment for metals",
      },
      {
        value: "[25929]Metal product services n.e.c.",
        zh: "[25929]Metal product services n.e.c. / 金属制品服务（不包括其他）",
        en: "[25929]Metal product services n.e.c.",
      },
      {
        value: "[25931]Manufacture of table, kitchen and other cutlery",
        zh: "[25931]Manufacture of table, kitchen and other cutlery / 制造餐桌、厨房及其他餐具",
        en: "[25931]Manufacture of table, kitchen and other cutlery",
      },
      {
        value: "[25932]Manufacture of hand and edge tools",
        zh: "[25932]Manufacture of hand and edge tools / 制造手工和边缘工具",
        en: "[25932]Manufacture of hand and edge tools",
      },
      {
        value: "[25939]Manufacture of general hardware n.e.c.",
        zh: "[25939]Manufacture of general hardware n.e.c. / 制造一般五金（不包括其他）",
        en: "[25939]Manufacture of general hardware n.e.c.",
      },
      {
        value: "[25941]Manufacture of uninsulated wire",
        zh: "[25941]Manufacture of uninsulated wire / 非绝缘电线制造",
        en: "[25941]Manufacture of uninsulated wire",
      },
      {
        value: "[25949]Manufacture of metal wire and cable products n.e.c.",
        zh: "[25949]Manufacture of metal wire and cable products n.e.c. / 非电气金属线缆产品制造",
        en: "[25949]Manufacture of metal wire and cable products n.e.c.",
      },
      {
        value: "[25951]Manufacture of tinplate cans",
        zh: "[25951]Manufacture of tinplate cans / 镀锡铁罐制造",
        en: "[25951]Manufacture of tinplate cans",
      },
      {
        value: "[25952]Manufacture of other tinplate and zinc articles",
        zh: "[25952]Manufacture of other tinplate and zinc articles / 其他镀锡和锌制品制造",
        en: "[25952]Manufacture of other tinplate and zinc articles",
      },
      {
        value: "[25959]Manufacture of metal cans, containers and related products n.e.c.",
        zh: "[25959]Manufacture of metal cans, containers and related products n.e.c. / 金属罐、容器及相关产品制造（不包括电气）",
        en: "[25959]Manufacture of metal cans, containers and related products n.e.c.",
      },
      {
        value: "[25991]Manufacture of sanitary ware of enamelled iron and metal and plumbers' ware of brass",
        zh: "[25991]Manufacture of sanitary ware of enamelled iron and metal and plumbers' ware of brass / 搪瓷铁制卫生洁具和黄铜制管道设备制造",
        en: "[25991]Manufacture of sanitary ware of enamelled iron and metal and plumbers' ware of brass",
      },
      {
        value: "[25992]Manufacture of plumbing, heating and related products (except electric)",
        zh: "[25992]Manufacture of plumbing, heating and related products (except electric) / 管道、供暖及相关产品制造（不包括电的）",
        en: "[25992]Manufacture of plumbing, heating and related products (except electric)",
      },
      {
        value: "[25993]Manufacture of bolts, nuts, rivets, fasteners and screw machine products",
        zh: "[25993]Manufacture of bolts, nuts, rivets, fasteners and screw machine products / 螺栓、螺母、铆钉、紧固件及螺丝机械产品的制造",
        en: "[25993]Manufacture of bolts, nuts, rivets, fasteners and screw machine products",
      },
      {
        value: "[25994]Manufacture of pipe fittings",
        zh: "[25994]Manufacture of pipe fittings / 管接头的制造",
        en: "[25994]Manufacture of pipe fittings",
      },
      {
        value: "[25995]Manufacture of springs",
        zh: "[25995]Manufacture of springs / 弹簧制造",
        en: "[25995]Manufacture of springs",
      },
      {
        value: "[25996]Manufacture of kitchen and household utensils",
        zh: "[25996]Manufacture of kitchen and household utensils / 厨房和家用器具的制造",
        en: "[25996]Manufacture of kitchen and household utensils",
      },
      {
        value: "[25997]Manufacture of metal precision components",
        zh: "[25997]Manufacture of metal precision components / 金属精密部件的制造",
        en: "[25997]Manufacture of metal precision components",
      },
      {
        value: "[25998]Slitting, shearing and pasting of metal sheeting",
        zh: "[25998]Slitting, shearing and pasting of metal sheeting / 金属板材的剪切、剪裁和粘贴",
        en: "[25998]Slitting, shearing and pasting of metal sheeting",
      },
      {
        value: "[25999]Manufacture of other fabricated metal products n.e.c.",
        zh: "[25999]Manufacture of other fabricated metal products n.e.c. / 其他未列明的金属制品制造",
        en: "[25999]Manufacture of other fabricated metal products n.e.c.",
      },
      {
        value: "[26111]Manufacture of discrete devices",
        zh: "[26111]Manufacture of discrete devices / 分立器件制造",
        en: "[26111]Manufacture of discrete devices",
      },
      {
        value: "[26112]Semiconductor wafer fabrication",
        zh: "[26112]Semiconductor wafer fabrication / 半导体晶圆制造",
        en: "[26112]Semiconductor wafer fabrication",
      },
      {
        value: "[26113]Assembly and testing of semiconductors",
        zh: "[26113]Assembly and testing of semiconductors / 半导体的组装与测试",
        en: "[26113]Assembly and testing of semiconductors",
      },
      {
        value: "[26114]Manufacture of solar wafers",
        zh: "[26114]Manufacture of solar wafers / 太阳能晶圆制造",
        en: "[26114]Manufacture of solar wafers",
      },
      {
        value: "[26115]Manufacture of solar cells",
        zh: "[26115]Manufacture of solar cells / 太阳能电池制造",
        en: "[26115]Manufacture of solar cells",
      },
      {
        value: "[26119]Manufacture of semiconductor devices n.e.c.",
        zh: "[26119]Manufacture of semiconductor devices n.e.c. / 半导体设备制造（不包括其他类）",
        en: "[26119]Manufacture of semiconductor devices n.e.c.",
      },
      {
        value: "[26121]Manufacture of capacitors",
        zh: "[26121]Manufacture of capacitors / 电容器制造",
        en: "[26121]Manufacture of capacitors",
      },
      {
        value: "[26122]Manufacture of printed circuit boards without electronic parts",
        zh: "[26122]Manufacture of printed circuit boards without electronic parts / 不带电子部件的印刷电路板制造",
        en: "[26122]Manufacture of printed circuit boards without electronic parts",
      },
      {
        value: "[26123]Manufacture of printed circuit boards with electronic parts",
        zh: "[26123]Manufacture of printed circuit boards with electronic parts / 带电子部件的印刷电路板制造",
        en: "[26123]Manufacture of printed circuit boards with electronic parts",
      },
      {
        value: "[26124]Manufacture of piezo-electric devices",
        zh: "[26124]Manufacture of piezo-electric devices / 压电设备制造",
        en: "[26124]Manufacture of piezo-electric devices",
      },
      {
        value: "[26125]Manufacture of electronic display devices (except light emitting diodes)",
        zh: "[26125]Manufacture of electronic display devices (except light emitting diodes) / 电子显示设备制造（不包括发光二极管）",
        en: "[26125]Manufacture of electronic display devices (except light emitting diodes)",
      },
      {
        value: "[26126]Manufacture of electronic connectors",
        zh: "[26126]Manufacture of electronic connectors / 电子连接器制造",
        en: "[26126]Manufacture of electronic connectors",
      },
      {
        value: "[26129]Manufacture of other electronic components and boards n.e.c.",
        zh: "[26129]Manufacture of other electronic components and boards n.e.c. / 其他电子元件及板制造",
        en: "[26129]Manufacture of other electronic components and boards n.e.c.",
      },
      {
        value: "[26201]Manufacture of computers and data processing equipment (except computer peripheral equipment)",
        zh: "[26201]Manufacture of computers and data processing equipment (except computer peripheral equipment) / 计算机及数据处理设备制造（不包括计算机外围设备）",
        en: "[26201]Manufacture of computers and data processing equipment (except computer peripheral equipment)",
      },
      {
        value: "[26202]Manufacture of disk drives",
        zh: "[26202]Manufacture of disk drives / 磁盘驱动器制造",
        en: "[26202]Manufacture of disk drives",
      },
      {
        value: "[26203]Manufacture of printers",
        zh: "[26203]Manufacture of printers / 打印机制造",
        en: "[26203]Manufacture of printers",
      },
      {
        value: "[26204]Manufacture of smart cards and related products",
        zh: "[26204]Manufacture of smart cards and related products / 智能卡及相关产品制造",
        en: "[26204]Manufacture of smart cards and related products",
      },
      {
        value: "[26209]Manufacture of computers and peripheral equipment n.e.c.",
        zh: "[26209]Manufacture of computers and peripheral equipment n.e.c. / 计算机及外围设备制造",
        en: "[26209]Manufacture of computers and peripheral equipment n.e.c.",
      },
      {
        value: "[26301]Manufacture of telecommunications apparatus",
        zh: "[26301]Manufacture of telecommunications apparatus / 电信设备制造",
        en: "[26301]Manufacture of telecommunications apparatus",
      },
      {
        value: "[26302]Manufacture of networking products",
        zh: "[26302]Manufacture of networking products / 网络产品制造",
        en: "[26302]Manufacture of networking products",
      },
      {
        value: "[26303]Manufacture of wireless communications equipment",
        zh: "[26303]Manufacture of wireless communications equipment / 无线通信设备制造",
        en: "[26303]Manufacture of wireless communications equipment",
      },
      {
        value: "[26304]Manufacture of electronic security systems",
        zh: "[26304]Manufacture of electronic security systems / 电子安全系统制造",
        en: "[26304]Manufacture of electronic security systems",
      },
      {
        value: "[26309]Manufacture of communications equipment n.e.c.",
        zh: "[26309]Manufacture of communications equipment n.e.c. / 通信设备制造（其他）",
        en: "[26309]Manufacture of communications equipment n.e.c.",
      },
      {
        value: "[26400]Manufacture of consumer electronics",
        zh: "[26400]Manufacture of consumer electronics / 消费电子产品制造",
        en: "[26400]Manufacture of consumer electronics",
      },
      {
        value: "[26511]Manufacture/repair of engineering and scientific instruments",
        zh: "[26511]Manufacture/repair of engineering and scientific instruments / 工程和科学仪器的制造/修理",
        en: "[26511]Manufacture/repair of engineering and scientific instruments",
      },
      {
        value: "[26512]Manufacture/repair of measuring devices",
        zh: "[26512]Manufacture/repair of measuring devices / 测量设备的制造/修理",
        en: "[26512]Manufacture/repair of measuring devices",
      },
      {
        value: "[26513]Manufacture/repair of process control equipment and related products",
        zh: "[26513]Manufacture/repair of process control equipment and related products / 过程控制设备及相关产品的制造/修理",
        en: "[26513]Manufacture/repair of process control equipment and related products",
      },
      {
        value: "[26520]Manufacture of watches and clocks",
        zh: "[26520]Manufacture of watches and clocks / 钟表和时钟的制造",
        en: "[26520]Manufacture of watches and clocks",
      },
      {
        value: "[26601]Manufacture/repair of electrotherapeutic devices",
        zh: "[26601]Manufacture/repair of electrotherapeutic devices / 电疗设备的制造/修理",
        en: "[26601]Manufacture/repair of electrotherapeutic devices",
      },
      {
        value: "[26602]Manufacture/repair of irradiation and electromedical equipment and instruments",
        zh: "[26602]Manufacture/repair of irradiation and electromedical equipment and instruments / 辐射和医用电气设备及仪器的制造/修理",
        en: "[26602]Manufacture/repair of irradiation and electromedical equipment and instruments",
      },
      {
        value: "[26701]Manufacture of photographic equipment and parts",
        zh: "[26701]Manufacture of photographic equipment and parts / 摄影设备和部件的制造",
        en: "[26701]Manufacture of photographic equipment and parts",
      },
      {
        value: "[26709]Manufacture of optical instruments and photographic equipment n.e.c.",
        zh: "[26709]Manufacture of optical instruments and photographic equipment n.e.c. / 光学仪器和摄影设备的制造（不包括其他）",
        en: "[26709]Manufacture of optical instruments and photographic equipment n.e.c.",
      },
      {
        value: "[26801]Manufacture of disk media",
        zh: "[26801]Manufacture of disk media / 磁盘介质的制造",
        en: "[26801]Manufacture of disk media",
      },
      {
        value: "[26802]Manufacture of blank magnetic tapes, diskettes, Blu-ray technology discs, CDs, DVDs and VCDs",
        zh: "[26802]Manufacture of blank magnetic tapes, diskettes, Blu-ray technology discs, CDs, DVDs and VCDs / 空白磁带、磁盘、蓝光技术光盘、CD、DVD和VCD的制造",
        en: "[26802]Manufacture of blank magnetic tapes, diskettes, Blu-ray technology discs, CDs, DVDs and VCDs",
      },
      {
        value: "[27101]Manufacture/repair of electric motors",
        zh: "[27101]Manufacture/repair of electric motors / 电动机的制造/修理",
        en: "[27101]Manufacture/repair of electric motors",
      },
      {
        value: "[27102]Manufacture/repair of electric generators",
        zh: "[27102]Manufacture/repair of electric generators / 发电机的制造/修理",
        en: "[27102]Manufacture/repair of electric generators",
      },
      {
        value: "[27103]Manufacture/repair of transformers",
        zh: "[27103]Manufacture/repair of transformers / 变压器的制造/修理",
        en: "[27103]Manufacture/repair of transformers",
      },
      {
        value: "[27104]Manufacture/repair of switchgear and switchboard apparatus",
        zh: "[27104]Manufacture/repair of switchgear and switchboard apparatus / 开关设备和配电盘设备的制造/修理",
        en: "[27104]Manufacture/repair of switchgear and switchboard apparatus",
      },
      {
        value: "[27109]Manufacture/repair of electric motors, generators, transformers and electricity distribution and control apparatus n.e.c.",
        zh: "[27109]Manufacture/repair of electric motors, generators, transformers and electricity distribution and control apparatus n.e.c. / 电动机、发电机、变压器及电力分配和控制设备的制造/修理",
        en: "[27109]Manufacture/repair of electric motors, generators, transformers and electricity distribution and control apparatus n.e.c.",
      },
      {
        value: "[27201]Manufacture of primary batteries",
        zh: "[27201]Manufacture of primary batteries / 制造初级电池",
        en: "[27201]Manufacture of primary batteries",
      },
      {
        value: "[27202]Manufacture of secondary batteries",
        zh: "[27202]Manufacture of secondary batteries / 制造次级电池",
        en: "[27202]Manufacture of secondary batteries",
      },
      {
        value: "[27321]Manufacture of telecommunications cables and wires",
        zh: "[27321]Manufacture of telecommunications cables and wires / 制造电信电缆和电线",
        en: "[27321]Manufacture of telecommunications cables and wires",
      },
      {
        value: "[27322]Manufacture of electric power cables and wires",
        zh: "[27322]Manufacture of electric power cables and wires / 制造电力电缆和电线",
        en: "[27322]Manufacture of electric power cables and wires",
      },
      {
        value: "[27323]Manufacture of wire and cable assemblies and harnesses",
        zh: "[27323]Manufacture of wire and cable assemblies and harnesses / 制造电线电缆组件和线束",
        en: "[27323]Manufacture of wire and cable assemblies and harnesses",
      },
      {
        value: "[27329]Manufacture of electronic and electric wires and cables n.e.c.",
        zh: "[27329]Manufacture of electronic and electric wires and cables n.e.c. / 制造电子和电力电线电缆等其他产品",
        en: "[27329]Manufacture of electronic and electric wires and cables n.e.c.",
      },
      {
        value: "[27330]Manufacture/repair of wiring devices",
        zh: "[27330]Manufacture/repair of wiring devices / 电线装置的制造/修理",
        en: "[27330]Manufacture/repair of wiring devices",
      },
      {
        value: "[27400]Manufacture/repair of electric lamps and lighting equipment",
        zh: "[27400]Manufacture/repair of electric lamps and lighting equipment / 电灯及照明设备制造/修理",
        en: "[27400]Manufacture/repair of electric lamps and lighting equipment",
      },
      {
        value: "[27501]Manufacture of electrical household appliances",
        zh: "[27501]Manufacture of electrical household appliances / 家用电器制造",
        en: "[27501]Manufacture of electrical household appliances",
      },
      {
        value: "[27509]Manufacture of domestic appliances n.e.c.",
        zh: "[27509]Manufacture of domestic appliances n.e.c. / 其他家用电器制造",
        en: "[27509]Manufacture of domestic appliances n.e.c.",
      },
      {
        value: "[27900]Manufacture of other electrical equipment, apparatus, appliances and supplies",
        zh: "[27900]Manufacture of other electrical equipment, apparatus, appliances and supplies / 其他电气设备、装置、器具及用品制造",
        en: "[27900]Manufacture of other electrical equipment, apparatus, appliances and supplies",
      },
      {
        value: "[28111]Manufacture/repair of engines and turbines (except aircraft, vehicle, cycle and marine engines)",
        zh: "[28111]Manufacture/repair of engines and turbines (except aircraft, vehicle, cycle and marine engines) / 发动机和涡轮的制造/修理（不包括飞机、车辆、自行车和船舶发动机）",
        en: "[28111]Manufacture/repair of engines and turbines (except aircraft, vehicle, cycle and marine engines)",
      },
      {
        value: "[28112]Manufacture/repair of marine engine",
        zh: "[28112]Manufacture/repair of marine engine / 船舶发动机的制造/修理",
        en: "[28112]Manufacture/repair of marine engine",
      },
      {
        value: "[28121]Manufacture/repair of pumps",
        zh: "[28121]Manufacture/repair of pumps / 泵的制造/修理",
        en: "[28121]Manufacture/repair of pumps",
      },
      {
        value: "[28122]Manufacture/repair of taps, cocks and valves",
        zh: "[28122]Manufacture/repair of taps, cocks and valves / 龙头、旋塞和阀门的制造/修理",
        en: "[28122]Manufacture/repair of taps, cocks and valves",
      },
      {
        value: "[28129]Manufacture/repair of pumps, compressors, taps and valves n.e.c.",
        zh: "[28129]Manufacture/repair of pumps, compressors, taps and valves n.e.c. / 泵、压缩机、龙头和阀门的制造/修理（不包括其他）",
        en: "[28129]Manufacture/repair of pumps, compressors, taps and valves n.e.c.",
      },
      {
        value: "[28141]Manufacture of bearings",
        zh: "[28141]Manufacture of bearings / 轴承的制造",
        en: "[28141]Manufacture of bearings",
      },
      {
        value: "[28142]Manufacture/repair of gears, gearing and driving elements",
        zh: "[28142]Manufacture/repair of gears, gearing and driving elements / 齿轮、传动装置和驱动元件的制造/修理",
        en: "[28142]Manufacture/repair of gears, gearing and driving elements",
      },
      {
        value: "[28150]Manufacture/repair of ovens, furnaces and furnace burners",
        zh: "[28150]Manufacture/repair of ovens, furnaces and furnace burners / 炉子、炉子和炉子燃烧器的制造/修理",
        en: "[28150]Manufacture/repair of ovens, furnaces and furnace burners",
      },
      {
        value: "[28161]Manufacture/repair of lifting and hoisting machinery (except electrical)",
        zh: "[28161]Manufacture/repair of lifting and hoisting machinery (except electrical) / 起重和提升机械（非电气）的制造/修理",
        en: "[28161]Manufacture/repair of lifting and hoisting machinery (except electrical)",
      },
      {
        value: "[28162]Manufacture/repair of lifts and escalators",
        zh: "[28162]Manufacture/repair of lifts and escalators / 电梯和自动扶梯的制造/修理",
        en: "[28162]Manufacture/repair of lifts and escalators",
      },
      {
        value: "[28169]Manufacture/repair of lifting and handling equipment n.e.c.",
        zh: "[28169]Manufacture/repair of lifting and handling equipment n.e.c. / 起重和搬运设备（不包括电动）的制造/修理",
        en: "[28169]Manufacture/repair of lifting and handling equipment n.e.c.",
      },
      {
        value: "[28171]Manufacture of office machinery and equipment (except computers and peripheral equipment)",
        zh: "[28171]Manufacture of office machinery and equipment (except computers and peripheral equipment) / 办公机械和设备（除了计算机及其外围设备）的制造",
        en: "[28171]Manufacture of office machinery and equipment (except computers and peripheral equipment)",
      },
      {
        value: "[28172]Repair and maintenance of office machinery and equipment",
        zh: "[28172]Repair and maintenance of office machinery and equipment / 修理和维护办公机械和设备",
        en: "[28172]Repair and maintenance of office machinery and equipment",
      },
      {
        value: "[28181]Manufacture/repair of industrial robots",
        zh: "[28181]Manufacture/repair of industrial robots / 制造/修理工业机器人",
        en: "[28181]Manufacture/repair of industrial robots",
      },
      {
        value: "[28182]Manufacture/repair of service robots",
        zh: "[28182]Manufacture/repair of service robots / 制造/修理服务机器人",
        en: "[28182]Manufacture/repair of service robots",
      },
      {
        value: "[28189]Manufacture/repair of robots n.e.c.",
        zh: "[28189]Manufacture/repair of robots n.e.c. / 制造/修理其他未分类机器人",
        en: "[28189]Manufacture/repair of robots n.e.c.",
      },
      {
        value: "[28191]Manufacture/repair of refrigerating, air-conditioning and ventilating machinery and equipment (except household refrigerators)",
        zh: "[28191]Manufacture/repair of refrigerating, air-conditioning and ventilating machinery and equipment (except household refrigerators) / 制造/修理冷藏、空调和通风机械及设备（不包括家用冰箱）",
        en: "[28191]Manufacture/repair of refrigerating, air-conditioning and ventilating machinery and equipment (except household refrigerators)",
      },
      {
        value: "[28192]Manufacture/repair of separation/mixing equipment",
        zh: "[28192]Manufacture/repair of separation/mixing equipment / 制造/修理分离/混合设备",
        en: "[28192]Manufacture/repair of separation/mixing equipment",
      },
      {
        value: "[28193]Manufacture/repair of solar modules and panels",
        zh: "[28193]Manufacture/repair of solar modules and panels / 制造/修理太阳能模块和电池板",
        en: "[28193]Manufacture/repair of solar modules and panels",
      },
      {
        value: "[28194]Manufacture/repair of welding and soldering equipment",
        zh: "[28194]Manufacture/repair of welding and soldering equipment / 制造/修理焊接和焊接设备",
        en: "[28194]Manufacture/repair of welding and soldering equipment",
      },
      {
        value: "[28195]Manufacture/repair of packaging machinery",
        zh: "[28195]Manufacture/repair of packaging machinery / 包装机械的制造/修理",
        en: "[28195]Manufacture/repair of packaging machinery",
      },
      {
        value: "[28199]Manufacture/repair of other general purpose machinery and equipment n.e.c. (except electrical and electronic)",
        zh: "[28199]Manufacture/repair of other general purpose machinery and equipment n.e.c. (except electrical and electronic) / 其他通用机械和设备的制造/修理（不包括电气和电子设备）",
        en: "[28199]Manufacture/repair of other general purpose machinery and equipment n.e.c. (except electrical and electronic)",
      },
      {
        value: "[28210]Manufacture/repair of agricultural and forestry machinery",
        zh: "[28210]Manufacture/repair of agricultural and forestry machinery / 农业和林业机械的制造/修理",
        en: "[28210]Manufacture/repair of agricultural and forestry machinery",
      },
      {
        value: "[28221]Manufacture/repair of machinery and machine-tools - metal cutting types",
        zh: "[28221]Manufacture/repair of machinery and machine-tools - metal cutting types / 金属切削类机械和机床的制造/修理",
        en: "[28221]Manufacture/repair of machinery and machine-tools - metal cutting types",
      },
      {
        value: "[28222]Manufacture/repair of machinery and machine-tools - metal forming types",
        zh: "[28222]Manufacture/repair of machinery and machine-tools - metal forming types / 金属成型类机械和机床的制造/修理",
        en: "[28222]Manufacture/repair of machinery and machine-tools - metal forming types",
      },
      {
        value: "[28223]Manufacture/repair of dies, moulds, tools, jigs and fixtures",
        zh: "[28223]Manufacture/repair of dies, moulds, tools, jigs and fixtures / 模具、模具、工具、夹具和装置的制造/修理",
        en: "[28223]Manufacture/repair of dies, moulds, tools, jigs and fixtures",
      },
      {
        value: "[28224]Manufacture/repair of machine tool accessories",
        zh: "[28224]Manufacture/repair of machine tool accessories / 机床附件的制造/修理",
        en: "[28224]Manufacture/repair of machine tool accessories",
      },
      {
        value: "[28229]Manufacture/repair of metal-forming machinery and machine tools n.e.c.",
        zh: "[28229]Manufacture/repair of metal-forming machinery and machine tools n.e.c. / 制造/修理金属成型机械和机床",
        en: "[28229]Manufacture/repair of metal-forming machinery and machine tools n.e.c.",
      },
      {
        value: "[28241]Manufacture/repair of oil rigs",
        zh: "[28241]Manufacture/repair of oil rigs / 制造/修理石油钻井平台",
        en: "[28241]Manufacture/repair of oil rigs",
      },
      {
        value: "[28242]Manufacture/repair of other oilfield and gasfield machinery and equipment",
        zh: "[28242]Manufacture/repair of other oilfield and gasfield machinery and equipment / 制造/修理其他油田和气田机械设备",
        en: "[28242]Manufacture/repair of other oilfield and gasfield machinery and equipment",
      },
      {
        value: "[28243]Manufacture/repair of construction machinery and parts",
        zh: "[28243]Manufacture/repair of construction machinery and parts / 制造/修理建筑机械和零件",
        en: "[28243]Manufacture/repair of construction machinery and parts",
      },
      {
        value: "[28249]Manufacture/repair of machinery for mining, quarrying and construction n.e.c.",
        zh: "[28249]Manufacture/repair of machinery for mining, quarrying and construction n.e.c. / 制造/修理采矿、采石和建筑用机械设备",
        en: "[28249]Manufacture/repair of machinery for mining, quarrying and construction n.e.c.",
      },
      {
        value: "[28251]Manufacture/repair of machinery for food products processing",
        zh: "[28251]Manufacture/repair of machinery for food products processing / 食品产品加工机械的制造/修理",
        en: "[28251]Manufacture/repair of machinery for food products processing",
      },
      {
        value: "[28252]Manufacture/repair of machinery for beverage production",
        zh: "[28252]Manufacture/repair of machinery for beverage production / 饮料生产机械的制造/修理",
        en: "[28252]Manufacture/repair of machinery for beverage production",
      },
      {
        value: "[28253]Manufacture/repair of machinery for tobacco processing",
        zh: "[28253]Manufacture/repair of machinery for tobacco processing / 烟草加工机械的制造/修理",
        en: "[28253]Manufacture/repair of machinery for tobacco processing",
      },
      {
        value: "[28260]Manufacture/repair of machinery for textile, apparel and leather production",
        zh: "[28260]Manufacture/repair of machinery for textile, apparel and leather production / 纺织、服装和皮革生产机械的制造和修理",
        en: "[28260]Manufacture/repair of machinery for textile, apparel and leather production",
      },
      {
        value: "[28271]Manufacture of probe cards",
        zh: "[28271]Manufacture of probe cards / 探针卡的制造",
        en: "[28271]Manufacture of probe cards",
      },
      {
        value: "[28272]Manufacture of bonding tools",
        zh: "[28272]Manufacture of bonding tools / 键合工具的制造",
        en: "[28272]Manufacture of bonding tools",
      },
      {
        value: "[28273]Manufacture/repair of semiconductor assembly and testing equipment",
        zh: "[28273]Manufacture/repair of semiconductor assembly and testing equipment / 半导体组装和测试设备的制造/修理",
        en: "[28273]Manufacture/repair of semiconductor assembly and testing equipment",
      },
      {
        value: "[28274]Manufacture/repair of semiconductor foundry equipment",
        zh: "[28274]Manufacture/repair of semiconductor foundry equipment / 半导体铸造设备的制造/修理",
        en: "[28274]Manufacture/repair of semiconductor foundry equipment",
      },
      {
        value: "[28291]Manufacture/repair of water/waste water treatment equipment",
        zh: "[28291]Manufacture/repair of water/waste water treatment equipment / 水/废水处理设备的制造/修理",
        en: "[28291]Manufacture/repair of water/waste water treatment equipment",
      },
      {
        value: "[28292]Manufacture/repair of plastic processing machinery",
        zh: "[28292]Manufacture/repair of plastic processing machinery / 塑料加工机械的制造/修理",
        en: "[28292]Manufacture/repair of plastic processing machinery",
      },
      {
        value: "[28293]Manufacture/repair of additive manufacturing (AM) equipment",
        zh: "[28293]Manufacture/repair of additive manufacturing (AM) equipment / 制造/修理增材制造（AM）设备",
        en: "[28293]Manufacture/repair of additive manufacturing (AM) equipment",
      },
      {
        value: "[28299]Manufacture/repair of other special purpose machinery n.e.c.",
        zh: "[28299]Manufacture/repair of other special purpose machinery n.e.c. / 制造/修理其他特殊用途机械",
        en: "[28299]Manufacture/repair of other special purpose machinery n.e.c.",
      },
      {
        value: "[28300]Installation of industrial machinery and equipment, mechanical engineering works",
        zh: "[28300]Installation of industrial machinery and equipment, mechanical engineering works / 工业机械及设备的安装，机械工程工作",
        en: "[28300]Installation of industrial machinery and equipment, mechanical engineering works",
      },
      {
        value: "[29100]Manufacture and assembly of motor vehicles (except motorcycles and scooters)",
        zh: "[29100]Manufacture and assembly of motor vehicles (except motorcycles and scooters) / 制造和组装汽车（摩托车和电动滑板车除外）",
        en: "[29100]Manufacture and assembly of motor vehicles (except motorcycles and scooters)",
      },
      {
        value: "[29200]Manufacture of motor vehicle bodies (coachwork), trailers and semi-trailers",
        zh: "[29200]Manufacture of motor vehicle bodies (coachwork), trailers and semi-trailers / 汽车车身（驾驶室）、拖车和半拖车的制造",
        en: "[29200]Manufacture of motor vehicle bodies (coachwork), trailers and semi-trailers",
      },
      {
        value: "[29300]Manufacture of parts and accessories for motor vehicles",
        zh: "[29300]Manufacture of parts and accessories for motor vehicles / 汽车零部件及配件制造",
        en: "[29300]Manufacture of parts and accessories for motor vehicles",
      },
      {
        value: "[30110]Building and repairing of ships, tankers, off-shore structures and other ocean-going vessels",
        zh: "[30110]Building and repairing of ships, tankers, off-shore structures and other ocean-going vessels / 船舶、油轮、海上结构和其他远洋船舶的建造与修理",
        en: "[30110]Building and repairing of ships, tankers, off-shore structures and other ocean-going vessels",
      },
      {
        value: "[30120]Building and repair of pleasure crafts, lighters and boats",
        zh: "[30120]Building and repair of pleasure crafts, lighters and boats / 娱乐船只、驳船和小船的建造与修理",
        en: "[30120]Building and repair of pleasure crafts, lighters and boats",
      },
      {
        value: "[30200]Manufacture/repair of railway and tramway locomotives and rolling stock",
        zh: "[30200]Manufacture/repair of railway and tramway locomotives and rolling stock / 铁路和有轨电车机车及车辆的制造/修理",
        en: "[30200]Manufacture/repair of railway and tramway locomotives and rolling stock",
      },
      {
        value: "[30301]Manufacture and assembly of aircraft and spacecraft",
        zh: "[30301]Manufacture and assembly of aircraft and spacecraft / 飞机和航天器的制造与组装",
        en: "[30301]Manufacture and assembly of aircraft and spacecraft",
      },
      {
        value: "[30302]Repair and servicing of aircraft and spacecraft",
        zh: "[30302]Repair and servicing of aircraft and spacecraft / 飞机和航天器的修理与维护",
        en: "[30302]Repair and servicing of aircraft and spacecraft",
      },
      {
        value: "[30400]Manufacture/repair of military fighting vehicles",
        zh: "[30400]Manufacture/repair of military fighting vehicles / 军用战斗车辆的制造/修理",
        en: "[30400]Manufacture/repair of military fighting vehicles",
      },
      {
        value: "[30910]Manufacture and assembly of motorcycles and scooters",
        zh: "[30910]Manufacture and assembly of motorcycles and scooters / 摩托车和轻便摩托车的制造与组装",
        en: "[30910]Manufacture and assembly of motorcycles and scooters",
      },
      {
        value: "[30920]Manufacture and assembly of bicycles, tricycles, trishaws and invalid carriages",
        zh: "[30920]Manufacture and assembly of bicycles, tricycles, trishaws and invalid carriages / 自行车、三轮车、三轮车和残疾人车辆的制造与组装",
        en: "[30920]Manufacture and assembly of bicycles, tricycles, trishaws and invalid carriages",
      },
      {
        value: "[30990]Manufacture/repair of other transport equipment n.e.c.",
        zh: "[30990]Manufacture/repair of other transport equipment n.e.c. / 其他未列明的运输设备的制造/修理",
        en: "[30990]Manufacture/repair of other transport equipment n.e.c.",
      },
      {
        value: "[31001]Manufacture of furniture and fixtures of wood",
        zh: "[31001]Manufacture of furniture and fixtures of wood / 木制家具和固定装置的制造",
        en: "[31001]Manufacture of furniture and fixtures of wood",
      },
      {
        value: "[31002]Manufacture of furniture of rattan and cane",
        zh: "[31002]Manufacture of furniture of rattan and cane / 藤条和竹条家具的制造",
        en: "[31002]Manufacture of furniture of rattan and cane",
      },
      {
        value: "[31003]Manufacture of furniture and fixtures primarily of metal",
        zh: "[31003]Manufacture of furniture and fixtures primarily of metal / 金属家具和固定装置的制造",
        en: "[31003]Manufacture of furniture and fixtures primarily of metal",
      },
      {
        value: "[31004]Manufacture of furniture of other materials (except primarily of stone, ceramic or concrete)",
        zh: "[31004]Manufacture of furniture of other materials (except primarily of stone, ceramic or concrete) / 其他材料（非主要石头、陶瓷或混凝土）的家具制造",
        en: "[31004]Manufacture of furniture of other materials (except primarily of stone, ceramic or concrete)",
      },
      {
        value: "[31005]Manufacture of window and door screens and shades",
        zh: "[31005]Manufacture of window and door screens and shades / 门窗纱窗和遮阳帘的制造",
        en: "[31005]Manufacture of window and door screens and shades",
      },
      {
        value: "[31006]Manufacture of mattresses",
        zh: "[31006]Manufacture of mattresses / 床垫的制造",
        en: "[31006]Manufacture of mattresses",
      },
      {
        value: "[31009]Manufacture of furniture n.e.c.",
        zh: "[31009]Manufacture of furniture n.e.c. / 其他未列明的家具制造",
        en: "[31009]Manufacture of furniture n.e.c.",
      },
      {
        value: "[32111]Manufacture of jewellery (except costume jewellery)",
        zh: "[32111]Manufacture of jewellery (except costume jewellery) / 珠宝制造（除时尚饰品外）",
        en: "[32111]Manufacture of jewellery (except costume jewellery)",
      },
      {
        value: "[32119]Manufacture of jewellery and related articles n.e.c. (except costume jewellery)",
        zh: "[32119]Manufacture of jewellery and related articles n.e.c. (except costume jewellery) / 珠宝及相关饰品制造（除时尚饰品外）",
        en: "[32119]Manufacture of jewellery and related articles n.e.c. (except costume jewellery)",
      },
      {
        value: "[32120]Manufacture of costume jewellery and related articles",
        zh: "[32120]Manufacture of costume jewellery and related articles / 时尚珠宝及配套饰品制造",
        en: "[32120]Manufacture of costume jewellery and related articles",
      },
      {
        value: "[32200]Manufacture of musical instruments",
        zh: "[32200]Manufacture of musical instruments / 乐器制造",
        en: "[32200]Manufacture of musical instruments",
      },
      {
        value: "[32300]Manufacture of sporting and athletic goods",
        zh: "[32300]Manufacture of sporting and athletic goods / 运动及体育用品的制造",
        en: "[32300]Manufacture of sporting and athletic goods",
      },
      {
        value: "[32400]Manufacture of games and toys",
        zh: "[32400]Manufacture of games and toys / 游戏及玩具的制造",
        en: "[32400]Manufacture of games and toys",
      },
      {
        value: "[32501]Manufacture of medical research and clinical diagnostic instruments and supplies",
        zh: "[32501]Manufacture of medical research and clinical diagnostic instruments and supplies / 医学研究和临床诊断仪器及用品的制造",
        en: "[32501]Manufacture of medical research and clinical diagnostic instruments and supplies",
      },
      {
        value: "[32502]Manufacture of medical disposables and surgical supplies",
        zh: "[32502]Manufacture of medical disposables and surgical supplies / 医用一次性产品和外科用品的制造",
        en: "[32502]Manufacture of medical disposables and surgical supplies",
      },
      {
        value: "[32503]Manufacture of implantables and artificial limbs",
        zh: "[32503]Manufacture of implantables and artificial limbs / 植入物和假肢的制造",
        en: "[32503]Manufacture of implantables and artificial limbs",
      },
      {
        value: "[32504]Manufacture of ophthalmic goods",
        zh: "[32504]Manufacture of ophthalmic goods / 眼科用品的制造",
        en: "[32504]Manufacture of ophthalmic goods",
      },
      {
        value: "[32509]Manufacture of medical and dental instruments and supplies n.e.c.",
        zh: "[32509]Manufacture of medical and dental instruments and supplies n.e.c. / 医疗和牙科仪器及用品制造",
        en: "[32509]Manufacture of medical and dental instruments and supplies n.e.c.",
      },
      {
        value: "[32901]Manufacture of signs and advertising displays",
        zh: "[32901]Manufacture of signs and advertising displays / 标志和广告展示制造",
        en: "[32901]Manufacture of signs and advertising displays",
      },
      {
        value: "[32909]Other manufacturing industries n.e.c.",
        zh: "[32909]Other manufacturing industries n.e.c. / 其他未列明的制造业",
        en: "[32909]Other manufacturing industries n.e.c.",
      },
      {
        value: "[35101]Generation of electricity from non-renewable sources",
        zh: "[35101]Generation of electricity from non-renewable sources / 从非可再生能源发电",
        en: "[35101]Generation of electricity from non-renewable sources",
      },
      {
        value: "[35102]Generation of electricity from renewable sources",
        zh: "[35102]Generation of electricity from renewable sources / 从可再生能源发电",
        en: "[35102]Generation of electricity from renewable sources",
      },
      {
        value: "[35103]Transmission, distribution and sale of electricity",
        zh: "[35103]Transmission, distribution and sale of electricity / 电力的传输、分配和销售",
        en: "[35103]Transmission, distribution and sale of electricity",
      },
      {
        value: "[35200]Manufacture of gas; distribution of gaseous fuels through mains; processing of natural gas",
        zh: "[35200]Manufacture of gas; distribution of gaseous fuels through mains; processing of natural gas / 气体的制造；通过管道分配气体燃料；天然气处理",
        en: "[35200]Manufacture of gas; distribution of gaseous fuels through mains; processing of natural gas",
      },
      {
        value: "[35300]Supply of air or water for cooling or heating purposes",
        zh: "[35300]Supply of air or water for cooling or heating purposes / 供应用于冷却或加热目的的空气或水",
        en: "[35300]Supply of air or water for cooling or heating purposes",
      },
      {
        value: "[35400]Activities of brokers and agents for electric power and natural gas",
        zh: "[35400]Activities of brokers and agents for electric power and natural gas / 电力和天然气经纪及代理活动",
        en: "[35400]Activities of brokers and agents for electric power and natural gas",
      },
      {
        value: "[36000]Collection, purification and distribution of water",
        zh: "[36000]Collection, purification and distribution of water / 收集、净化和分配水",
        en: "[36000]Collection, purification and distribution of water",
      },
      {
        value: "[37000]Operation of sewer systems",
        zh: "[37000]Operation of sewer systems / 运营污水系统",
        en: "[37000]Operation of sewer systems",
      },
      {
        value: "[38100]Collection of waste",
        zh: "[38100]Collection of waste / 收集废物",
        en: "[38100]Collection of waste",
      },
      {
        value: "[38200]Treatment and disposal of waste",
        zh: "[38200]Treatment and disposal of waste / 废物的处理和处置",
        en: "[38200]Treatment and disposal of waste",
      },
      {
        value: "[38301]Recycling of metal waste and scrap",
        zh: "[38301]Recycling of metal waste and scrap / 金属废物和废料的回收",
        en: "[38301]Recycling of metal waste and scrap",
      },
      {
        value: "[38309]Recycling of non-metal waste n.e.c.",
        zh: "[38309]Recycling of non-metal waste n.e.c. / 非金属废物的回收",
        en: "[38309]Recycling of non-metal waste n.e.c.",
      },
      {
        value: "[39000]Carbon capture activities",
        zh: "[39000]Carbon capture activities / 碳捕获活动",
        en: "[39000]Carbon capture activities",
      },
      {
        value: "[41001]General contractors for building construction and major upgrading works",
        zh: "[41001]General contractors for building construction and major upgrading works / 建筑物建设及重大升级工程的总承包商",
        en: "[41001]General contractors for building construction and major upgrading works",
      },
      {
        value: "[41002]Structural repair contractors",
        zh: "[41002]Structural repair contractors / 结构修复承包商",
        en: "[41002]Structural repair contractors",
      },
      {
        value: "[41009]Construction of buildings n.e.c.",
        zh: "[41009]Construction of buildings n.e.c. / 其他建筑建设",
        en: "[41009]Construction of buildings n.e.c.",
      },
      {
        value: "[42100]Civil engineering general contractors",
        zh: "[42100]Civil engineering general contractors / 土木工程总承包商",
        en: "[42100]Civil engineering general contractors",
      },
      {
        value: "[42200]Road, railway and associated viaduct, bridge and tunnel construction",
        zh: "[42200]Road, railway and associated viaduct, bridge and tunnel construction / 道路、铁路及相关高架桥、桥梁和隧道建设",
        en: "[42200]Road, railway and associated viaduct, bridge and tunnel construction",
      },
      {
        value: "[42301]Water and gas pipe-line and sewer construction",
        zh: "[42301]Water and gas pipe-line and sewer construction / 水和煤气管道及下水道建造",
        en: "[42301]Water and gas pipe-line and sewer construction",
      },
      {
        value: "[42302]Communications and power line construction",
        zh: "[42302]Communications and power line construction / 通信和电力线路建设",
        en: "[42302]Communications and power line construction",
      },
      {
        value: "[42901]Land reclamation works",
        zh: "[42901]Land reclamation works / 土地复垦工程",
        en: "[42901]Land reclamation works",
      },
      {
        value: "[42902]Dam and drainage construction",
        zh: "[42902]Dam and drainage construction / 大坝和排水系统建设",
        en: "[42902]Dam and drainage construction",
      },
      {
        value: "[42903]Marine construction",
        zh: "[42903]Marine construction / 海上建设",
        en: "[42903]Marine construction",
      },
      {
        value: "[42909]Construction of other civil engineering projects n.e.c.",
        zh: "[42909]Construction of other civil engineering projects n.e.c. / 其他土木工程项目建造（不包括在其他类别中）",
        en: "[42909]Construction of other civil engineering projects n.e.c.",
      },
      {
        value: "[43110]Wrecking and demolition works",
        zh: "[43110]Wrecking and demolition works / 破坏和拆除工作",
        en: "[43110]Wrecking and demolition works",
      },
      {
        value: "[43121]Soil investigation, treatment and stabilisation",
        zh: "[43121]Soil investigation, treatment and stabilisation / 土壤调查、处理和稳定化",
        en: "[43121]Soil investigation, treatment and stabilisation",
      },
      {
        value: "[43122]Excavation and earthmoving works",
        zh: "[43122]Excavation and earthmoving works / 挖掘和土方工程",
        en: "[43122]Excavation and earthmoving works",
      },
      {
        value: "[43129]Site preparation n.e.c.",
        zh: "[43129]Site preparation n.e.c. / 场地准备等其他",
        en: "[43129]Site preparation n.e.c.",
      },
      {
        value: "[43210]Electrical works",
        zh: "[43210]Electrical works / 电气工程",
        en: "[43210]Electrical works",
      },
      {
        value: "[43220]Installation of plumbing, heating (non-electric) and air-conditioning systems",
        zh: "[43220]Installation of plumbing, heating (non-electric) and air-conditioning systems / 管道、非电热设备和空调系统的安装",
        en: "[43220]Installation of plumbing, heating (non-electric) and air-conditioning systems",
      },
      {
        value: "[43291]Installation and erection of building equipment",
        zh: "[43291]Installation and erection of building equipment / 建筑物设备的安装和架设",
        en: "[43291]Installation and erection of building equipment",
      },
      {
        value: "[43292]Installation of building automated systems for remote monitoring",
        zh: "[43292]Installation of building automated systems for remote monitoring / 远程监控建筑自动化系统的安装",
        en: "[43292]Installation of building automated systems for remote monitoring",
      },
      {
        value: "[43293]Installation of awning and window shades",
        zh: "[43293]Installation of awning and window shades / 遮阳篷和窗遮阳的安装",
        en: "[43293]Installation of awning and window shades",
      },
      {
        value: "[43294]Installation of thermal and sound insulation",
        zh: "[43294]Installation of thermal and sound insulation / 热绝缘和隔音安装",
        en: "[43294]Installation of thermal and sound insulation",
      },
      {
        value: "[43295]Signcraft installation",
        zh: "[43295]Signcraft installation / 招牌安装",
        en: "[43295]Signcraft installation",
      },
      {
        value: "[43299]Other construction installation n.e.c.",
        zh: "[43299]Other construction installation n.e.c. / 其他建筑安装",
        en: "[43299]Other construction installation n.e.c.",
      },
      {
        value: "[43301]Renovation contractors",
        zh: "[43301]Renovation contractors / 装修承包商",
        en: "[43301]Renovation contractors",
      },
      {
        value: "[43302]Tile setting and plastering",
        zh: "[43302]Tile setting and plastering / 瓷砖铺设和抹灰",
        en: "[43302]Tile setting and plastering",
      },
      {
        value: "[43303]Joinery and other woodworks",
        zh: "[43303]Joinery and other woodworks / 细木工和其他木工",
        en: "[43303]Joinery and other woodworks",
      },
      {
        value: "[43304]Painting and decorating",
        zh: "[43304]Painting and decorating / 油漆和装饰",
        en: "[43304]Painting and decorating",
      },
      {
        value: "[43305]Glass and glazing works; mirror and shower screen installation",
        zh: "[43305]Glass and glazing works; mirror and shower screen installation / 玻璃及玻璃安装; 镜子和淋浴屏安装",
        en: "[43305]Glass and glazing works; mirror and shower screen installation",
      },
      {
        value: "[43306]Curtain walling/cladding works",
        zh: "[43306]Curtain walling/cladding works / 幕墙/覆层工作",
        en: "[43306]Curtain walling/cladding works",
      },
      {
        value: "[43307]Installation of doors, gates, grilles and windows",
        zh: "[43307]Installation of doors, gates, grilles and windows / 门、门、格栅和窗户的安装",
        en: "[43307]Installation of doors, gates, grilles and windows",
      },
      {
        value: "[43309]Building completion and finishing n.e.c.",
        zh: "[43309]Building completion and finishing n.e.c. / 建筑竣工和收尾（其他）",
        en: "[43309]Building completion and finishing n.e.c.",
      },
      {
        value: "[43901]Foundation works; micropiling, conventional piling and underpinning",
        zh: "[43901]Foundation works; micropiling, conventional piling and underpinning / 基础工程；微型桩、常规桩和基础加固",
        en: "[43901]Foundation works; micropiling, conventional piling and underpinning",
      },
      {
        value: "[43902]Brick laying, stone setting and cement works",
        zh: "[43902]Brick laying, stone setting and cement works / 砌砖、石料铺设和水泥工程",
        en: "[43902]Brick laying, stone setting and cement works",
      },
      {
        value: "[43903]Roofing works; timber carcassing",
        zh: "[43903]Roofing works; timber carcassing / 屋顶工程；木材框架建造",
        en: "[43903]Roofing works; timber carcassing",
      },
      {
        value: "[43904]Production of pre-cast components",
        zh: "[43904]Production of pre-cast components / 预制组件的生产",
        en: "[43904]Production of pre-cast components",
      },
      {
        value: "[43905]Scaffolding works",
        zh: "[43905]Scaffolding works / 脚手架工程",
        en: "[43905]Scaffolding works",
      },
      {
        value: "[43906]Sandblasting/shotblasting works (except ships)",
        zh: "[43906]Sandblasting/shotblasting works (except ships) / 砂/喷砂作业（不包括船舶）",
        en: "[43906]Sandblasting/shotblasting works (except ships)",
      },
      {
        value: "[43907]Production of Prefabricated Prefinished Volumetric Construction (PPVC) modules",
        zh: "[43907]Production of Prefabricated Prefinished Volumetric Construction (PPVC) modules / 预制成品体积建筑（PPVC）模块的生产",
        en: "[43907]Production of Prefabricated Prefinished Volumetric Construction (PPVC) modules",
      },
      {
        value: "[43909]Other specialised construction activities n.e.c.",
        zh: "[43909]Other specialised construction activities n.e.c. / 其他未特指的专门建筑活动",
        en: "[43909]Other specialised construction activities n.e.c.",
      },
      {
        value: "[46100]Wholesale on a fee or commission basis",
        zh: "[46100]Wholesale on a fee or commission basis / 按费用或佣金基础的批发",
        en: "[46100]Wholesale on a fee or commission basis",
      },
      {
        value: "[46211]Wholesale of cut flowers and plants",
        zh: "[46211]Wholesale of cut flowers and plants / 鲜切花和植物的批发",
        en: "[46211]Wholesale of cut flowers and plants",
      },
      {
        value: "[46212]Wholesale of aquarium fishes and related accessories/products",
        zh: "[46212]Wholesale of aquarium fishes and related accessories/products / 水族鱼及相关配件/产品的批发",
        en: "[46212]Wholesale of aquarium fishes and related accessories/products",
      },
      {
        value: "[46213]Wholesale of pet birds and animals and related accessories/products",
        zh: "[46213]Wholesale of pet birds and animals and related accessories/products / 宠物鸟和动物及相关配件/产品的批发",
        en: "[46213]Wholesale of pet birds and animals and related accessories/products",
      },
      {
        value: "[46219]Wholesale of agricultural raw materials and live animals n.e.c. (except tropical produce)",
        zh: "[46219]Wholesale of agricultural raw materials and live animals n.e.c. (except tropical produce) / 农产品和活体动物（除热带产品外）的批发",
        en: "[46219]Wholesale of agricultural raw materials and live animals n.e.c. (except tropical produce)",
      },
      {
        value: "[46221]Wholesale of rubber",
        zh: "[46221]Wholesale of rubber / 橡胶的批发",
        en: "[46221]Wholesale of rubber",
      },
      {
        value: "[46222]Wholesale of pepper and other spices",
        zh: "[46222]Wholesale of pepper and other spices / 胡椒和其他香料的批发",
        en: "[46222]Wholesale of pepper and other spices",
      },
      {
        value: "[46223]Wholesale of coffee, cocoa and tea",
        zh: "[46223]Wholesale of coffee, cocoa and tea / 咖啡、可可和茶叶批发",
        en: "[46223]Wholesale of coffee, cocoa and tea",
      },
      {
        value: "[46224]Wholesale of coconut",
        zh: "[46224]Wholesale of coconut / 椰子批发",
        en: "[46224]Wholesale of coconut",
      },
      {
        value: "[46225]Wholesale of palm oil",
        zh: "[46225]Wholesale of palm oil / 棕榈油批发",
        en: "[46225]Wholesale of palm oil",
      },
      {
        value: "[46229]Wholesale of tropical produce n.e.c.",
        zh: "[46229]Wholesale of tropical produce n.e.c. / 热带产品批发",
        en: "[46229]Wholesale of tropical produce n.e.c.",
      },
      {
        value: "[46301]Wholesale of fruits and vegetables",
        zh: "[46301]Wholesale of fruits and vegetables / 水果和蔬菜批发",
        en: "[46301]Wholesale of fruits and vegetables",
      },
      {
        value: "[46302]Wholesale of livestock, meat, poultry, eggs and seafood",
        zh: "[46302]Wholesale of livestock, meat, poultry, eggs and seafood / 牲畜、肉类、家禽、蛋和海鲜批发",
        en: "[46302]Wholesale of livestock, meat, poultry, eggs and seafood",
      },
      {
        value: "[46303]Wholesale of a general line of groceries",
        zh: "[46303]Wholesale of a general line of groceries / 杂货批发",
        en: "[46303]Wholesale of a general line of groceries",
      },
      {
        value: "[46304]Wholesale of confectionery and bakery products",
        zh: "[46304]Wholesale of confectionery and bakery products / 糖果和烘焙产品批发",
        en: "[46304]Wholesale of confectionery and bakery products",
      },
      {
        value: "[46305]Wholesale of ice-cream",
        zh: "[46305]Wholesale of ice-cream / 冰淇淋批发",
        en: "[46305]Wholesale of ice-cream",
      },
      {
        value: "[46306]Wholesale of health supplements",
        zh: "[46306]Wholesale of health supplements / 健康补充品批发",
        en: "[46306]Wholesale of health supplements",
      },
      {
        value: "[46307]Wholesale of liquor, soft drinks and beverages",
        zh: "[46307]Wholesale of liquor, soft drinks and beverages / 酒类、软饮料及饮品批发",
        en: "[46307]Wholesale of liquor, soft drinks and beverages",
      },
      {
        value: "[46308]Wholesale of tobacco products",
        zh: "[46308]Wholesale of tobacco products / 烟草制品批发",
        en: "[46308]Wholesale of tobacco products",
      },
      {
        value: "[46309]Wholesale of food, beverages and tobacco n.e.c.",
        zh: "[46309]Wholesale of food, beverages and tobacco n.e.c. / 食品、饮料及烟草制品（其他）批发",
        en: "[46309]Wholesale of food, beverages and tobacco n.e.c.",
      },
      {
        value: "[46411]Wholesale of textiles and leathers",
        zh: "[46411]Wholesale of textiles and leathers / 纺织品及皮革批发",
        en: "[46411]Wholesale of textiles and leathers",
      },
      {
        value: "[46412]Wholesale of adults' clothing",
        zh: "[46412]Wholesale of adults' clothing / 成人服装批发",
        en: "[46412]Wholesale of adults' clothing",
      },
      {
        value: "[46413]Wholesale of children and infants' clothing",
        zh: "[46413]Wholesale of children and infants' clothing / 儿童及婴儿服装批发",
        en: "[46413]Wholesale of children and infants' clothing",
      },
      {
        value: "[46414]Wholesale of footwear",
        zh: "[46414]Wholesale of footwear / 鞋类批发",
        en: "[46414]Wholesale of footwear",
      },
      {
        value: "[46415]Wholesale of bags, luggage and travel accessories",
        zh: "[46415]Wholesale of bags, luggage and travel accessories / 箱包、行李和旅行配件批发",
        en: "[46415]Wholesale of bags, luggage and travel accessories",
      },
      {
        value: "[46416]Wholesale of sewing and clothing accessories",
        zh: "[46416]Wholesale of sewing and clothing accessories / 缝纫和服装配件批发",
        en: "[46416]Wholesale of sewing and clothing accessories",
      },
      {
        value: "[46421]Wholesale of jewellery made from precious metals and stones",
        zh: "[46421]Wholesale of jewellery made from precious metals and stones / 贵金属和宝石首饰批发",
        en: "[46421]Wholesale of jewellery made from precious metals and stones",
      },
      {
        value: "[46422]Wholesale of costume jewellery",
        zh: "[46422]Wholesale of costume jewellery / 时尚饰品批发",
        en: "[46422]Wholesale of costume jewellery",
      },
      {
        value: "[46423]Wholesale of watches and clocks",
        zh: "[46423]Wholesale of watches and clocks / 手表和钟表批发",
        en: "[46423]Wholesale of watches and clocks",
      },
      {
        value: "[46424]Wholesale of personal care products",
        zh: "[46424]Wholesale of personal care products / 个人护理产品批发",
        en: "[46424]Wholesale of personal care products",
      },
      {
        value: "[46429]Wholesale of personal effects n.e.c.",
        zh: "[46429]Wholesale of personal effects n.e.c. / 个人效果品其他批发",
        en: "[46429]Wholesale of personal effects n.e.c.",
      },
      {
        value: "[46431]Wholesale of furniture",
        zh: "[46431]Wholesale of furniture / 家具批发",
        en: "[46431]Wholesale of furniture",
      },
      {
        value: "[46432]Wholesale of furnishings",
        zh: "[46432]Wholesale of furnishings / 家居装饰品批发",
        en: "[46432]Wholesale of furnishings",
      },
      {
        value: "[46433]Wholesale of lighting and lighting accessories",
        zh: "[46433]Wholesale of lighting and lighting accessories / 照明及照明配件批发",
        en: "[46433]Wholesale of lighting and lighting accessories",
      },
      {
        value: "[46434]Wholesale of crockery, cutlery and kitchen utensils",
        zh: "[46434]Wholesale of crockery, cutlery and kitchen utensils / 餐具、刀具和厨房用具批发",
        en: "[46434]Wholesale of crockery, cutlery and kitchen utensils",
      },
      {
        value: "[46435]Wholesale of household electrical appliances and equipment",
        zh: "[46435]Wholesale of household electrical appliances and equipment / 家用电器及设备批发",
        en: "[46435]Wholesale of household electrical appliances and equipment",
      },
      {
        value: "[46436]Wholesale of audio and video equipment (except electrical and electronic components)",
        zh: "[46436]Wholesale of audio and video equipment (except electrical and electronic components) / 音频和视频设备批发（不包括电气和电子组件）",
        en: "[46436]Wholesale of audio and video equipment (except electrical and electronic components)",
      },
      {
        value: "[46439]Wholesale of furniture, home furnishings and other household equipment n.e.c.",
        zh: "[46439]Wholesale of furniture, home furnishings and other household equipment n.e.c. / 家具、家居装饰品及其他家用设备批发",
        en: "[46439]Wholesale of furniture, home furnishings and other household equipment n.e.c.",
      },
      {
        value: "[46441]Wholesale of sporting goods and equipment",
        zh: "[46441]Wholesale of sporting goods and equipment / 运动用品和设备批发",
        en: "[46441]Wholesale of sporting goods and equipment",
      },
      {
        value: "[46442]Wholesale of music and video recordings",
        zh: "[46442]Wholesale of music and video recordings / 音乐和视频录音批发",
        en: "[46442]Wholesale of music and video recordings",
      },
      {
        value: "[46443]Wholesale of toys and games",
        zh: "[46443]Wholesale of toys and games / 玩具和游戏批发",
        en: "[46443]Wholesale of toys and games",
      },
      {
        value: "[46444]Wholesale of computer games",
        zh: "[46444]Wholesale of computer games / 电脑游戏批发",
        en: "[46444]Wholesale of computer games",
      },
      {
        value: "[46445]Wholesale of musical instruments and scores",
        zh: "[46445]Wholesale of musical instruments and scores / 乐器和乐谱批发",
        en: "[46445]Wholesale of musical instruments and scores",
      },
      {
        value: "[46449]Wholesale of sporting and other recreational goods n.e.c.",
        zh: "[46449]Wholesale of sporting and other recreational goods n.e.c. / 体育用品和其他娱乐用品批发",
        en: "[46449]Wholesale of sporting and other recreational goods n.e.c.",
      },
      {
        value: "[46451]Wholesale of antiques and works of art",
        zh: "[46451]Wholesale of antiques and works of art / 古董和艺术品批发",
        en: "[46451]Wholesale of antiques and works of art",
      },
      {
        value: "[46452]Wholesale of handicrafts and gifts",
        zh: "[46452]Wholesale of handicrafts and gifts / 手工艺品和礼品批发",
        en: "[46452]Wholesale of handicrafts and gifts",
      },
      {
        value: "[46453]Wholesale of artificial flowers and plants",
        zh: "[46453]Wholesale of artificial flowers and plants / 人造花卉和植物批发",
        en: "[46453]Wholesale of artificial flowers and plants",
      },
      {
        value: "[46459]Wholesale of handicrafts and fancy goods n.e.c.",
        zh: "[46459]Wholesale of handicrafts and fancy goods n.e.c. / 手工艺品和装饰品批发（其他）",
        en: "[46459]Wholesale of handicrafts and fancy goods n.e.c.",
      },
      {
        value: "[46461]Wholesale of medicinal and pharmaceutical products (Western)",
        zh: "[46461]Wholesale of medicinal and pharmaceutical products (Western) / 西药批发",
        en: "[46461]Wholesale of medicinal and pharmaceutical products (Western)",
      },
      {
        value: "[46462]Wholesale of medicine and herbs (except Western)",
        zh: "[46462]Wholesale of medicine and herbs (except Western) / 药材和草药批发（除西药外）",
        en: "[46462]Wholesale of medicine and herbs (except Western)",
      },
      {
        value: "[46471]Wholesale of paper and paper products",
        zh: "[46471]Wholesale of paper and paper products / 纸张和纸制品批发",
        en: "[46471]Wholesale of paper and paper products",
      },
      {
        value: "[46472]Wholesale of packaging materials",
        zh: "[46472]Wholesale of packaging materials / 包装材料批发",
        en: "[46472]Wholesale of packaging materials",
      },
      {
        value: "[46473]Wholesale of stationery",
        zh: "[46473]Wholesale of stationery / 文具批发",
        en: "[46473]Wholesale of stationery",
      },
      {
        value: "[46474]Wholesale of books and magazines",
        zh: "[46474]Wholesale of books and magazines / 书籍和杂志批发",
        en: "[46474]Wholesale of books and magazines",
      },
      {
        value: "[46479]Wholesale of paper, paper-related products, stationery, cellophane products and packaging materials n.e.c.",
        zh: "[46479]Wholesale of paper, paper-related products, stationery, cellophane products and packaging materials n.e.c. / 纸张、纸制品、文具、玻璃纸产品及包装材料批发（不包括其他）",
        en: "[46479]Wholesale of paper, paper-related products, stationery, cellophane products and packaging materials n.e.c.",
      },
      {
        value: "[46491]Wholesale of optical equipment and supplies (except binoculars)",
        zh: "[46491]Wholesale of optical equipment and supplies (except binoculars) / 光学设备及用品批发（除双筒望远镜外）",
        en: "[46491]Wholesale of optical equipment and supplies (except binoculars)",
      },
      {
        value: "[46492]Wholesale of photographic equipment and supplies",
        zh: "[46492]Wholesale of photographic equipment and supplies / 批发摄影设备及用品",
        en: "[46492]Wholesale of photographic equipment and supplies",
      },
      {
        value: "[46499]Wholesale of other household goods n.e.c.",
        zh: "[46499]Wholesale of other household goods n.e.c. / 批发其他杂项家用商品",
        en: "[46499]Wholesale of other household goods n.e.c.",
      },
      {
        value: "[46511]Wholesale of computer hardware and peripheral equipment (except cybersecurity related hardware and peripheral equipment)",
        zh: "[46511]Wholesale of computer hardware and peripheral equipment (except cybersecurity related hardware and peripheral equipment) / 批发计算机硬件及外围设备（不包括网络安全相关硬件及外围设备）",
        en: "[46511]Wholesale of computer hardware and peripheral equipment (except cybersecurity related hardware and peripheral equipment)",
      },
      {
        value: "[46512]Wholesale of computer software (except games and cybersecurity software)",
        zh: "[46512]Wholesale of computer software (except games and cybersecurity software) / 批发计算机软件（不包括游戏和网络安全软件）",
        en: "[46512]Wholesale of computer software (except games and cybersecurity software)",
      },
      {
        value: "[46513]Wholesale of computer accessories",
        zh: "[46513]Wholesale of computer accessories / 批发计算机配件",
        en: "[46513]Wholesale of computer accessories",
      },
      {
        value: "[46514]Wholesale of cybersecurity software, hardware and peripheral equipment",
        zh: "[46514]Wholesale of cybersecurity software, hardware and peripheral equipment / 批发网络安全软件、硬件及外围设备",
        en: "[46514]Wholesale of cybersecurity software, hardware and peripheral equipment",
      },
      {
        value: "[46521]Wholesale of telecommunications equipment (except handphones)",
        zh: "[46521]Wholesale of telecommunications equipment (except handphones) / 批发电信设备（不包括手机）",
        en: "[46521]Wholesale of telecommunications equipment (except handphones)",
      },
      {
        value: "[46522]Wholesale of electronic components",
        zh: "[46522]Wholesale of electronic components / 批发电子元件",
        en: "[46522]Wholesale of electronic components",
      },
      {
        value: "[46523]Wholesale of handphones and related telecommunications and peripheral equipment",
        zh: "[46523]Wholesale of handphones and related telecommunications and peripheral equipment / 批发手机及相关电信和外围设备",
        en: "[46523]Wholesale of handphones and related telecommunications and peripheral equipment",
      },
      {
        value: "[46530]Wholesale of agricultural machinery, equipment and supplies",
        zh: "[46530]Wholesale of agricultural machinery, equipment and supplies / 批发农业机械、设备和供应品",
        en: "[46530]Wholesale of agricultural machinery, equipment and supplies",
      },
      {
        value: "[46541]Wholesale of industrial machinery and equipment",
        zh: "[46541]Wholesale of industrial machinery and equipment / 批发工业机械和设备",
        en: "[46541]Wholesale of industrial machinery and equipment",
      },
      {
        value: "[46542]Wholesale of construction equipment",
        zh: "[46542]Wholesale of construction equipment / 批发建筑设备",
        en: "[46542]Wholesale of construction equipment",
      },
      {
        value: "[46543]Wholesale of lifts, escalators and industrial and office air-conditioning equipment",
        zh: "[46543]Wholesale of lifts, escalators and industrial and office air-conditioning equipment / 批发电梯、自动扶梯及工业和办公空调设备",
        en: "[46543]Wholesale of lifts, escalators and industrial and office air-conditioning equipment",
      },
      {
        value: "[46544]Wholesale of electrical and wiring accessories",
        zh: "[46544]Wholesale of electrical and wiring accessories / 批发电气和布线配件",
        en: "[46544]Wholesale of electrical and wiring accessories",
      },
      {
        value: "[46549]Wholesale of industrial, construction and related machinery and equipment n.e.c.",
        zh: "[46549]Wholesale of industrial, construction and related machinery and equipment n.e.c. / 批发工业、建筑及相关机械和设备（其他）",
        en: "[46549]Wholesale of industrial, construction and related machinery and equipment n.e.c.",
      },
      {
        value: "[46551]Wholesale of marine equipment and accessories",
        zh: "[46551]Wholesale of marine equipment and accessories / 船舶设备及配件批发",
        en: "[46551]Wholesale of marine equipment and accessories",
      },
      {
        value: "[46552]Wholesale of aircraft equipment and supplies",
        zh: "[46552]Wholesale of aircraft equipment and supplies / 航空设备及供应品批发",
        en: "[46552]Wholesale of aircraft equipment and supplies",
      },
      {
        value: "[46559]Wholesale of transport equipment n.e.c. (except motor vehicles and motorcycles)",
        zh: "[46559]Wholesale of transport equipment n.e.c. (except motor vehicles and motorcycles) / 运输设备批发（不包括机动车和摩托车）",
        en: "[46559]Wholesale of transport equipment n.e.c. (except motor vehicles and motorcycles)",
      },
      {
        value: "[46561]Wholesale of motor vehicles (except motorcycles and scooters)",
        zh: "[46561]Wholesale of motor vehicles (except motorcycles and scooters) / 机动车批发（不包括摩托车和轻便摩托车）",
        en: "[46561]Wholesale of motor vehicles (except motorcycles and scooters)",
      },
      {
        value: "[46562]Wholesale of motorcycles and scooters",
        zh: "[46562]Wholesale of motorcycles and scooters / 摩托车和轻便摩托车批发",
        en: "[46562]Wholesale of motorcycles and scooters",
      },
      {
        value: "[46563]Wholesale of parts and accessories for motor vehicles",
        zh: "[46563]Wholesale of parts and accessories for motor vehicles / 机动车零件和配件批发",
        en: "[46563]Wholesale of parts and accessories for motor vehicles",
      },
      {
        value: "[46591]Wholesale of office machines and equipment",
        zh: "[46591]Wholesale of office machines and equipment / 办公机器和设备批发",
        en: "[46591]Wholesale of office machines and equipment",
      },
      {
        value: "[46592]Wholesale of medical, professional, scientific and precision equipment",
        zh: "[46592]Wholesale of medical, professional, scientific and precision equipment / 医疗、专业、科学和精密设备批发",
        en: "[46592]Wholesale of medical, professional, scientific and precision equipment",
      },
      {
        value: "[46593]Wholesale of commercial food service equipment",
        zh: "[46593]Wholesale of commercial food service equipment / 商业食品服务设备批发",
        en: "[46593]Wholesale of commercial food service equipment",
      },
      {
        value: "[46594]Wholesale of service establishment equipment and supplies",
        zh: "[46594]Wholesale of service establishment equipment and supplies / 服务设施设备及用品批发",
        en: "[46594]Wholesale of service establishment equipment and supplies",
      },
      {
        value: "[46595]Wholesale of security and safety equipment",
        zh: "[46595]Wholesale of security and safety equipment / 安全与保护设备批发",
        en: "[46595]Wholesale of security and safety equipment",
      },
      {
        value: "[46599]Wholesale of other machinery and equipment n.e.c.",
        zh: "[46599]Wholesale of other machinery and equipment n.e.c. / 其他机械和设备（不包括一般硬件）批发",
        en: "[46599]Wholesale of other machinery and equipment n.e.c.",
      },
      {
        value: "[46610]Wholesale of fuels and related products",
        zh: "[46610]Wholesale of fuels and related products / 燃料及相关产品批发",
        en: "[46610]Wholesale of fuels and related products",
      },
      {
        value: "[46620]Wholesale of metals and metal ores (except general hardware)",
        zh: "[46620]Wholesale of metals and metal ores (except general hardware) / 金属和金属矿石（除一般五金外）批发",
        en: "[46620]Wholesale of metals and metal ores (except general hardware)",
      },
      {
        value: "[46631]Wholesale of logs, sawn timber, plywood and related products",
        zh: "[46631]Wholesale of logs, sawn timber, plywood and related products / 木材、锯材、胶合板及相关产品的批发",
        en: "[46631]Wholesale of logs, sawn timber, plywood and related products",
      },
      {
        value: "[46632]Wholesale of general hardware",
        zh: "[46632]Wholesale of general hardware / 五金工具的批发",
        en: "[46632]Wholesale of general hardware",
      },
      {
        value: "[46633]Wholesale of structural clay and concrete products",
        zh: "[46633]Wholesale of structural clay and concrete products / 结构用陶土和混凝土产品的批发",
        en: "[46633]Wholesale of structural clay and concrete products",
      },
      {
        value: "[46634]Wholesale of paints",
        zh: "[46634]Wholesale of paints / 油漆的批发",
        en: "[46634]Wholesale of paints",
      },
      {
        value: "[46635]Wholesale of glass",
        zh: "[46635]Wholesale of glass / 玻璃的批发",
        en: "[46635]Wholesale of glass",
      },
      {
        value: "[46639]Wholesale of construction materials, hardware, plumbing and heating equipment and supplies n.e.c.",
        zh: "[46639]Wholesale of construction materials, hardware, plumbing and heating equipment and supplies n.e.c. / 建筑材料、五金、管道和供暖设备及供应品的批发",
        en: "[46639]Wholesale of construction materials, hardware, plumbing and heating equipment and supplies n.e.c.",
      },
      {
        value: "[46641]Wholesale of basic industrial chemicals (except fertilisers)",
        zh: "[46641]Wholesale of basic industrial chemicals (except fertilisers) / 基础工业化学品（肥料除外）的批发",
        en: "[46641]Wholesale of basic industrial chemicals (except fertilisers)",
      },
      {
        value: "[46642]Wholesale of chemical fertilisers",
        zh: "[46642]Wholesale of chemical fertilisers / 化学肥料的批发",
        en: "[46642]Wholesale of chemical fertilisers",
      },
      {
        value: "[46643]Wholesale of petrochemical products",
        zh: "[46643]Wholesale of petrochemical products / 石化产品批发",
        en: "[46643]Wholesale of petrochemical products",
      },
      {
        value: "[46649]Wholesale of chemicals and chemical products n.e.c.",
        zh: "[46649]Wholesale of chemicals and chemical products n.e.c. / 化学品及化学制品批发（不包括其他）",
        en: "[46649]Wholesale of chemicals and chemical products n.e.c.",
      },
      {
        value: "[46651]Wholesale of scrap, junk and waste dealers",
        zh: "[46651]Wholesale of scrap, junk and waste dealers / 废料、废品和废品经销商批发",
        en: "[46651]Wholesale of scrap, junk and waste dealers",
      },
      {
        value: "[46659]Wholesale of other intermediate products, waste and scrap n.e.c.",
        zh: "[46659]Wholesale of other intermediate products, waste and scrap n.e.c. / 其他中间产品、废料和废品批发（不包括其他）",
        en: "[46659]Wholesale of other intermediate products, waste and scrap n.e.c.",
      },
      {
        value: "[46661]Ship chandlers",
        zh: "[46661]Ship chandlers / 船舶供应",
        en: "[46661]Ship chandlers",
      },
      {
        value: "[46662]Ship bunkering",
        zh: "[46662]Ship bunkering / 船舶加油",
        en: "[46662]Ship bunkering",
      },
      {
        value: "[46900]Wholesale trade of a variety of goods without a dominant product",
        zh: "[46900]Wholesale trade of a variety of goods without a dominant product / 无主导产品的各种商品批发",
        en: "[46900]Wholesale trade of a variety of goods without a dominant product",
      },
      {
        value: "[47101]Supermarkets and hypermarkets",
        zh: "[47101]Supermarkets and hypermarkets / 超级市场和大型超市",
        en: "[47101]Supermarkets and hypermarkets",
      },
      {
        value: "[47102]Mini-marts, convenience stores and provision shops",
        zh: "[47102]Mini-marts, convenience stores and provision shops / 便利店、方便店及杂货店",
        en: "[47102]Mini-marts, convenience stores and provision shops",
      },
      {
        value: "[47103]Department stores",
        zh: "[47103]Department stores / 百货商店",
        en: "[47103]Department stores",
      },
      {
        value: "[47109]Retail sale in non-specialised stores n.e.c.",
        zh: "[47109]Retail sale in non-specialised stores n.e.c. / 非专门店零售 n.e.c.",
        en: "[47109]Retail sale in non-specialised stores n.e.c.",
      },
      {
        value: "[47211]Retail sale of fruits and vegetables",
        zh: "[47211]Retail sale of fruits and vegetables / 水果和蔬菜零售",
        en: "[47211]Retail sale of fruits and vegetables",
      },
      {
        value: "[47212]Retail sale of meat, poultry, eggs and seafood",
        zh: "[47212]Retail sale of meat, poultry, eggs and seafood / 肉类、家禽、蛋和海鲜零售",
        en: "[47212]Retail sale of meat, poultry, eggs and seafood",
      },
      {
        value: "[47213]Retail sale of confectionery and bakery products (not manufactured on site)",
        zh: "[47213]Retail sale of confectionery and bakery products (not manufactured on site) / 糖果和烘焙产品零售（非现场制作）",
        en: "[47213]Retail sale of confectionery and bakery products (not manufactured on site)",
      },
      {
        value: "[47214]Retail sale of health supplements",
        zh: "[47214]Retail sale of health supplements / 健康补充品零售",
        en: "[47214]Retail sale of health supplements",
      },
      {
        value: "[47219]Retail sale of food n.e.c.",
        zh: "[47219]Retail sale of food n.e.c. / 食品零售",
        en: "[47219]Retail sale of food n.e.c.",
      },
      {
        value: "[47220]Retail sale of beverages",
        zh: "[47220]Retail sale of beverages / 饮料零售",
        en: "[47220]Retail sale of beverages",
      },
      {
        value: "[47230]Retail sale of tobacco products",
        zh: "[47230]Retail sale of tobacco products / 烟草产品零售",
        en: "[47230]Retail sale of tobacco products",
      },
      {
        value: "[47311]Retail sale of motor vehicles (except motorcycles and scooters)",
        zh: "[47311]Retail sale of motor vehicles (except motorcycles and scooters) / 机动车（不包括摩托车和轻便摩托车）的零售",
        en: "[47311]Retail sale of motor vehicles (except motorcycles and scooters)",
      },
      {
        value: "[47312]Retail sale of motorcycles and scooters",
        zh: "[47312]Retail sale of motorcycles and scooters / 摩托车和轻便摩托车的零售",
        en: "[47312]Retail sale of motorcycles and scooters",
      },
      {
        value: "[47313]Retail sale of tyres and batteries for motor vehicles",
        zh: "[47313]Retail sale of tyres and batteries for motor vehicles / 机动车轮胎和电池的零售",
        en: "[47313]Retail sale of tyres and batteries for motor vehicles",
      },
      {
        value: "[47314]Retail sale of parts and accessories for motor vehicles",
        zh: "[47314]Retail sale of parts and accessories for motor vehicles / 机动车零部件及配件的零售",
        en: "[47314]Retail sale of parts and accessories for motor vehicles",
      },
      {
        value: "[47320]Retail sale of automotive fuel",
        zh: "[47320]Retail sale of automotive fuel / 汽车燃料的零售",
        en: "[47320]Retail sale of automotive fuel",
      },
      {
        value: "[47411]Retail sale of handphones and related telecommunications and peripheral equipment",
        zh: "[47411]Retail sale of handphones and related telecommunications and peripheral equipment / 零售手机及相关的电信和外围设备",
        en: "[47411]Retail sale of handphones and related telecommunications and peripheral equipment",
      },
      {
        value: "[47412]Retail sale of computer hardware and peripheral equipment, and computer software (except games and cybersecurity hardware and software)",
        zh: "[47412]Retail sale of computer hardware and peripheral equipment, and computer software (except games and cybersecurity hardware and software) / 零售销售计算机硬件及外围设备，以及计算机软件（不包括游戏和网络安全硬件及软件）",
        en: "[47412]Retail sale of computer hardware and peripheral equipment, and computer software (except games and cybersecurity hardware and software)",
      },
      {
        value: "[47413]Retail sale of computer games",
        zh: "[47413]Retail sale of computer games / 零售销售电脑游戏",
        en: "[47413]Retail sale of computer games",
      },
      {
        value: "[47414]Retail sale of computer and office equipment consumables",
        zh: "[47414]Retail sale of computer and office equipment consumables / 零售销售计算机和办公设备耗材",
        en: "[47414]Retail sale of computer and office equipment consumables",
      },
      {
        value: "[47415]Retail sale of cybersecurity software, hardware and peripheral equipment",
        zh: "[47415]Retail sale of cybersecurity software, hardware and peripheral equipment / 零售销售网络安全软件、硬件及外围设备",
        en: "[47415]Retail sale of cybersecurity software, hardware and peripheral equipment",
      },
      {
        value: "[47510]Retail sale of textiles",
        zh: "[47510]Retail sale of textiles / 零售销售纺织品",
        en: "[47510]Retail sale of textiles",
      },
      {
        value: "[47521]Retail sale of paints",
        zh: "[47521]Retail sale of paints / 零售销售油漆",
        en: "[47521]Retail sale of paints",
      },
      {
        value: "[47522]Retail sale of hardware",
        zh: "[47522]Retail sale of hardware / 零售销售五金",
        en: "[47522]Retail sale of hardware",
      },
      {
        value: "[47529]Retail sale of hardware, paint and glass n.e.c.",
        zh: "[47529]Retail sale of hardware, paint and glass n.e.c. / 零售五金、油漆和玻璃（不包括专门商店）",
        en: "[47529]Retail sale of hardware, paint and glass n.e.c.",
      },
      {
        value: "[47531]Retail sale of furniture",
        zh: "[47531]Retail sale of furniture / 零售家具",
        en: "[47531]Retail sale of furniture",
      },
      {
        value: "[47532]Retail sale of furnishings",
        zh: "[47532]Retail sale of furnishings / 零售家具",
        en: "[47532]Retail sale of furnishings",
      },
      {
        value: "[47533]Retail sale of lighting and lighting accessories",
        zh: "[47533]Retail sale of lighting and lighting accessories / 零售照明及照明配件",
        en: "[47533]Retail sale of lighting and lighting accessories",
      },
      {
        value: "[47534]Retail sale of crockery, cutlery and kitchen utensils",
        zh: "[47534]Retail sale of crockery, cutlery and kitchen utensils / 零售餐具、餐具和厨房用具",
        en: "[47534]Retail sale of crockery, cutlery and kitchen utensils",
      },
      {
        value: "[47535]Retail sale of household electrical appliances and equipment",
        zh: "[47535]Retail sale of household electrical appliances and equipment / 零售家用电器和设备",
        en: "[47535]Retail sale of household electrical appliances and equipment",
      },
      {
        value: "[47536]Retail sale of security and safety equipment",
        zh: "[47536]Retail sale of security and safety equipment / 零售安全和防护设备",
        en: "[47536]Retail sale of security and safety equipment",
      },
      {
        value: "[47539]Retail sale of electrical household appliances, furniture, lighting equipment and other household articles n.e.c.",
        zh: "[47539]Retail sale of electrical household appliances, furniture, lighting equipment and other household articles n.e.c. / 零售家用电器、家具、照明设备和其他家居用品（不包括专门商店）",
        en: "[47539]Retail sale of electrical household appliances, furniture, lighting equipment and other household articles n.e.c.",
      },
      {
        value: "[47610]Retail sale of books, newspapers and stationery",
        zh: "[47610]Retail sale of books, newspapers and stationery / 书籍、报纸和文具零售",
        en: "[47610]Retail sale of books, newspapers and stationery",
      },
      {
        value: "[47620]Retail sale of music and video recordings",
        zh: "[47620]Retail sale of music and video recordings / 音乐和视频录音零售",
        en: "[47620]Retail sale of music and video recordings",
      },
      {
        value: "[47630]Retail sale of sports apparel and equipment",
        zh: "[47630]Retail sale of sports apparel and equipment / 零售运动服装和装备",
        en: "[47630]Retail sale of sports apparel and equipment",
      },
      {
        value: "[47640]Retail sale of games and toys",
        zh: "[47640]Retail sale of games and toys / 游戏和玩具零售",
        en: "[47640]Retail sale of games and toys",
      },
      {
        value: "[47650]Retail sale of musical instruments and scores",
        zh: "[47650]Retail sale of musical instruments and scores / 乐器和乐谱零售",
        en: "[47650]Retail sale of musical instruments and scores",
      },
      {
        value: "[47711]Retail sale of clothing for adults",
        zh: "[47711]Retail sale of clothing for adults / 成人服装零售",
        en: "[47711]Retail sale of clothing for adults",
      },
      {
        value: "[47712]Retail sale of children and infants' clothing",
        zh: "[47712]Retail sale of children and infants' clothing / 儿童及婴儿服装零售",
        en: "[47712]Retail sale of children and infants' clothing",
      },
      {
        value: "[47713]Retail sale of footwear",
        zh: "[47713]Retail sale of footwear / 鞋类零售",
        en: "[47713]Retail sale of footwear",
      },
      {
        value: "[47714]Retail sale of bags, luggage and travel accessories",
        zh: "[47714]Retail sale of bags, luggage and travel accessories / 包袋、行李和旅行配件零售",
        en: "[47714]Retail sale of bags, luggage and travel accessories",
      },
      {
        value: "[47715]Retail sale of sewing and clothing accessories",
        zh: "[47715]Retail sale of sewing and clothing accessories / 缝纫和服装配件零售",
        en: "[47715]Retail sale of sewing and clothing accessories",
      },
      {
        value: "[47719]Retail sale of clothing, footwear and leather articles n.e.c.",
        zh: "[47719]Retail sale of clothing, footwear and leather articles n.e.c. / 服装、鞋类和皮革制品等其他零售",
        en: "[47719]Retail sale of clothing, footwear and leather articles n.e.c.",
      },
      {
        value: "[47721]Retail sale of personal care products",
        zh: "[47721]Retail sale of personal care products / 个人护理产品零售",
        en: "[47721]Retail sale of personal care products",
      },
      {
        value: "[47722]Pharmacies and drug stores (Western)",
        zh: "[47722]Pharmacies and drug stores (Western) / 药房和药店（西式）",
        en: "[47722]Pharmacies and drug stores (Western)",
      },
      {
        value: "[47723]Chinese medicine shops",
        zh: "[47723]Chinese medicine shops / 中药店",
        en: "[47723]Chinese medicine shops",
      },
      {
        value: "[47729]Retail sale of pharmaceutical and medical goods n.e.c.",
        zh: "[47729]Retail sale of pharmaceutical and medical goods n.e.c. / 其他未分类药品和医疗用品的零售",
        en: "[47729]Retail sale of pharmaceutical and medical goods n.e.c.",
      },
      {
        value: "[47731]Retail sale of jewellery made from precious metals and stones",
        zh: "[47731]Retail sale of jewellery made from precious metals and stones / 贵金属和宝石制珠宝首饰的零售业务",
        en: "[47731]Retail sale of jewellery made from precious metals and stones",
      },
      {
        value: "[47732]Retail sale of costume jewellery",
        zh: "[47732]Retail sale of costume jewellery / 人造饰品零售",
        en: "[47732]Retail sale of costume jewellery",
      },
      {
        value: "[47733]Retail sale of watches and clocks",
        zh: "[47733]Retail sale of watches and clocks / 手表和钟表的零售",
        en: "[47733]Retail sale of watches and clocks",
      },
      {
        value: "[47739]Retail sale of personal effects n.e.c.",
        zh: "[47739]Retail sale of personal effects n.e.c. / 其他未分类个人用品零售",
        en: "[47739]Retail sale of personal effects n.e.c.",
      },
      {
        value: "[47741]Retail sale of antiques and works of art",
        zh: "[47741]Retail sale of antiques and works of art / 古董和艺术品零售",
        en: "[47741]Retail sale of antiques and works of art",
      },
      {
        value: "[47742]Retail sale of handicrafts, collectibles and gifts",
        zh: "[47742]Retail sale of handicrafts, collectibles and gifts / 零售销售手工艺品，收藏品和礼品",
        en: "[47742]Retail sale of handicrafts, collectibles and gifts",
      },
      {
        value: "[47743]Retail sale of cut flowers",
        zh: "[47743]Retail sale of cut flowers / 零售销售切花",
        en: "[47743]Retail sale of cut flowers",
      },
      {
        value: "[47744]Retail sale of artificial flowers and plants",
        zh: "[47744]Retail sale of artificial flowers and plants / 零售销售人造花和植物",
        en: "[47744]Retail sale of artificial flowers and plants",
      },
      {
        value: "[47745]Retail sale of aquarium fishes and related accessories/products",
        zh: "[47745]Retail sale of aquarium fishes and related accessories/products / 零售销售水族鱼类及相关配件/产品",
        en: "[47745]Retail sale of aquarium fishes and related accessories/products",
      },
      {
        value: "[47746]Retail sale of pet birds and animals and related accessories/products",
        zh: "[47746]Retail sale of pet birds and animals and related accessories/products / 零售销售宠物鸟和动物及相关配件/产品",
        en: "[47746]Retail sale of pet birds and animals and related accessories/products",
      },
      {
        value: "[47749]Retail sale of handicrafts and fancy goods, flowers, plants and pet animals n.e.c.",
        zh: "[47749]Retail sale of handicrafts and fancy goods, flowers, plants and pet animals n.e.c. / 零售销售手工艺品和装饰品，花卉，植物和宠物动物等",
        en: "[47749]Retail sale of handicrafts and fancy goods, flowers, plants and pet animals n.e.c.",
      },
      {
        value: "[47751]Retail sale of spectacles and other optical goods",
        zh: "[47751]Retail sale of spectacles and other optical goods / 零售销售眼镜和其他光学商品",
        en: "[47751]Retail sale of spectacles and other optical goods",
      },
      {
        value: "[47752]Retail sale of cameras and other photographic goods",
        zh: "[47752]Retail sale of cameras and other photographic goods / 零售销售相机和其他摄影商品",
        en: "[47752]Retail sale of cameras and other photographic goods",
      },
      {
        value: "[47759]Retail sale of optical and photographic goods n.e.c.",
        zh: "[47759]Retail sale of optical and photographic goods n.e.c. / 零售销售光学和摄影商品等",
        en: "[47759]Retail sale of optical and photographic goods n.e.c.",
      },
      {
        value: "[47761]Retail sale of joss paper and other ceremonial products",
        zh: "[47761]Retail sale of joss paper and other ceremonial products / 零售销售冥纸和其他仪式用品",
        en: "[47761]Retail sale of joss paper and other ceremonial products",
      },
      {
        value: "[47762]Retail sale of liquefied petroleum gas (LPG)",
        zh: "[47762]Retail sale of liquefied petroleum gas (LPG) / 零售销售液化石油气（LPG）",
        en: "[47762]Retail sale of liquefied petroleum gas (LPG)",
      },
      {
        value: "[47769]Retail sale of other goods n.e.c.",
        zh: "[47769]Retail sale of other goods n.e.c. / 零售销售其他未列明的商品",
        en: "[47769]Retail sale of other goods n.e.c.",
      },
      {
        value: "[47770]Retail sale of second-hand goods in stores",
        zh: "[47770]Retail sale of second-hand goods in stores / 商店内二手商品零售",
        en: "[47770]Retail sale of second-hand goods in stores",
      },
      {
        value: "[47801]Stalls selling uncooked food",
        zh: "[47801]Stalls selling uncooked food / 销售未煮食品的摊位",
        en: "[47801]Stalls selling uncooked food",
      },
      {
        value: "[47802]Stalls selling other goods (except uncooked food)",
        zh: "[47802]Stalls selling other goods (except uncooked food) / 销售其他商品的摊位（除未煮食品）",
        en: "[47802]Stalls selling other goods (except uncooked food)",
      },
      {
        value: "[49101]Railroad services",
        zh: "[49101]Railroad services / 铁路服务",
        en: "[49101]Railroad services",
      },
      {
        value: "[49102]Mass rapid transit systems",
        zh: "[49102]Mass rapid transit systems / 大众快速交通系统",
        en: "[49102]Mass rapid transit systems",
      },
      {
        value: "[49211]Public bus services (scheduled services)",
        zh: "[49211]Public bus services (scheduled services) / 公共巴士服务（定时服务）",
        en: "[49211]Public bus services (scheduled services)",
      },
      {
        value: "[49212]Chartered bus services",
        zh: "[49212]Chartered bus services / 包车巴士服务",
        en: "[49212]Chartered bus services",
      },
      {
        value: "[49213]Inter-country bus services",
        zh: "[49213]Inter-country bus services / 跨国公共汽车服务",
        en: "[49213]Inter-country bus services",
      },
      {
        value: "[49214]Street-hail and ride-hail service providers",
        zh: "[49214]Street-hail and ride-hail service providers / 街头招揽及应召乘车服务提供者",
        en: "[49214]Street-hail and ride-hail service providers",
      },
      {
        value: "[49215]Rental and leasing of cars with driver (except street-hail and ride-hail service providers)",
        zh: "[49215]Rental and leasing of cars with driver (except street-hail and ride-hail service providers) / 配备驾驶员的汽车租赁和出租（不包括街头招揽及应召乘车服务）",
        en: "[49215]Rental and leasing of cars with driver (except street-hail and ride-hail service providers)",
      },
      {
        value: "[49220]Aerial cableways",
        zh: "[49220]Aerial cableways / 空中缆车",
        en: "[49220]Aerial cableways",
      },
      {
        value: "[49231]Freight transport by road",
        zh: "[49231]Freight transport by road / 公路货运",
        en: "[49231]Freight transport by road",
      },
      {
        value: "[49232]Moving services",
        zh: "[49232]Moving services / 搬家服务",
        en: "[49232]Moving services",
      },
      {
        value: "[49233]Rental and leasing of freight land transport vehicle with driver",
        zh: "[49233]Rental and leasing of freight land transport vehicle with driver / 配备驾驶员的货运陆路运输车辆租赁和出租",
        en: "[49233]Rental and leasing of freight land transport vehicle with driver",
      },
      {
        value: "[49300]Transport via pipelines",
        zh: "[49300]Transport via pipelines / 通过管道运输",
        en: "[49300]Transport via pipelines",
      },
      {
        value: "[50011]International cruise services",
        zh: "[50011]International cruise services / 国际游轮服务",
        en: "[50011]International cruise services",
      },
      {
        value: "[50012]Other sight-seeing cruise services",
        zh: "[50012]Other sight-seeing cruise services / 其他观光游轮服务",
        en: "[50012]Other sight-seeing cruise services",
      },
      {
        value: "[50013]Passenger ferry services",
        zh: "[50013]Passenger ferry services / 客运渡轮服务",
        en: "[50013]Passenger ferry services",
      },
      {
        value: "[50014]Chartering of ships and boats with crew (passenger)",
        zh: "[50014]Chartering of ships and boats with crew (passenger) / 带船员的船舶和船只租赁（客运）",
        en: "[50014]Chartering of ships and boats with crew (passenger)",
      },
      {
        value: "[50021]Shipping companies and chartering of ships/boats with crew (freight)",
        zh: "[50021]Shipping companies and chartering of ships/boats with crew (freight) / 航运公司和租用带有船员的船只/小船（货运）",
        en: "[50021]Shipping companies and chartering of ships/boats with crew (freight)",
      },
      {
        value: "[50022]Operators and charterers of barges, tugboats and bumboats (freight)",
        zh: "[50022]Operators and charterers of barges, tugboats and bumboats (freight) / 驳船、拖船和小船的运营商和租用人（货运）",
        en: "[50022]Operators and charterers of barges, tugboats and bumboats (freight)",
      },
      {
        value: "[50023]Branches of foreign shipping lines",
        zh: "[50023]Branches of foreign shipping lines / 外国航运线的分支机构",
        en: "[50023]Branches of foreign shipping lines",
      },
      {
        value: "[51001]Airlines (passenger)",
        zh: "[51001]Airlines (passenger) / 航空公司（客运）",
        en: "[51001]Airlines (passenger)",
      },
      {
        value: "[51002]Airlines (freight)",
        zh: "[51002]Airlines (freight) / 航空公司（货运）",
        en: "[51002]Airlines (freight)",
      },
      {
        value: "[51003]Branches of foreign airlines (passenger)",
        zh: "[51003]Branches of foreign airlines (passenger) / 外国航空公司的分支机构（客运）",
        en: "[51003]Branches of foreign airlines (passenger)",
      },
      {
        value: "[51004]Branches of foreign airlines (freight)",
        zh: "[51004]Branches of foreign airlines (freight) / 外国航空公司的分支机构（货运）",
        en: "[51004]Branches of foreign airlines (freight)",
      },
      {
        value: "[51005]Aircraft chartering with operator",
        zh: "[51005]Aircraft chartering with operator / 带操作员的飞机包租",
        en: "[51005]Aircraft chartering with operator",
      },
      {
        value: "[52101]General warehousing",
        zh: "[52101]General warehousing / 一般仓储",
        en: "[52101]General warehousing",
      },
      {
        value: "[52102]Refrigerated warehousing and storage",
        zh: "[52102]Refrigerated warehousing and storage / 冷藏仓储和储存",
        en: "[52102]Refrigerated warehousing and storage",
      },
      {
        value: "[52103]Storage for dangerous goods",
        zh: "[52103]Storage for dangerous goods / 危险品储存",
        en: "[52103]Storage for dangerous goods",
      },
      {
        value: "[52109]Specialised storage n.e.c.",
        zh: "[52109]Specialised storage n.e.c. / 未具体说明的专业储存",
        en: "[52109]Specialised storage n.e.c.",
      },
      {
        value: "[52211]Carpark management and operation services",
        zh: "[52211]Carpark management and operation services / 停车场管理与运营服务",
        en: "[52211]Carpark management and operation services",
      },
      {
        value: "[52212]Motor vehicle towing services",
        zh: "[52212]Motor vehicle towing services / 机动车辆拖车服务",
        en: "[52212]Motor vehicle towing services",
      },
      {
        value: "[52219]Supporting services to land transport n.e.c.",
        zh: "[52219]Supporting services to land transport n.e.c. / 陆上运输支持服务（未列明的）",
        en: "[52219]Supporting services to land transport n.e.c.",
      },
      {
        value: "[52221]Representative offices of foreign shipping lines",
        zh: "[52221]Representative offices of foreign shipping lines / 外国航运公司代表处",
        en: "[52221]Representative offices of foreign shipping lines",
      },
      {
        value: "[52222]Shipping agencies (freight)",
        zh: "[52222]Shipping agencies (freight) / 航运代理（货运）",
        en: "[52222]Shipping agencies (freight)",
      },
      {
        value: "[52223]Port operators",
        zh: "[52223]Port operators / 港口运营商",
        en: "[52223]Port operators",
      },
      {
        value: "[52224]Lighterage services",
        zh: "[52224]Lighterage services / 驳船运输服务",
        en: "[52224]Lighterage services",
      },
      {
        value: "[52225]Salvaging of distressed vessels and cargos",
        zh: "[52225]Salvaging of distressed vessels and cargos / 打捞遇难船只和货物",
        en: "[52225]Salvaging of distressed vessels and cargos",
      },
      {
        value: "[52226]Ship management services",
        zh: "[52226]Ship management services / 船舶管理服务",
        en: "[52226]Ship management services",
      },
      {
        value: "[52227]Ship brokering services",
        zh: "[52227]Ship brokering services / 船舶经纪服务",
        en: "[52227]Ship brokering services",
      },
      {
        value: "[52229]Supporting services to water transport n.e.c.",
        zh: "[52229]Supporting services to water transport n.e.c. / 水上运输支持服务",
        en: "[52229]Supporting services to water transport n.e.c.",
      },
      {
        value: "[52231]Representative offices of foreign airlines",
        zh: "[52231]Representative offices of foreign airlines / 外国航空公司代表处",
        en: "[52231]Representative offices of foreign airlines",
      },
      {
        value: "[52232]Airline agencies (freight)",
        zh: "[52232]Airline agencies (freight) / 航空代理（货运）",
        en: "[52232]Airline agencies (freight)",
      },
      {
        value: "[52233]Airport operation services",
        zh: "[52233]Airport operation services / 机场运营服务",
        en: "[52233]Airport operation services",
      },
      {
        value: "[52234]Airport terminal services",
        zh: "[52234]Airport terminal services / 机场终端服务",
        en: "[52234]Airport terminal services",
      },
      {
        value: "[52239]Supporting services to air transport n.e.c.",
        zh: "[52239]Supporting services to air transport n.e.c. / 航空运输支持服务",
        en: "[52239]Supporting services to air transport n.e.c.",
      },
      {
        value: "[52241]Container depot services",
        zh: "[52241]Container depot services / 集装箱堆场服务",
        en: "[52241]Container depot services",
      },
      {
        value: "[52242]Industrial cargo lifting and moving services (except for use in construction industry)",
        zh: "[52242]Industrial cargo lifting and moving services (except for use in construction industry) / 工业货物搬运服务（不包括建筑行业使用）",
        en: "[52242]Industrial cargo lifting and moving services (except for use in construction industry)",
      },
      {
        value: "[52243]Stevedoring services",
        zh: "[52243]Stevedoring services / 装卸服务",
        en: "[52243]Stevedoring services",
      },
      {
        value: "[52251]Classification societies",
        zh: "[52251]Classification societies / 船级社",
        en: "[52251]Classification societies",
      },
      {
        value: "[52252]Marine surveying services (except classification societies)",
        zh: "[52252]Marine surveying services (except classification societies) / 海事调查服务（不包括船级社）",
        en: "[52252]Marine surveying services (except classification societies)",
      },
      {
        value: "[52291]Cargo surveying services",
        zh: "[52291]Cargo surveying services / 货物检验服务",
        en: "[52291]Cargo surveying services",
      },
      {
        value: "[52292]Freight transport arrangement",
        zh: "[52292]Freight transport arrangement / 货运安排服务",
        en: "[52292]Freight transport arrangement",
      },
      {
        value: "[53100]National post activities",
        zh: "[53100]National post activities / 国家邮政活动",
        en: "[53100]National post activities",
      },
      {
        value: "[53200]Courier activities (except national post activities)",
        zh: "[53200]Courier activities (except national post activities) / 快递活动（除国家邮政活动外）",
        en: "[53200]Courier activities (except national post activities)",
      },
      {
        value: "[55101]Hotels",
        zh: "[55101]Hotels / 酒店",
        en: "[55101]Hotels",
      },
      {
        value: "[55109]Short term accommodation activities n.e.c.",
        zh: "[55109]Short term accommodation activities n.e.c. / 其他短期住宿活动",
        en: "[55109]Short term accommodation activities n.e.c.",
      },
      {
        value: "[55900]Hostels and dormitories for students, workers and other individuals",
        zh: "[55900]Hostels and dormitories for students, workers and other individuals / 学生、工人及其他个人的宿舍和旅馆",
        en: "[55900]Hostels and dormitories for students, workers and other individuals",
      },
      {
        value: "[56111]Restaurants",
        zh: "[56111]Restaurants / 餐厅",
        en: "[56111]Restaurants",
      },
      {
        value: "[56112]Cafes",
        zh: "[56112]Cafes / 咖啡馆",
        en: "[56112]Cafes",
      },
      {
        value: "[56121]Fast food outlets",
        zh: "[56121]Fast food outlets / 快餐店",
        en: "[56121]Fast food outlets",
      },
      {
        value: "[56122]Operators of food courts, hawker centres, coffee shops and canteens (with mainly food and beverage income)",
        zh: "[56122]Operators of food courts, hawker centres, coffee shops and canteens (with mainly food and beverage income) / 美食广场、小贩中心、咖啡店和食堂的运营商（主要收入来自食品和饮料）",
        en: "[56122]Operators of food courts, hawker centres, coffee shops and canteens (with mainly food and beverage income)",
      },
      {
        value: "[56123]Food and drinks kiosks mainly for takeaway and delivery",
        zh: "[56123]Food and drinks kiosks mainly for takeaway and delivery / 主要提供外卖和送餐服务的食品和饮料摊位",
        en: "[56123]Food and drinks kiosks mainly for takeaway and delivery",
      },
      {
        value: "[56130]Pubs",
        zh: "[56130]Pubs / 酒吧",
        en: "[56130]Pubs",
      },
      {
        value: "[56140]Stalls selling cooked food and prepared drinks",
        zh: "[56140]Stalls selling cooked food and prepared drinks / 销售熟食和即饮饮料的摊位",
        en: "[56140]Stalls selling cooked food and prepared drinks",
      },
      {
        value: "[56200]Food caterers",
        zh: "[56200]Food caterers / 食品供应商",
        en: "[56200]Food caterers",
      },
      {
        value: "[58110]Publishing of books, brochures, musical books and other publications",
        zh: "[58110]Publishing of books, brochures, musical books and other publications / 书籍、小册子、乐谱和其他出版物的出版",
        en: "[58110]Publishing of books, brochures, musical books and other publications",
      },
      {
        value: "[58120]Publishing of directories and mailing lists",
        zh: "[58120]Publishing of directories and mailing lists / 目录和邮寄名单的出版",
        en: "[58120]Publishing of directories and mailing lists",
      },
      {
        value: "[58131]Publishing of news",
        zh: "[58131]Publishing of news / 新闻出版",
        en: "[58131]Publishing of news",
      },
      {
        value: "[58132]Publishing of journals, periodicals and magazines",
        zh: "[58132]Publishing of journals, periodicals and magazines / 期刊、定期刊物和杂志的出版",
        en: "[58132]Publishing of journals, periodicals and magazines",
      },
      {
        value: "[58190]Other publishing activities",
        zh: "[58190]Other publishing activities / 其他出版活动",
        en: "[58190]Other publishing activities",
      },
      {
        value: "[58201]Publishing of games software/applications",
        zh: "[58201]Publishing of games software/applications / 游戏软件/应用程序出版",
        en: "[58201]Publishing of games software/applications",
      },
      {
        value: "[58202]Publishing of software/applications (non-games)",
        zh: "[58202]Publishing of software/applications (non-games) / 非游戏软件/应用程序出版",
        en: "[58202]Publishing of software/applications (non-games)",
      },
      {
        value: "[59111]Movie production",
        zh: "[59111]Movie production / 电影制作",
        en: "[59111]Movie production",
      },
      {
        value: "[59112]Production of advertisements, corporate videos and event videos",
        zh: "[59112]Production of advertisements, corporate videos and event videos / 广告、企业视频和活动视频的制作",
        en: "[59112]Production of advertisements, corporate videos and event videos",
      },
      {
        value: "[59113]Production of dramas, variety shows and documentaries",
        zh: "[59113]Production of dramas, variety shows and documentaries / 戏剧、综艺节目和纪录片的制作",
        en: "[59113]Production of dramas, variety shows and documentaries",
      },
      {
        value: "[59114]Animation production",
        zh: "[59114]Animation production / 动画制作",
        en: "[59114]Animation production",
      },
      {
        value: "[59119]Movie, video, television and other programme production activities n.e.c.",
        zh: "[59119]Movie, video, television and other programme production activities n.e.c. / 电影、视频、电视和其他节目制作活动（未特指的）",
        en: "[59119]Movie, video, television and other programme production activities n.e.c.",
      },
      {
        value: "[59120]Movie, video, television and other programme post-production activities",
        zh: "[59120]Movie, video, television and other programme post-production activities / 电影、视频、电视和其他节目后期制作活动",
        en: "[59120]Movie, video, television and other programme post-production activities",
      },
      {
        value: "[59131]Movie distribution",
        zh: "[59131]Movie distribution / 电影发行",
        en: "[59131]Movie distribution",
      },
      {
        value: "[59132]Distribution of television programmes",
        zh: "[59132]Distribution of television programmes / 电视节目发行",
        en: "[59132]Distribution of television programmes",
      },
      {
        value: "[59139]Movie, video, television and other programme distribution activities n.e.c.",
        zh: "[59139]Movie, video, television and other programme distribution activities n.e.c. / 电影、视频、电视和其他节目发行活动（未特指的）",
        en: "[59139]Movie, video, television and other programme distribution activities n.e.c.",
      },
      {
        value: "[59140]Movie projection activities",
        zh: "[59140]Movie projection activities / 电影放映活动",
        en: "[59140]Movie projection activities",
      },
      {
        value: "[59201]Sound recording production",
        zh: "[59201]Sound recording production / 声音录制制作",
        en: "[59201]Sound recording production",
      },
      {
        value: "[59202]Music publishing and distribution activities",
        zh: "[59202]Music publishing and distribution activities / 音乐出版与发行活动",
        en: "[59202]Music publishing and distribution activities",
      },
      {
        value: "[60100]Radio programme production and broadcasting",
        zh: "[60100]Radio programme production and broadcasting / 广播节目制作与广播",
        en: "[60100]Radio programme production and broadcasting",
      },
      {
        value: "[60200]Television programming and broadcasting",
        zh: "[60200]Television programming and broadcasting / 电视节目编制与广播",
        en: "[60200]Television programming and broadcasting",
      },
      {
        value: "[60301]News agency activities",
        zh: "[60301]News agency activities / 新闻机构活动",
        en: "[60301]News agency activities",
      },
      {
        value: "[60302]Operation of social network sites and other content distribution activities (except publishing)",
        zh: "[60302]Operation of social network sites and other content distribution activities (except publishing) / 社交网络站点和其他内容分发活动（除出版外）的运营",
        en: "[60302]Operation of social network sites and other content distribution activities (except publishing)",
      },
      {
        value: "[61010]Telecommunications network operation",
        zh: "[61010]Telecommunications network operation / 电信网络运营",
        en: "[61010]Telecommunications network operation",
      },
      {
        value: "[61020]Telecommunications resellers/third party telecommunications providers",
        zh: "[61020]Telecommunications resellers/third party telecommunications providers / 电信转售商/第三方电信服务提供商",
        en: "[61020]Telecommunications resellers/third party telecommunications providers",
      },
      {
        value: "[61090]Other telecommunication services",
        zh: "[61090]Other telecommunication services / 其他电信服务",
        en: "[61090]Other telecommunication services",
      },
      {
        value: "[62011]Development of software and applications (except games and cybersecurity)",
        zh: "[62011]Development of software and applications (except games and cybersecurity) / 软件和应用程序开发（不包括游戏和网络安全）",
        en: "[62011]Development of software and applications (except games and cybersecurity)",
      },
      {
        value: "[62012]Development of computer games",
        zh: "[62012]Development of computer games / 计算机游戏开发",
        en: "[62012]Development of computer games",
      },
      {
        value: "[62013]Development of software for cybersecurity",
        zh: "[62013]Development of software for cybersecurity / 网络安全软件开发",
        en: "[62013]Development of software for cybersecurity",
      },
      {
        value: "[62021]Information technology consultancy (except cybersecurity)",
        zh: "[62021]Information technology consultancy (except cybersecurity) / 信息技术咨询（不包括网络安全）",
        en: "[62021]Information technology consultancy (except cybersecurity)",
      },
      {
        value: "[62022]Information technology cybersecurity consultancy",
        zh: "[62022]Information technology cybersecurity consultancy / 信息技术网络安全咨询",
        en: "[62022]Information technology cybersecurity consultancy",
      },
      {
        value: "[62023]Computer facilities management activities",
        zh: "[62023]Computer facilities management activities / 计算机设施管理活动",
        en: "[62023]Computer facilities management activities",
      },
      {
        value: "[62090]Other information technology and computer service activities",
        zh: "[62090]Other information technology and computer service activities / 其他信息技术和计算机服务活动",
        en: "[62090]Other information technology and computer service activities",
      },
      {
        value: "[63111]Data centres",
        zh: "[63111]Data centres / 数据中心",
        en: "[63111]Data centres",
      },
      {
        value: "[63112]Hosting services by non-data centres",
        zh: "[63112]Hosting services by non-data centres / 非数据中心的托管服务",
        en: "[63112]Hosting services by non-data centres",
      },
      {
        value: "[63119]Data analytics, processing, hosting and related activities n.e.c.",
        zh: "[63119]Data analytics, processing, hosting and related activities n.e.c. / 数据分析、处理、托管及相关活动等未列明的其他活动",
        en: "[63119]Data analytics, processing, hosting and related activities n.e.c.",
      },
      {
        value:
          "[63201]Online marketplaces operating on a fee or commission basis for goods and food sold by third-party; Online marketplaces operating on a fee or commission basis for food delivery services",
        zh: "[63201]Online marketplaces operating on a fee or commission basis for goods and food sold by third-party; Online marketplaces operating on a fee or commission basis for food delivery services / 第三方销售的商品和食品的基于费用或佣金的在线市场平台；第三方提供的食品配送服务的基于费用或佣金的在线市场平台",
        en: "[63201]Online marketplaces operating on a fee or commission basis for goods and food sold by third-party; Online marketplaces operating on a fee or commission basis for food delivery services",
      },
      {
        value: "[63202]Online marketplaces operating on a fee or commission basis for health services provided by third-party",
        zh: "[63202]Online marketplaces operating on a fee or commission basis for health services provided by third-party / 第三方提供健康服务的基于费用或佣金的在线市场平台",
        en: "[63202]Online marketplaces operating on a fee or commission basis for health services provided by third-party",
      },
      {
        value: "[63203]Online marketplaces operating on a fee or commission basis for education services provided by third-party",
        zh: "[63203]Online marketplaces operating on a fee or commission basis for education services provided by third-party / 第三方提供的教育服务的基于费用或佣金的在线市场平台",
        en: "[63203]Online marketplaces operating on a fee or commission basis for education services provided by third-party",
      },
      {
        value: "[63204]Online marketplaces operating on a fee or commission basis for travel and accommodation services provided by third-party",
        zh: "[63204]Online marketplaces operating on a fee or commission basis for travel and accommodation services provided by third-party / 第三方提供旅游和住宿服务的基于费用或佣金的在线市场平台",
        en: "[63204]Online marketplaces operating on a fee or commission basis for travel and accommodation services provided by third-party",
      },
      {
        value: "[63205]Online marketplaces operating on a fee or commission basis for real estate services provided by third-party",
        zh: "[63205]Online marketplaces operating on a fee or commission basis for real estate services provided by third-party / 为第三方提供的房地产服务按费用或佣金运营的在线市场",
        en: "[63205]Online marketplaces operating on a fee or commission basis for real estate services provided by third-party",
      },
      {
        value: "[63209]Online marketplaces operating on a fee or commission basis for other services provided by third-party",
        zh: "[63209]Online marketplaces operating on a fee or commission basis for other services provided by third-party / 为第三方提供的其他服务按费用或佣金运营的在线市场",
        en: "[63209]Online marketplaces operating on a fee or commission basis for other services provided by third-party",
      },
      {
        value: "[63901]Internet search engines",
        zh: "[63901]Internet search engines / 互联网搜索引擎",
        en: "[63901]Internet search engines",
      },
      {
        value: "[63909]Other information service activities n.e.c.",
        zh: "[63909]Other information service activities n.e.c. / 其他信息服务业活动",
        en: "[63909]Other information service activities n.e.c.",
      },
      {
        value: "[64110]Central bank",
        zh: "[64110]Central bank / 中央银行",
        en: "[64110]Central bank",
      },
      {
        value: "[64120]Full banks",
        zh: "[64120]Full banks / 全面银行",
        en: "[64120]Full banks",
      },
      {
        value: "[64130]Wholesale banks",
        zh: "[64130]Wholesale banks / 批发银行",
        en: "[64130]Wholesale banks",
      },
      {
        value: "[64140]Merchant banks",
        zh: "[64140]Merchant banks / 商业银行",
        en: "[64140]Merchant banks",
      },
      {
        value: "[64150]Finance companies (with deposit taking functions)",
        zh: "[64150]Finance companies (with deposit taking functions) / 金融公司（具有存款功能）",
        en: "[64150]Finance companies (with deposit taking functions)",
      },
      {
        value: "[64201]Holding companies of firms engaged in financial and insurance activities",
        zh: "[64201]Holding companies of firms engaged in financial and insurance activities / 从事金融和保险活动的公司的控股公司",
        en: "[64201]Holding companies of firms engaged in financial and insurance activities",
      },
      {
        value: "[64202]Holding companies of firms engaged in non-financial and insurance activities",
        zh: "[64202]Holding companies of firms engaged in non-financial and insurance activities / 从事非金融和保险活动的公司的控股公司",
        en: "[64202]Holding companies of firms engaged in non-financial and insurance activities",
      },
      {
        value: "[64300]Trusts, funds and similar financial entities (except those with rental income)",
        zh: "[64300]Trusts, funds and similar financial entities (except those with rental income) / 信托、基金和类似金融实体（不包括那些拥有租金收入的）",
        en: "[64300]Trusts, funds and similar financial entities (except those with rental income)",
      },
      {
        value: "[64910]Financial leasing companies",
        zh: "[64910]Financial leasing companies / 金融租赁公司",
        en: "[64910]Financial leasing companies",
      },
      {
        value: "[64921]Thrift and loan societies and credit associations",
        zh: "[64921]Thrift and loan societies and credit associations / 储蓄与贷款协会和信贷协会",
        en: "[64921]Thrift and loan societies and credit associations",
      },
      {
        value: "[64922]Credit card services",
        zh: "[64922]Credit card services / 信用卡服务",
        en: "[64922]Credit card services",
      },
      {
        value: "[64923]Mutual benefits organisations",
        zh: "[64923]Mutual benefits organisations / 互助组织",
        en: "[64923]Mutual benefits organisations",
      },
      {
        value: "[64924]Money-lending",
        zh: "[64924]Money-lending / 放贷",
        en: "[64924]Money-lending",
      },
      {
        value: "[64925]Pawnbrokerage",
        zh: "[64925]Pawnbrokerage / 当铺",
        en: "[64925]Pawnbrokerage",
      },
      {
        value: "[64929]Other credit granting n.e.c.",
        zh: "[64929]Other credit granting n.e.c. / 其他信贷授予活动",
        en: "[64929]Other credit granting n.e.c.",
      },
      {
        value: "[64991]Factoring companies",
        zh: "[64991]Factoring companies / 保理公司",
        en: "[64991]Factoring companies",
      },
      {
        value: "[64992]Representative offices of foreign banks",
        zh: "[64992]Representative offices of foreign banks / 外国银行代表处",
        en: "[64992]Representative offices of foreign banks",
      },
      {
        value: "[64993]Remittance services",
        zh: "[64993]Remittance services / 汇款服务",
        en: "[64993]Remittance services",
      },
      {
        value: "[64994]Treasury centres",
        zh: "[64994]Treasury centres / 财务中心",
        en: "[64994]Treasury centres",
      },
      {
        value: "[64999]Other financial service activities n.e.c. (except insurance and pension funding activities)",
        zh: "[64999]Other financial service activities n.e.c. (except insurance and pension funding activities) / 其他金融服务活动（不包括保险和养老金资助活动）",
        en: "[64999]Other financial service activities n.e.c. (except insurance and pension funding activities)",
      },
      {
        value: "[65110]Life insurance",
        zh: "[65110]Life insurance / 人寿保险",
        en: "[65110]Life insurance",
      },
      {
        value: "[65121]Marine insurance",
        zh: "[65121]Marine insurance / 海上保险",
        en: "[65121]Marine insurance",
      },
      {
        value: "[65122]Captive insurance",
        zh: "[65122]Captive insurance / 专属保险",
        en: "[65122]Captive insurance",
      },
      {
        value: "[65123]Import, export and credit insurance",
        zh: "[65123]Import, export and credit insurance / 进出口和信贷保险",
        en: "[65123]Import, export and credit insurance",
      },
      {
        value: "[65124]General insurance (except marine and import, export and credit insurance)",
        zh: "[65124]General insurance (except marine and import, export and credit insurance) / 一般保险（除海事、进出口和信用保险外）",
        en: "[65124]General insurance (except marine and import, export and credit insurance)",
      },
      {
        value: "[65201]Life reinsurance",
        zh: "[65201]Life reinsurance / 人寿再保险",
        en: "[65201]Life reinsurance",
      },
      {
        value: "[65202]General reinsurance",
        zh: "[65202]General reinsurance / 普通再保险",
        en: "[65202]General reinsurance",
      },
      {
        value: "[65300]Provident funding and pension funding",
        zh: "[65300]Provident funding and pension funding / 福利资金和养老金资金",
        en: "[65300]Provident funding and pension funding",
      },
      {
        value: "[66110]Securities and commodities exchange",
        zh: "[66110]Securities and commodities exchange / 证券和商品交易所",
        en: "[66110]Securities and commodities exchange",
      },
      {
        value: "[66121]Stock, share and bond brokers and dealers",
        zh: "[66121]Stock, share and bond brokers and dealers / 股票、股份和债券经纪人及交易商",
        en: "[66121]Stock, share and bond brokers and dealers",
      },
      {
        value: "[66122]Foreign exchange brokers and dealers",
        zh: "[66122]Foreign exchange brokers and dealers / 外汇经纪人和交易商",
        en: "[66122]Foreign exchange brokers and dealers",
      },
      {
        value: "[66123]Gold bullion brokers and dealers",
        zh: "[66123]Gold bullion brokers and dealers / 金条经纪人和交易商",
        en: "[66123]Gold bullion brokers and dealers",
      },
      {
        value: "[66124]Commodity and futures brokers and dealers (except gold)",
        zh: "[66124]Commodity and futures brokers and dealers (except gold) / 商品和期货经纪人及交易商（除金外）",
        en: "[66124]Commodity and futures brokers and dealers (except gold)",
      },
      {
        value: "[66125]Carbon credit brokers/traders",
        zh: "[66125]Carbon credit brokers/traders / 碳信用经纪人/交易商",
        en: "[66125]Carbon credit brokers/traders",
      },
      {
        value: "[66126]Money-changing services",
        zh: "[66126]Money-changing services / 货币兑换服务",
        en: "[66126]Money-changing services",
      },
      {
        value: "[66129]Security dealings and commodity contracts brokerage activities n.e.c.",
        zh: "[66129]Security dealings and commodity contracts brokerage activities n.e.c. / 证券交易及商品合同经纪活动",
        en: "[66129]Security dealings and commodity contracts brokerage activities n.e.c.",
      },
      {
        value: "[66191]Trustee, fiduciary and custody services",
        zh: "[66191]Trustee, fiduciary and custody services / 信托、受托和保管服务",
        en: "[66191]Trustee, fiduciary and custody services",
      },
      {
        value: "[66192]Corporate finance advisory services",
        zh: "[66192]Corporate finance advisory services / 企业财务咨询服务",
        en: "[66192]Corporate finance advisory services",
      },
      {
        value: "[66193]Clearing and settlement of financial instruments",
        zh: "[66193]Clearing and settlement of financial instruments / 金融工具的清算和结算",
        en: "[66193]Clearing and settlement of financial instruments",
      },
      {
        value: "[66194]Activities auxiliary to fund management activities",
        zh: "[66194]Activities auxiliary to fund management activities / 基金管理活动辅助活动",
        en: "[66194]Activities auxiliary to fund management activities",
      },
      {
        value: "[66195]Transaction/payment processing services",
        zh: "[66195]Transaction/payment processing services / 交易/支付处理服务",
        en: "[66195]Transaction/payment processing services",
      },
      {
        value: "[66199]Other activities auxiliary to financial service activities n.e.c.",
        zh: "[66199]Other activities auxiliary to financial service activities n.e.c. / 其他金融服务活动辅助活动",
        en: "[66199]Other activities auxiliary to financial service activities n.e.c.",
      },
      {
        value: "[66210]Risk and damage evaluation",
        zh: "[66210]Risk and damage evaluation / 风险和损害评估",
        en: "[66210]Risk and damage evaluation",
      },
      {
        value: "[66221]Insurance agencies and agents",
        zh: "[66221]Insurance agencies and agents / 保险代理机构和经纪人",
        en: "[66221]Insurance agencies and agents",
      },
      {
        value: "[66222]Insurance brokers",
        zh: "[66222]Insurance brokers / 保险经纪人",
        en: "[66222]Insurance brokers",
      },
      {
        value: "[66291]Representative offices of foreign insurers and professional reinsurers",
        zh: "[66291]Representative offices of foreign insurers and professional reinsurers / 外国保险公司和专业再保险代表处",
        en: "[66291]Representative offices of foreign insurers and professional reinsurers",
      },
      {
        value: "[66292]Captive managers",
        zh: "[66292]Captive managers / 专属管理人",
        en: "[66292]Captive managers",
      },
      {
        value: "[66299]Other activities auxiliary to insurance and pension funding n.e.c.",
        zh: "[66299]Other activities auxiliary to insurance and pension funding n.e.c. / 其他辅助保险和养老金资金活动（不包括其他类）",
        en: "[66299]Other activities auxiliary to insurance and pension funding n.e.c.",
      },
      {
        value: "[66301]Traditional/long-only asset/portfolio management",
        zh: "[66301]Traditional/long-only asset/portfolio management / 传统/仅限多头资产/投资组合管理",
        en: "[66301]Traditional/long-only asset/portfolio management",
      },
      {
        value: "[66302]Hedge fund management",
        zh: "[66302]Hedge fund management / 对冲基金管理",
        en: "[66302]Hedge fund management",
      },
      {
        value: "[66303]Property fund/REIT management",
        zh: "[66303]Property fund/REIT management / 房地产基金/REIT管理",
        en: "[66303]Property fund/REIT management",
      },
      {
        value: "[66304]Private equity firms",
        zh: "[66304]Private equity firms / 私募股权公司",
        en: "[66304]Private equity firms",
      },
      {
        value: "[66305]Venture capital activities",
        zh: "[66305]Venture capital activities / 风险投资活动",
        en: "[66305]Venture capital activities",
      },
      {
        value: "[66306]Single/multiple family offices activities",
        zh: "[66306]Single/multiple family offices activities / 单一/多重家庭办公室活动",
        en: "[66306]Single/multiple family offices activities",
      },
      {
        value: "[66307]Private debt funds",
        zh: "[66307]Private debt funds / 私人债务基金",
        en: "[66307]Private debt funds",
      },
      {
        value: "[66309]Fund management activities n.e.c.",
        zh: "[66309]Fund management activities n.e.c. / 其他基金管理活动",
        en: "[66309]Fund management activities n.e.c.",
      },
      {
        value: "[68101]Real estate developers",
        zh: "[68101]Real estate developers / 房地产开发商",
        en: "[68101]Real estate developers",
      },
      {
        value: "[68102]Operating of serviced apartments",
        zh: "[68102]Operating of serviced apartments / 经营服务式公寓",
        en: "[68102]Operating of serviced apartments",
      },
      {
        value: "[68103]Letting and operating of self-owned or leased real estate property (except food courts, hawker centres, coffee shops and canteens)",
        zh: "[68103]Letting and operating of self-owned or leased real estate property (except food courts, hawker centres, coffee shops and canteens) / 出租及经营自有的或租赁的房地产（不包括美食广场、小贩中心、咖啡厅和食堂）",
        en: "[68103]Letting and operating of self-owned or leased real estate property (except food courts, hawker centres, coffee shops and canteens)",
      },
      {
        value: "[68104]Letting and operating of self-owned or leased food courts, hawker centres, coffee shops and canteens (with mainly rental income)",
        zh: "[68104]Letting and operating of self-owned or leased food courts, hawker centres, coffee shops and canteens (with mainly rental income) / 出租及经营自有的或租赁的美食广场、小贩中心、咖啡厅和食堂（主要收入为租金）",
        en: "[68104]Letting and operating of self-owned or leased food courts, hawker centres, coffee shops and canteens (with mainly rental income)",
      },
      {
        value: "[68105]Collective portfolio investment funds with rental income",
        zh: "[68105]Collective portfolio investment funds with rental income / 具有租金收入的集体投资组合投资基金",
        en: "[68105]Collective portfolio investment funds with rental income",
      },
      {
        value: "[68106]Management of self-owned strata titled property",
        zh: "[68106]Management of self-owned strata titled property / 管理自有的分层产权物业",
        en: "[68106]Management of self-owned strata titled property",
      },
      {
        value: "[68201]Real estate agencies and valuation services",
        zh: "[68201]Real estate agencies and valuation services / 房地产代理和估值服务",
        en: "[68201]Real estate agencies and valuation services",
      },
      {
        value: "[68202]Town councils",
        zh: "[68202]Town councils / 镇议会",
        en: "[68202]Town councils",
      },
      {
        value: "[68203]Residential, commercial and industrial real estate management (except town councils)",
        zh: "[68203]Residential, commercial and industrial real estate management (except town councils) / 住宅、商业和工业房地产管理（不包括镇议会）",
        en: "[68203]Residential, commercial and industrial real estate management (except town councils)",
      },
      {
        value: "[68209]Real estate activities on a fee or commission basis n.e.c.",
        zh: "[68209]Real estate activities on a fee or commission basis n.e.c. / 其他以费用或佣金为基础的房地产业务",
        en: "[68209]Real estate activities on a fee or commission basis n.e.c.",
      },
      {
        value: "[69101]Legal activities",
        zh: "[69101]Legal activities / 法律活动",
        en: "[69101]Legal activities",
      },
      {
        value: "[69102]Arbitration and mediation services",
        zh: "[69102]Arbitration and mediation services / 仲裁和调解服务",
        en: "[69102]Arbitration and mediation services",
      },
      {
        value: "[69201]Accounting, auditing and tax consultancy services",
        zh: "[69201]Accounting, auditing and tax consultancy services / 会计、审计及税务咨询服务",
        en: "[69201]Accounting, auditing and tax consultancy services",
      },
      {
        value: "[69202]Book-keeping services",
        zh: "[69202]Book-keeping services / 簿记服务",
        en: "[69202]Book-keeping services",
      },
      {
        value: "[70101]Activities of head and regional head offices; Centralised administrative offices and subsidiary management offices",
        zh: "[70101]Activities of head and regional head offices; Centralised administrative offices and subsidiary management offices / 总部及区域总部活动；集中行政办公室和子公司管理办公室",
        en: "[70101]Activities of head and regional head offices; Centralised administrative offices and subsidiary management offices",
      },
      {
        value: "[70102]Business representative offices",
        zh: "[70102]Business representative offices / 商务代表处",
        en: "[70102]Business representative offices",
      },
      {
        value: "[70201]Management consultancy services",
        zh: "[70201]Management consultancy services / 管理咨询服务",
        en: "[70201]Management consultancy services",
      },
      {
        value: "[70202]Management consultancy services for healthcare organisations",
        zh: "[70202]Management consultancy services for healthcare organisations / 医疗组织的管理咨询服务",
        en: "[70202]Management consultancy services for healthcare organisations",
      },
      {
        value: "[70203]Management consultancy services for hotels",
        zh: "[70203]Management consultancy services for hotels / 酒店的管理咨询服务",
        en: "[70203]Management consultancy services for hotels",
      },
      {
        value: "[70204]Human resource consultancy services",
        zh: "[70204]Human resource consultancy services / 人力资源咨询服务",
        en: "[70204]Human resource consultancy services",
      },
      {
        value: "[70205]Public relations, marketing and brand consultancy services",
        zh: "[70205]Public relations, marketing and brand consultancy services / 公共关系、市场营销和品牌咨询",
        en: "[70205]Public relations, marketing and brand consultancy services",
      },
      {
        value: "[70206]Port, shipping and maritime-related consultancy services",
        zh: "[70206]Port, shipping and maritime-related consultancy services / 港口、航运及海事相关咨询服务",
        en: "[70206]Port, shipping and maritime-related consultancy services",
      },
      {
        value: "[70209]Management consultancy services n.e.c.",
        zh: "[70209]Management consultancy services n.e.c. / 其他管理咨询服务",
        en: "[70209]Management consultancy services n.e.c.",
      },
      {
        value: "[71111]Architectural services",
        zh: "[71111]Architectural services / 建筑设计服务",
        en: "[71111]Architectural services",
      },
      {
        value: "[71112]Landscape design and landscape architecture",
        zh: "[71112]Landscape design and landscape architecture / 景观设计与景观建筑",
        en: "[71112]Landscape design and landscape architecture",
      },
      {
        value: "[71113]Quantity surveying services",
        zh: "[71113]Quantity surveying services / 工程量估算服务",
        en: "[71113]Quantity surveying services",
      },
      {
        value: "[71114]Land surveying services",
        zh: "[71114]Land surveying services / 土地测量服务",
        en: "[71114]Land surveying services",
      },
      {
        value: "[71119]Other surveying services n.e.c.",
        zh: "[71119]Other surveying services n.e.c. / 其他测量服务（不包括上述各项）",
        en: "[71119]Other surveying services n.e.c.",
      },
      {
        value: "[71121]General building engineering design and consultancy services",
        zh: "[71121]General building engineering design and consultancy services / 一般建筑工程项目设计与咨询服务",
        en: "[71121]General building engineering design and consultancy services",
      },
      {
        value: "[71122]Process and industrial plant engineering design and consultancy services",
        zh: "[71122]Process and industrial plant engineering design and consultancy services / 流程和工业设施工程设计与咨询服务",
        en: "[71122]Process and industrial plant engineering design and consultancy services",
      },
      {
        value: "[71123]Engineering design and consultancy services in energy management and clean energy systems",
        zh: "[71123]Engineering design and consultancy services in energy management and clean energy systems / 能源管理和清洁能源系统工程设计与咨询服务",
        en: "[71123]Engineering design and consultancy services in energy management and clean energy systems",
      },
      {
        value: "[71124]Environmental engineering design and consultancy services (except clean energy)",
        zh: "[71124]Environmental engineering design and consultancy services (except clean energy) / 环境工程设计与咨询服务（不包括清洁能源）",
        en: "[71124]Environmental engineering design and consultancy services (except clean energy)",
      },
      {
        value: "[71125]Infrastructure engineering design and consultancy services",
        zh: "[71125]Infrastructure engineering design and consultancy services / 基础设施工程设计及咨询服务",
        en: "[71125]Infrastructure engineering design and consultancy services",
      },
      {
        value: "[71126]Engineering design and consultancy services supporting mining, oil and gas extraction and offshore exploration activities",
        zh: "[71126]Engineering design and consultancy services supporting mining, oil and gas extraction and offshore exploration activities / 支持矿产、石油和天然气开采以及海上勘探活动的工程设计及咨询服务业",
        en: "[71126]Engineering design and consultancy services supporting mining, oil and gas extraction and offshore exploration activities",
      },
      {
        value: "[71129]Engineering design and consultancy activities n.e.c.",
        zh: "[71129]Engineering design and consultancy activities n.e.c. / 工程设计及咨询活动（不包括其他）",
        en: "[71129]Engineering design and consultancy activities n.e.c.",
      },
      {
        value: "[71200]Technical testing and analysis services; certification of products and services",
        zh: "[71200]Technical testing and analysis services; certification of products and services / 技术测试与分析服务；产品和服务的认证",
        en: "[71200]Technical testing and analysis services; certification of products and services",
      },
      {
        value: "[72101]Research and experimental development on biotechnology (except medical and veterinary science)",
        zh: "[72101]Research and experimental development on biotechnology (except medical and veterinary science) / 生物技术研究与实验发展（不包括医学和兽医学）",
        en: "[72101]Research and experimental development on biotechnology (except medical and veterinary science)",
      },
      {
        value: "[72102]Research and experimental development on electronics (except medical and veterinary science)",
        zh: "[72102]Research and experimental development on electronics (except medical and veterinary science) / 电子学的研究与实验发展（不包括医学和兽医学）",
        en: "[72102]Research and experimental development on electronics (except medical and veterinary science)",
      },
      {
        value: "[72103]Research and experimental development on chemicals (except medical and veterinary science)",
        zh: "[72103]Research and experimental development on chemicals (except medical and veterinary science) / 化学品的研究与实验发展（不包括医学和兽医学）",
        en: "[72103]Research and experimental development on chemicals (except medical and veterinary science)",
      },
      {
        value: "[72104]Research and experimental development on engineering",
        zh: "[72104]Research and experimental development on engineering / 工程学的研究与实验发展",
        en: "[72104]Research and experimental development on engineering",
      },
      {
        value: "[72105]Research and experimental development on environment and clean technologies (except biotechnology)",
        zh: "[72105]Research and experimental development on environment and clean technologies (except biotechnology) / 环境和清洁技术的研究与实验发展（不包括生物技术）",
        en: "[72105]Research and experimental development on environment and clean technologies (except biotechnology)",
      },
      {
        value: "[72106]Research and experimental development on medical and veterinary sciences",
        zh: "[72106]Research and experimental development on medical and veterinary sciences / 医学和兽医学的研究与实验发展",
        en: "[72106]Research and experimental development on medical and veterinary sciences",
      },
      {
        value: "[72109]Research and experimental development on natural sciences n.e.c.",
        zh: "[72109]Research and experimental development on natural sciences n.e.c. / 自然科学的研究与实验发展",
        en: "[72109]Research and experimental development on natural sciences n.e.c.",
      },
      {
        value: "[72200]Research and experimental development on social sciences and humanities",
        zh: "[72200]Research and experimental development on social sciences and humanities / 社会人文科学的研究与实验发展",
        en: "[72200]Research and experimental development on social sciences and humanities",
      },
      {
        value: "[73100]Advertising activities",
        zh: "[73100]Advertising activities / 广告活动",
        en: "[73100]Advertising activities",
      },
      {
        value: "[73200]Market research and public opinion polling",
        zh: "[73200]Market research and public opinion polling / 市场研究与民意测验",
        en: "[73200]Market research and public opinion polling",
      },
      {
        value: "[74111]Electronics-related industrial design services",
        zh: "[74111]Electronics-related industrial design services / 与电子相关的工业设计服务",
        en: "[74111]Electronics-related industrial design services",
      },
      {
        value: "[74112]Transport-related industrial design services",
        zh: "[74112]Transport-related industrial design services / 与交通有关的工业设计服务",
        en: "[74112]Transport-related industrial design services",
      },
      {
        value: "[74113]Furniture design services",
        zh: "[74113]Furniture design services / 家具设计服务",
        en: "[74113]Furniture design services",
      },
      {
        value: "[74119]Industrial design activities n.e.c.",
        zh: "[74119]Industrial design activities n.e.c. / 工业设计活动（不包括其他类）",
        en: "[74119]Industrial design activities n.e.c.",
      },
      {
        value: "[74191]Interior design services",
        zh: "[74191]Interior design services / 室内设计服务",
        en: "[74191]Interior design services",
      },
      {
        value: "[74192]Art and graphic design services",
        zh: "[74192]Art and graphic design services / 艺术与图形设计服务",
        en: "[74192]Art and graphic design services",
      },
      {
        value: "[74193]Fashion and accessories design services",
        zh: "[74193]Fashion and accessories design services / 时尚与配饰设计服务",
        en: "[74193]Fashion and accessories design services",
      },
      {
        value: "[74194]Exhibition stand design services",
        zh: "[74194]Exhibition stand design services / 展览摊位设计服务",
        en: "[74194]Exhibition stand design services",
      },
      {
        value: "[74199]Other specialised design activities n.e.c.",
        zh: "[74199]Other specialised design activities n.e.c. / 其他专门设计活动（不包括其他类）",
        en: "[74199]Other specialised design activities n.e.c.",
      },
      {
        value: "[74200]Photographic activities",
        zh: "[74200]Photographic activities / 摄影活动",
        en: "[74200]Photographic activities",
      },
      {
        value: "[74901]Translation services",
        zh: "[74901]Translation services / 翻译服务",
        en: "[74901]Translation services",
      },
      {
        value: "[74902]Brokerage and consultancy services of intellectual property assets",
        zh: "[74902]Brokerage and consultancy services of intellectual property assets / 知识产权资产的经纪和咨询服务",
        en: "[74902]Brokerage and consultancy services of intellectual property assets",
      },
      {
        value: "[74903]Agrotechnology consultancy services",
        zh: "[74903]Agrotechnology consultancy services / 农业技术咨询服务",
        en: "[74903]Agrotechnology consultancy services",
      },
      {
        value: "[74904]Sustainability consultancy services",
        zh: "[74904]Sustainability consultancy services / 可持续性咨询服务",
        en: "[74904]Sustainability consultancy services",
      },
      {
        value: "[74905]Agents for artistes, athletes, models and other performers",
        zh: "[74905]Agents for artistes, athletes, models and other performers / 艺术家、运动员、模特和其他表演者代理",
        en: "[74905]Agents for artistes, athletes, models and other performers",
      },
      {
        value: "[74909]Other professional, scientific and technical activities n.e.c.",
        zh: "[74909]Other professional, scientific and technical activities n.e.c. / 其他专业、科学和技术活动（其他）",
        en: "[74909]Other professional, scientific and technical activities n.e.c.",
      },
      {
        value: "[75000]Veterinary activities",
        zh: "[75000]Veterinary activities / 兽医活动",
        en: "[75000]Veterinary activities",
      },
      {
        value: "[77101]Renting and leasing of private cars without driver",
        zh: "[77101]Renting and leasing of private cars without driver / 无司机的私家车租赁",
        en: "[77101]Renting and leasing of private cars without driver",
      },
      {
        value: "[77102]Renting and leasing of bicycles and inline/roller skates",
        zh: "[77102]Renting and leasing of bicycles and inline/roller skates / 自行车和直排轮/溜冰鞋的租赁",
        en: "[77102]Renting and leasing of bicycles and inline/roller skates",
      },
      {
        value: "[77109]Renting and leasing of land transport equipment without driver n.e.c. (except cars)",
        zh: "[77109]Renting and leasing of land transport equipment without driver n.e.c. (except cars) / 陆上运输设备（不包括汽车）的租赁和出租，未具体说明的",
        en: "[77109]Renting and leasing of land transport equipment without driver n.e.c. (except cars)",
      },
      {
        value: "[77210]Renting and leasing of recreational and sports goods",
        zh: "[77210]Renting and leasing of recreational and sports goods / 娱乐和运动用品的租赁和出租",
        en: "[77210]Renting and leasing of recreational and sports goods",
      },
      {
        value: "[77291]Renting and leasing of furniture, utensils and electronic equipment for household use",
        zh: "[77291]Renting and leasing of furniture, utensils and electronic equipment for household use / 家具、餐具和家用电子设备的租赁和出租",
        en: "[77291]Renting and leasing of furniture, utensils and electronic equipment for household use",
      },
      {
        value: "[77292]Renting of costumes and other attire",
        zh: "[77292]Renting of costumes and other attire / 服装和其他服饰的租赁",
        en: "[77292]Renting of costumes and other attire",
      },
      {
        value: "[77299]Renting and leasing of other personal and household goods n.e.c.",
        zh: "[77299]Renting and leasing of other personal and household goods n.e.c. / 其他个人和家庭用品的租赁和出租",
        en: "[77299]Renting and leasing of other personal and household goods n.e.c.",
      },
      {
        value: "[77310]Renting of water transport equipment and floating structures without operator",
        zh: "[77310]Renting of water transport equipment and floating structures without operator / 不带操作员的水上运输设备和浮动结构租赁",
        en: "[77310]Renting of water transport equipment and floating structures without operator",
      },
      {
        value: "[77320]Renting of air transport equipment without operator",
        zh: "[77320]Renting of air transport equipment without operator / 不带操作员的航空运输设备租赁",
        en: "[77320]Renting of air transport equipment without operator",
      },
      {
        value: "[77330]Renting of construction and civil engineering machinery and equipment without operator",
        zh: "[77330]Renting of construction and civil engineering machinery and equipment without operator / 不带操作员的建筑和土木工程机械和设备租赁",
        en: "[77330]Renting of construction and civil engineering machinery and equipment without operator",
      },
      {
        value: "[77341]Renting of computers and peripheral equipment without operator",
        zh: "[77341]Renting of computers and peripheral equipment without operator / 不带操作员的计算机及外围设备租赁",
        en: "[77341]Renting of computers and peripheral equipment without operator",
      },
      {
        value: "[77342]Renting of office machinery and equipment without operator",
        zh: "[77342]Renting of office machinery and equipment without operator / 不带操作员的办公机械和设备租赁",
        en: "[77342]Renting of office machinery and equipment without operator",
      },
      {
        value: "[77391]Renting and leasing of professional radio and television sets and sound reproducing and recording equipment without operator",
        zh: "[77391]Renting and leasing of professional radio and television sets and sound reproducing and recording equipment without operator / 不带操作员的专业无线电和电视设备及声音复制和录制设备租赁",
        en: "[77391]Renting and leasing of professional radio and television sets and sound reproducing and recording equipment without operator",
      },
      {
        value: "[77392]Renting of industrial machinery and equipment without operator",
        zh: "[77392]Renting of industrial machinery and equipment without operator / 出租工业机械和设备（不含操作员）",
        en: "[77392]Renting of industrial machinery and equipment without operator",
      },
      {
        value: "[77399]Renting of other machinery, equipment and tangible goods without operator n.e.c.",
        zh: "[77399]Renting of other machinery, equipment and tangible goods without operator n.e.c. / 出租其他机械、设备及有形物品（不含操作员）",
        en: "[77399]Renting of other machinery, equipment and tangible goods without operator n.e.c.",
      },
      {
        value: "[77400]Leasing of non-financial intangible assets",
        zh: "[77400]Leasing of non-financial intangible assets / 非金融无形资产的租赁",
        en: "[77400]Leasing of non-financial intangible assets",
      },
      {
        value: "[78101]IT manpower contracting services",
        zh: "[78101]IT manpower contracting services / IT人力外包服务",
        en: "[78101]IT manpower contracting services",
      },
      {
        value: "[78102]Manpower contracting services (except IT manpower)",
        zh: "[78102]Manpower contracting services (except IT manpower) / 人力外包服务（除了IT人力）",
        en: "[78102]Manpower contracting services (except IT manpower)",
      },
      {
        value: "[78103]Domestic worker employment placement agencies",
        zh: "[78103]Domestic worker employment placement agencies / 家庭工人就业安置机构",
        en: "[78103]Domestic worker employment placement agencies",
      },
      {
        value: "[78104]Employment agencies (except domestic worker employment placement agencies)",
        zh: "[78104]Employment agencies (except domestic worker employment placement agencies) / 就业机构（不包括家庭工人就业安置机构）",
        en: "[78104]Employment agencies (except domestic worker employment placement agencies)",
      },
      {
        value: "[78300]Management of human resource functions",
        zh: "[78300]Management of human resource functions / 人力资源职能管理",
        en: "[78300]Management of human resource functions",
      },
      {
        value: "[79101]Travel agencies and tour operators (mainly inbound)",
        zh: "[79101]Travel agencies and tour operators (mainly inbound) / 旅行社和旅游运营商（主要接待国内游客）",
        en: "[79101]Travel agencies and tour operators (mainly inbound)",
      },
      {
        value: "[79102]Travel agencies and tour operators (mainly outbound)",
        zh: "[79102]Travel agencies and tour operators (mainly outbound) / 旅行社和旅游运营商（主要组织出境游）",
        en: "[79102]Travel agencies and tour operators (mainly outbound)",
      },
      {
        value: "[80100]Private security activities",
        zh: "[80100]Private security activities / 私人保安活动",
        en: "[80100]Private security activities",
      },
      {
        value: "[80200]Detective and investigation activities",
        zh: "[80200]Detective and investigation activities / 侦探和调查活动",
        en: "[80200]Detective and investigation activities",
      },
      {
        value: "[81211]General cleaning services (except household cleaning)",
        zh: "[81211]General cleaning services (except household cleaning) / 一般清洁服务（不包括家庭清洁）",
        en: "[81211]General cleaning services (except household cleaning)",
      },
      {
        value: "[81212]Domestic/household cleaning services",
        zh: "[81212]Domestic/household cleaning services / 家庭/住宅清洁服务",
        en: "[81212]Domestic/household cleaning services",
      },
      {
        value: "[81291]Pest control services not in connection with agriculture",
        zh: "[81291]Pest control services not in connection with agriculture / 与农业无关的害虫控制服务",
        en: "[81291]Pest control services not in connection with agriculture",
      },
      {
        value: "[81292]Cleaning, maintenance and/or treatment of swimming pools, spa pools, water playgrounds and fountains",
        zh: "[81292]Cleaning, maintenance and/or treatment of swimming pools, spa pools, water playgrounds and fountains / 游泳池、水疗池、水上乐园和喷泉的清洁、维护和/或处理",
        en: "[81292]Cleaning, maintenance and/or treatment of swimming pools, spa pools, water playgrounds and fountains",
      },
      {
        value: "[81299]Other cleaning services n.e.c.",
        zh: "[81299]Other cleaning services n.e.c. / 其他未列明的清洁服务",
        en: "[81299]Other cleaning services n.e.c.",
      },
      {
        value: "[81300]Landscape service activities (except landscape design and architecture)",
        zh: "[81300]Landscape service activities (except landscape design and architecture) / 景观服务活动（除景观设计和建筑外）",
        en: "[81300]Landscape service activities (except landscape design and architecture)",
      },
      {
        value: "[82110]Office administrative services on a fee or contract basis",
        zh: "[82110]Office administrative services on a fee or contract basis / 按费用或合同基础的办公行政服务",
        en: "[82110]Office administrative services on a fee or contract basis",
      },
      {
        value: "[82191]Stenographic and secretarial services",
        zh: "[82191]Stenographic and secretarial services / 速记和秘书服务",
        en: "[82191]Stenographic and secretarial services",
      },
      {
        value: "[82192]Duplicating and photo-copying services",
        zh: "[82192]Duplicating and photo-copying services / 复印和照相复制服务",
        en: "[82192]Duplicating and photo-copying services",
      },
      {
        value: "[82199]Other specialised office support activities n.e.c.",
        zh: "[82199]Other specialised office support activities n.e.c. / 其他未特指的专业办公支持活动",
        en: "[82199]Other specialised office support activities n.e.c.",
      },
      {
        value: "[82200]Call centres",
        zh: "[82200]Call centres / 呼叫中心",
        en: "[82200]Call centres",
      },
      {
        value: "[82301]Exhibition organisers",
        zh: "[82301]Exhibition organisers / 展览组织者",
        en: "[82301]Exhibition organisers",
      },
      {
        value: "[82302]Convention/conference/corporate meeting organisers",
        zh: "[82302]Convention/conference/corporate meeting organisers / 会议/会议/企业会议组织者",
        en: "[82302]Convention/conference/corporate meeting organisers",
      },
      {
        value: "[82303]Event organisers (except concerts, sports/fitness event organisers and wedding planners)",
        zh: "[82303]Event organisers (except concerts, sports/fitness event organisers and wedding planners) / 活动组织者（音乐会、体育/健身活动组织者和婚礼策划者除外）",
        en: "[82303]Event organisers (except concerts, sports/fitness event organisers and wedding planners)",
      },
      {
        value: "[82304]Exhibition stand contractors",
        zh: "[82304]Exhibition stand contractors / 展览摊位承包商",
        en: "[82304]Exhibition stand contractors",
      },
      {
        value: "[82305]Concert organisers",
        zh: "[82305]Concert organisers / 音乐会组织者",
        en: "[82305]Concert organisers",
      },
      {
        value: "[82911]Debt collection services",
        zh: "[82911]Debt collection services / 债务催收服务",
        en: "[82911]Debt collection services",
      },
      {
        value: "[82912]Credit rating agencies",
        zh: "[82912]Credit rating agencies / 信用评级机构",
        en: "[82912]Credit rating agencies",
      },
      {
        value: "[82920]Packaging activities",
        zh: "[82920]Packaging activities / 包装活动",
        en: "[82920]Packaging activities",
      },
      {
        value: "[82991]Activities of auction houses",
        zh: "[82991]Activities of auction houses / 拍卖行活动",
        en: "[82991]Activities of auction houses",
      },
      {
        value: "[82999]Other business support service activities",
        zh: "[82999]Other business support service activities / 其他商业支持服务活动",
        en: "[82999]Other business support service activities",
      },
      {
        value: "[84110]Executive, legislative and other general public administration",
        zh: "[84110]Executive, legislative and other general public administration / 行政、立法及其他一般公共行政",
        en: "[84110]Executive, legislative and other general public administration",
      },
      {
        value: "[84120]Public administration of economic, social and environmental programmes",
        zh: "[84120]Public administration of economic, social and environmental programmes / 经济、社会和环境计划的公共行政",
        en: "[84120]Public administration of economic, social and environmental programmes",
      },
      {
        value: "[84210]Foreign affairs",
        zh: "[84210]Foreign affairs / 外交事务",
        en: "[84210]Foreign affairs",
      },
      {
        value: "[84221]Armed forces",
        zh: "[84221]Armed forces / 武装部队",
        en: "[84221]Armed forces",
      },
      {
        value: "[84229]Defence activities n.e.c.",
        zh: "[84229]Defence activities n.e.c. / 其他国防活动",
        en: "[84229]Defence activities n.e.c.",
      },
      {
        value: "[84231]Judiciary and related services",
        zh: "[84231]Judiciary and related services / 司法及相关服务",
        en: "[84231]Judiciary and related services",
      },
      {
        value: "[84232]Police",
        zh: "[84232]Police / 警察",
        en: "[84232]Police",
      },
      {
        value: "[84233]Prisons",
        zh: "[84233]Prisons / 监狱",
        en: "[84233]Prisons",
      },
      {
        value: "[84234]Other places of detention, correction and rehabilitation",
        zh: "[84234]Other places of detention, correction and rehabilitation / 其他拘留、矫正和康复场所",
        en: "[84234]Other places of detention, correction and rehabilitation",
      },
      {
        value: "[84235]Civil defence",
        zh: "[84235]Civil defence / 民防",
        en: "[84235]Civil defence",
      },
      {
        value: "[84239]Public order and safety activities n.e.c.",
        zh: "[84239]Public order and safety activities n.e.c. / 公共秩序与安全活动（不包括其他分类的）",
        en: "[84239]Public order and safety activities n.e.c.",
      },
      {
        value: "[85100]Pre-primary education; child care with pre-primary education services",
        zh: "[85100]Pre-primary education; child care with pre-primary education services / 学前教育；含学前教育的托儿服务",
        en: "[85100]Pre-primary education; child care with pre-primary education services",
      },
      {
        value: "[85200]Primary education",
        zh: "[85200]Primary education / 初等教育",
        en: "[85200]Primary education",
      },
      {
        value: "[85310]Secondary schools; combined primary and secondary schools",
        zh: "[85310]Secondary schools; combined primary and secondary schools / 中学；包含小学和中学的学校",
        en: "[85310]Secondary schools; combined primary and secondary schools",
      },
      {
        value: "[85320]Technical and vocational (secondary and post-secondary non-tertiary) education",
        zh: "[85320]Technical and vocational (secondary and post-secondary non-tertiary) education / 技术和职业教育（中等及中等后非高等教育）",
        en: "[85320]Technical and vocational (secondary and post-secondary non-tertiary) education",
      },
      {
        value: "[85331]Junior colleges and centralised pre-university institutes (post-secondary non-tertiary); combined secondary schools and post-secondary non-tertiary schools",
        zh: "[85331]Junior colleges and centralised pre-university institutes (post-secondary non-tertiary); combined secondary schools and post-secondary non-tertiary schools / 初级学院和集中式预大学学院（高中后非高等教育）；综合中学和高中后非高等教育学校",
        en: "[85331]Junior colleges and centralised pre-university institutes (post-secondary non-tertiary); combined secondary schools and post-secondary non-tertiary schools",
      },
      {
        value: "[85332]Commercial schools offering general secondary and post-secondary non-tertiary education programmes",
        zh: "[85332]Commercial schools offering general secondary and post-secondary non-tertiary education programmes / 提供普通中等和高中后非高等教育课程的商业学校",
        en: "[85332]Commercial schools offering general secondary and post-secondary non-tertiary education programmes",
      },
      {
        value: "[85340]International and foreign system schools",
        zh: "[85340]International and foreign system schools / 国际和外国体系学校",
        en: "[85340]International and foreign system schools",
      },
      {
        value: "[85350]Schools for special needs",
        zh: "[85350]Schools for special needs / 特殊需求学校",
        en: "[85350]Schools for special needs",
      },
      {
        value: "[85360]Specialised education schools",
        zh: "[85360]Specialised education schools / 专门教育学校",
        en: "[85360]Specialised education schools",
      },
      {
        value: "[85401]Polytechnics",
        zh: "[85401]Polytechnics / 理工学院",
        en: "[85401]Polytechnics",
      },
      {
        value: "[85402]Universities",
        zh: "[85402]Universities / 大学",
        en: "[85402]Universities",
      },
      {
        value: "[85403]Teachers' training institute",
        zh: "[85403]Teachers' training institute / 教师培训学院",
        en: "[85403]Teachers' training institute",
      },
      {
        value: "[85404]Commercial schools offering tertiary education programmes",
        zh: "[85404]Commercial schools offering tertiary education programmes / 提供高等教育课程的商业学校",
        en: "[85404]Commercial schools offering tertiary education programmes",
      },
      {
        value: "[85501]Training courses for construction, real estate, security and investigation services, cleaning, landscaping, waste management and pest management",
        zh: "[85501]Training courses for construction, real estate, security and investigation services, cleaning, landscaping, waste management and pest management / 建筑、房地产、安全与调查服务、清洁、景观设计、废物管理和害虫管理培训课程",
        en: "[85501]Training courses for construction, real estate, security and investigation services, cleaning, landscaping, waste management and pest management",
      },
      {
        value: "[85502]Training courses for healthcare, education, community and social services",
        zh: "[85502]Training courses for healthcare, education, community and social services / 医疗保健、教育、社区和社会服务培训课程",
        en: "[85502]Training courses for healthcare, education, community and social services",
      },
      {
        value: "[85503]Training courses for food and beverage, retail and accommodation, tour operators, travel agencies and travel-related reservation services",
        zh: "[85503]Training courses for food and beverage, retail and accommodation, tour operators, travel agencies and travel-related reservation services / 食品与饮料、零售和住宿、旅行社、旅游代理和相关预订服务培训课程",
        en: "[85503]Training courses for food and beverage, retail and accommodation, tour operators, travel agencies and travel-related reservation services",
      },
      {
        value: "[85504]Training courses for manufacturing",
        zh: "[85504]Training courses for manufacturing / 制造业培训课程",
        en: "[85504]Training courses for manufacturing",
      },
      {
        value: "[85505]Training courses for information and communications, finance and professional services",
        zh: "[85505]Training courses for information and communications, finance and professional services / 信息与通信、金融和专业服务培训课程",
        en: "[85505]Training courses for information and communications, finance and professional services",
      },
      {
        value: "[85506]Training courses for wholesale trade, logistics and transport",
        zh: "[85506]Training courses for wholesale trade, logistics and transport / 批发贸易、物流和运输培训课程",
        en: "[85506]Training courses for wholesale trade, logistics and transport",
      },
      {
        value: "[85507]Training courses for sports and games",
        zh: "[85507]Training courses for sports and games / 体育和游戏培训课程",
        en: "[85507]Training courses for sports and games",
      },
      {
        value: "[85508]Training courses for music, dancing, art, speech and drama",
        zh: "[85508]Training courses for music, dancing, art, speech and drama / 音乐、舞蹈、艺术、演讲和戏剧培训课程",
        en: "[85508]Training courses for music, dancing, art, speech and drama",
      },
      {
        value: "[85509]Training courses n.e.c.",
        zh: "[85509]Training courses n.e.c. / 其他教育服务培训课程",
        en: "[85509]Training courses n.e.c.",
      },
      {
        value: "[85601]Student recruitment agencies",
        zh: "[85601]Student recruitment agencies / 学生招生代理机构",
        en: "[85601]Student recruitment agencies",
      },
      {
        value: "[85602]Examination and accreditation agencies for education services",
        zh: "[85602]Examination and accreditation agencies for education services / 教育服务考试和认证机构",
        en: "[85602]Examination and accreditation agencies for education services",
      },
      {
        value: "[85609]Educational support services n.e.c.",
        zh: "[85609]Educational support services n.e.c. / 其他教育支持服务",
        en: "[85609]Educational support services n.e.c.",
      },
      {
        value: "[86101]Acute hospitals",
        zh: "[86101]Acute hospitals / 急性医院",
        en: "[86101]Acute hospitals",
      },
      {
        value: "[86102]Community hospitals",
        zh: "[86102]Community hospitals / 社区医院",
        en: "[86102]Community hospitals",
      },
      {
        value: "[86109]Hospital activities n.e.c.",
        zh: "[86109]Hospital activities n.e.c. / 其他医院活动",
        en: "[86109]Hospital activities n.e.c.",
      },
      {
        value: "[86201]Clinics and other general medical services (Western)",
        zh: "[86201]Clinics and other general medical services (Western) / 诊所和其他一般医疗服务（西方）",
        en: "[86201]Clinics and other general medical services (Western)",
      },
      {
        value: "[86202]Clinics and other general medical services (Non-Western)",
        zh: "[86202]Clinics and other general medical services (Non-Western) / 诊所及其他一般医疗服务（非西方）",
        en: "[86202]Clinics and other general medical services (Non-Western)",
      },
      {
        value: "[86203]Specialised medical services",
        zh: "[86203]Specialised medical services / 专业医疗服务",
        en: "[86203]Specialised medical services",
      },
      {
        value: "[86204]Dental services",
        zh: "[86204]Dental services / 牙科服务",
        en: "[86204]Dental services",
      },
      {
        value: "[86901]Medical laboratories",
        zh: "[86901]Medical laboratories / 医学实验室",
        en: "[86901]Medical laboratories",
      },
      {
        value: "[86902]Medical diagnostic imaging centres",
        zh: "[86902]Medical diagnostic imaging centres / 医学诊断影像中心",
        en: "[86902]Medical diagnostic imaging centres",
      },
      {
        value: "[86903]Ambulance and medical evacuation services",
        zh: "[86903]Ambulance and medical evacuation services / 救护车和医疗撤离服务",
        en: "[86903]Ambulance and medical evacuation services",
      },
      {
        value: "[86904]Home healthcare services",
        zh: "[86904]Home healthcare services / 家庭医疗保健服务",
        en: "[86904]Home healthcare services",
      },
      {
        value: "[86905]Dialysis services",
        zh: "[86905]Dialysis services / 透析服务",
        en: "[86905]Dialysis services",
      },
      {
        value: "[86909]Other health services n.e.c.",
        zh: "[86909]Other health services n.e.c. / 其他健康服务",
        en: "[86909]Other health services n.e.c.",
      },
      {
        value: "[87010]Nursing and personal care facilities",
        zh: "[87010]Nursing and personal care facilities / 护理和个人护理设施",
        en: "[87010]Nursing and personal care facilities",
      },
      {
        value: "[87021]Residential care services for the elderly",
        zh: "[87021]Residential care services for the elderly / 老年人住宅护理服务",
        en: "[87021]Residential care services for the elderly",
      },
      {
        value: "[87022]Residential care services for children",
        zh: "[87022]Residential care services for children / 儿童住宅护理服务",
        en: "[87022]Residential care services for children",
      },
      {
        value: "[87029]Other residential care services n.e.c.",
        zh: "[87029]Other residential care services n.e.c. / 其他住宅护理服务",
        en: "[87029]Other residential care services n.e.c.",
      },
      {
        value: "[88101]Social services for the elderly",
        zh: "[88101]Social services for the elderly / 老年人的社会服务",
        en: "[88101]Social services for the elderly",
      },
      {
        value: "[88102]Social services for persons with disabilities",
        zh: "[88102]Social services for persons with disabilities / 残疾人社会服务",
        en: "[88102]Social services for persons with disabilities",
      },
      {
        value: "[88911]Infant care services; child minding services for pre-school children",
        zh: "[88911]Infant care services; child minding services for pre-school children / 婴儿护理服务；学龄前儿童看护服务",
        en: "[88911]Infant care services; child minding services for pre-school children",
      },
      {
        value: "[88912]Student care services; child minding services for school-going children",
        zh: "[88912]Student care services; child minding services for school-going children / 学生护理服务；学龄儿童看护服务",
        en: "[88912]Student care services; child minding services for school-going children",
      },
      {
        value: "[88913]Social services for children and youths",
        zh: "[88913]Social services for children and youths / 儿童和青少年的社会服务",
        en: "[88913]Social services for children and youths",
      },
      {
        value: "[88919]Social services without accommodation for children, youth and families n.e.c.",
        zh: "[88919]Social services without accommodation for children, youth and families n.e.c. / 无住宿的社会服务，包括儿童、青少年和家庭",
        en: "[88919]Social services without accommodation for children, youth and families n.e.c.",
      },
      {
        value: "[88920]Community development councils",
        zh: "[88920]Community development councils / 社区发展议会",
        en: "[88920]Community development councils",
      },
      {
        value: "[88991]Job training and vocational rehabilitation services",
        zh: "[88991]Job training and vocational rehabilitation services / 职业培训和职业康复服务",
        en: "[88991]Job training and vocational rehabilitation services",
      },
      {
        value: "[88992]Charitable and other supporting activities aimed at humanitarian work",
        zh: "[88992]Charitable and other supporting activities aimed at humanitarian work / 旨在人道主义工作的慈善和其他支持活动",
        en: "[88992]Charitable and other supporting activities aimed at humanitarian work",
      },
      {
        value: "[88999]Other social services without accommodation n.e.c.",
        zh: "[88999]Other social services without accommodation n.e.c. / 其他无住宿的社会服务",
        en: "[88999]Other social services without accommodation n.e.c.",
      },
      {
        value: "[90110]Literary creation and musical composition activities",
        zh: "[90110]Literary creation and musical composition activities / 文学创作和音乐作曲活动",
        en: "[90110]Literary creation and musical composition activities",
      },
      {
        value: "[90120]Visual arts creation activities",
        zh: "[90120]Visual arts creation activities / 视觉艺术创作活动",
        en: "[90120]Visual arts creation activities",
      },
      {
        value: "[90190]Other arts creation activities",
        zh: "[90190]Other arts creation activities / 其他艺术创作活动",
        en: "[90190]Other arts creation activities",
      },
      {
        value: "[90201]Production of live theatrical presentations",
        zh: "[90201]Production of live theatrical presentations / 现场戏剧制作活动",
        en: "[90201]Production of live theatrical presentations",
      },
      {
        value: "[90202]Orchestras, musical bands, choirs and dance performance activities",
        zh: "[90202]Orchestras, musical bands, choirs and dance performance activities / 管弦乐队、音乐乐队、合唱团和舞蹈表演活动",
        en: "[90202]Orchestras, musical bands, choirs and dance performance activities",
      },
      {
        value: "[90209]Activities of performing arts n.e.c.",
        zh: "[90209]Activities of performing arts n.e.c. / 其他表演艺术活动",
        en: "[90209]Activities of performing arts n.e.c.",
      },
      {
        value: "[90310]Arts facilities/venue operation",
        zh: "[90310]Arts facilities/venue operation / 艺术设施/场地运营",
        en: "[90310]Arts facilities/venue operation",
      },
      {
        value: "[90390]Other support activities to arts and performing arts",
        zh: "[90390]Other support activities to arts and performing arts / 其他艺术及表演艺术支持活动",
        en: "[90390]Other support activities to arts and performing arts",
      },
      {
        value: "[91100]Libraries and archives activities",
        zh: "[91100]Libraries and archives activities / 图书馆和档案馆活动",
        en: "[91100]Libraries and archives activities",
      },
      {
        value: "[91201]Museums",
        zh: "[91201]Museums / 博物馆",
        en: "[91201]Museums",
      },
      {
        value: "[91209]Operation of historical sites and buildings n.e.c.",
        zh: "[91209]Operation of historical sites and buildings n.e.c. / 历史遗址和建筑物的运营（不包括未分类的）",
        en: "[91209]Operation of historical sites and buildings n.e.c.",
      },
      {
        value: "[91300]Conservation, restoration and other support activities for cultural heritage",
        zh: "[91300]Conservation, restoration and other support activities for cultural heritage / 文化遗产的保护、修复及其他支持活动",
        en: "[91300]Conservation, restoration and other support activities for cultural heritage",
      },
      {
        value: "[91400]Botanical and zoological gardens and nature reserves activities (except landscaping and nature tours)",
        zh: "[91400]Botanical and zoological gardens and nature reserves activities (except landscaping and nature tours) / 植物园和动物园及自然保护区活动（除景观设计和自然之旅）",
        en: "[91400]Botanical and zoological gardens and nature reserves activities (except landscaping and nature tours)",
      },
      {
        value: "[92001]Horse-racing and other betting activities",
        zh: "[92001]Horse-racing and other betting activities / 赛马及其他投注活动",
        en: "[92001]Horse-racing and other betting activities",
      },
      {
        value: "[92002]Casinos",
        zh: "[92002]Casinos / 赌场",
        en: "[92002]Casinos",
      },
      {
        value: "[93111]Fitness centres and gymnasiums",
        zh: "[93111]Fitness centres and gymnasiums / 健身中心和体育馆",
        en: "[93111]Fitness centres and gymnasiums",
      },
      {
        value: "[93112]Sports/fitness event organisers",
        zh: "[93112]Sports/fitness event organisers / 体育/健身活动组织者",
        en: "[93112]Sports/fitness event organisers",
      },
      {
        value: "[93119]Operation of sports facilities n.e.c.",
        zh: "[93119]Operation of sports facilities n.e.c. / 其他体育设施运营",
        en: "[93119]Operation of sports facilities n.e.c.",
      },
      {
        value: "[93120]Activities of sports clubs/associations and related activities",
        zh: "[93120]Activities of sports clubs/associations and related activities / 体育俱乐部/协会活动及相关活动",
        en: "[93120]Activities of sports clubs/associations and related activities",
      },
      {
        value: "[93201]Amusement theme parks, adventure and family attractions",
        zh: "[93201]Amusement theme parks, adventure and family attractions / 娱乐主题公园、冒险和家庭娱乐设施",
        en: "[93201]Amusement theme parks, adventure and family attractions",
      },
      {
        value: "[93202]Game arcade, online game aggregator, LAN game operators and gaming centres",
        zh: "[93202]Game arcade, online game aggregator, LAN game operators and gaming centres / 游戏机房、在线游戏聚合、局域网游戏运营商和游戏中心",
        en: "[93202]Game arcade, online game aggregator, LAN game operators and gaming centres",
      },
      {
        value: "[93203]Night clubs, discotheques, dance clubs and karaoke lounges",
        zh: "[93203]Night clubs, discotheques, dance clubs and karaoke lounges / 夜总会、迪斯科舞厅、舞蹈俱乐部和卡拉OK休息室",
        en: "[93203]Night clubs, discotheques, dance clubs and karaoke lounges",
      },
      {
        value: "[93204]Recreation clubs",
        zh: "[93204]Recreation clubs / 休闲俱乐部",
        en: "[93204]Recreation clubs",
      },
      {
        value: "[93209]Other amusement and recreation activities n.e.c.",
        zh: "[93209]Other amusement and recreation activities n.e.c. / 其他娱乐和休闲活动（不包括在内）",
        en: "[93209]Other amusement and recreation activities n.e.c.",
      },
      {
        value: "[94110]Activities of business and employers' membership organisations",
        zh: "[94110]Activities of business and employers' membership organisations / 商业和雇主会员组织的活动",
        en: "[94110]Activities of business and employers' membership organisations",
      },
      {
        value: "[94120]Activities of professional membership organisations",
        zh: "[94120]Activities of professional membership organisations / 专业会员组织的活动",
        en: "[94120]Activities of professional membership organisations",
      },
      {
        value: "[94200]Activities of trade unions and platform work associations",
        zh: "[94200]Activities of trade unions and platform work associations / 工会和平台工作协会的活动",
        en: "[94200]Activities of trade unions and platform work associations",
      },
      {
        value: "[94911]Churches",
        zh: "[94911]Churches / 教堂",
        en: "[94911]Churches",
      },
      {
        value: "[94912]Mosques",
        zh: "[94912]Mosques / 清真寺",
        en: "[94912]Mosques",
      },
      {
        value: "[94913]Buddhist/Taoist temples",
        zh: "[94913]Buddhist/Taoist temples / 佛教/道教寺庙",
        en: "[94913]Buddhist/Taoist temples",
      },
      {
        value: "[94914]Hindu/Sikh temples",
        zh: "[94914]Hindu/Sikh temples / 印度教/锡克教寺庙",
        en: "[94914]Hindu/Sikh temples",
      },
      {
        value: "[94919]Activities of religious organisations n.e.c.",
        zh: "[94919]Activities of religious organisations n.e.c. / 宗教组织的其他活动",
        en: "[94919]Activities of religious organisations n.e.c.",
      },
      {
        value: "[94920]Activities of political organisations",
        zh: "[94920]Activities of political organisations / 政治组织的活动",
        en: "[94920]Activities of political organisations",
      },
      {
        value: "[94991]Philanthropic trusts, foundations and related activities",
        zh: "[94991]Philanthropic trusts, foundations and related activities / 慈善信托、基金会及相关活动",
        en: "[94991]Philanthropic trusts, foundations and related activities",
      },
      {
        value: "[94992]Ethnic associations",
        zh: "[94992]Ethnic associations / 民族协会",
        en: "[94992]Ethnic associations",
      },
      {
        value: "[94993]Associations for hobbies, recreational, cultural and extra-curricular activities",
        zh: "[94993]Associations for hobbies, recreational, cultural and extra-curricular activities / 爱好、娱乐、文化和课外活动协会",
        en: "[94993]Associations for hobbies, recreational, cultural and extra-curricular activities",
      },
      {
        value: "[94994]Student/alumni bodies and related associations",
        zh: "[94994]Student/alumni bodies and related associations / 学生/校友团体及相关协会",
        en: "[94994]Student/alumni bodies and related associations",
      },
      {
        value: "[94995]Organisations for the protection of the environment and animals",
        zh: "[94995]Organisations for the protection of the environment and animals / 环境保护和动物保护组织",
        en: "[94995]Organisations for the protection of the environment and animals",
      },
      {
        value: "[94996]Community and grassroots organisations",
        zh: "[94996]Community and grassroots organisations / 社区和基层组织",
        en: "[94996]Community and grassroots organisations",
      },
      {
        value: "[94999]Activities of other membership organisations n.e.c.",
        zh: "[94999]Activities of other membership organisations n.e.c. / 其他会员组织的活动",
        en: "[94999]Activities of other membership organisations n.e.c.",
      },
      {
        value: "[95110]Repair and maintenance of computer hardware, data processing equipment and computer peripherals",
        zh: "[95110]Repair and maintenance of computer hardware, data processing equipment and computer peripherals / 计算机硬件、数据处理设备及计算机外围设备的修理和维护",
        en: "[95110]Repair and maintenance of computer hardware, data processing equipment and computer peripherals",
      },
      {
        value: "[95120]Repair of communications equipment",
        zh: "[95120]Repair of communications equipment / 通信设备修理",
        en: "[95120]Repair of communications equipment",
      },
      {
        value: "[95210]Repair of audio and video equipment",
        zh: "[95210]Repair of audio and video equipment / 视听设备修理",
        en: "[95210]Repair of audio and video equipment",
      },
      {
        value: "[95220]Repair of domestic electrical/electronic appliances (except audio and video equipment)",
        zh: "[95220]Repair of domestic electrical/electronic appliances (except audio and video equipment) / 家用电气/电子设备修理（不包括视听设备）",
        en: "[95220]Repair of domestic electrical/electronic appliances (except audio and video equipment)",
      },
      {
        value: "[95230]Repair of footwear and leather goods",
        zh: "[95230]Repair of footwear and leather goods / 鞋类和皮革制品修理",
        en: "[95230]Repair of footwear and leather goods",
      },
      {
        value: "[95240]Repair and restoration of cabinets, furniture, upholstery, window shades and other fixtures",
        zh: "[95240]Repair and restoration of cabinets, furniture, upholstery, window shades and other fixtures / 橱柜、家具、软包、窗帘及其他装置的修理和修复",
        en: "[95240]Repair and restoration of cabinets, furniture, upholstery, window shades and other fixtures",
      },
      {
        value: "[95291]Repair of bicycles and tricycles",
        zh: "[95291]Repair of bicycles and tricycles / 自行车和三轮车修理",
        en: "[95291]Repair of bicycles and tricycles",
      },
      {
        value: "[95292]Repair of watches and clocks",
        zh: "[95292]Repair of watches and clocks / 手表和钟表修理",
        en: "[95292]Repair of watches and clocks",
      },
      {
        value: "[95293]Repair of jewellery",
        zh: "[95293]Repair of jewellery / 珠宝修理",
        en: "[95293]Repair of jewellery",
      },
      {
        value: "[95299]Repair of other personal and household goods n.e.c.",
        zh: "[95299]Repair of other personal and household goods n.e.c. / 其他个人及家庭用品修理（不包括分类的）",
        en: "[95299]Repair of other personal and household goods n.e.c.",
      },
      {
        value: "[95301]Repair and maintenance of motor vehicles",
        zh: "[95301]Repair and maintenance of motor vehicles / 机动车的修理和维护",
        en: "[95301]Repair and maintenance of motor vehicles",
      },
      {
        value: "[95302]Car washing and related services",
        zh: "[95302]Car washing and related services / 洗车及相关服务",
        en: "[95302]Car washing and related services",
      },
      {
        value: "[95303]Motor vehicles inspection and valuation services",
        zh: "[95303]Motor vehicles inspection and valuation services / 机动车辆检查和估价服务",
        en: "[95303]Motor vehicles inspection and valuation services",
      },
      {
        value: "[96011]Laundry and dry cleaning services (except self-operated laundries)",
        zh: "[96011]Laundry and dry cleaning services (except self-operated laundries) / 洗衣和干洗服务(不包括自助洗衣店)",
        en: "[96011]Laundry and dry cleaning services (except self-operated laundries)",
      },
      {
        value: "[96012]Self-operated laundries",
        zh: "[96012]Self-operated laundries / 自助洗衣店",
        en: "[96012]Self-operated laundries",
      },
      {
        value: "[96021]Hairdressing salons/shops",
        zh: "[96021]Hairdressing salons/shops / 理发店/沙龙",
        en: "[96021]Hairdressing salons/shops",
      },
      {
        value: "[96022]Beauty salons and spas",
        zh: "[96022]Beauty salons and spas / 美容院和水疗中心",
        en: "[96022]Beauty salons and spas",
      },
      {
        value: "[96023]Manicure and pedicure services",
        zh: "[96023]Manicure and pedicure services / 修甲和足部护理服务",
        en: "[96023]Manicure and pedicure services",
      },
      {
        value: "[96024]Massage parlours and foot reflexology",
        zh: "[96024]Massage parlours and foot reflexology / 按摩院和足部反射疗法",
        en: "[96024]Massage parlours and foot reflexology",
      },
      {
        value: "[96029]Beauty and other personal care services n.e.c.",
        zh: "[96029]Beauty and other personal care services n.e.c. / 美容及其他个人护理服务",
        en: "[96029]Beauty and other personal care services n.e.c.",
      },
      {
        value: "[96030]Funeral and related activities",
        zh: "[96030]Funeral and related activities / 丧葬及相关活动",
        en: "[96030]Funeral and related activities",
      },
      {
        value: "[96040]Wedding and related activities",
        zh: "[96040]Wedding and related activities / 婚礼及相关活动",
        en: "[96040]Wedding and related activities",
      },
      {
        value: "[96091]Friendship, match-making and dating services",
        zh: "[96091]Friendship, match-making and dating services / 友谊、媒人和约会服务",
        en: "[96091]Friendship, match-making and dating services",
      },
      {
        value: "[96092]Social escort services",
        zh: "[96092]Social escort services / 社交陪同服务",
        en: "[96092]Social escort services",
      },
      {
        value: "[96093]Astrology, palmistry and other fortune telling services",
        zh: "[96093]Astrology, palmistry and other fortune telling services / 占星术、手相术和其他算命服务",
        en: "[96093]Astrology, palmistry and other fortune telling services",
      },
      {
        value: "[96094]Training of pets",
        zh: "[96094]Training of pets / 宠物训练",
        en: "[96094]Training of pets",
      },
      {
        value: "[96095]Care services for pets and animals",
        zh: "[96095]Care services for pets and animals / 宠物及动物的护理服务",
        en: "[96095]Care services for pets and animals",
      },
      {
        value: "[96099]Other personal service activities n.e.c.",
        zh: "[96099]Other personal service activities n.e.c. / 其他个人服务活动",
        en: "[96099]Other personal service activities n.e.c.",
      },
      {
        value: "[97001]Activities of households as employers of domestic workers",
        zh: "[97001]Activities of households as employers of domestic workers / 家庭作为家庭雇员的活动",
        en: "[97001]Activities of households as employers of domestic workers",
      },
      {
        value: "[97002]Activities of households as employers of other domestic personnel",
        zh: "[97002]Activities of households as employers of other domestic personnel / 家庭作为其他家庭雇员的活动",
        en: "[97002]Activities of households as employers of other domestic personnel",
      },
      {
        value: "[99010]Foreign embassies and trade representative offices",
        zh: "[99010]Foreign embassies and trade representative offices / 外国大使馆和贸易代表处",
        en: "[99010]Foreign embassies and trade representative offices",
      },
      {
        value: "[99020]Foreign armed forces",
        zh: "[99020]Foreign armed forces / 外国武装力量",
        en: "[99020]Foreign armed forces",
      },
      {
        value: "[99090]Other extra-territorial organisations and bodies",
        zh: "[99090]Other extra-territorial organisations and bodies / 其他境外组织和机构",
        en: "[99090]Other extra-territorial organisations and bodies",
      },
    ],
    // 旧的
    [
      {
        value: "[01111]Growing of leafy and fruit vegetables",
        zh: "[01111]Growing of leafy and fruit vegetables / 种植多叶蔬菜和水果蔬菜",
        en: "[01111]Growing of leafy and fruit vegetables",
      },
      {
        value: "[01112]Growing of mushrooms",
        zh: "[01112]Growing of mushrooms / 蘑菇的生长",
        en: "[01112]Growing of mushrooms",
      },
      {
        value: "[01113]Growing of root crops",
        zh: "[01113]Growing of root crops / 块根作物的种植",
        en: "[01113]Growing of root crops",
      },
      {
        value: "[01119]Growing of food crops (non-hydroponics) n.e.c.",
        zh: "[01119]Growing of food crops (non-hydroponics) n.e.c. / 种植粮食作物（非水培）",
        en: "[01119]Growing of food crops (non-hydroponics) n.e.c.",
      },
      {
        value: "[01120]Growing of leafy and fruit vegetables (hydroponics)",
        zh: "[01120]Growing of leafy and fruit vegetables (hydroponics) / 种植多叶蔬菜和水果蔬菜（水培）",
        en: "[01120]Growing of leafy and fruit vegetables (hydroponics)",
      },
      {
        value: "[01130]Growing of fruits",
        zh: "[01130]Growing of fruits / 水果的生长",
        en: "[01130]Growing of fruits",
      },
      {
        value: "[01141]Growing of orchids",
        zh: "[01141]Growing of orchids / 兰花的生长",
        en: "[01141]Growing of orchids",
      },
      {
        value: "[01142]Growing of ornamental plants",
        zh: "[01142]Growing of ornamental plants / 观赏植物的种植",
        en: "[01142]Growing of ornamental plants",
      },
      {
        value: "[01149]Growing of nursery products n.e.c.",
        zh: "[01149]Growing of nursery products n.e.c. / 育苗产品的种植",
        en: "[01149]Growing of nursery products n.e.c.",
      },
      {
        value: "[01190]Growing of other crops",
        zh: "[01190]Growing of other crops / 种植其他作物",
        en: "[01190]Growing of other crops",
      },
      {
        value: "[01411]Pig farms",
        zh: "[01411]Pig farms / 养猪场",
        en: "[01411]Pig farms",
      },
      {
        value: "[01412]Cattle farms (including dairy cattle)",
        zh: "[01412]Cattle farms (including dairy cattle) / 养牛场（包括奶牛）",
        en: "[01412]Cattle farms (including dairy cattle)",
      },
      {
        value: "[01413]Goat farms (including goat's milk production)",
        zh: "[01413]Goat farms (including goat's milk production) / 山羊农场（包括山羊奶生产）",
        en: "[01413]Goat farms (including goat's milk production)",
      },
      {
        value: "[01421]Poultry breeding/hatcheries",
        zh: "[01421]Poultry breeding/hatcheries / 家禽养殖/孵化场",
        en: "[01421]Poultry breeding/hatcheries",
      },
      {
        value: "[01422]Broiler farms (chickens reared for meat)",
        zh: "[01422]Broiler farms (chickens reared for meat) / 肉鸡农场（肉鸡饲养）",
        en: "[01422]Broiler farms (chickens reared for meat)",
      },
      {
        value: "[01423]Layer farms (chickens reared for eggs)",
        zh: "[01423]Layer farms (chickens reared for eggs) / 蛋鸡养殖场（饲养鸡蛋的鸡）",
        en: "[01423]Layer farms (chickens reared for eggs)",
      },
      {
        value: "[01424]Duck farms",
        zh: "[01424]Duck farms / 养鸭场",
        en: "[01424]Duck farms",
      },
      {
        value: "[01491]Dog breeding",
        zh: "[01491]Dog breeding / 养狗",
        en: "[01491]Dog breeding",
      },
      {
        value: "[01492]Bird breeding",
        zh: "[01492]Bird breeding / 鸟类育种",
        en: "[01492]Bird breeding",
      },
      {
        value: "[01493]Crocodile farms",
        zh: "[01493]Crocodile farms / 鳄鱼养殖场",
        en: "[01493]Crocodile farms",
      },
      {
        value: "[01494]Frog farms",
        zh: "[01494]Frog farms / 青蛙农场",
        en: "[01494]Frog farms",
      },
      {
        value: "[01499]Other animal production n.e.c.",
        zh: "[01499]Other animal production n.e.c. / 其他动物生产",
        en: "[01499]Other animal production n.e.c.",
      },
      {
        value: "[01500]Growing of crops combined with animal production (mixed farming)",
        zh: "[01500]Growing of crops combined with animal production (mixed farming) / 农作物种植与畜牧生产相结合（混合农业）",
        en: "[01500]Growing of crops combined with animal production (mixed farming)",
      },
      {
        value: "[01600]Agricultural and animal husbandry service activities except veterinary activities",
        zh: "[01600]Agricultural and animal husbandry service activities except veterinary activities / 除兽医活动外的农牧业服务活动",
        en: "[01600]Agricultural and animal husbandry service activities except veterinary activities",
      },
      {
        value: "[02000]Forestry, logging and related service activities",
        zh: "[02000]Forestry, logging and related service activities / 林业、伐木及相关服务活动",
        en: "[02000]Forestry, logging and related service activities",
      },
      {
        value: "[03101]Fishing in kelongs",
        zh: "[03101]Fishing in kelongs / 在科隆捕鱼",
        en: "[03101]Fishing in kelongs",
      },
      {
        value: "[03102]Ocean fishing except fishing in kelongs",
        zh: "[03102]Ocean fishing except fishing in kelongs / 远洋捕鱼，除了在科隆捕鱼",
        en: "[03102]Ocean fishing except fishing in kelongs",
      },
      {
        value: "[03103]Coastal fishing except fishing in kelongs",
        zh: "[03103]Coastal fishing except fishing in kelongs / 沿海捕鱼，除了在科隆捕鱼",
        en: "[03103]Coastal fishing except fishing in kelongs",
      },
      {
        value: "[03109]Fishing n.e.c.",
        zh: "[03109]Fishing n.e.c. / 钓鱼",
        en: "[03109]Fishing n.e.c.",
      },
      {
        value: "[03201]Food fish farms",
        zh: "[03201]Food fish farms / 食用鱼养殖场",
        en: "[03201]Food fish farms",
      },
      {
        value: "[03202]Ornamental fish farms",
        zh: "[03202]Ornamental fish farms / 观赏鱼场",
        en: "[03202]Ornamental fish farms",
      },
      {
        value: "[03209]Operation of fish hatcheries and fish farms n.e.c. (including turtle, prawn, crab, mussel farms)",
        zh: "[03209]Operation of fish hatcheries and fish farms n.e.c. (including turtle, prawn, crab, mussel farms) / 经营鱼类孵化场和养殖场（包括龟、虾、蟹、贻贝养殖场）",
        en: "[03209]Operation of fish hatcheries and fish farms n.e.c. (including turtle, prawn, crab, mussel farms)",
      },
      {
        value: "[08101]Stone quarrying",
        zh: "[08101]Stone quarrying / 采石",
        en: "[08101]Stone quarrying",
      },
      {
        value: "[08102]Quarrying of sand and clay",
        zh: "[08102]Quarrying of sand and clay / 采砂和粘土",
        en: "[08102]Quarrying of sand and clay",
      },
      {
        value: "[08900]Other mining and quarrying",
        zh: "[08900]Other mining and quarrying / 其他采矿和采石",
        en: "[08900]Other mining and quarrying",
      },
      {
        value: "[09001]Crude petroleum and natural gas production",
        zh: "[09001]Crude petroleum and natural gas production / 原油和天然气生产",
        en: "[09001]Crude petroleum and natural gas production",
      },
      {
        value:
          "[09002]Service activities incidental to oil and gas extraction (excluding surveying and engineering design and consultancy services supporting mining, oil and gas extraction and offshore exploration activities)",
        zh: "[09002]Service activities incidental to oil and gas extraction (excluding surveying and engineering design and consultancy services supporting mining, oil and gas extraction and offshore exploration activities) / 石油和天然气开采附带的服务活动（不包括支持采矿、石油和天然气开采和海上勘探活动的测量和工程设计和咨询服务）",
        en: "[09002]Service activities incidental to oil and gas extraction (excluding surveying and engineering design and consultancy services supporting mining, oil and gas extraction and offshore exploration activities)",
      },
      {
        value: "[10101]Slaughtering of livestock and poultry",
        zh: "[10101]Slaughtering of livestock and poultry / 畜禽屠宰",
        en: "[10101]Slaughtering of livestock and poultry",
      },
      {
        value: "[10102]Manufacture of sausage",
        zh: "[10102]Manufacture of sausage / 香肠的制造",
        en: "[10102]Manufacture of sausage",
      },
      {
        value: "[10103]Preparing, canning and preserving of livestock and livestock products (including lard and other edible animal fats)",
        zh: "[10103]Preparing, canning and preserving of livestock and livestock products (including lard and other edible animal fats) / 牲畜和畜产品（包括猪油和其他食用动物脂肪）的制备、罐装和保存",
        en: "[10103]Preparing, canning and preserving of livestock and livestock products (including lard and other edible animal fats)",
      },
      {
        value: "[10104]Preparing, canning and preserving of poultry and poultry products",
        zh: "[10104]Preparing, canning and preserving of poultry and poultry products / 家禽和家禽产品的制备、罐装和保存",
        en: "[10104]Preparing, canning and preserving of poultry and poultry products",
      },
      {
        value: "[10109]Processing and preserving of meat and meat products n.e.c.",
        zh: "[10109]Processing and preserving of meat and meat products n.e.c. / 肉类和肉制品的加工和保存",
        en: "[10109]Processing and preserving of meat and meat products n.e.c.",
      },
      {
        value: "[10200]Processing and preserving of seafood",
        zh: "[10200]Processing and preserving of seafood / 海产品的加工和保存",
        en: "[10200]Processing and preserving of seafood",
      },
      {
        value: "[10301]Manufacture of jams (including fruit jelly)",
        zh: "[10301]Manufacture of jams (including fruit jelly) / 果酱制造（包括果冻）",
        en: "[10301]Manufacture of jams (including fruit jelly)",
      },
      {
        value: "[10302]Other canning and preserving of fruits and fruit juices",
        zh: "[10302]Other canning and preserving of fruits and fruit juices / 其他水果和果汁的罐头和保存",
        en: "[10302]Other canning and preserving of fruits and fruit juices",
      },
      {
        value: "[10303]Other canning and preserving of vegetables and vegetable juices (including pickles)",
        zh: "[10303]Other canning and preserving of vegetables and vegetable juices (including pickles) / 其他蔬菜和蔬菜汁（包括泡菜）的罐头和保存",
        en: "[10303]Other canning and preserving of vegetables and vegetable juices (including pickles)",
      },
      {
        value: "[10401]Manufacture of edible vegetable and animal oils and fats",
        zh: "[10401]Manufacture of edible vegetable and animal oils and fats / 食用植物和动物油脂的制造",
        en: "[10401]Manufacture of edible vegetable and animal oils and fats",
      },
      {
        value: "[10402]Manufacture of inedible vegetable and animal oils and fats",
        zh: "[10402]Manufacture of inedible vegetable and animal oils and fats / 非食用植物和动物油脂的制造",
        en: "[10402]Manufacture of inedible vegetable and animal oils and fats",
      },
      {
        value: "[10409]Manufacture of vegetable and animal oils and fats n.e.c.",
        zh: "[10409]Manufacture of vegetable and animal oils and fats n.e.c. / 其他植物和动物油脂的制造",
        en: "[10409]Manufacture of vegetable and animal oils and fats n.e.c.",
      },
      {
        value: "[10501]Manufacture of condensed and evaporated milk (including pasteurising and bottling of fluid milk)",
        zh: "[10501]Manufacture of condensed and evaporated milk (including pasteurising and bottling of fluid milk) / 炼乳和淡奶的制造（包括巴氏杀菌和液态奶的装瓶）",
        en: "[10501]Manufacture of condensed and evaporated milk (including pasteurising and bottling of fluid milk)",
      },
      {
        value: "[10502]Manufacture of milk powder",
        zh: "[10502]Manufacture of milk powder / 奶粉的制造",
        en: "[10502]Manufacture of milk powder",
      },
      {
        value: "[10503]Manufacture of ice-cream",
        zh: "[10503]Manufacture of ice-cream / 冰淇淋的制造",
        en: "[10503]Manufacture of ice-cream",
      },
      {
        value: "[10509]Manufacture of dairy products n.e.c. (e.g. butter, cheese, ice-cream mixes and powder, yoghurt)",
        zh: "[10509]Manufacture of dairy products n.e.c. (e.g. butter, cheese, ice-cream mixes and powder, yoghurt) / 其他乳制品的制造（例如黄油、奶酪、冰淇淋混合物和粉末、酸奶）",
        en: "[10509]Manufacture of dairy products n.e.c. (e.g. butter, cheese, ice-cream mixes and powder, yoghurt)",
      },
      {
        value: "[10611]Rice milling",
        zh: "[10611]Rice milling / 碾米",
        en: "[10611]Rice milling",
      },
      {
        value: "[10612]Wheat milling",
        zh: "[10612]Wheat milling / 小麦碾磨",
        en: "[10612]Wheat milling",
      },
      {
        value: "[10613]Provision of milling services",
        zh: "[10613]Provision of milling services / 提供制粉服务",
        en: "[10613]Provision of milling services",
      },
      {
        value: "[10619]Manufacture of grain mill products n.e.c.",
        zh: "[10619]Manufacture of grain mill products n.e.c. / 谷物磨粉产品的制造",
        en: "[10619]Manufacture of grain mill products n.e.c.",
      },
      {
        value: "[10620]Manufacture of starches and starch products",
        zh: "[10620]Manufacture of starches and starch products / 淀粉和淀粉制品的制造",
        en: "[10620]Manufacture of starches and starch products",
      },
      {
        value: "[10711]Manufacture of biscuits (including wafers and cones)",
        zh: "[10711]Manufacture of biscuits (including wafers and cones) / 饼干制造（包括威化饼和甜筒）",
        en: "[10711]Manufacture of biscuits (including wafers and cones)",
      },
      {
        value: "[10712]Manufacture of bread, cakes and confectionery (excluding frozen bakery products)",
        zh: "[10712]Manufacture of bread, cakes and confectionery (excluding frozen bakery products) / 面包、蛋糕和糖果的制造（不包括冷冻烘焙产品）",
        en: "[10712]Manufacture of bread, cakes and confectionery (excluding frozen bakery products)",
      },
      {
        value: "[10719]Manufacture of bakery products n.e.c.",
        zh: "[10719]Manufacture of bakery products n.e.c. / 烘焙产品的制造",
        en: "[10719]Manufacture of bakery products n.e.c.",
      },
      {
        value: "[10720]Manufacture of sugar and sugar products",
        zh: "[10720]Manufacture of sugar and sugar products / 糖和糖制品的制造",
        en: "[10720]Manufacture of sugar and sugar products",
      },
      {
        value: "[10731]Manufacture of cocoa and chocolate powder from beans",
        zh: "[10731]Manufacture of cocoa and chocolate powder from beans / 从豆类中制造可可粉和巧克力粉",
        en: "[10731]Manufacture of cocoa and chocolate powder from beans",
      },
      {
        value: "[10732]Manufacture of chocolate and chocolate products",
        zh: "[10732]Manufacture of chocolate and chocolate products / 巧克力和巧克力产品的制造",
        en: "[10732]Manufacture of chocolate and chocolate products",
      },
      {
        value: "[10733]Manufacture of non-chocolate confectionery (e.g. sweets, toffees, crystallised fruits, chewing gums)",
        zh: "[10733]Manufacture of non-chocolate confectionery (e.g. sweets, toffees, crystallised fruits, chewing gums) / 非巧克力糖果的制造（例如糖果、太妃糖、结晶水果、口香糖）",
        en: "[10733]Manufacture of non-chocolate confectionery (e.g. sweets, toffees, crystallised fruits, chewing gums)",
      },
      {
        value: "[10740]Manufacture of macaroni, noodles, vermicelli and other related products",
        zh: "[10740]Manufacture of macaroni, noodles, vermicelli and other related products / 生产通心粉、面条、粉丝及其他相关产品",
        en: "[10740]Manufacture of macaroni, noodles, vermicelli and other related products",
      },
      {
        value: "[10750]Manufacture of cooked-food preparations (e.g. frozen dinners)",
        zh: "[10750]Manufacture of cooked-food preparations (e.g. frozen dinners) / 熟食制品的制造（例如冷冻晚餐）",
        en: "[10750]Manufacture of cooked-food preparations (e.g. frozen dinners)",
      },
      {
        value: "[10761]Manufacture of instant beverages",
        zh: "[10761]Manufacture of instant beverages / 速溶饮料的制造",
        en: "[10761]Manufacture of instant beverages",
      },
      {
        value: "[10762]Processing of coffee seeds",
        zh: "[10762]Processing of coffee seeds / 咖啡种子加工",
        en: "[10762]Processing of coffee seeds",
      },
      {
        value: "[10763]Manufacture of coffee powder",
        zh: "[10763]Manufacture of coffee powder / 咖啡粉的制造",
        en: "[10763]Manufacture of coffee powder",
      },
      {
        value: "[10764]Manufacture of tea (including processing of tea leaves)",
        zh: "[10764]Manufacture of tea (including processing of tea leaves) / 茶叶制造（包括茶叶加工）",
        en: "[10764]Manufacture of tea (including processing of tea leaves)",
      },
      {
        value: "[10765]Manufacture of non-dairy creamer",
        zh: "[10765]Manufacture of non-dairy creamer / 非乳制奶精的制造",
        en: "[10765]Manufacture of non-dairy creamer",
      },
      {
        value: "[10791]Manufacture of sauces including soya bean sauce (e.g. tomato sauce, chilli sauce)",
        zh: "[10791]Manufacture of sauces including soya bean sauce (e.g. tomato sauce, chilli sauce) / 制造酱料，包括豆酱（例如番茄酱、辣椒酱）",
        en: "[10791]Manufacture of sauces including soya bean sauce (e.g. tomato sauce, chilli sauce)",
      },
      {
        value: "[10792]Manufacture of soya bean products except soya bean sauce and soya bean milk",
        zh: "[10792]Manufacture of soya bean products except soya bean sauce and soya bean milk / 除豆酱和豆浆外的豆制品制造",
        en: "[10792]Manufacture of soya bean products except soya bean sauce and soya bean milk",
      },
      {
        value: "[10793]Manufacture and processing of spices (including curry powder and spice extracts)",
        zh: "[10793]Manufacture and processing of spices (including curry powder and spice extracts) / 香料（包括咖喱粉和香料提取物）的制造和加工",
        en: "[10793]Manufacture and processing of spices (including curry powder and spice extracts)",
      },
      {
        value: "[10794]Manufacture of chips, crackers and other titbits (excluding biscuits and confectionery)",
        zh: "[10794]Manufacture of chips, crackers and other titbits (excluding biscuits and confectionery) / 薯片、薄脆饼干和其他小玩意的制造（饼干和糖果除外）",
        en: "[10794]Manufacture of chips, crackers and other titbits (excluding biscuits and confectionery)",
      },
      {
        value: "[10799]Manufacture of other food products n.e.c. (except food chemicals and additives)",
        zh: "[10799]Manufacture of other food products n.e.c. (except food chemicals and additives) / 其他食品的制造（不包括食品化学品和添加剂）",
        en: "[10799]Manufacture of other food products n.e.c. (except food chemicals and additives)",
      },
      {
        value: "[10800]Manufacture of prepared animal feeds (including additives for animal feed)",
        zh: "[10800]Manufacture of prepared animal feeds (including additives for animal feed) / 制备动物饲料（包括动物饲料添加剂）的制造",
        en: "[10800]Manufacture of prepared animal feeds (including additives for animal feed)",
      },
      {
        value: "[11010]Distilling, rectifying and blending of spirits; ethyl alcohol production from fermented materials (including samsu and Chinese liquors)",
        zh: "[11010]Distilling, rectifying and blending of spirits; ethyl alcohol production from fermented materials (including samsu and Chinese liquors) / 烈酒的蒸馏、精馏和勾兑；发酵原料生产乙醇（包括三苏酒和中国白酒）",
        en: "[11010]Distilling, rectifying and blending of spirits; ethyl alcohol production from fermented materials (including samsu and Chinese liquors)",
      },
      {
        value: "[11020]Manufacture of wines",
        zh: "[11020]Manufacture of wines / 葡萄酒的制造",
        en: "[11020]Manufacture of wines",
      },
      {
        value: "[11030]Manufacture of malt liquors and malt (e.g. beer and stout)",
        zh: "[11030]Manufacture of malt liquors and malt (e.g. beer and stout) / 麦芽酒和麦芽（例如啤酒和黑啤酒）的制造",
        en: "[11030]Manufacture of malt liquors and malt (e.g. beer and stout)",
      },
      {
        value: "[11041]Manufacture of soft drinks, production of mineral waters (including carbonated waters, soya bean milk, barley water, chrysanthemum water)",
        zh: "[11041]Manufacture of soft drinks, production of mineral waters (including carbonated waters, soya bean milk, barley water, chrysanthemum water) / 软饮料制造、矿泉水生产（包括碳酸水、豆浆、薏米水、菊花水）",
        en: "[11041]Manufacture of soft drinks, production of mineral waters (including carbonated waters, soya bean milk, barley water, chrysanthemum water)",
      },
      {
        value: "[11042]Manufacture of cordials, syrups and composite concentrates for beverages",
        zh: "[11042]Manufacture of cordials, syrups and composite concentrates for beverages / 生产饮料用甜酒、糖浆和复合浓缩物",
        en: "[11042]Manufacture of cordials, syrups and composite concentrates for beverages",
      },
      {
        value: "[11043]Manufacture of ice except dry ice",
        zh: "[11043]Manufacture of ice except dry ice / 制造除干冰以外的冰",
        en: "[11043]Manufacture of ice except dry ice",
      },
      {
        value: "[12001]Manufacture of cigarettes",
        zh: "[12001]Manufacture of cigarettes / 香烟制造",
        en: "[12001]Manufacture of cigarettes",
      },
      {
        value: "[12009]Manufacture of tobacco products n.e.c. (e.g. cigars, loose tobacco)",
        zh: "[12009]Manufacture of tobacco products n.e.c. (e.g. cigars, loose tobacco) / 其他烟草制品的制造（例如雪茄、散装烟草）",
        en: "[12009]Manufacture of tobacco products n.e.c. (e.g. cigars, loose tobacco)",
      },
      {
        value: "[13100]Spinning, weaving and finishing of textiles",
        zh: "[13100]Spinning, weaving and finishing of textiles / 纺织品的纺纱、织造和整理",
        en: "[13100]Spinning, weaving and finishing of textiles",
      },
      {
        value: "[13910]Manufacture of knitted and crocheted fabrics and laces",
        zh: "[13910]Manufacture of knitted and crocheted fabrics and laces / 针织和钩编织物和花边的制造",
        en: "[13910]Manufacture of knitted and crocheted fabrics and laces",
      },
      {
        value: "[13921]Manufacture of curtains, pillow cases, bed sheets and bed spreads",
        zh: "[13921]Manufacture of curtains, pillow cases, bed sheets and bed spreads / 窗帘、枕套、床单和床罩的制造",
        en: "[13921]Manufacture of curtains, pillow cases, bed sheets and bed spreads",
      },
      {
        value: "[13922]Manufacture of other made-up house furnishings (e.g. napkins, table cloths)",
        zh: "[13922]Manufacture of other made-up house furnishings (e.g. napkins, table cloths) / 其他家居装饰（如餐巾、桌布）的制造",
        en: "[13922]Manufacture of other made-up house furnishings (e.g. napkins, table cloths)",
      },
      {
        value: "[13929]Manufacture of made-up textile articles except apparel n.e.c. (e.g. scrolls, flags and sails, banners, canvas products, cushions, pillows)",
        zh: "[13929]Manufacture of made-up textile articles except apparel n.e.c. (e.g. scrolls, flags and sails, banners, canvas products, cushions, pillows) / 纺织制成品的制造（如卷轴、旗帜和帆、横幅、帆布制品、靠垫、枕头）",
        en: "[13929]Manufacture of made-up textile articles except apparel n.e.c. (e.g. scrolls, flags and sails, banners, canvas products, cushions, pillows)",
      },
      {
        value: "[13930]Manufacture of carpets and rugs",
        zh: "[13930]Manufacture of carpets and rugs / 地毯和地毯的制造",
        en: "[13930]Manufacture of carpets and rugs",
      },
      {
        value: "[13940]Manufacture of cordage, rope, twine and netting",
        zh: "[13940]Manufacture of cordage, rope, twine and netting / 绳索、绳索、麻绳和网的制造",
        en: "[13940]Manufacture of cordage, rope, twine and netting",
      },
      {
        value: "[13990]Manufacture of other textiles n.e.c. (e.g. upholstery filling)",
        zh: "[13990]Manufacture of other textiles n.e.c. (e.g. upholstery filling) / 其他纺织品的制造（例如室内装潢填充物）",
        en: "[13990]Manufacture of other textiles n.e.c. (e.g. upholstery filling)",
      },
      {
        value: "[14101]Manufacture of outer garments",
        zh: "[14101]Manufacture of outer garments / 外衣制造",
        en: "[14101]Manufacture of outer garments",
      },
      {
        value: "[14102]Manufacture of brassieres and other undergarments",
        zh: "[14102]Manufacture of brassieres and other undergarments / 胸罩和其他内衣的制造",
        en: "[14102]Manufacture of brassieres and other undergarments",
      },
      {
        value: "[14103]Tailoring and dressmaking (to individual order)",
        zh: "[14103]Tailoring and dressmaking (to individual order) / 裁缝和制衣（根据个人订单）",
        en: "[14103]Tailoring and dressmaking (to individual order)",
      },
      {
        value: "[14109]Manufacture of wearing apparel except fur apparel n.e.c. (e.g. songkoks, caps, gloves and mittens, garters, handkerchiefs, raincoats, shawls and hair nets)",
        zh: "[14109]Manufacture of wearing apparel except fur apparel n.e.c. (e.g. songkoks, caps, gloves and mittens, garters, handkerchiefs, raincoats, shawls and hair nets) / 非毛皮服装以外的服装制造（例如，松果、帽子、手套和连指手套、吊袜带、手帕、雨衣、披肩和发网）",
        en: "[14109]Manufacture of wearing apparel except fur apparel n.e.c. (e.g. songkoks, caps, gloves and mittens, garters, handkerchiefs, raincoats, shawls and hair nets)",
      },
      {
        value: "[14200]Manufacture of fur apparel and articles of fur (e.g. fur rugs, mats and cushions)",
        zh: "[14200]Manufacture of fur apparel and articles of fur (e.g. fur rugs, mats and cushions) / 毛皮服装和毛皮制品的制造（例如毛皮地毯、垫子和靠垫）",
        en: "[14200]Manufacture of fur apparel and articles of fur (e.g. fur rugs, mats and cushions)",
      },
      {
        value: "[14301]Manufacture of socks, stockings and other hosiery",
        zh: "[14301]Manufacture of socks, stockings and other hosiery / 袜子、长筒袜和其他袜子的制造",
        en: "[14301]Manufacture of socks, stockings and other hosiery",
      },
      {
        value: "[14302]Manufacture of briefs, singlets and other knitted or crocheted wear (e.g. pullovers, cardigans)",
        zh: "[14302]Manufacture of briefs, singlets and other knitted or crocheted wear (e.g. pullovers, cardigans) / 三角裤、背心和其他针织或钩编服装（如套头衫、开襟衫）的制造",
        en: "[14302]Manufacture of briefs, singlets and other knitted or crocheted wear (e.g. pullovers, cardigans)",
      },
      {
        value: "[14309]Manufacture of knitted and crocheted apparel n.e.c.",
        zh: "[14309]Manufacture of knitted and crocheted apparel n.e.c. / 针织和钩编服装的制造",
        en: "[14309]Manufacture of knitted and crocheted apparel n.e.c.",
      },
      {
        value: "[15110]Tanning and dressing of leather; dressing and dyeing of fur",
        zh: "[15110]Tanning and dressing of leather; dressing and dyeing of fur / 皮革的鞣制和修整；毛皮的修整和染色",
        en: "[15110]Tanning and dressing of leather; dressing and dyeing of fur",
      },
      {
        value: "[15121]Manufacture of luggage, bags, brief cases and the like",
        zh: "[15121]Manufacture of luggage, bags, brief cases and the like / 箱包、箱包、公文包等的制造",
        en: "[15121]Manufacture of luggage, bags, brief cases and the like",
      },
      {
        value: "[15122]Manufacture of handbags",
        zh: "[15122]Manufacture of handbags / 手袋制造",
        en: "[15122]Manufacture of handbags",
      },
      {
        value: "[15129]Manufacture of saddlery, harness and articles of leather n.e.c. (e.g. coin purses, key cases)",
        zh: "[15129]Manufacture of saddlery, harness and articles of leather n.e.c. (e.g. coin purses, key cases) / 鞍具、马具和皮革制品（例如零钱包、钥匙包）的制造",
        en: "[15129]Manufacture of saddlery, harness and articles of leather n.e.c. (e.g. coin purses, key cases)",
      },
      {
        value: "[15200]Manufacture of footwear",
        zh: "[15200]Manufacture of footwear / 鞋类制造",
        en: "[15200]Manufacture of footwear",
      },
      {
        value: "[16101]Sawmilling",
        zh: "[16101]Sawmilling / 锯木厂",
        en: "[16101]Sawmilling",
      },
      {
        value: "[16102]Preservation of wood",
        zh: "[16102]Preservation of wood / 木材的保存",
        en: "[16102]Preservation of wood",
      },
      {
        value: "[16109]Sawmilling and planing of wood n.e.c.",
        zh: "[16109]Sawmilling and planing of wood n.e.c. / 锯木和刨削木材",
        en: "[16109]Sawmilling and planing of wood n.e.c.",
      },
      {
        value: "[16211]Manufacture of plywood and veneer",
        zh: "[16211]Manufacture of plywood and veneer / 胶合板和单板的制造",
        en: "[16211]Manufacture of plywood and veneer",
      },
      {
        value: "[16219]Manufacture of laminboard, particle board and other panels and boards n.e.c.",
        zh: "[16219]Manufacture of laminboard, particle board and other panels and boards n.e.c. / 制造层压板、刨花板及其他面板和板材",
        en: "[16219]Manufacture of laminboard, particle board and other panels and boards n.e.c.",
      },
      {
        value: "[16291]Manufacture of wooden window, door and other millwork, except prefabricated wooden building structures",
        zh: "[16291]Manufacture of wooden window, door and other millwork, except prefabricated wooden building structures / 木门窗和其他木制品的制造，预制木建筑结构除外",
        en: "[16291]Manufacture of wooden window, door and other millwork, except prefabricated wooden building structures",
      },
      {
        value: "[16292]Manufacture of household and kitchen wooden ware except wooden footwear",
        zh: "[16292]Manufacture of household and kitchen wooden ware except wooden footwear / 家用和厨房用木器的制造，木鞋除外",
        en: "[16292]Manufacture of household and kitchen wooden ware except wooden footwear",
      },
      {
        value: "[16293]Manufacture of wooden containers",
        zh: "[16293]Manufacture of wooden containers / 木制容器的制造",
        en: "[16293]Manufacture of wooden containers",
      },
      {
        value: "[16294]Manufacture of attap and attap products",
        zh: "[16294]Manufacture of attap and attap products / 亞答屋和亞答屋产品的制造",
        en: "[16294]Manufacture of attap and attap products",
      },
      {
        value: "[16295]Rattan processing",
        zh: "[16295]Rattan processing / 藤条加工",
        en: "[16295]Rattan processing",
      },
      {
        value: "[16299]Manufacture of other products of wood and articles of cork, straw and plaiting materials n.e.c.",
        zh: "[16299]Manufacture of other products of wood and articles of cork, straw and plaiting materials n.e.c. / 其他木材制品和软木、稻草和编织材料制品的制造",
        en: "[16299]Manufacture of other products of wood and articles of cork, straw and plaiting materials n.e.c.",
      },
      {
        value: "[17010]Manufacture of pulp, paper and paperboard",
        zh: "[17010]Manufacture of pulp, paper and paperboard / 纸浆、纸和纸板的制造",
        en: "[17010]Manufacture of pulp, paper and paperboard",
      },
      {
        value: "[17021]Manufacture of corrugated paper and paperboard",
        zh: "[17021]Manufacture of corrugated paper and paperboard / 瓦楞纸和纸板的制造",
        en: "[17021]Manufacture of corrugated paper and paperboard",
      },
      {
        value: "[17022]Manufacture of containers and boxes of paper and paperboard",
        zh: "[17022]Manufacture of containers and boxes of paper and paperboard / 制造纸和纸板的容器和盒子",
        en: "[17022]Manufacture of containers and boxes of paper and paperboard",
      },
      {
        value: "[17091]Manufacture of joss paper and other related ceremonial paper products (including effigies and other funeral paper goods and Chinese lanterns)",
        zh: "[17091]Manufacture of joss paper and other related ceremonial paper products (including effigies and other funeral paper goods and Chinese lanterns) / 制造金纸和其他相关的礼仪纸制品（包括肖像和其他葬礼纸制品和中国灯笼）",
        en: "[17091]Manufacture of joss paper and other related ceremonial paper products (including effigies and other funeral paper goods and Chinese lanterns)",
      },
      {
        value: "[17092]Manufacture of sanitary towels, toilet paper, paper towels, disposable diapers and related paper products",
        zh: "[17092]Manufacture of sanitary towels, toilet paper, paper towels, disposable diapers and related paper products / 卫生巾、卫生纸、纸巾、一次性尿布及相关纸制品的制造",
        en: "[17092]Manufacture of sanitary towels, toilet paper, paper towels, disposable diapers and related paper products",
      },
      {
        value: "[17093]Manufacture of paper cups, plates and utensils",
        zh: "[17093]Manufacture of paper cups, plates and utensils / 纸杯、盘子和餐具的制造",
        en: "[17093]Manufacture of paper cups, plates and utensils",
      },
      {
        value: "[17094]Manufacture of cards, envelopes and stationery, unprinted",
        zh: "[17094]Manufacture of cards, envelopes and stationery, unprinted / 未印刷的卡片、信封和文具的制造",
        en: "[17094]Manufacture of cards, envelopes and stationery, unprinted",
      },
      {
        value: "[17099]Manufacture of other articles of paper and paperboard n.e.c. (e.g. papier mache, wallpaper)",
        zh: "[17099]Manufacture of other articles of paper and paperboard n.e.c. (e.g. papier mache, wallpaper) / 其他纸制品和纸板制品的制造（例如纸浆、壁纸）",
        en: "[17099]Manufacture of other articles of paper and paperboard n.e.c. (e.g. papier mache, wallpaper)",
      },
      {
        value: "[18111]Printing of newspapers",
        zh: "[18111]Printing of newspapers / 报纸印刷",
        en: "[18111]Printing of newspapers",
      },
      {
        value: "[18112]Printing of periodicals, books and magazines",
        zh: "[18112]Printing of periodicals, books and magazines / 期刊、书籍和杂志的印刷",
        en: "[18112]Printing of periodicals, books and magazines",
      },
      {
        value: "[18113]Commercial printing (e.g. printing of brochures, cards, envelopes, labels and stationery)",
        zh: "[18113]Commercial printing (e.g. printing of brochures, cards, envelopes, labels and stationery) / 商业印刷（例如小册子、卡片、信封、标签和文具的印刷）",
        en: "[18113]Commercial printing (e.g. printing of brochures, cards, envelopes, labels and stationery)",
      },
      {
        value: "[18114]Printing of continuous and fan-fold forms",
        zh: "[18114]Printing of continuous and fan-fold forms / 连续和折叠形式的印刷",
        en: "[18114]Printing of continuous and fan-fold forms",
      },
      {
        value: "[18115]Silk screen printing (including metal printing)",
        zh: "[18115]Silk screen printing (including metal printing) / 丝网印刷（包括金属印刷）",
        en: "[18115]Silk screen printing (including metal printing)",
      },
      {
        value: "[18119]Printing n.e.c.",
        zh: "[18119]Printing n.e.c. / 印刷相关",
        en: "[18119]Printing n.e.c.",
      },
      {
        value: "[18121]Bookbinding (e.g. book packaging)",
        zh: "[18121]Bookbinding (e.g. book packaging) / 装订（如书籍包装）",
        en: "[18121]Bookbinding (e.g. book packaging)",
      },
      {
        value: "[18122]Colour separation",
        zh: "[18122]Colour separation / 分色",
        en: "[18122]Colour separation",
      },
      {
        value: "[18129]Service activities related to printing n.e.c. (including plate-making)",
        zh: "[18129]Service activities related to printing n.e.c. (including plate-making) / 与印刷相关的服务活动（包括制版）",
        en: "[18129]Service activities related to printing n.e.c. (including plate-making)",
      },
      {
        value: "[18200]Reproduction of recorded media (including reproduction of phonograph records, recorded magnetic tapes, compact discs and non-customised software)",
        zh: "[18200]Reproduction of recorded media (including reproduction of phonograph records, recorded magnetic tapes, compact discs and non-customised software) / 录制媒体的复制（包括留声机唱片、录制的磁带、光盘和非定制软件的复制）",
        en: "[18200]Reproduction of recorded media (including reproduction of phonograph records, recorded magnetic tapes, compact discs and non-customised software)",
      },
      {
        value: "[19100]Manufacture of coke oven products",
        zh: "[19100]Manufacture of coke oven products / 焦炉产品制造",
        en: "[19100]Manufacture of coke oven products",
      },
      {
        value: "[19201]Petroleum refineries",
        zh: "[19201]Petroleum refineries / 炼油厂",
        en: "[19201]Petroleum refineries",
      },
      {
        value: "[19202]Manufacture of petroleum lubricating oil",
        zh: "[19202]Manufacture of petroleum lubricating oil / 石油润滑油的制造",
        en: "[19202]Manufacture of petroleum lubricating oil",
      },
      {
        value: "[19209]Manufacture of refined petroleum products n.e.c.",
        zh: "[19209]Manufacture of refined petroleum products n.e.c. / 精炼石油产品的制造",
        en: "[19209]Manufacture of refined petroleum products n.e.c.",
      },
      {
        value: "[20111]Manufacture of industrial gases and dry ice",
        zh: "[20111]Manufacture of industrial gases and dry ice / 工业气体和干冰的制造",
        en: "[20111]Manufacture of industrial gases and dry ice",
      },
      {
        value: "[20112]Manufacture of basic industrial acids and alkalis",
        zh: "[20112]Manufacture of basic industrial acids and alkalis / 生产碱性工业酸和碱",
        en: "[20112]Manufacture of basic industrial acids and alkalis",
      },
      {
        value: "[20113]Manufacture of basic chemicals except fertilisers and nitrogen",
        zh: "[20113]Manufacture of basic chemicals except fertilisers and nitrogen / 生产除化肥和氮以外的基础化学品",
        en: "[20113]Manufacture of basic chemicals except fertilisers and nitrogen",
      },
      {
        value: "[20114]Manufacture of solvents",
        zh: "[20114]Manufacture of solvents / 制造溶剂",
        en: "[20114]Manufacture of solvents",
      },
      {
        value: "[20119]Manufacture of basic chemicals n.e.c.",
        zh: "[20119]Manufacture of basic chemicals n.e.c. / 基础化学品制造",
        en: "[20119]Manufacture of basic chemicals n.e.c.",
      },
      {
        value: "[20120]Manufacture of fertilisers and nitrogen compounds",
        zh: "[20120]Manufacture of fertilisers and nitrogen compounds / 化肥和氮化合物的制造",
        en: "[20120]Manufacture of fertilisers and nitrogen compounds",
      },
      {
        value: "[20131]Manufacture of petrochemical primary products (e.g. olefins, aromatics, basic building blocks)",
        zh: "[20131]Manufacture of petrochemical primary products (e.g. olefins, aromatics, basic building blocks) / 生产石化初级产品（例如烯烃、芳烃、基本构件）",
        en: "[20131]Manufacture of petrochemical primary products (e.g. olefins, aromatics, basic building blocks)",
      },
      {
        value:
          "[20132]Manufacture of derivatives and intermediates produced from basic building blocks (e.g. acetyls, acrylics, oxochemicals, styrene, phenolic, ethylene oxide derivatives and polymers)",
        zh: "[20132]Manufacture of derivatives and intermediates produced from basic building blocks (e.g. acetyls, acrylics, oxochemicals, styrene, phenolic, ethylene oxide derivatives and polymers) / 生产由基本结构单元（例如乙酰基、丙烯酸树脂、含氧化合物、苯乙烯、酚醛树脂、环氧乙烷衍生物和聚合物）生产的衍生物和中间体",
        en: "[20132]Manufacture of derivatives and intermediates produced from basic building blocks (e.g. acetyls, acrylics, oxochemicals, styrene, phenolic, ethylene oxide derivatives and polymers)",
      },
      {
        value: "[20133]Manufacture of synthetic rubber",
        zh: "[20133]Manufacture of synthetic rubber / 合成橡胶的制造",
        en: "[20133]Manufacture of synthetic rubber",
      },
      {
        value: "[20210]Manufacture of pesticides and other agro-chemical products (including insecticides, herbicides and disinfectants)",
        zh: "[20210]Manufacture of pesticides and other agro-chemical products (including insecticides, herbicides and disinfectants) / 杀虫剂和其他农化产品（包括杀虫剂、除草剂和消毒剂）的制造",
        en: "[20210]Manufacture of pesticides and other agro-chemical products (including insecticides, herbicides and disinfectants)",
      },
      {
        value: "[20221]Manufacture of paints",
        zh: "[20221]Manufacture of paints / 涂料制造",
        en: "[20221]Manufacture of paints",
      },
      {
        value: "[20222]Manufacture of varnishes and lacquers (including enamels)",
        zh: "[20222]Manufacture of varnishes and lacquers (including enamels) / 清漆和油漆（包括搪瓷）的制造",
        en: "[20222]Manufacture of varnishes and lacquers (including enamels)",
      },
      {
        value: "[20229]Manufacture of paints, varnishes and similar coatings and mastics n.e.c.",
        zh: "[20229]Manufacture of paints, varnishes and similar coatings and mastics n.e.c. / 油漆、清漆和类似涂料及胶粘剂的制造",
        en: "[20229]Manufacture of paints, varnishes and similar coatings and mastics n.e.c.",
      },
      {
        value: "[20231]Manufacture of soap, detergents, washing and other cleaning preparations",
        zh: "[20231]Manufacture of soap, detergents, washing and other cleaning preparations / 制造肥皂、洗涤剂、洗涤用品和其他清洁制剂",
        en: "[20231]Manufacture of soap, detergents, washing and other cleaning preparations",
      },
      {
        value: "[20232]Manufacture of perfumes and fragrances",
        zh: "[20232]Manufacture of perfumes and fragrances / 香水和香精的制造",
        en: "[20232]Manufacture of perfumes and fragrances",
      },
      {
        value: "[20233]Manufacture of cosmetics and toiletries",
        zh: "[20233]Manufacture of cosmetics and toiletries / 化妆品和盥洗用品的制造",
        en: "[20233]Manufacture of cosmetics and toiletries",
      },
      {
        value: "[20234]Manufacture of waxes and polishes and deodorising preparations",
        zh: "[20234]Manufacture of waxes and polishes and deodorising preparations / 制造蜡、抛光剂和除臭制剂",
        en: "[20234]Manufacture of waxes and polishes and deodorising preparations",
      },
      {
        value: "[20241]Manufacture of food chemicals and additives (e.g. flavours, preservatives and colourings)",
        zh: "[20241]Manufacture of food chemicals and additives (e.g. flavours, preservatives and colourings) / 食品化学品和添加剂的制造（例如香精、防腐剂和色素）",
        en: "[20241]Manufacture of food chemicals and additives (e.g. flavours, preservatives and colourings)",
      },
      {
        value: "[20242]Manufacture of additives for mineral oil (e.g. lubricant and fuel additives)",
        zh: "[20242]Manufacture of additives for mineral oil (e.g. lubricant and fuel additives) / 制造矿物油添加剂（例如润滑油和燃料添加剂）",
        en: "[20242]Manufacture of additives for mineral oil (e.g. lubricant and fuel additives)",
      },
      {
        value: "[20249]Manufacture of additives n.e.c.",
        zh: "[20249]Manufacture of additives n.e.c. / 制造添加剂",
        en: "[20249]Manufacture of additives n.e.c.",
      },
      {
        value: "[20291]Manufacture of epoxy moulding compounds and phenolic moulding compounds",
        zh: "[20291]Manufacture of epoxy moulding compounds and phenolic moulding compounds / 制造环氧模塑料和酚醛模塑料",
        en: "[20291]Manufacture of epoxy moulding compounds and phenolic moulding compounds",
      },
      {
        value: "[20292]Manufacture of ultrapure electronic chemicals, materials and laminates",
        zh: "[20292]Manufacture of ultrapure electronic chemicals, materials and laminates / 超纯电子化学品、材料和层压板的制造",
        en: "[20292]Manufacture of ultrapure electronic chemicals, materials and laminates",
      },
      {
        value: "[20293]Manufacture of water treatment, waste treatment and oilfield chemicals",
        zh: "[20293]Manufacture of water treatment, waste treatment and oilfield chemicals / 水处理、废物处理和油田化学品制造",
        en: "[20293]Manufacture of water treatment, waste treatment and oilfield chemicals",
      },
      {
        value: "[20294]Manufacture of inks, dyestuffs, pigments and carbon black",
        zh: "[20294]Manufacture of inks, dyestuffs, pigments and carbon black / 油墨、染料、颜料和炭黑的制造",
        en: "[20294]Manufacture of inks, dyestuffs, pigments and carbon black",
      },
      {
        value: "[20295]Manufacture of photographic film, paper, plate and chemicals",
        zh: "[20295]Manufacture of photographic film, paper, plate and chemicals / 照相胶卷、纸张、印版和化学品的制造",
        en: "[20295]Manufacture of photographic film, paper, plate and chemicals",
      },
      {
        value: "[20296]Manufacture of adhesives and sealants",
        zh: "[20296]Manufacture of adhesives and sealants / 粘合剂和密封剂的制造",
        en: "[20296]Manufacture of adhesives and sealants",
      },
      {
        value: "[20297]Manufacture of catalysts and catalyst regeneration",
        zh: "[20297]Manufacture of catalysts and catalyst regeneration / 催化剂制造及催化剂再生",
        en: "[20297]Manufacture of catalysts and catalyst regeneration",
      },
      {
        value: "[20298]Manufacture of biofuels",
        zh: "[20298]Manufacture of biofuels / 生物燃料的制造",
        en: "[20298]Manufacture of biofuels",
      },
      {
        value:
          "[20299]Manufacture of other chemical products n.e.c. (e.g. gelatin and derivatives, laundry blue, explosives, processed salts, industrial starch, incense and joss sticks, camphor products)",
        zh: "[20299]Manufacture of other chemical products n.e.c. (e.g. gelatin and derivatives, laundry blue, explosives, processed salts, industrial starch, incense and joss sticks, camphor products) / 其他化工产品（如明胶及其衍生物、洗衣蓝、炸药、加工盐、工业淀粉、香和香、樟脑产品）的制造",
        en: "[20299]Manufacture of other chemical products n.e.c. (e.g. gelatin and derivatives, laundry blue, explosives, processed salts, industrial starch, incense and joss sticks, camphor products)",
      },
      {
        value: "[20300]Manufacture of man-made fibres except glass",
        zh: "[20300]Manufacture of man-made fibres except glass / 制造除玻璃以外的人造纤维",
        en: "[20300]Manufacture of man-made fibres except glass",
      },
      {
        value: "[21011]Manufacture of pharmaceutical intermediates and fine chemicals for human use",
        zh: "[21011]Manufacture of pharmaceutical intermediates and fine chemicals for human use / 医药中间体和人用精细化学品的制造",
        en: "[21011]Manufacture of pharmaceutical intermediates and fine chemicals for human use",
      },
      {
        value: "[21012]Manufacture of pharmaceutical products and preparations for human use (e.g. tableted products)",
        zh: "[21012]Manufacture of pharmaceutical products and preparations for human use (e.g. tableted products) / 人用药品和制剂的制造（例如片剂）",
        en: "[21012]Manufacture of pharmaceutical products and preparations for human use (e.g. tableted products)",
      },
      {
        value: "[21013]Manufacture of pharmaceutical products for veterinary use",
        zh: "[21013]Manufacture of pharmaceutical products for veterinary use / 兽用医药产品的制造",
        en: "[21013]Manufacture of pharmaceutical products for veterinary use",
      },
      {
        value: "[21021]Manufacture of vaccines for human use",
        zh: "[21021]Manufacture of vaccines for human use / 生产人用疫苗",
        en: "[21021]Manufacture of vaccines for human use",
      },
      {
        value: "[21022]Manufacture of other biological products and preparations for human use",
        zh: "[21022]Manufacture of other biological products and preparations for human use / 其他生物制品和人用制剂的制造",
        en: "[21022]Manufacture of other biological products and preparations for human use",
      },
      {
        value: "[21023]Manufacture of biological products and preparations for veterinary use",
        zh: "[21023]Manufacture of biological products and preparations for veterinary use / 兽用生物制品和制剂的制造",
        en: "[21023]Manufacture of biological products and preparations for veterinary use",
      },
      {
        value: "[21030]Manufacture of Traditional Chinese Medicine",
        zh: "[21030]Manufacture of Traditional Chinese Medicine / 中药制造",
        en: "[21030]Manufacture of Traditional Chinese Medicine",
      },
      {
        value: "[22111]Processing of rubber (including processing of rubber latex)",
        zh: "[22111]Processing of rubber (including processing of rubber latex) / 橡胶加工（包括胶乳加工）",
        en: "[22111]Processing of rubber (including processing of rubber latex)",
      },
      {
        value: "[22112]Grading and packing of rubber",
        zh: "[22112]Grading and packing of rubber / 橡胶分级包装",
        en: "[22112]Grading and packing of rubber",
      },
      {
        value: "[22119]Processing of natural gums n.e.c. (e.g. gum damar, jelutong)",
        zh: "[22119]Processing of natural gums n.e.c. (e.g. gum damar, jelutong) / 天然树胶的加工",
        en: "[22119]Processing of natural gums n.e.c. (e.g. gum damar, jelutong)",
      },
      {
        value: "[22121]Manufacture of tyres and tubes",
        zh: "[22121]Manufacture of tyres and tubes / 轮胎和内胎的制造",
        en: "[22121]Manufacture of tyres and tubes",
      },
      {
        value: "[22122]Retreading and vulcanising of tyres",
        zh: "[22122]Retreading and vulcanising of tyres / 轮胎翻新和硫化",
        en: "[22122]Retreading and vulcanising of tyres",
      },
      {
        value: "[22191]Manufacture of foam rubber products (excluding foam rubber mattresses)",
        zh: "[22191]Manufacture of foam rubber products (excluding foam rubber mattresses) / 泡沫橡胶制品的制造（不包括泡沫橡胶床垫）",
        en: "[22191]Manufacture of foam rubber products (excluding foam rubber mattresses)",
      },
      {
        value: "[22192]Manufacture of rubber automotive parts",
        zh: "[22192]Manufacture of rubber automotive parts / 橡胶汽车零部件的制造",
        en: "[22192]Manufacture of rubber automotive parts",
      },
      {
        value: "[22193]Manufacture of industrial and mechanical rubber goods",
        zh: "[22193]Manufacture of industrial and mechanical rubber goods / 工业和机械橡胶制品的制造",
        en: "[22193]Manufacture of industrial and mechanical rubber goods",
      },
      {
        value: "[22194]Manufacture of rubber floorings",
        zh: "[22194]Manufacture of rubber floorings / 橡胶地板的制造",
        en: "[22194]Manufacture of rubber floorings",
      },
      {
        value: "[22199]Manufacture of other rubber products n.e.c. (except rubber footwear and toys)",
        zh: "[22199]Manufacture of other rubber products n.e.c. (except rubber footwear and toys) / 其他橡胶制品的制造（不包括橡胶鞋和玩具）",
        en: "[22199]Manufacture of other rubber products n.e.c. (except rubber footwear and toys)",
      },
      {
        value: "[22211]Manufacture of plastic tableware, household and kitchen ware (excluding disposable utensils)",
        zh: "[22211]Manufacture of plastic tableware, household and kitchen ware (excluding disposable utensils) / 塑料餐具、家庭和厨房用具的制造（不包括一次性器具）",
        en: "[22211]Manufacture of plastic tableware, household and kitchen ware (excluding disposable utensils)",
      },
      {
        value: "[22212]Manufacture of styrofoam and plastic disposable utensils",
        zh: "[22212]Manufacture of styrofoam and plastic disposable utensils / 聚苯乙烯泡沫塑料和一次性塑料餐具的制造",
        en: "[22212]Manufacture of styrofoam and plastic disposable utensils",
      },
      {
        value: "[22213]Manufacture of plastic sheet, film and articles thereof (e.g. polythene and polypropylene bags)",
        zh: "[22213]Manufacture of plastic sheet, film and articles thereof (e.g. polythene and polypropylene bags) / 塑料片材、薄膜及其制品的制造（例如聚乙烯和聚丙烯袋）",
        en: "[22213]Manufacture of plastic sheet, film and articles thereof (e.g. polythene and polypropylene bags)",
      },
      {
        value: "[22214]Manufacture of plastic bottles, boxes and containers (except for household use)",
        zh: "[22214]Manufacture of plastic bottles, boxes and containers (except for household use) / 塑料瓶、盒和容器的制造（家用除外）",
        en: "[22214]Manufacture of plastic bottles, boxes and containers (except for household use)",
      },
      {
        value: "[22215]Manufacture of plastic pipes and tubes",
        zh: "[22215]Manufacture of plastic pipes and tubes / 塑料管材和管材的制造",
        en: "[22215]Manufacture of plastic pipes and tubes",
      },
      {
        value: "[22216]Manufacture of plastic precision engineering parts",
        zh: "[22216]Manufacture of plastic precision engineering parts / 塑料精密工程零件制造",
        en: "[22216]Manufacture of plastic precision engineering parts",
      },
      {
        value: "[22217]Manufacture of PVC files, holders and albums",
        zh: "[22217]Manufacture of PVC files, holders and albums / PVC文件、支架和相册的制造",
        en: "[22217]Manufacture of PVC files, holders and albums",
      },
      {
        value: "[22218]Manufacture of plastic cable ties",
        zh: "[22218]Manufacture of plastic cable ties / 塑料电缆扎带的制造",
        en: "[22218]Manufacture of plastic cable ties",
      },
      {
        value: "[22219]Manufacture of plastic products n.e.c. (except plastic footwear and toys)",
        zh: "[22219]Manufacture of plastic products n.e.c. (except plastic footwear and toys) / 其他塑料制品的制造（塑料鞋类和玩具除外）",
        en: "[22219]Manufacture of plastic products n.e.c. (except plastic footwear and toys)",
      },
      {
        value: "[22220]Plastic product services",
        zh: "[22220]Plastic product services / 塑料制品服务",
        en: "[22220]Plastic product services",
      },
      {
        value: "[23100]Manufacture of glass and glass products (including yarn of glass fibres)",
        zh: "[23100]Manufacture of glass and glass products (including yarn of glass fibres) / 玻璃和玻璃制品的制造（包括玻璃纤维纱）",
        en: "[23100]Manufacture of glass and glass products (including yarn of glass fibres)",
      },
      {
        value: "[23911]Manufacture of bricks",
        zh: "[23911]Manufacture of bricks / 砖的制造",
        en: "[23911]Manufacture of bricks",
      },
      {
        value: "[23912]Manufacture of tiles, pipes and channels (including clay roofing, wall and floor tiles, and earthen and glazed pipes)",
        zh: "[23912]Manufacture of tiles, pipes and channels (including clay roofing, wall and floor tiles, and earthen and glazed pipes) / 瓷砖、管道和管道的制造（包括粘土屋顶、墙砖和地砖，以及陶制和釉面管道）",
        en: "[23912]Manufacture of tiles, pipes and channels (including clay roofing, wall and floor tiles, and earthen and glazed pipes)",
      },
      {
        value: "[23919]Manufacture of clay products n.e.c.",
        zh: "[23919]Manufacture of clay products n.e.c. / 制造粘土制品",
        en: "[23919]Manufacture of clay products n.e.c.",
      },
      {
        value: "[23931]Manufacture of plumbing fixtures and fittings of vitreous china, china and earthenware (e.g. sinks, closets, bowls)",
        zh: "[23931]Manufacture of plumbing fixtures and fittings of vitreous china, china and earthenware (e.g. sinks, closets, bowls) / 玻璃瓷、瓷器和陶器的管道装置和配件的制造（例如水槽、壁橱、碗）",
        en: "[23931]Manufacture of plumbing fixtures and fittings of vitreous china, china and earthenware (e.g. sinks, closets, bowls)",
      },
      {
        value: "[23939]Manufacture of other porcelain and ceramic products n.e.c.",
        zh: "[23939]Manufacture of other porcelain and ceramic products n.e.c. / 其他瓷器和陶瓷制品的制造",
        en: "[23939]Manufacture of other porcelain and ceramic products n.e.c.",
      },
      {
        value: "[23940]Manufacture of cement, lime and plaster",
        zh: "[23940]Manufacture of cement, lime and plaster / 生产水泥、石灰和石膏",
        en: "[23940]Manufacture of cement, lime and plaster",
      },
      {
        value: "[23951]Manufacture of ready-mix concrete",
        zh: "[23951]Manufacture of ready-mix concrete / 生产预拌混凝土",
        en: "[23951]Manufacture of ready-mix concrete",
      },
      {
        value: "[23959]Manufacture of articles of concrete, cement and plaster n.e.c. (except precast concrete components)",
        zh: "[23959]Manufacture of articles of concrete, cement and plaster n.e.c. (except precast concrete components) / 混凝土、水泥和石膏制品的制造（预制混凝土构件除外）",
        en: "[23959]Manufacture of articles of concrete, cement and plaster n.e.c. (except precast concrete components)",
      },
      {
        value: "[23960]Cutting, shaping and finishing of stone (including tomb-stones and furniture of stone or marble)",
        zh: "[23960]Cutting, shaping and finishing of stone (including tomb-stones and furniture of stone or marble) / 石材的切割、成型和修整（包括墓碑和石材或大理石家具）",
        en: "[23960]Cutting, shaping and finishing of stone (including tomb-stones and furniture of stone or marble)",
      },
      {
        value: "[23991]Manufacture of asbestos products except asbestos paper",
        zh: "[23991]Manufacture of asbestos products except asbestos paper / 石棉纸以外的石棉制品的制造",
        en: "[23991]Manufacture of asbestos products except asbestos paper",
      },
      {
        value: "[23992]Manufacture of fibreglass and fibreglass products",
        zh: "[23992]Manufacture of fibreglass and fibreglass products / 制造玻璃纤维和玻璃纤维制品",
        en: "[23992]Manufacture of fibreglass and fibreglass products",
      },
      {
        value: "[23993]Manufacture of other insulation products (e.g. ceramic IC packages, refractory materials, rock wool products, insulation services)",
        zh: "[23993]Manufacture of other insulation products (e.g. ceramic IC packages, refractory materials, rock wool products, insulation services) / 其他绝缘产品制造（如陶瓷IC封装、耐火材料、岩棉制品、绝缘服务）",
        en: "[23993]Manufacture of other insulation products (e.g. ceramic IC packages, refractory materials, rock wool products, insulation services)",
      },
      {
        value: "[23994]Manufacture of non-structural pre-cast components (e.g. lightweight partitions, secondary roof slabs)",
        zh: "[23994]Manufacture of non-structural pre-cast components (e.g. lightweight partitions, secondary roof slabs) / 非结构预制构件的制造（例如轻质隔板、二次屋顶板）",
        en: "[23994]Manufacture of non-structural pre-cast components (e.g. lightweight partitions, secondary roof slabs)",
      },
      {
        value: "[23995]Manufacture of asphalt premix",
        zh: "[23995]Manufacture of asphalt premix / 生产沥青预混料",
        en: "[23995]Manufacture of asphalt premix",
      },
      {
        value: "[23999]Manufacture of other non-metallic mineral products n.e.c. (e.g. graphite products)",
        zh: "[23999]Manufacture of other non-metallic mineral products n.e.c. (e.g. graphite products) / 其他非金属矿产品（如石墨产品）的制造",
        en: "[23999]Manufacture of other non-metallic mineral products n.e.c. (e.g. graphite products)",
      },
      {
        value: "[24101]Iron and steel rolling mills",
        zh: "[24101]Iron and steel rolling mills / 钢铁轧机",
        en: "[24101]Iron and steel rolling mills",
      },
      {
        value: "[24102]Manufacture of ferrous metal alloys",
        zh: "[24102]Manufacture of ferrous metal alloys / 黑色金属合金的制造",
        en: "[24102]Manufacture of ferrous metal alloys",
      },
      {
        value: "[24109]Manufacture of basic iron and steel n.e.c. (including smelting)",
        zh: "[24109]Manufacture of basic iron and steel n.e.c. (including smelting) / 基础钢铁制造（包括冶炼）",
        en: "[24109]Manufacture of basic iron and steel n.e.c. (including smelting)",
      },
      {
        value: "[24201]Tin smelting",
        zh: "[24201]Tin smelting / 锡冶炼",
        en: "[24201]Tin smelting",
      },
      {
        value: "[24202]Manufacture of non-ferrous metal alloys",
        zh: "[24202]Manufacture of non-ferrous metal alloys / 有色金属合金制造",
        en: "[24202]Manufacture of non-ferrous metal alloys",
      },
      {
        value: "[24209]Manufacture of basic precious and non-ferrous metals n.e.c.",
        zh: "[24209]Manufacture of basic precious and non-ferrous metals n.e.c. / 基本贵金属和有色金属的制造",
        en: "[24209]Manufacture of basic precious and non-ferrous metals n.e.c.",
      },
      {
        value: "[24310]Iron and steel foundries",
        zh: "[24310]Iron and steel foundries / 钢铁铸造厂",
        en: "[24310]Iron and steel foundries",
      },
      {
        value: "[24320]Non-ferrous metal foundries",
        zh: "[24320]Non-ferrous metal foundries / 有色金属铸造厂",
        en: "[24320]Non-ferrous metal foundries",
      },
      {
        value: "[25111]Manufacture of metal doors, window and door frames, grilles and gratings",
        zh: "[25111]Manufacture of metal doors, window and door frames, grilles and gratings / 金属门、窗和门框、格栅和格栅的制造",
        en: "[25111]Manufacture of metal doors, window and door frames, grilles and gratings",
      },
      {
        value: "[25112]Manufacture of metal strips and slabs (e.g. awnings)",
        zh: "[25112]Manufacture of metal strips and slabs (e.g. awnings) / 金属条和金属板的制造（例如遮阳篷）",
        en: "[25112]Manufacture of metal strips and slabs (e.g. awnings)",
      },
      {
        value: "[25113]Manufacture of metal pipes and tubes",
        zh: "[25113]Manufacture of metal pipes and tubes / 金属管道和管材的制造",
        en: "[25113]Manufacture of metal pipes and tubes",
      },
      {
        value: "[25114]Manufacture of steel structural component",
        zh: "[25114]Manufacture of steel structural component / 钢结构件制造",
        en: "[25114]Manufacture of steel structural component",
      },
      {
        value: "[25119]Manufacture of structural metal products n.e.c. (e.g. metal sections, corrugated sheets)",
        zh: "[25119]Manufacture of structural metal products n.e.c. (e.g. metal sections, corrugated sheets) / 制造结构金属产品（例如金属型材、波纹板）",
        en: "[25119]Manufacture of structural metal products n.e.c. (e.g. metal sections, corrugated sheets)",
      },
      {
        value: "[25120]Manufacture and repair of tanks, reservoirs and containers of metal (e.g. metal cylinders, storage vessels and containers for compressed or liquefied gas)",
        zh: "[25120]Manufacture and repair of tanks, reservoirs and containers of metal (e.g. metal cylinders, storage vessels and containers for compressed or liquefied gas) / 金属罐、储罐和容器（例如金属气瓶、储存容器和压缩或液化气体容器）的制造和维修",
        en: "[25120]Manufacture and repair of tanks, reservoirs and containers of metal (e.g. metal cylinders, storage vessels and containers for compressed or liquefied gas)",
      },
      {
        value: "[25131]Manufacture and repair of heating boilers, radiators and correctors (including parts)",
        zh: "[25131]Manufacture and repair of heating boilers, radiators and correctors (including parts) / 供暖锅炉、散热器和校正器（包括零件）的制造和维修",
        en: "[25131]Manufacture and repair of heating boilers, radiators and correctors (including parts)",
      },
      {
        value: "[25139]Manufacture and repair of steam generators n.e.c. (except central heating hot water boilers)",
        zh: "[25139]Manufacture and repair of steam generators n.e.c. (except central heating hot water boilers) / 蒸汽发生器的制造和维修（集中供热热水锅炉除外）",
        en: "[25139]Manufacture and repair of steam generators n.e.c. (except central heating hot water boilers)",
      },
      {
        value: "[25200]Manufacture and repair of weapons and ammunition (e.g. ordnance and accessories)",
        zh: "[25200]Manufacture and repair of weapons and ammunition (e.g. ordnance and accessories) / 制造和修理武器和弹药（例如军械和配件）",
        en: "[25200]Manufacture and repair of weapons and ammunition (e.g. ordnance and accessories)",
      },
      {
        value: "[25911]Iron and steel and non-ferrous forgings",
        zh: "[25911]Iron and steel and non-ferrous forgings / 钢铁和有色金属锻件",
        en: "[25911]Iron and steel and non-ferrous forgings",
      },
      {
        value: "[25912]Manufacture of metal caps (e.g. crown corks)",
        zh: "[25912]Manufacture of metal caps (e.g. crown corks) / 金属瓶盖的制造（例如皇冠软木塞）",
        en: "[25912]Manufacture of metal caps (e.g. crown corks)",
      },
      {
        value: "[25913]Manufacture of leadframe",
        zh: "[25913]Manufacture of leadframe / 引线框架的制造",
        en: "[25913]Manufacture of leadframe",
      },
      {
        value: "[25914]Metal stampings except metal caps",
        zh: "[25914]Metal stampings except metal caps / 除金属盖外的金属冲压件",
        en: "[25914]Metal stampings except metal caps",
      },
      {
        value: "[25919]Pressing and roll-forming of metal and powder metallurgy n.e.c.",
        zh: "[25919]Pressing and roll-forming of metal and powder metallurgy n.e.c. / 金属和粉末冶金的压制和滚压成型",
        en: "[25919]Pressing and roll-forming of metal and powder metallurgy n.e.c.",
      },
      {
        value: "[25921]Electroplating and plating of metals and formed products",
        zh: "[25921]Electroplating and plating of metals and formed products / 金属和成型产品的电镀和电镀",
        en: "[25921]Electroplating and plating of metals and formed products",
      },
      {
        value: "[25922]Polishing of metals and formed products",
        zh: "[25922]Polishing of metals and formed products / 金属和成型产品的抛光",
        en: "[25922]Polishing of metals and formed products",
      },
      {
        value: "[25923]Rustproofing of metals and formed products",
        zh: "[25923]Rustproofing of metals and formed products / 金属和成型产品的防锈",
        en: "[25923]Rustproofing of metals and formed products",
      },
      {
        value: "[25924]Heat treatment for metals",
        zh: "[25924]Heat treatment for metals / 金属热处理",
        en: "[25924]Heat treatment for metals",
      },
      {
        value: "[25929]Metal product services n.e.c.",
        zh: "[25929]Metal product services n.e.c. / 金属产品服务",
        en: "[25929]Metal product services n.e.c.",
      },
      {
        value: "[25931]Manufacture of table, kitchen and other cutlery",
        zh: "[25931]Manufacture of table, kitchen and other cutlery / 餐桌、厨房和其他餐具的制造",
        en: "[25931]Manufacture of table, kitchen and other cutlery",
      },
      {
        value: "[25932]Manufacture of hand and edge tools",
        zh: "[25932]Manufacture of hand and edge tools / 手动和边缘工具的制造",
        en: "[25932]Manufacture of hand and edge tools",
      },
      {
        value: "[25939]Manufacture of general hardware (including blacksmith shops) n.e.c. (e.g. locks and keys, hinges, clamps, hooks)",
        zh: "[25939]Manufacture of general hardware (including blacksmith shops) n.e.c. (e.g. locks and keys, hinges, clamps, hooks) / 制造一般硬件（包括铁匠铺）（例如锁和钥匙、铰链、夹子、挂钩）",
        en: "[25939]Manufacture of general hardware (including blacksmith shops) n.e.c. (e.g. locks and keys, hinges, clamps, hooks)",
      },
      {
        value: "[25941]Manufacture of uninsulated wire (e.g. electronic component wire, bonding wire)",
        zh: "[25941]Manufacture of uninsulated wire (e.g. electronic component wire, bonding wire) / 非绝缘线（如电子元件线、键合线）的制造",
        en: "[25941]Manufacture of uninsulated wire (e.g. electronic component wire, bonding wire)",
      },
      {
        value: "[25949]Manufacture of metal wire and cable products n.e.c.",
        zh: "[25949]Manufacture of metal wire and cable products n.e.c. / 金属电线电缆产品制造",
        en: "[25949]Manufacture of metal wire and cable products n.e.c.",
      },
      {
        value: "[25951]Manufacture of tinplate cans",
        zh: "[25951]Manufacture of tinplate cans / 马口铁罐的制造",
        en: "[25951]Manufacture of tinplate cans",
      },
      {
        value: "[25952]Manufacture of other tinplate and zinc articles (e.g. pails, buckets, dustbins)",
        zh: "[25952]Manufacture of other tinplate and zinc articles (e.g. pails, buckets, dustbins) / 其他马口铁和锌制品的制造（例如桶、桶、垃圾箱）",
        en: "[25952]Manufacture of other tinplate and zinc articles (e.g. pails, buckets, dustbins)",
      },
      {
        value: "[25959]Manufacture of metal cans, containers and related products n.e.c. (e.g. barrels, steel drums, kegs)",
        zh: "[25959]Manufacture of metal cans, containers and related products n.e.c. (e.g. barrels, steel drums, kegs) / 制造金属罐、容器和相关产品（例如桶、钢桶、小桶）",
        en: "[25959]Manufacture of metal cans, containers and related products n.e.c. (e.g. barrels, steel drums, kegs)",
      },
      {
        value: "[25991]Manufacture of sanitary ware of enamelled iron and metal and plumbers' ware of brass",
        zh: "[25991]Manufacture of sanitary ware of enamelled iron and metal and plumbers' ware of brass / 搪瓷铁和金属卫生洁具和黄铜水管工器具的制造",
        en: "[25991]Manufacture of sanitary ware of enamelled iron and metal and plumbers' ware of brass",
      },
      {
        value: "[25992]Manufacture of plumbing, heating and related products (including parts) except electric",
        zh: "[25992]Manufacture of plumbing, heating and related products (including parts) except electric / 管道、暖气和相关产品（包括零件）的制造，但电气除外",
        en: "[25992]Manufacture of plumbing, heating and related products (including parts) except electric",
      },
      {
        value: "[25993]Manufacture of bolts, nuts, rivets, fasteners and screw machine products",
        zh: "[25993]Manufacture of bolts, nuts, rivets, fasteners and screw machine products / 制造螺栓、螺母、铆钉、紧固件和螺丝机产品",
        en: "[25993]Manufacture of bolts, nuts, rivets, fasteners and screw machine products",
      },
      {
        value: "[25994]Manufacture of pipe fittings",
        zh: "[25994]Manufacture of pipe fittings / 管件制造",
        en: "[25994]Manufacture of pipe fittings",
      },
      {
        value: "[25995]Manufacture of springs",
        zh: "[25995]Manufacture of springs / 弹簧制造",
        en: "[25995]Manufacture of springs",
      },
      {
        value:
          "[25996]Manufacture of kitchen and household utensils (e.g. steel shelf, showcase counters, kitchen trolleys display racks, sink bowls and other customised kitchen equipment)",
        zh: "[25996]Manufacture of kitchen and household utensils (e.g. steel shelf, showcase counters, kitchen trolleys display racks, sink bowls and other customised kitchen equipment) / 厨房和家庭用具的制造（例如钢架子、展示柜、厨房手推车展示架、水槽碗和其他定制厨房设备）",
        en: "[25996]Manufacture of kitchen and household utensils (e.g. steel shelf, showcase counters, kitchen trolleys display racks, sink bowls and other customised kitchen equipment)",
      },
      {
        value: "[25997]Manufacture of metal precision components",
        zh: "[25997]Manufacture of metal precision components / 金属精密零件制造",
        en: "[25997]Manufacture of metal precision components",
      },
      {
        value: "[25998]Slitting, shearing and pasting of metal sheeting",
        zh: "[25998]Slitting, shearing and pasting of metal sheeting / 金属片材的分切、剪切和粘贴",
        en: "[25998]Slitting, shearing and pasting of metal sheeting",
      },
      {
        value: "[25999]Manufacture of other fabricated metal products n.e.c. (including voice coil magnets)",
        zh: "[25999]Manufacture of other fabricated metal products n.e.c. (including voice coil magnets) / 其他金属制品的制造（包括音圈磁铁）",
        en: "[25999]Manufacture of other fabricated metal products n.e.c. (including voice coil magnets)",
      },
      {
        value: "[26111]Manufacture of discrete devices (e.g. diodes, light-emitting diodes, transistors and rectifiers)",
        zh: "[26111]Manufacture of discrete devices (e.g. diodes, light-emitting diodes, transistors and rectifiers) / 分立器件的制造（例如二极管、发光二极管、晶体管和整流器）",
        en: "[26111]Manufacture of discrete devices (e.g. diodes, light-emitting diodes, transistors and rectifiers)",
      },
      {
        value: "[26112]Semiconductor wafer fabrication",
        zh: "[26112]Semiconductor wafer fabrication / 半导体晶圆制造",
        en: "[26112]Semiconductor wafer fabrication",
      },
      {
        value: "[26113]Assembly and testing of semiconductors",
        zh: "[26113]Assembly and testing of semiconductors / 半导体的组装和测试",
        en: "[26113]Assembly and testing of semiconductors",
      },
      {
        value: "[26114]Manufacture of solar wafers",
        zh: "[26114]Manufacture of solar wafers / 太阳能晶片的制造",
        en: "[26114]Manufacture of solar wafers",
      },
      {
        value: "[26115]Manufacture of solar cells",
        zh: "[26115]Manufacture of solar cells / 太阳能电池的制造",
        en: "[26115]Manufacture of solar cells",
      },
      {
        value: "[26119]Manufacture of semiconductor devices n.e.c.",
        zh: "[26119]Manufacture of semiconductor devices n.e.c. / 半导体器件的制造 ",
        en: "[26119]Manufacture of semiconductor devices n.e.c.",
      },
      {
        value: "[26121]Manufacture of capacitors",
        zh: "[26121]Manufacture of capacitors / 电容器制造",
        en: "[26121]Manufacture of capacitors",
      },
      {
        value: "[26122]Manufacture of printed circuit boards without electronic parts",
        zh: "[26122]Manufacture of printed circuit boards without electronic parts / 制造不含电子零件的印刷电路板",
        en: "[26122]Manufacture of printed circuit boards without electronic parts",
      },
      {
        value: "[26123]Manufacture of printed circuit boards with electronic parts",
        zh: "[26123]Manufacture of printed circuit boards with electronic parts / 制造带有电子零件的印刷电路板",
        en: "[26123]Manufacture of printed circuit boards with electronic parts",
      },
      {
        value: "[26124]Manufacture of piezo-electric devices (e.g. quartz crystals, quartz crystal filters, delay lines)",
        zh: "[26124]Manufacture of piezo-electric devices (e.g. quartz crystals, quartz crystal filters, delay lines) / 压电器件的制造（例如石英晶体、石英晶体滤波器、延迟线）",
        en: "[26124]Manufacture of piezo-electric devices (e.g. quartz crystals, quartz crystal filters, delay lines)",
      },
      {
        value: "[26125]Manufacture of electronic display devices except light emitting diodes",
        zh: "[26125]Manufacture of electronic display devices except light emitting diodes / 发光二极管以外的电子显示装置的制造",
        en: "[26125]Manufacture of electronic display devices except light emitting diodes",
      },
      {
        value: "[26126]Manufacture of electronic connectors",
        zh: "[26126]Manufacture of electronic connectors / 电子连接器制造",
        en: "[26126]Manufacture of electronic connectors",
      },
      {
        value: "[26129]Manufacture of other electronic components and boards n.e.c.",
        zh: "[26129]Manufacture of other electronic components and boards n.e.c. / 其他电子元件和电路板的制造",
        en: "[26129]Manufacture of other electronic components and boards n.e.c.",
      },
      {
        value: "[26201]Manufacture of computers and data processing equipment except computer peripheral equipment",
        zh: "[26201]Manufacture of computers and data processing equipment except computer peripheral equipment / 除计算机外围设备外的计算机和数据处理设备的制造",
        en: "[26201]Manufacture of computers and data processing equipment except computer peripheral equipment",
      },
      {
        value: "[26202]Manufacture of disk drives (including CD-ROM drives, DVD-ROM drives, optical drives, flash drives, tape drives, solid state drives, storage subsystems)",
        zh: "[26202]Manufacture of disk drives (including CD-ROM drives, DVD-ROM drives, optical drives, flash drives, tape drives, solid state drives, storage subsystems) / 磁盘驱动器（包括 CD-ROM 驱动器、DVD-ROM 驱动器、光驱、闪存驱动器、磁带驱动器、固态驱动器、存储子系统）的制造",
        en: "[26202]Manufacture of disk drives (including CD-ROM drives, DVD-ROM drives, optical drives, flash drives, tape drives, solid state drives, storage subsystems)",
      },
      {
        value: "[26203]Manufacture of printers",
        zh: "[26203]Manufacture of printers / 打印机制造",
        en: "[26203]Manufacture of printers",
      },
      {
        value: "[26204]Manufacture of smart cards and related products (e.g. smart card readers)",
        zh: "[26204]Manufacture of smart cards and related products (e.g. smart card readers) / 智能卡及相关产品（如智能卡读卡器）的制造",
        en: "[26204]Manufacture of smart cards and related products (e.g. smart card readers)",
      },
      {
        value: "[26209]Manufacture of computers and peripheral equipment n.e.c.",
        zh: "[26209]Manufacture of computers and peripheral equipment n.e.c. / 电脑及周边设备的制造",
        en: "[26209]Manufacture of computers and peripheral equipment n.e.c.",
      },
      {
        value: "[26301]Manufacture of telecommunications apparatus (e.g. PBX equipment, telephones except cellular)",
        zh: "[26301]Manufacture of telecommunications apparatus (e.g. PBX equipment, telephones except cellular) / 电信设备的制造（例如 PBX 设备、蜂窝电话除外）",
        en: "[26301]Manufacture of telecommunications apparatus (e.g. PBX equipment, telephones except cellular)",
      },
      {
        value: "[26302]Manufacture of networking products (e.g. routers, switches)",
        zh: "[26302]Manufacture of networking products (e.g. routers, switches) / 网络产品制造（例如路由器、交换机）",
        en: "[26302]Manufacture of networking products (e.g. routers, switches)",
      },
      {
        value: "[26303]Manufacture of wireless communications equipment (e.g. cellular phones)",
        zh: "[26303]Manufacture of wireless communications equipment (e.g. cellular phones) / 制造无线通讯设备（例如手机）",
        en: "[26303]Manufacture of wireless communications equipment (e.g. cellular phones)",
      },
      {
        value: "[26304]Manufacture of electronic security systems (including electronic sensors, burglar and fire alarm systems)",
        zh: "[26304]Manufacture of electronic security systems (including electronic sensors, burglar and fire alarm systems) / 制造电子安全系统（包括电子传感器、防盗和火灾报警系统）",
        en: "[26304]Manufacture of electronic security systems (including electronic sensors, burglar and fire alarm systems)",
      },
      {
        value: "[26309]Manufacture of communications equipment n.e.c.",
        zh: "[26309]Manufacture of communications equipment n.e.c. / 通信设备制造",
        en: "[26309]Manufacture of communications equipment n.e.c.",
      },
      {
        value: "[26400]Manufacture of consumer electronics",
        zh: "[26400]Manufacture of consumer electronics / 消费电子产品制造",
        en: "[26400]Manufacture of consumer electronics",
      },
      {
        value: "[26511]Manufacture and repair of engineering and scientific instruments",
        zh: "[26511]Manufacture and repair of engineering and scientific instruments / 工程和科学仪器的制造和维修",
        en: "[26511]Manufacture and repair of engineering and scientific instruments",
      },
      {
        value: "[26512]Manufacture and repair of measuring devices (e.g. meters)",
        zh: "[26512]Manufacture and repair of measuring devices (e.g. meters) / 测量设备（例如仪表）的制造和维修",
        en: "[26512]Manufacture and repair of measuring devices (e.g. meters)",
      },
      {
        value: "[26513]Manufacture and repair of process control equipment and related products",
        zh: "[26513]Manufacture and repair of process control equipment and related products / 过程控制设备及相关产品的制造和维修",
        en: "[26513]Manufacture and repair of process control equipment and related products",
      },
      {
        value: "[26521]Manufacture of fully electronic watches and clocks",
        zh: "[26521]Manufacture of fully electronic watches and clocks / 制造全电子钟表",
        en: "[26521]Manufacture of fully electronic watches and clocks",
      },
      {
        value: "[26522]Manufacture of electro-mechanical watches and clocks (e.g. watches and clocks with moving parts and battery)",
        zh: "[26522]Manufacture of electro-mechanical watches and clocks (e.g. watches and clocks with moving parts and battery) / 制造机电钟表（例如带有运动部件和电池的钟表）",
        en: "[26522]Manufacture of electro-mechanical watches and clocks (e.g. watches and clocks with moving parts and battery)",
      },
      {
        value: "[26523]Manufacture of mechanical watches and clocks",
        zh: "[26523]Manufacture of mechanical watches and clocks / 机械钟表制造",
        en: "[26523]Manufacture of mechanical watches and clocks",
      },
      {
        value: "[26524]Manufacture of parts and accessories for watches and clocks",
        zh: "[26524]Manufacture of parts and accessories for watches and clocks / 制造钟表零件和配件",
        en: "[26524]Manufacture of parts and accessories for watches and clocks",
      },
      {
        value: "[26601]Manufacture and repair of electrotherapeutic devices",
        zh: "[26601]Manufacture and repair of electrotherapeutic devices / 电疗设备的制造和维修",
        en: "[26601]Manufacture and repair of electrotherapeutic devices",
      },
      {
        value: "[26602]Manufacture and repair of irradiation and electromedical equipment and instruments",
        zh: "[26602]Manufacture and repair of irradiation and electromedical equipment and instruments / 辐照和电子医疗设备和仪器的制造和维修",
        en: "[26602]Manufacture and repair of irradiation and electromedical equipment and instruments",
      },
      {
        value: "[26701]Manufacture of photographic equipment and parts (including lenses)",
        zh: "[26701]Manufacture of photographic equipment and parts (including lenses) / 摄影器材及零件（包括镜头）的制造",
        en: "[26701]Manufacture of photographic equipment and parts (including lenses)",
      },
      {
        value: "[26709]Manufacture of optical instruments and photographic equipment n.e.c.",
        zh: "[26709]Manufacture of optical instruments and photographic equipment n.e.c. / 光学仪器和摄影设备的制造 ",
        en: "[26709]Manufacture of optical instruments and photographic equipment n.e.c.",
      },
      {
        value: "[26801]Manufacture of disk media",
        zh: "[26801]Manufacture of disk media / 磁盘介质的制造",
        en: "[26801]Manufacture of disk media",
      },
      {
        value: "[26802]Manufacture of blank magnetic tapes, diskettes, Blu-ray technology discs, CDs, DVDs and VCDs",
        zh: "[26802]Manufacture of blank magnetic tapes, diskettes, Blu-ray technology discs, CDs, DVDs and VCDs / 空白磁带、软盘、蓝光技术光盘、CD、DVD 和 VCD 的制造",
        en: "[26802]Manufacture of blank magnetic tapes, diskettes, Blu-ray technology discs, CDs, DVDs and VCDs",
      },
      {
        value: "[27101]Manufacture and repair of electric motors",
        zh: "[27101]Manufacture and repair of electric motors / 电动机的制造和维修",
        en: "[27101]Manufacture and repair of electric motors",
      },
      {
        value: "[27102]Manufacture and repair of electric generators",
        zh: "[27102]Manufacture and repair of electric generators / 发电机的制造和维修",
        en: "[27102]Manufacture and repair of electric generators",
      },
      {
        value: "[27103]Manufacture and repair of transformers",
        zh: "[27103]Manufacture and repair of transformers / 变压器的制造和维修",
        en: "[27103]Manufacture and repair of transformers",
      },
      {
        value: "[27104]Manufacture and repair of switchgear and switchboard apparatus (including switches, circuit breakers and electrical control panels)",
        zh: "[27104]Manufacture and repair of switchgear and switchboard apparatus (including switches, circuit breakers and electrical control panels) / 开关设备和配电盘设备（包括开关、断路器和电气控制面板）的制造和维修",
        en: "[27104]Manufacture and repair of switchgear and switchboard apparatus (including switches, circuit breakers and electrical control panels)",
      },
      {
        value: "[27109]Manufacture and repair of electric motors, generators, transformers and electricity distribution and control apparatus n.e.c. (e.g. busbar trunking)",
        zh: "[27109]Manufacture and repair of electric motors, generators, transformers and electricity distribution and control apparatus n.e.c. (e.g. busbar trunking) / 制造和维修电动机、发电机、变压器以及配电和控制设备（例如母线槽）",
        en: "[27109]Manufacture and repair of electric motors, generators, transformers and electricity distribution and control apparatus n.e.c. (e.g. busbar trunking)",
      },
      {
        value: "[27201]Manufacture of primary batteries",
        zh: "[27201]Manufacture of primary batteries / 原电池制造",
        en: "[27201]Manufacture of primary batteries",
      },
      {
        value: "[27202]Manufacture of secondary batteries",
        zh: "[27202]Manufacture of secondary batteries / 二次电池的制造",
        en: "[27202]Manufacture of secondary batteries",
      },
      {
        value: "[27321]Manufacture of telecommunications cables and wires",
        zh: "[27321]Manufacture of telecommunications cables and wires / 电信电缆和电线的制造",
        en: "[27321]Manufacture of telecommunications cables and wires",
      },
      {
        value: "[27322]Manufacture of electric power cables and wires",
        zh: "[27322]Manufacture of electric power cables and wires / 电力电缆和电线的制造",
        en: "[27322]Manufacture of electric power cables and wires",
      },
      {
        value: "[27323]Manufacture of enamelled wires (used for winding of motors, transformers etc)",
        zh: "[27323]Manufacture of enamelled wires (used for winding of motors, transformers etc) / 漆包线的制造（用于电机、变压器等的绕组）",
        en: "[27323]Manufacture of enamelled wires (used for winding of motors, transformers etc)",
      },
      {
        value: "[27324]Manufacture of wire and cable assemblies and harnesses",
        zh: "[27324]Manufacture of wire and cable assemblies and harnesses / 电线电缆组件和线束的制造",
        en: "[27324]Manufacture of wire and cable assemblies and harnesses",
      },
      {
        value: "[27329]Manufacture of other electronic and electric wires and cables n.e.c.",
        zh: "[27329]Manufacture of other electronic and electric wires and cables n.e.c. / 其他电子电气电线电缆的制造",
        en: "[27329]Manufacture of other electronic and electric wires and cables n.e.c.",
      },
      {
        value: "[27330]Manufacture and repair of wiring devices",
        zh: "[27330]Manufacture and repair of wiring devices / 接线设备的制造和维修",
        en: "[27330]Manufacture and repair of wiring devices",
      },
      {
        value: "[27400]Manufacture and repair of electric lamps and lighting equipment (including silver reflectors, fittings and parts)",
        zh: "[27400]Manufacture and repair of electric lamps and lighting equipment (including silver reflectors, fittings and parts) / 电灯和照明设备的制造和修理（包括银反射器、配件和零件）",
        en: "[27400]Manufacture and repair of electric lamps and lighting equipment (including silver reflectors, fittings and parts)",
      },
      {
        value: "[27501]Manufacture of electrical household appliances (e.g. refrigerators, hot plates, toasters, food mixers, cookers, hair dryers, fans, shavers)",
        zh: "[27501]Manufacture of electrical household appliances (e.g. refrigerators, hot plates, toasters, food mixers, cookers, hair dryers, fans, shavers) / 家用电器制造（如冰箱、电热板、烤面包机、食品搅拌机、炊具、吹风机、风扇、剃须刀）",
        en: "[27501]Manufacture of electrical household appliances (e.g. refrigerators, hot plates, toasters, food mixers, cookers, hair dryers, fans, shavers)",
      },
      {
        value: "[27509]Manufacture of domestic appliances n.e.c. (e.g. non-electric cooking ranges, grates, stoves)",
        zh: "[27509]Manufacture of domestic appliances n.e.c. (e.g. non-electric cooking ranges, grates, stoves) / 家用电器制造（例如非电动灶具、炉排、炉灶）",
        en: "[27509]Manufacture of domestic appliances n.e.c. (e.g. non-electric cooking ranges, grates, stoves)",
      },
      {
        value: "[27901]Manufacture of fuel cells",
        zh: "[27901]Manufacture of fuel cells / 燃料电池的制造",
        en: "[27901]Manufacture of fuel cells",
      },
      {
        value:
          "[27902]Manufacture of electrical machinery, apparatus, appliances and supplies (including sound or visual signalling apparatus, electrical insulators except porcelain or glass)",
        zh: "[27902]Manufacture of electrical machinery, apparatus, appliances and supplies (including sound or visual signalling apparatus, electrical insulators except porcelain or glass) / 电气机械、仪器、器具和用品的制造（包括声音或视觉信号装置、电绝缘体，瓷器或玻璃除外）",
        en: "[27902]Manufacture of electrical machinery, apparatus, appliances and supplies (including sound or visual signalling apparatus, electrical insulators except porcelain or glass)",
      },
      {
        value: "[28111]Manufacture and repair of engines and turbines except aircraft, vehicle, cycle and marine engines",
        zh: "[28111]Manufacture and repair of engines and turbines except aircraft, vehicle, cycle and marine engines / 发动机和涡轮机的制造和维修，飞机、车辆、自行车和船用发动机除外",
        en: "[28111]Manufacture and repair of engines and turbines except aircraft, vehicle, cycle and marine engines",
      },
      {
        value: "[28112]Manufacture and repair of marine engine",
        zh: "[28112]Manufacture and repair of marine engine / 船用发动机制造与维修",
        en: "[28112]Manufacture and repair of marine engine",
      },
      {
        value: "[28121]Manufacture and repair of pumps (e.g. hydraulic pumps, drainage pumps)",
        zh: "[28121]Manufacture and repair of pumps (e.g. hydraulic pumps, drainage pumps) / 制造和修理泵（例如液压泵、排水泵）",
        en: "[28121]Manufacture and repair of pumps (e.g. hydraulic pumps, drainage pumps)",
      },
      {
        value: "[28122]Manufacture and repair of taps, cocks and valves",
        zh: "[28122]Manufacture and repair of taps, cocks and valves / 水龙头、旋塞和阀门的制造和维修",
        en: "[28122]Manufacture and repair of taps, cocks and valves",
      },
      {
        value: "[28129]Manufacture and repair of pumps, compressors, taps and valves n.e.c.",
        zh: "[28129]Manufacture and repair of pumps, compressors, taps and valves n.e.c. / 泵、压缩机、水龙头和阀门的制造和维修",
        en: "[28129]Manufacture and repair of pumps, compressors, taps and valves n.e.c.",
      },
      {
        value: "[28141]Manufacture of bearings (including disc and ball bearings)",
        zh: "[28141]Manufacture of bearings (including disc and ball bearings) / 轴承制造（包括圆盘和滚珠轴承）",
        en: "[28141]Manufacture of bearings (including disc and ball bearings)",
      },
      {
        value: "[28142]Manufacture and repair of gears, gearing and driving elements",
        zh: "[28142]Manufacture and repair of gears, gearing and driving elements / 齿轮、传动装置和驱动元件的制造和维修",
        en: "[28142]Manufacture and repair of gears, gearing and driving elements",
      },
      {
        value: "[28150]Manufacture and repair of ovens, furnaces and furnace burners",
        zh: "[28150]Manufacture and repair of ovens, furnaces and furnace burners / 烤箱、熔炉和熔炉燃烧器的制造和维修",
        en: "[28150]Manufacture and repair of ovens, furnaces and furnace burners",
      },
      {
        value: "[28161]Manufacture and repair of lifting and hoisting machinery except electrical",
        zh: "[28161]Manufacture and repair of lifting and hoisting machinery except electrical / 起重和起重机械的制造和维修，但电气除外",
        en: "[28161]Manufacture and repair of lifting and hoisting machinery except electrical",
      },
      {
        value: "[28162]Manufacture and repair of lifts and escalators",
        zh: "[28162]Manufacture and repair of lifts and escalators / 电梯和自动扶梯的制造和维修",
        en: "[28162]Manufacture and repair of lifts and escalators",
      },
      {
        value: "[28169]Manufacture and repair of lifting and handling equipment n.e.c. (including conveying systems and industrial automated systems)",
        zh: "[28169]Manufacture and repair of lifting and handling equipment n.e.c. (including conveying systems and industrial automated systems) / 起重和搬运设备 （包括输送系统和工业自动化系统）的制造和维修",
        en: "[28169]Manufacture and repair of lifting and handling equipment n.e.c. (including conveying systems and industrial automated systems)",
      },
      {
        value: "[28171]Manufacture of office machinery and equipment (except computers and peripheral equipment)",
        zh: "[28171]Manufacture of office machinery and equipment (except computers and peripheral equipment) / 办公机械设备制造（电脑及周边设备除外）",
        en: "[28171]Manufacture of office machinery and equipment (except computers and peripheral equipment)",
      },
      {
        value: "[28172]Repair and maintenance of office machinery and equipment",
        zh: "[28172]Repair and maintenance of office machinery and equipment / 办公机械设备的维修保养",
        en: "[28172]Repair and maintenance of office machinery and equipment",
      },
      {
        value: "[28181]Manufacture and repair of industrial robots (including Automated Guided Vehicles (AGVs))",
        zh: "[28181]Manufacture and repair of industrial robots (including Automated Guided Vehicles (AGVs)) / 工业机器人（包括自动导引车（AGV））的制造和维修",
        en: "[28181]Manufacture and repair of industrial robots (including Automated Guided Vehicles (AGVs))",
      },
      {
        value: "[28182]Manufacture and repair of service robots",
        zh: "[28182]Manufacture and repair of service robots / 服务机器人的制造和维修",
        en: "[28182]Manufacture and repair of service robots",
      },
      {
        value: "[28189]Manufacture and repair of robots n.e.c.",
        zh: "[28189]Manufacture and repair of robots n.e.c. / 制造和维修机器人",
        en: "[28189]Manufacture and repair of robots n.e.c.",
      },
      {
        value: "[28191]Manufacture and repair of refrigerating, air-conditioning and ventilating machinery and equipment except household refrigerators",
        zh: "[28191]Manufacture and repair of refrigerating, air-conditioning and ventilating machinery and equipment except household refrigerators / 除家用冰箱外的制冷、空调、通风机械设备的制造和维修",
        en: "[28191]Manufacture and repair of refrigerating, air-conditioning and ventilating machinery and equipment except household refrigerators",
      },
      {
        value: "[28192]Manufacture and repair of separation/mixing equipment (e.g. filters, separators, mixers)",
        zh: "[28192]Manufacture and repair of separation/mixing equipment (e.g. filters, separators, mixers) / 分离/混合设备（如过滤器、分离器、混合器）的制造和维修",
        en: "[28192]Manufacture and repair of separation/mixing equipment (e.g. filters, separators, mixers)",
      },
      {
        value: "[28193]Manufacture and repair of solar modules and panels",
        zh: "[28193]Manufacture and repair of solar modules and panels / 太阳能组件和电池板的制造和维修",
        en: "[28193]Manufacture and repair of solar modules and panels",
      },
      {
        value: "[28194]Manufacture and repair of welding and soldering equipment (including arc welding electrodes)",
        zh: "[28194]Manufacture and repair of welding and soldering equipment (including arc welding electrodes) / 焊接和钎焊设备（包括弧焊电极）的制造和修理",
        en: "[28194]Manufacture and repair of welding and soldering equipment (including arc welding electrodes)",
      },
      {
        value: "[28195]Manufacture and repair of packaging machinery",
        zh: "[28195]Manufacture and repair of packaging machinery / 包装机械制造与维修",
        en: "[28195]Manufacture and repair of packaging machinery",
      },
      {
        value: "[28199]Manufacture and repair of other general purpose machinery and equipment except electrical and electronic n.e.c.",
        zh: "[28199]Manufacture and repair of other general purpose machinery and equipment except electrical and electronic n.e.c. / 其他通用机械设备的制造和维修，但电气和电子设备除外",
        en: "[28199]Manufacture and repair of other general purpose machinery and equipment except electrical and electronic n.e.c.",
      },
      {
        value: "[28210]Manufacture and repair of agricultural and forestry machinery",
        zh: "[28210]Manufacture and repair of agricultural and forestry machinery / 农林机械制造、修理",
        en: "[28210]Manufacture and repair of agricultural and forestry machinery",
      },
      {
        value: "[28221]Manufacture and repair of machinery and machine-tools - metal cutting types (e.g. lathes, milling machines, shaping machines)",
        zh: "[28221]Manufacture and repair of machinery and machine-tools - metal cutting types (e.g. lathes, milling machines, shaping machines) / 机械和机床的制造和维修 - 金属切削类型（例如车床、铣床、成型机）",
        en: "[28221]Manufacture and repair of machinery and machine-tools - metal cutting types (e.g. lathes, milling machines, shaping machines)",
      },
      {
        value: "[28222]Manufacture and repair of machinery and machine-tools - metal forming types (e.g. forging press, cold heading machines, press breaks)",
        zh: "[28222]Manufacture and repair of machinery and machine-tools - metal forming types (e.g. forging press, cold heading machines, press breaks) / 机械和机床的制造和维修 - 金属成型类型（例如锻压机、冷镦机、压机）",
        en: "[28222]Manufacture and repair of machinery and machine-tools - metal forming types (e.g. forging press, cold heading machines, press breaks)",
      },
      {
        value: "[28223]Manufacture of dies, moulds, tools, jigs and fixtures",
        zh: "[28223]Manufacture of dies, moulds, tools, jigs and fixtures / 模具、模具、工具、夹具和固定装置的制造",
        en: "[28223]Manufacture of dies, moulds, tools, jigs and fixtures",
      },
      {
        value: "[28224]Manufacture of machine tool accessories (e.g. small cutting tools, precision measuring tools and other attachments such as tool holders)",
        zh: "[28224]Manufacture of machine tool accessories (e.g. small cutting tools, precision measuring tools and other attachments such as tool holders) / 制造机床附件（如小型切削刀具、精密量具和其他附件如刀架）",
        en: "[28224]Manufacture of machine tool accessories (e.g. small cutting tools, precision measuring tools and other attachments such as tool holders)",
      },
      {
        value: "[28225]Manufacture and repair of metal additive manufacturing (AM) equipment (including metal powder)",
        zh: "[28225]Manufacture and repair of metal additive manufacturing (AM) equipment (including metal powder) / 金属增材制造 (AM) 设备（包括金属粉末）的制造和维修",
        en: "[28225]Manufacture and repair of metal additive manufacturing (AM) equipment (including metal powder)",
      },
      {
        value: "[28229]Manufacture and repair of metal-forming machinery and machine tools n.e.c. (including metalworking machinery)",
        zh: "[28229]Manufacture and repair of metal-forming machinery and machine tools n.e.c. (including metalworking machinery) / 金属成型机械和机床（包括金属加工机械）的制造和修理",
        en: "[28229]Manufacture and repair of metal-forming machinery and machine tools n.e.c. (including metalworking machinery)",
      },
      {
        value: "[28241]Manufacture and repair of oil rigs",
        zh: "[28241]Manufacture and repair of oil rigs / 石油钻井平台的制造和维修",
        en: "[28241]Manufacture and repair of oil rigs",
      },
      {
        value: "[28242]Manufacture and repair of other oilfield and gasfield machinery and equipment (e.g. derricks, tool joints)",
        zh: "[28242]Manufacture and repair of other oilfield and gasfield machinery and equipment (e.g. derricks, tool joints) / 其他油田、气田机械设备（如井架、工具接头）的制造和维修",
        en: "[28242]Manufacture and repair of other oilfield and gasfield machinery and equipment (e.g. derricks, tool joints)",
      },
      {
        value: "[28243]Manufacture and repair of construction machinery and parts",
        zh: "[28243]Manufacture and repair of construction machinery and parts / 工程机械及零部件的制造和维修",
        en: "[28243]Manufacture and repair of construction machinery and parts",
      },
      {
        value: "[28249]Manufacture and repair of machinery for mining, quarrying and construction n.e.c.",
        zh: "[28249]Manufacture and repair of machinery for mining, quarrying and construction n.e.c. / 采矿、采石和建筑用机械的制造和维修",
        en: "[28249]Manufacture and repair of machinery for mining, quarrying and construction n.e.c.",
      },
      {
        value: "[28251]Manufacture and repair of machinery for food products processing",
        zh: "[28251]Manufacture and repair of machinery for food products processing / 食品加工机械的制造和维修",
        en: "[28251]Manufacture and repair of machinery for food products processing",
      },
      {
        value: "[28252]Manufacture and repair of machinery for beverage production",
        zh: "[28252]Manufacture and repair of machinery for beverage production / 饮料生产机械的制造和维修",
        en: "[28252]Manufacture and repair of machinery for beverage production",
      },
      {
        value: "[28253]Manufacture and repair of machinery for tobacco processing",
        zh: "[28253]Manufacture and repair of machinery for tobacco processing / 烟草加工机械的制造和维修",
        en: "[28253]Manufacture and repair of machinery for tobacco processing",
      },
      {
        value: "[28260]Manufacture and repair of machinery for textile, apparel and leather production",
        zh: "[28260]Manufacture and repair of machinery for textile, apparel and leather production / 纺织、服装和皮革生产机械的制造和维修",
        en: "[28260]Manufacture and repair of machinery for textile, apparel and leather production",
      },
      {
        value: "[28271]Manufacture of probe cards",
        zh: "[28271]Manufacture of probe cards / 探针卡的制造",
        en: "[28271]Manufacture of probe cards",
      },
      {
        value: "[28272]Manufacture of bonding tools",
        zh: "[28272]Manufacture of bonding tools / 焊接工具的制造",
        en: "[28272]Manufacture of bonding tools",
      },
      {
        value: "[28273]Manufacture and repair of semiconductor assembly and testing equipment (including computer burn-in system)",
        zh: "[28273]Manufacture and repair of semiconductor assembly and testing equipment (including computer burn-in system) / 半导体组装和测试设备的制造和维修（包括计算机老化系统）",
        en: "[28273]Manufacture and repair of semiconductor assembly and testing equipment (including computer burn-in system)",
      },
      {
        value: "[28274]Manufacture and repair of semiconductor foundry equipment",
        zh: "[28274]Manufacture and repair of semiconductor foundry equipment / 半导体代工设备的制造和维修",
        en: "[28274]Manufacture and repair of semiconductor foundry equipment",
      },
      {
        value: "[28291]Manufacture and repair of water/waste water treatment equipment",
        zh: "[28291]Manufacture and repair of water/waste water treatment equipment / 水/废水处理设备的制造和维修",
        en: "[28291]Manufacture and repair of water/waste water treatment equipment",
      },
      {
        value: "[28292]Manufacture and repair of plastic processing machinery",
        zh: "[28292]Manufacture and repair of plastic processing machinery / 塑料加工机械制造与维修",
        en: "[28292]Manufacture and repair of plastic processing machinery",
      },
      {
        value: "[28293]Manufacture and repair of woodworking machinery",
        zh: "[28293]Manufacture and repair of woodworking machinery / 木工机械的制造和维修",
        en: "[28293]Manufacture and repair of woodworking machinery",
      },
      {
        value: "[28294]Manufacture and repair of polymer additive manufacturing (AM) equipment",
        zh: "[28294]Manufacture and repair of polymer additive manufacturing (AM) equipment / 聚合物增材制造 (AM) 设备的制造和维修",
        en: "[28294]Manufacture and repair of polymer additive manufacturing (AM) equipment",
      },
      {
        value: "[28299]Manufacture and repair of other special purpose machinery n.e.c. (including plating equipment, industrial paint mixers and chemical mixing equipment)",
        zh: "[28299]Manufacture and repair of other special purpose machinery n.e.c. (including plating equipment, industrial paint mixers and chemical mixing equipment) / 其他特殊用途机械（包括电镀设备、工业油漆搅拌机和化学混合设备）的制造和维修",
        en: "[28299]Manufacture and repair of other special purpose machinery n.e.c. (including plating equipment, industrial paint mixers and chemical mixing equipment)",
      },
      {
        value: "[28300]Installation of industrial machinery and equipment, mechanical engineering works",
        zh: "[28300]Installation of industrial machinery and equipment, mechanical engineering works / 工业机械设备安装、机械工程",
        en: "[28300]Installation of industrial machinery and equipment, mechanical engineering works",
      },
      {
        value: "[29100]Manufacture and assembly of motor vehicles",
        zh: "[29100]Manufacture and assembly of motor vehicles / 机动车辆的制造和组装",
        en: "[29100]Manufacture and assembly of motor vehicles",
      },
      {
        value: "[29200]Manufacture of motor vehicle bodies (coachwork), trailers and semi-trailers",
        zh: "[29200]Manufacture of motor vehicle bodies (coachwork), trailers and semi-trailers / 汽车车身（车身）、挂车和半挂车的制造",
        en: "[29200]Manufacture of motor vehicle bodies (coachwork), trailers and semi-trailers",
      },
      {
        value: "[29300]Manufacture of parts and accessories for motor vehicles (e.g. engine parts, brakes, clutches, axles, gear boxes)",
        zh: "[29300]Manufacture of parts and accessories for motor vehicles (e.g. engine parts, brakes, clutches, axles, gear boxes) / 制造汽车零件和配件（例如发动机零件、制动器、离合器、车轴、齿轮箱）",
        en: "[29300]Manufacture of parts and accessories for motor vehicles (e.g. engine parts, brakes, clutches, axles, gear boxes)",
      },
      {
        value: "[30110]Building and repairing of ships, tankers and other ocean-going vessels (including conversion of ships into off-shore structures)",
        zh: "[30110]Building and repairing of ships, tankers and other ocean-going vessels (including conversion of ships into off-shore structures) / 船舶、油轮和其他远洋船舶的建造和修理（包括将船舶改装为离岸结构）",
        en: "[30110]Building and repairing of ships, tankers and other ocean-going vessels (including conversion of ships into off-shore structures)",
      },
      {
        value: "[30120]Building and repair of pleasure crafts, lighters and boats",
        zh: "[30120]Building and repair of pleasure crafts, lighters and boats / 游艇、打火机和船只的建造和修理",
        en: "[30120]Building and repair of pleasure crafts, lighters and boats",
      },
      {
        value:
          "[30200]Manufacture and repair of railway and tramway locomotives and rolling stock (including specialised parts except engines, electric motors and signalling equipment)",
        zh: "[30200]Manufacture and repair of railway and tramway locomotives and rolling stock (including specialised parts except engines, electric motors and signalling equipment) / 铁路和有轨电车机车车辆的制造和修理（包括除发动机、电动机和信号设备外的专用零件）",
        en: "[30200]Manufacture and repair of railway and tramway locomotives and rolling stock (including specialised parts except engines, electric motors and signalling equipment)",
      },
      {
        value: "[30301]Manufacture and assembly of aircraft and spacecraft (including aircraft engines and other parts)",
        zh: "[30301]Manufacture and assembly of aircraft and spacecraft (including aircraft engines and other parts) / 飞机和航天器的制造和装配（包括飞机发动机和其他零件）",
        en: "[30301]Manufacture and assembly of aircraft and spacecraft (including aircraft engines and other parts)",
      },
      {
        value: "[30302]Repair and servicing of aircraft and spacecraft (including aircraft engines and other parts)",
        zh: "[30302]Repair and servicing of aircraft and spacecraft (including aircraft engines and other parts) / 飞机和航天器（包括飞机发动机和其他零件）的维修和保养",
        en: "[30302]Repair and servicing of aircraft and spacecraft (including aircraft engines and other parts)",
      },
      {
        value: "[30400]Manufacture of military fighting vehicles",
        zh: "[30400]Manufacture of military fighting vehicles / 军用战车制造",
        en: "[30400]Manufacture of military fighting vehicles",
      },
      {
        value: "[30910]Manufacture and assembly of motorcycles and scooters (including engines and other parts and accessories)",
        zh: "[30910]Manufacture and assembly of motorcycles and scooters (including engines and other parts and accessories) / 摩托车和踏板车（包括发动机和其他零部件）的制造和组装",
        en: "[30910]Manufacture and assembly of motorcycles and scooters (including engines and other parts and accessories)",
      },
      {
        value: "[30920]Manufacture and assembly of bicycles, tricycles, trishaws and invalid carriages (including parts and accessories)",
        zh: "[30920]Manufacture and assembly of bicycles, tricycles, trishaws and invalid carriages (including parts and accessories) / 自行车、三轮车、三轮车、残疾人车（包括零部件）的制造、组装",
        en: "[30920]Manufacture and assembly of bicycles, tricycles, trishaws and invalid carriages (including parts and accessories)",
      },
      {
        value: "[30990]Manufacture of other transport equipment n.e.c. (e.g. carts, wagons)",
        zh: "[30990]Manufacture of other transport equipment n.e.c. (e.g. carts, wagons) / 其他运输设备的制造（例如手推车、货车）",
        en: "[30990]Manufacture of other transport equipment n.e.c. (e.g. carts, wagons)",
      },
      {
        value: "[31001]Manufacture of furniture and fixtures of wood (including upholstery)",
        zh: "[31001]Manufacture of furniture and fixtures of wood (including upholstery) / 木制家具和固定装置的制造（包括室内装潢）",
        en: "[31001]Manufacture of furniture and fixtures of wood (including upholstery)",
      },
      {
        value: "[31002]Manufacture of furniture of rattan and cane",
        zh: "[31002]Manufacture of furniture of rattan and cane / 藤、藤家具制造",
        en: "[31002]Manufacture of furniture of rattan and cane",
      },
      {
        value: "[31003]Manufacture of furniture and fixtures primarily of metal",
        zh: "[31003]Manufacture of furniture and fixtures primarily of metal / 主要由金属制成的家具和固定装置的制造",
        en: "[31003]Manufacture of furniture and fixtures primarily of metal",
      },
      {
        value: "[31004]Manufacture of furniture of other materials except primarily of stone, ceramic or concrete",
        zh: "[31004]Manufacture of furniture of other materials except primarily of stone, ceramic or concrete / 制造除主要由石头、陶瓷或混凝土制成的其他材料的家具",
        en: "[31004]Manufacture of furniture of other materials except primarily of stone, ceramic or concrete",
      },
      {
        value: "[31005]Manufacture of window and door screens and shades",
        zh: "[31005]Manufacture of window and door screens and shades / 门窗纱窗和窗帘的制造",
        en: "[31005]Manufacture of window and door screens and shades",
      },
      {
        value: "[31006]Manufacture of mattresses including those of foam rubber",
        zh: "[31006]Manufacture of mattresses including those of foam rubber / 制造床垫，包括泡沫橡胶床垫",
        en: "[31006]Manufacture of mattresses including those of foam rubber",
      },
      {
        value: "[31009]Manufacture of furniture n.e.c.",
        zh: "[31009]Manufacture of furniture n.e.c. / 家具制造",
        en: "[31009]Manufacture of furniture n.e.c.",
      },
      {
        value: "[32111]Manufacture of jewellery except costume jewellery",
        zh: "[32111]Manufacture of jewellery except costume jewellery / 珠宝首饰制造（服装首饰除外）",
        en: "[32111]Manufacture of jewellery except costume jewellery",
      },
      {
        value: "[32112]Manufacture of pewter ware",
        zh: "[32112]Manufacture of pewter ware / 锡器制造",
        en: "[32112]Manufacture of pewter ware",
      },
      {
        value: "[32119]Manufacture of jewellery and related articles n.e.c. (except costume jewellery)",
        zh: "[32119]Manufacture of jewellery and related articles n.e.c. (except costume jewellery) / 其他珠宝及相关物品的制造（服装珠宝除外）",
        en: "[32119]Manufacture of jewellery and related articles n.e.c. (except costume jewellery)",
      },
      {
        value: "[32120]Manufacture of costume jewellery and related articles",
        zh: "[32120]Manufacture of costume jewellery and related articles / 服装首饰及相关物品的制造",
        en: "[32120]Manufacture of costume jewellery and related articles",
      },
      {
        value: "[32200]Manufacture of musical instruments",
        zh: "[32200]Manufacture of musical instruments / 乐器制造",
        en: "[32200]Manufacture of musical instruments",
      },
      {
        value: "[32300]Manufacture of sporting and athletic goods (including gym, diving and underwater equipment)",
        zh: "[32300]Manufacture of sporting and athletic goods (including gym, diving and underwater equipment) / 运动和运动用品的制造（包括健身房、潜水和水下设备）",
        en: "[32300]Manufacture of sporting and athletic goods (including gym, diving and underwater equipment)",
      },
      {
        value: "[32400]Manufacture of games and toys",
        zh: "[32400]Manufacture of games and toys / 游戏和玩具制造",
        en: "[32400]Manufacture of games and toys",
      },
      {
        value: "[32501]Manufacture of medical research and clinical diagnostic instruments and supplies (e.g. reagents)",
        zh: "[32501]Manufacture of medical research and clinical diagnostic instruments and supplies (e.g. reagents) / 制造医学研究和临床诊断仪器和用品（例如试剂）",
        en: "[32501]Manufacture of medical research and clinical diagnostic instruments and supplies (e.g. reagents)",
      },
      {
        value: "[32502]Manufacture of medical disposables and surgical supplies (e.g. test kits, syringes, tubes, fluid administration sets)",
        zh: "[32502]Manufacture of medical disposables and surgical supplies (e.g. test kits, syringes, tubes, fluid administration sets) / 医疗一次性用品和手术用品的制造（例如测试套件、注射器、试管、输液装置）",
        en: "[32502]Manufacture of medical disposables and surgical supplies (e.g. test kits, syringes, tubes, fluid administration sets)",
      },
      {
        value: "[32503]Manufacture of implantables and artificial limbs (e.g. heart valves, stents, orthopaedic implants)",
        zh: "[32503]Manufacture of implantables and artificial limbs (e.g. heart valves, stents, orthopaedic implants) / 制造植入物和假肢（例如心脏瓣膜、支架、骨科植入物）",
        en: "[32503]Manufacture of implantables and artificial limbs (e.g. heart valves, stents, orthopaedic implants)",
      },
      {
        value: "[32504]Manufacture of ophthalmic goods (e.g. spectacles, contact lenses and parts)",
        zh: "[32504]Manufacture of ophthalmic goods (e.g. spectacles, contact lenses and parts) / 眼科产品的制造（例如眼镜、隐形眼镜和零件）",
        en: "[32504]Manufacture of ophthalmic goods (e.g. spectacles, contact lenses and parts)",
      },
      {
        value: "[32509]Manufacture of medical and dental tools, instruments and supplies n.e.c.",
        zh: "[32509]Manufacture of medical and dental tools, instruments and supplies n.e.c. / 制造医疗和牙科工具、仪器和用品 ",
        en: "[32509]Manufacture of medical and dental tools, instruments and supplies n.e.c.",
      },
      {
        value: "[32901]Manufacture of signs and advertising displays (including neon-lighting)",
        zh: "[32901]Manufacture of signs and advertising displays (including neon-lighting) / 标牌和广告展示（包括霓虹灯）的制造",
        en: "[32901]Manufacture of signs and advertising displays (including neon-lighting)",
      },
      {
        value: "[32909]Other manufacturing industries n.e.c.",
        zh: "[32909]Other manufacturing industries n.e.c. / 其他制造业 ",
        en: "[32909]Other manufacturing industries n.e.c.",
      },
      {
        value: "[35101]Generation of electricity by fossil fuels",
        zh: "[35101]Generation of electricity by fossil fuels / 化石燃料发电",
        en: "[35101]Generation of electricity by fossil fuels",
      },
      {
        value: "[35102]Generation of electricity by other sources (e.g. solar power, biofuels etc)",
        zh: "[35102]Generation of electricity by other sources (e.g. solar power, biofuels etc) / 其他来源发电（例如太阳能、生物燃料等）",
        en: "[35102]Generation of electricity by other sources (e.g. solar power, biofuels etc)",
      },
      {
        value: "[35103]Transmission, distribution and sale of electricity",
        zh: "[35103]Transmission, distribution and sale of electricity / 电力的传输、分配和销售",
        en: "[35103]Transmission, distribution and sale of electricity",
      },
      {
        value: "[35104]Other related services (e.g. electricity brokers, meter reading)",
        zh: "[35104]Other related services (e.g. electricity brokers, meter reading) / 其他相关服务（例如电力经纪人、抄表）",
        en: "[35104]Other related services (e.g. electricity brokers, meter reading)",
      },
      {
        value: "[35201]Manufacture of gas; distribution of gaseous fuels through mains",
        zh: "[35201]Manufacture of gas; distribution of gaseous fuels through mains / 气体制造；通过干线分配气体燃料",
        en: "[35201]Manufacture of gas; distribution of gaseous fuels through mains",
      },
      {
        value: "[35202]Processing of natural gas",
        zh: "[35202]Processing of natural gas / 天然气加工",
        en: "[35202]Processing of natural gas",
      },
      {
        value: "[35203]Other related services (e.g. arranging for sale of natural gas)",
        zh: "[35203]Other related services (e.g. arranging for sale of natural gas) / 其他相关服务（例如安排销售天然气）",
        en: "[35203]Other related services (e.g. arranging for sale of natural gas)",
      },
      {
        value: "[35300]Supply of air or water for cooling or heating purposes",
        zh: "[35300]Supply of air or water for cooling or heating purposes / 为冷却或加热目的供应空气或水",
        en: "[35300]Supply of air or water for cooling or heating purposes",
      },
      {
        value: "[36000]Collection, purification and distribution of water (including desalination of water)",
        zh: "[36000]Collection, purification and distribution of water (including desalination of water) / 水的收集、净化和分配（包括海水淡化）",
        en: "[36000]Collection, purification and distribution of water (including desalination of water)",
      },
      {
        value: "[37000]Operation of sewer systems (including sewer treatment facilities)",
        zh: "[37000]Operation of sewer systems (including sewer treatment facilities) / 下水道系统的运行（包括下水道处理设施）",
        en: "[37000]Operation of sewer systems (including sewer treatment facilities)",
      },
      {
        value: "[38100]Collection of waste",
        zh: "[38100]Collection of waste / 废物收集",
        en: "[38100]Collection of waste",
      },
      {
        value: "[38200]Treatment and disposal of waste (including remediation activities)",
        zh: "[38200]Treatment and disposal of waste (including remediation activities) / 废物的处理和处置（包括修复活动）",
        en: "[38200]Treatment and disposal of waste (including remediation activities)",
      },
      {
        value: "[38301]Recycling of metal waste and scrap",
        zh: "[38301]Recycling of metal waste and scrap / 金属废料和废料的回收利用",
        en: "[38301]Recycling of metal waste and scrap",
      },
      {
        value: "[38309]Recycling of non-metal waste n.e.c. (e.g. marine clay and oil sludge)",
        zh: "[38309]Recycling of non-metal waste n.e.c. (e.g. marine clay and oil sludge) / 回收非金属废料（如海洋粘土和油泥）",
        en: "[38309]Recycling of non-metal waste n.e.c. (e.g. marine clay and oil sludge)",
      },
      {
        value: "[41001]General contractors (building construction including major upgrading works)",
        zh: "[41001]General contractors (building construction including major upgrading works) / 总承包商（建筑施工，包括重大升级工程）",
        en: "[41001]General contractors (building construction including major upgrading works)",
      },
      {
        value: "[41002]Structural repair contractors",
        zh: "[41002]Structural repair contractors / 结构维修承包商",
        en: "[41002]Structural repair contractors",
      },
      {
        value: "[41009]Building construction n.e.c.",
        zh: "[41009]Building construction n.e.c. / 建筑施工",
        en: "[41009]Building construction n.e.c.",
      },
      {
        value: "[42101]General contractors (non-building construction)",
        zh: "[42101]General contractors (non-building construction) / 总承包商（非建筑施工）",
        en: "[42101]General contractors (non-building construction)",
      },
      {
        value: "[42102]Road and railway construction",
        zh: "[42102]Road and railway construction / 公路和铁路建设",
        en: "[42102]Road and railway construction",
      },
      {
        value: "[42103]Bridge, tunnel, viaduct and expressway construction",
        zh: "[42103]Bridge, tunnel, viaduct and expressway construction / 桥梁、隧道、高架桥和高速公路建设",
        en: "[42103]Bridge, tunnel, viaduct and expressway construction",
      },
      {
        value: "[42201]Water and gas pipe-line and sewer construction",
        zh: "[42201]Water and gas pipe-line and sewer construction / 水、气管道及下水道建设",
        en: "[42201]Water and gas pipe-line and sewer construction",
      },
      {
        value: "[42202]Communications and power line construction",
        zh: "[42202]Communications and power line construction / 通讯及电力线路建设",
        en: "[42202]Communications and power line construction",
      },
      {
        value: "[42901]Land reclamation works",
        zh: "[42901]Land reclamation works / 土地复垦工程",
        en: "[42901]Land reclamation works",
      },
      {
        value: "[42902]Dam and drainage construction",
        zh: "[42902]Dam and drainage construction / 大坝和排水工程",
        en: "[42902]Dam and drainage construction",
      },
      {
        value: "[42903]Marine construction (e.g. harbours, piers, docks, wharves)",
        zh: "[42903]Marine construction (e.g. harbours, piers, docks, wharves) / 海洋建筑（例如海港、码头、船坞、码头）",
        en: "[42903]Marine construction (e.g. harbours, piers, docks, wharves)",
      },
      {
        value: "[42909]Construction of other civil engineering projects n.e.c. (e.g. playground systems)",
        zh: "[42909]Construction of other civil engineering projects n.e.c. (e.g. playground systems) / 其他土木工程项目的建设（例如游乐场系统）",
        en: "[42909]Construction of other civil engineering projects n.e.c. (e.g. playground systems)",
      },
      {
        value: "[43110]Wrecking and demolition works",
        zh: "[43110]Wrecking and demolition works / 破坏和拆除工程",
        en: "[43110]Wrecking and demolition works",
      },
      {
        value: "[43121]Soil investigation, treatment and stabilisation (including grouting and guniting)",
        zh: "[43121]Soil investigation, treatment and stabilisation (including grouting and guniting) / 土壤调查、处理和稳定（包括灌浆和喷浆）",
        en: "[43121]Soil investigation, treatment and stabilisation (including grouting and guniting)",
      },
      {
        value: "[43122]Excavation and earthmoving works",
        zh: "[43122]Excavation and earthmoving works / 挖掘和土方工程",
        en: "[43122]Excavation and earthmoving works",
      },
      {
        value: "[43129]Site preparation n.e.c.",
        zh: "[43129]Site preparation n.e.c. / 场地准备 ",
        en: "[43129]Site preparation n.e.c.",
      },
      {
        value: "[43210]Electrical works",
        zh: "[43210]Electrical works / 电气工程",
        en: "[43210]Electrical works",
      },
      {
        value: "[43220]Installation of plumbing, heating (non-electric) and air-conditioning systems",
        zh: "[43220]Installation of plumbing, heating (non-electric) and air-conditioning systems / 安装管道、供暖（非电力）和空调系统",
        en: "[43220]Installation of plumbing, heating (non-electric) and air-conditioning systems",
      },
      {
        value: "[43291]Installation and erection of building equipment (e.g. lifts, escalators, travellators)",
        zh: "[43291]Installation and erection of building equipment (e.g. lifts, escalators, travellators) / 安装和安装建筑设备（例如电梯、自动扶梯、自动人行道）",
        en: "[43291]Installation and erection of building equipment (e.g. lifts, escalators, travellators)",
      },
      {
        value: "[43292]Installation of fire protection and security alarm systems",
        zh: "[43292]Installation of fire protection and security alarm systems / 安装防火和安全警报系统",
        en: "[43292]Installation of fire protection and security alarm systems",
      },
      {
        value: "[43293]Installation of building automated systems for remote monitoring",
        zh: "[43293]Installation of building automated systems for remote monitoring / 安装用于远程监控的楼宇自动化系统",
        en: "[43293]Installation of building automated systems for remote monitoring",
      },
      {
        value: "[43294]Installation of awning and window shades",
        zh: "[43294]Installation of awning and window shades / 安装遮阳篷和窗帘",
        en: "[43294]Installation of awning and window shades",
      },
      {
        value: "[43295]Installation of thermal and sound insulation (including solar control films)",
        zh: "[43295]Installation of thermal and sound insulation (including solar control films) / 安装隔热和隔音（包括太阳能控制膜）",
        en: "[43295]Installation of thermal and sound insulation (including solar control films)",
      },
      {
        value: "[43296]Signcraft installation",
        zh: "[43296]Signcraft installation / 标牌安装",
        en: "[43296]Signcraft installation",
      },
      {
        value: "[43299]Other construction installation n.e.c.",
        zh: "[43299]Other construction installation n.e.c. / 其他建筑安装",
        en: "[43299]Other construction installation n.e.c.",
      },
      {
        value: "[43301]Renovation contractors",
        zh: "[43301]Renovation contractors / 装修承包商",
        en: "[43301]Renovation contractors",
      },
      {
        value: "[43302]Tile setting and plastering",
        zh: "[43302]Tile setting and plastering / 瓷砖设置和抹灰",
        en: "[43302]Tile setting and plastering",
      },
      {
        value: "[43303]Joinery and other woodworks (e.g. laminated or parquet flooring)",
        zh: "[43303]Joinery and other woodworks (e.g. laminated or parquet flooring) / 细木工和其他木制品（例如层压或镶木地板）",
        en: "[43303]Joinery and other woodworks (e.g. laminated or parquet flooring)",
      },
      {
        value: "[43304]Painting and decorating",
        zh: "[43304]Painting and decorating / 绘画和装饰",
        en: "[43304]Painting and decorating",
      },
      {
        value: "[43305]Glass and glazing works (including mirror and shower screen installation)",
        zh: "[43305]Glass and glazing works (including mirror and shower screen installation) / 玻璃和玻璃工程（包括镜子和淋浴屏安装）",
        en: "[43305]Glass and glazing works (including mirror and shower screen installation)",
      },
      {
        value: "[43306]Curtain walling/cladding works",
        zh: "[43306]Curtain walling/cladding works / 幕墙/覆层工程",
        en: "[43306]Curtain walling/cladding works",
      },
      {
        value: "[43307]Installation of doors, gates, grilles and windows",
        zh: "[43307]Installation of doors, gates, grilles and windows / 安装门、大门、格栅和窗户",
        en: "[43307]Installation of doors, gates, grilles and windows",
      },
      {
        value: "[43309]Building completion and finishing n.e.c.",
        zh: "[43309]Building completion and finishing n.e.c. / 建筑竣工和装修 ",
        en: "[43309]Building completion and finishing n.e.c.",
      },
      {
        value: "[43901]Foundation works (including micropiling, conventional piling and underpinning)",
        zh: "[43901]Foundation works (including micropiling, conventional piling and underpinning) / 基础工程（包括微型打桩、常规打桩和托换）",
        en: "[43901]Foundation works (including micropiling, conventional piling and underpinning)",
      },
      {
        value: "[43902]Brick laying, stone setting and cement works",
        zh: "[43902]Brick laying, stone setting and cement works / 砌砖、砌石和水泥工程",
        en: "[43902]Brick laying, stone setting and cement works",
      },
      {
        value: "[43903]Roofing works (including timber carcassing)",
        zh: "[43903]Roofing works (including timber carcassing) / 屋面工程（包括木材胴体）",
        en: "[43903]Roofing works (including timber carcassing)",
      },
      {
        value: "[43904]Production of pre-cast components",
        zh: "[43904]Production of pre-cast components / 预制构件的生产",
        en: "[43904]Production of pre-cast components",
      },
      {
        value: "[43905]Scaffolding works",
        zh: "[43905]Scaffolding works / 脚手架工程",
        en: "[43905]Scaffolding works",
      },
      {
        value: "[43906]Sandblasting/Shotblasting works (except ships)",
        zh: "[43906]Sandblasting/Shotblasting works (except ships) / 喷砂/喷丸工程（船舶除外）",
        en: "[43906]Sandblasting/Shotblasting works (except ships)",
      },
      {
        value: "[43907]Production of Prefabricated Prefinished Volumetric Construction (PPVC) modules",
        zh: "[43907]Production of Prefabricated Prefinished Volumetric Construction (PPVC) modules / 预制预制体积结构 (PPVC) 模块的生产",
        en: "[43907]Production of Prefabricated Prefinished Volumetric Construction (PPVC) modules",
      },
      {
        value: "[43909]Other specialised construction and related activities n.e.c. (excluding online marketplaces)",
        zh: "[43909]Other specialised construction and related activities n.e.c. (excluding online marketplaces) / 其他专业建设和相关活动（不包括在线市场）",
        en: "[43909]Other specialised construction and related activities n.e.c. (excluding online marketplaces)",
      },
      {
        value: "[46100]Wholesale on a fee or commission basis (excluding online marketplaces)",
        zh: "[46100]Wholesale on a fee or commission basis (excluding online marketplaces) / 收费或佣金批发（不包括在线市场）",
        en: "[46100]Wholesale on a fee or commission basis (excluding online marketplaces)",
      },
      {
        value: "[46211]Wholesale of cut flowers and plants",
        zh: "[46211]Wholesale of cut flowers and plants / 切花和植物的批发",
        en: "[46211]Wholesale of cut flowers and plants",
      },
      {
        value: "[46212]Wholesale of aquarium fishes (including food and accessories)",
        zh: "[46212]Wholesale of aquarium fishes (including food and accessories) / 观赏鱼批发（包括食品及配件）",
        en: "[46212]Wholesale of aquarium fishes (including food and accessories)",
      },
      {
        value: "[46213]Wholesale of pet birds and animals (including food and accessories)",
        zh: "[46213]Wholesale of pet birds and animals (including food and accessories) / 宠物鸟和动物的批发（包括食品和配件）",
        en: "[46213]Wholesale of pet birds and animals (including food and accessories)",
      },
      {
        value: "[46219]Wholesale of agricultural raw materials and live animals n.e.c. (excluding tropical produce)",
        zh: "[46219]Wholesale of agricultural raw materials and live animals n.e.c. (excluding tropical produce) / 农业原料和活体动物的批发（不包括热带农产品）",
        en: "[46219]Wholesale of agricultural raw materials and live animals n.e.c. (excluding tropical produce)",
      },
      {
        value: "[46221]Wholesale of rubber (including rubber brokers)",
        zh: "[46221]Wholesale of rubber (including rubber brokers) / 橡胶批发（包括橡胶经纪人）",
        en: "[46221]Wholesale of rubber (including rubber brokers)",
      },
      {
        value: "[46222]Wholesale of pepper and other spices",
        zh: "[46222]Wholesale of pepper and other spices / 胡椒和其他香料的批发",
        en: "[46222]Wholesale of pepper and other spices",
      },
      {
        value: "[46223]Wholesale of coffee, cocoa and tea",
        zh: "[46223]Wholesale of coffee, cocoa and tea / 咖啡、可可和茶的批发",
        en: "[46223]Wholesale of coffee, cocoa and tea",
      },
      {
        value: "[46224]Wholesale of coconut",
        zh: "[46224]Wholesale of coconut / 椰子批发",
        en: "[46224]Wholesale of coconut",
      },
      {
        value: "[46225]Wholesale of palm oil",
        zh: "[46225]Wholesale of palm oil / 棕榈油批发",
        en: "[46225]Wholesale of palm oil",
      },
      {
        value: "[46229]Wholesale of tropical produce n.e.c.",
        zh: "[46229]Wholesale of tropical produce n.e.c. / 批发热带农产品 ",
        en: "[46229]Wholesale of tropical produce n.e.c.",
      },
      {
        value: "[46301]Wholesale of fruits and vegetables (including fresh and frozen)",
        zh: "[46301]Wholesale of fruits and vegetables (including fresh and frozen) / 水果和蔬菜的批发（包括新鲜和冷冻）",
        en: "[46301]Wholesale of fruits and vegetables (including fresh and frozen)",
      },
      {
        value: "[46302]Wholesale of livestock, meat, poultry, eggs and seafood (including fresh and frozen)",
        zh: "[46302]Wholesale of livestock, meat, poultry, eggs and seafood (including fresh and frozen) / 畜、肉、禽、蛋、海产品批发（含鲜、冻）",
        en: "[46302]Wholesale of livestock, meat, poultry, eggs and seafood (including fresh and frozen)",
      },
      {
        value: "[46303]Wholesale of a general line (wide range) of groceries (e.g. cereals, sugar, edible oils, sauces and dairy products)",
        zh: "[46303]Wholesale of a general line (wide range) of groceries (e.g. cereals, sugar, edible oils, sauces and dairy products) / 杂货（例如谷物、糖、食用油、酱汁和乳制品）的一般产品线（范围广泛）的批发",
        en: "[46303]Wholesale of a general line (wide range) of groceries (e.g. cereals, sugar, edible oils, sauces and dairy products)",
      },
      {
        value: "[46304]Wholesale of confectionery and bakery products",
        zh: "[46304]Wholesale of confectionery and bakery products / 糖果和烘焙产品的批发",
        en: "[46304]Wholesale of confectionery and bakery products",
      },
      {
        value: "[46305]Wholesale of ice-cream",
        zh: "[46305]Wholesale of ice-cream / 冰淇淋批发",
        en: "[46305]Wholesale of ice-cream",
      },
      {
        value: "[46306]Wholesale of health supplements",
        zh: "[46306]Wholesale of health supplements / 保健品批发",
        en: "[46306]Wholesale of health supplements",
      },
      {
        value: "[46307]Wholesale of liquor, soft drinks and beverages",
        zh: "[46307]Wholesale of liquor, soft drinks and beverages / 酒类、软饮料和饮料的批发",
        en: "[46307]Wholesale of liquor, soft drinks and beverages",
      },
      {
        value: "[46308]Wholesale of tobacco products",
        zh: "[46308]Wholesale of tobacco products / 烟草制品批发",
        en: "[46308]Wholesale of tobacco products",
      },
      {
        value: "[46309]Wholesale of food, beverages and tobacco n.e.c. (including dried or canned)",
        zh: "[46309]Wholesale of food, beverages and tobacco n.e.c. (including dried or canned) / 食品、饮料和烟草（包括干制或罐装）的批发",
        en: "[46309]Wholesale of food, beverages and tobacco n.e.c. (including dried or canned)",
      },
      {
        value: "[46411]Wholesale of textiles and leathers",
        zh: "[46411]Wholesale of textiles and leathers / 纺织品和皮革的批发",
        en: "[46411]Wholesale of textiles and leathers",
      },
      {
        value: "[46412]Wholesale of adults' clothing",
        zh: "[46412]Wholesale of adults' clothing / 成人服装批发",
        en: "[46412]Wholesale of adults' clothing",
      },
      {
        value: "[46413]Wholesale of children and infants' clothing (including products and accessories for infants)",
        zh: "[46413]Wholesale of children and infants' clothing (including products and accessories for infants) / 儿童及婴幼儿服装（包括婴幼儿用品及配饰）的批发",
        en: "[46413]Wholesale of children and infants' clothing (including products and accessories for infants)",
      },
      {
        value: "[46414]Wholesale of footwear",
        zh: "[46414]Wholesale of footwear / 鞋类批发",
        en: "[46414]Wholesale of footwear",
      },
      {
        value: "[46415]Wholesale of bags, luggage and travel accessories",
        zh: "[46415]Wholesale of bags, luggage and travel accessories / 箱包、行李箱和旅行配件的批发",
        en: "[46415]Wholesale of bags, luggage and travel accessories",
      },
      {
        value: "[46416]Wholesale of sewing and clothing accessories (e.g. button, thread, lace, zip, belt, tie)",
        zh: "[46416]Wholesale of sewing and clothing accessories (e.g. button, thread, lace, zip, belt, tie) / 批发缝纫和服装配件（例如纽扣、线、花边、拉链、腰带、领带）",
        en: "[46416]Wholesale of sewing and clothing accessories (e.g. button, thread, lace, zip, belt, tie)",
      },
      {
        value: "[46421]Wholesale of jewellery made from precious metals and stones",
        zh: "[46421]Wholesale of jewellery made from precious metals and stones / 批发贵金属和宝石首饰",
        en: "[46421]Wholesale of jewellery made from precious metals and stones",
      },
      {
        value: "[46422]Wholesale of costume jewellery",
        zh: "[46422]Wholesale of costume jewellery / 服装首饰批发",
        en: "[46422]Wholesale of costume jewellery",
      },
      {
        value: "[46423]Wholesale of watches and clocks",
        zh: "[46423]Wholesale of watches and clocks / 钟表批发",
        en: "[46423]Wholesale of watches and clocks",
      },
      {
        value: "[46424]Wholesale of cosmetics and toiletries",
        zh: "[46424]Wholesale of cosmetics and toiletries / 化妆品和洗漱用品批发",
        en: "[46424]Wholesale of cosmetics and toiletries",
      },
      {
        value: "[46429]Wholesale of personal effects n.e.c.",
        zh: "[46429]Wholesale of personal effects n.e.c. / 个人物品的批发 ",
        en: "[46429]Wholesale of personal effects n.e.c.",
      },
      {
        value: "[46431]Wholesale of furniture (including mattresses, cushions)",
        zh: "[46431]Wholesale of furniture (including mattresses, cushions) / 家具批发（包括床垫、靠垫）",
        en: "[46431]Wholesale of furniture (including mattresses, cushions)",
      },
      {
        value: "[46432]Wholesale of furnishings (including curtains, carpets, wallpaper)",
        zh: "[46432]Wholesale of furnishings (including curtains, carpets, wallpaper) / 家具批发（包括窗帘、地毯、壁纸）",
        en: "[46432]Wholesale of furnishings (including curtains, carpets, wallpaper)",
      },
      {
        value: "[46433]Wholesale of lighting and lighting accessories",
        zh: "[46433]Wholesale of lighting and lighting accessories / 灯饰及灯饰配件批发",
        en: "[46433]Wholesale of lighting and lighting accessories",
      },
      {
        value: "[46434]Wholesale of crockery, cutlery and kitchen utensils",
        zh: "[46434]Wholesale of crockery, cutlery and kitchen utensils / 陶器、餐具和厨房用具的批发",
        en: "[46434]Wholesale of crockery, cutlery and kitchen utensils",
      },
      {
        value: "[46435]Wholesale of household electrical appliances and equipment (including household air-conditioners)",
        zh: "[46435]Wholesale of household electrical appliances and equipment (including household air-conditioners) / 家用电器及设备（包括家用空调）的批发",
        en: "[46435]Wholesale of household electrical appliances and equipment (including household air-conditioners)",
      },
      {
        value:
          "[46436]Wholesale of audio and video equipment except electrical and electronic components (e.g. radio and television sets, sound reproducing and recording equipment)",
        zh: "[46436]Wholesale of audio and video equipment except electrical and electronic components (e.g. radio and television sets, sound reproducing and recording equipment) / 音频和视频设备的批发，但电气和电子元件除外（例如收音机和电视机、声音再现和录音设备）",
        en: "[46436]Wholesale of audio and video equipment except electrical and electronic components (e.g. radio and television sets, sound reproducing and recording equipment)",
      },
      {
        value: "[46437]Wholesale of musical instruments and scores",
        zh: "[46437]Wholesale of musical instruments and scores / 乐器和乐谱的批发",
        en: "[46437]Wholesale of musical instruments and scores",
      },
      {
        value: "[46439]Wholesale of furniture, home furnishings and other household equipment n.e.c.",
        zh: "[46439]Wholesale of furniture, home furnishings and other household equipment n.e.c. / 家具、家居用品和其他家用设备的批发",
        en: "[46439]Wholesale of furniture, home furnishings and other household equipment n.e.c.",
      },
      {
        value: "[46441]Wholesale of sporting goods and equipment (including bicycles and healthcare equipment)",
        zh: "[46441]Wholesale of sporting goods and equipment (including bicycles and healthcare equipment) / 体育用品和设备的批发（包括自行车和保健设备）",
        en: "[46441]Wholesale of sporting goods and equipment (including bicycles and healthcare equipment)",
      },
      {
        value: "[46442]Wholesale of music and video recordings (e.g. DVDs, Blu-ray discs)",
        zh: "[46442]Wholesale of music and video recordings (e.g. DVDs, Blu-ray discs) / 批发音乐和录像（如 DVD、蓝光光盘）",
        en: "[46442]Wholesale of music and video recordings (e.g. DVDs, Blu-ray discs)",
      },
      {
        value: "[46443]Wholesale of toys and games",
        zh: "[46443]Wholesale of toys and games / 玩具和游戏的批发",
        en: "[46443]Wholesale of toys and games",
      },
      {
        value: "[46444]Wholesale of computer games (including electronic games and video game consoles)",
        zh: "[46444]Wholesale of computer games (including electronic games and video game consoles) / 电脑游戏批发（包括电子游戏和视频游戏机）",
        en: "[46444]Wholesale of computer games (including electronic games and video game consoles)",
      },
      {
        value: "[46449]Wholesale of sporting and other recreational goods n.e.c.",
        zh: "[46449]Wholesale of sporting and other recreational goods n.e.c. / 体育用品和其他休闲用品的批发",
        en: "[46449]Wholesale of sporting and other recreational goods n.e.c.",
      },
      {
        value: "[46451]Wholesale of antiques and works of art",
        zh: "[46451]Wholesale of antiques and works of art / 古董和艺术品的批发",
        en: "[46451]Wholesale of antiques and works of art",
      },
      {
        value: "[46452]Wholesale of handicrafts and gifts",
        zh: "[46452]Wholesale of handicrafts and gifts / 工艺品和礼品的批发",
        en: "[46452]Wholesale of handicrafts and gifts",
      },
      {
        value: "[46453]Wholesale of artificial flowers and plants",
        zh: "[46453]Wholesale of artificial flowers and plants / 人造花卉和植物的批发",
        en: "[46453]Wholesale of artificial flowers and plants",
      },
      {
        value: "[46459]Wholesale of handicrafts and fancy goods n.e.c.",
        zh: "[46459]Wholesale of handicrafts and fancy goods n.e.c. / 手工艺品和高档商品的批发",
        en: "[46459]Wholesale of handicrafts and fancy goods n.e.c.",
      },
      {
        value: "[46461]Wholesale of medicinal and pharmaceutical products (Western)",
        zh: "[46461]Wholesale of medicinal and pharmaceutical products (Western) / 药品和医药产品的批发（西方）",
        en: "[46461]Wholesale of medicinal and pharmaceutical products (Western)",
      },
      {
        value: "[46462]Wholesale of medicine and herbs (other than Western)",
        zh: "[46462]Wholesale of medicine and herbs (other than Western) / 药品和草药的批发（西药除外）",
        en: "[46462]Wholesale of medicine and herbs (other than Western)",
      },
      {
        value: "[46471]Wholesale of paper and paper products",
        zh: "[46471]Wholesale of paper and paper products / 纸及纸制品的批发",
        en: "[46471]Wholesale of paper and paper products",
      },
      {
        value: "[46472]Wholesale of packaging materials",
        zh: "[46472]Wholesale of packaging materials / 包装材料批发",
        en: "[46472]Wholesale of packaging materials",
      },
      {
        value: "[46473]Wholesale of stationery",
        zh: "[46473]Wholesale of stationery / 文具批发",
        en: "[46473]Wholesale of stationery",
      },
      {
        value: "[46474]Wholesale of books and magazines",
        zh: "[46474]Wholesale of books and magazines / 书籍和杂志的批发",
        en: "[46474]Wholesale of books and magazines",
      },
      {
        value: "[46479]Wholesale of paper, paper and cellophane products and stationery n.e.c.",
        zh: "[46479]Wholesale of paper, paper and cellophane products and stationery n.e.c. / 纸、纸和玻璃纸制品和文具的批发",
        en: "[46479]Wholesale of paper, paper and cellophane products and stationery n.e.c.",
      },
      {
        value: "[46491]Wholesale of optical equipment and supplies (excluding binoculars)",
        zh: "[46491]Wholesale of optical equipment and supplies (excluding binoculars) / 光学设备和用品的批发（不包括双筒望远镜）",
        en: "[46491]Wholesale of optical equipment and supplies (excluding binoculars)",
      },
      {
        value: "[46492]Wholesale of photographic equipment and supplies (including binoculars)",
        zh: "[46492]Wholesale of photographic equipment and supplies (including binoculars) / 摄影器材和用品（包括双筒望远镜）的批发",
        en: "[46492]Wholesale of photographic equipment and supplies (including binoculars)",
      },
      {
        value: "[46499]Wholesale of other household goods n.e.c.",
        zh: "[46499]Wholesale of other household goods n.e.c. / 其他家居用品的批发",
        en: "[46499]Wholesale of other household goods n.e.c.",
      },
      {
        value: "[46511]Wholesale of computer hardware and peripheral equipment (except cybersecurity related hardware and peripheral equipment)",
        zh: "[46511]Wholesale of computer hardware and peripheral equipment (except cybersecurity related hardware and peripheral equipment) / 计算机硬件及周边设备批发（网络安全相关硬件及周边设备除外）",
        en: "[46511]Wholesale of computer hardware and peripheral equipment (except cybersecurity related hardware and peripheral equipment)",
      },
      {
        value: "[46512]Wholesale of computer software (except games and cybersecurity software)",
        zh: "[46512]Wholesale of computer software (except games and cybersecurity software) / 计算机软件批发（游戏和网络安全软件除外）",
        en: "[46512]Wholesale of computer software (except games and cybersecurity software)",
      },
      {
        value: "[46513]Wholesale of computer accessories (e.g. memory cards, computer cables)",
        zh: "[46513]Wholesale of computer accessories (e.g. memory cards, computer cables) / 电脑配件批发（如记忆卡、电脑线）",
        en: "[46513]Wholesale of computer accessories (e.g. memory cards, computer cables)",
      },
      {
        value: "[46514]Wholesale of cybersecurity software, hardware and peripheral equipment",
        zh: "[46514]Wholesale of cybersecurity software, hardware and peripheral equipment / 网络安全软件、硬件及周边设备的批发",
        en: "[46514]Wholesale of cybersecurity software, hardware and peripheral equipment",
      },
      {
        value: "[46521]Wholesale of telecommunications equipment (excluding handphones)",
        zh: "[46521]Wholesale of telecommunications equipment (excluding handphones) / 电信设备批发（不包括手机）",
        en: "[46521]Wholesale of telecommunications equipment (excluding handphones)",
      },
      {
        value: "[46522]Wholesale of electronic components",
        zh: "[46522]Wholesale of electronic components / 电子元器件批发",
        en: "[46522]Wholesale of electronic components",
      },
      {
        value: "[46523]Wholesale of handphones, handphone peripheral equipment and other telecommunications equipment",
        zh: "[46523]Wholesale of handphones, handphone peripheral equipment and other telecommunications equipment / 手机、手机周边设备和其他电信设备的批发",
        en: "[46523]Wholesale of handphones, handphone peripheral equipment and other telecommunications equipment",
      },
      {
        value: "[46530]Wholesale of agricultural machinery, equipment and supplies",
        zh: "[46530]Wholesale of agricultural machinery, equipment and supplies / 农业机械、设备和用品的批发",
        en: "[46530]Wholesale of agricultural machinery, equipment and supplies",
      },
      {
        value: "[46541]Wholesale of industrial machinery and equipment (e.g. industrial crane)",
        zh: "[46541]Wholesale of industrial machinery and equipment (e.g. industrial crane) / 工业机械设备的批发（如工业起重机）",
        en: "[46541]Wholesale of industrial machinery and equipment (e.g. industrial crane)",
      },
      {
        value: "[46542]Wholesale of construction equipment (e.g. concrete mixer)",
        zh: "[46542]Wholesale of construction equipment (e.g. concrete mixer) / 建筑设备的批发（例如混凝土搅拌机）",
        en: "[46542]Wholesale of construction equipment (e.g. concrete mixer)",
      },
      {
        value: "[46543]Wholesale of lifts, escalators and industrial and office air-conditioning equipment",
        zh: "[46543]Wholesale of lifts, escalators and industrial and office air-conditioning equipment / 升降机、自动扶梯及工业和办公室空调设备的批发",
        en: "[46543]Wholesale of lifts, escalators and industrial and office air-conditioning equipment",
      },
      {
        value: "[46544]Wholesale of electrical and wiring accessories",
        zh: "[46544]Wholesale of electrical and wiring accessories / 电器及电线配件批发",
        en: "[46544]Wholesale of electrical and wiring accessories",
      },
      {
        value: "[46549]Wholesale of industrial, construction and related machinery and equipment n.e.c.",
        zh: "[46549]Wholesale of industrial, construction and related machinery and equipment n.e.c. / 工业、建筑及相关机械设备的批发",
        en: "[46549]Wholesale of industrial, construction and related machinery and equipment n.e.c.",
      },
      {
        value: "[46551]Wholesale of marine equipment and accessories (including marine navigational equipment and radar)",
        zh: "[46551]Wholesale of marine equipment and accessories (including marine navigational equipment and radar) / 船用设备及配件（包括船用导航设备和雷达）的批发",
        en: "[46551]Wholesale of marine equipment and accessories (including marine navigational equipment and radar)",
      },
      {
        value: "[46552]Wholesale of aircraft equipment and supplies (including aeronautical equipment)",
        zh: "[46552]Wholesale of aircraft equipment and supplies (including aeronautical equipment) / 飞机设备和用品（包括航空设备）的批发",
        en: "[46552]Wholesale of aircraft equipment and supplies (including aeronautical equipment)",
      },
      {
        value: "[46559]Wholesale of transport equipment except motor vehicles and motorcycles n.e.c.",
        zh: "[46559]Wholesale of transport equipment except motor vehicles and motorcycles n.e.c. / 除机动车和摩托车以外的运输设备批发",
        en: "[46559]Wholesale of transport equipment except motor vehicles and motorcycles n.e.c.",
      },
      {
        value: "[46561]Wholesale of motor vehicles except motorcycles and scooters",
        zh: "[46561]Wholesale of motor vehicles except motorcycles and scooters / 机动车辆的批发，摩托车和踏板车除外",
        en: "[46561]Wholesale of motor vehicles except motorcycles and scooters",
      },
      {
        value: "[46562]Wholesale of motorcycles and scooters",
        zh: "[46562]Wholesale of motorcycles and scooters / 摩托车和踏板车的批发",
        en: "[46562]Wholesale of motorcycles and scooters",
      },
      {
        value: "[46563]Wholesale of parts and accessories for vehicles",
        zh: "[46563]Wholesale of parts and accessories for vehicles / 车辆零部件的批发",
        en: "[46563]Wholesale of parts and accessories for vehicles",
      },
      {
        value: "[46591]Wholesale of office machines and equipment (including accessories)",
        zh: "[46591]Wholesale of office machines and equipment (including accessories) / 办公机器设备（包括配件）的批发",
        en: "[46591]Wholesale of office machines and equipment (including accessories)",
      },
      {
        value: "[46592]Wholesale of medical, professional, scientific and precision equipment",
        zh: "[46592]Wholesale of medical, professional, scientific and precision equipment / 医疗、专业、科学和精密设备的批发",
        en: "[46592]Wholesale of medical, professional, scientific and precision equipment",
      },
      {
        value: "[46593]Wholesale of commercial food service equipment (e.g. hotel kitchen equipment)",
        zh: "[46593]Wholesale of commercial food service equipment (e.g. hotel kitchen equipment) / 商业餐饮服务设备（如酒店厨房设备）的批发",
        en: "[46593]Wholesale of commercial food service equipment (e.g. hotel kitchen equipment)",
      },
      {
        value: "[46594]Wholesale of service establishment equipment and supplies (e.g. beauty salon equipment)",
        zh: "[46594]Wholesale of service establishment equipment and supplies (e.g. beauty salon equipment) / 服务机构设备和用品的批发（例如美容院设备）",
        en: "[46594]Wholesale of service establishment equipment and supplies (e.g. beauty salon equipment)",
      },
      {
        value: "[46595]Wholesale of security and safety equipment",
        zh: "[46595]Wholesale of security and safety equipment / 安防设备批发",
        en: "[46595]Wholesale of security and safety equipment",
      },
      {
        value: "[46599]Wholesale of other machinery and equipment n.e.c.",
        zh: "[46599]Wholesale of other machinery and equipment n.e.c. / 其他机械设备的批发",
        en: "[46599]Wholesale of other machinery and equipment n.e.c.",
      },
      {
        value: "[46610]Wholesale of fuels and related products",
        zh: "[46610]Wholesale of fuels and related products / 燃料及相关产品的批发",
        en: "[46610]Wholesale of fuels and related products",
      },
      {
        value: "[46620]Wholesale of metals and metal ores (e.g. steel pipes) except general hardware",
        zh: "[46620]Wholesale of metals and metal ores (e.g. steel pipes) except general hardware / 金属和金属矿石（如钢管）的批发，一般五金除外",
        en: "[46620]Wholesale of metals and metal ores (e.g. steel pipes) except general hardware",
      },
      {
        value: "[46631]Wholesale of logs, sawn timber, plywood and related products",
        zh: "[46631]Wholesale of logs, sawn timber, plywood and related products / 原木、锯材、胶合板及相关产品的批发",
        en: "[46631]Wholesale of logs, sawn timber, plywood and related products",
      },
      {
        value: "[46632]Wholesale of general hardware (e.g. locks, hinges)",
        zh: "[46632]Wholesale of general hardware (e.g. locks, hinges) / 一般五金件（如锁具、铰链）的批发",
        en: "[46632]Wholesale of general hardware (e.g. locks, hinges)",
      },
      {
        value: "[46633]Wholesale of structural clay and concrete products (e.g. mosaic tiles, bricks)",
        zh: "[46633]Wholesale of structural clay and concrete products (e.g. mosaic tiles, bricks) / 结构粘土和混凝土产品的批发（例如马赛克瓷砖、砖）",
        en: "[46633]Wholesale of structural clay and concrete products (e.g. mosaic tiles, bricks)",
      },
      {
        value: "[46634]Wholesale of paints (including varnishes and supplies)",
        zh: "[46634]Wholesale of paints (including varnishes and supplies) / 油漆批发（包括清漆和用品）",
        en: "[46634]Wholesale of paints (including varnishes and supplies)",
      },
      {
        value: "[46635]Wholesale of glass",
        zh: "[46635]Wholesale of glass / 玻璃批发",
        en: "[46635]Wholesale of glass",
      },
      {
        value: "[46639]Wholesale of construction materials, hardware, plumbing and heating equipment and supplies n.e.c. (e.g. cement, sand)",
        zh: "[46639]Wholesale of construction materials, hardware, plumbing and heating equipment and supplies n.e.c. (e.g. cement, sand) / 建筑材料、五金、管道和供暖设备及其他用品（如水泥、沙子）的批发",
        en: "[46639]Wholesale of construction materials, hardware, plumbing and heating equipment and supplies n.e.c. (e.g. cement, sand)",
      },
      {
        value: "[46641]Wholesale of basic industrial chemicals (except fertilisers)",
        zh: "[46641]Wholesale of basic industrial chemicals (except fertilisers) / 基础工业化学品批发（化肥除外）",
        en: "[46641]Wholesale of basic industrial chemicals (except fertilisers)",
      },
      {
        value: "[46642]Wholesale of chemical fertilisers",
        zh: "[46642]Wholesale of chemical fertilisers / 化肥批发",
        en: "[46642]Wholesale of chemical fertilisers",
      },
      {
        value: "[46643]Wholesale of petrochemical products",
        zh: "[46643]Wholesale of petrochemical products / 石化产品批发",
        en: "[46643]Wholesale of petrochemical products",
      },
      {
        value: "[46649]Wholesale of chemicals and chemical products n.e.c.",
        zh: "[46649]Wholesale of chemicals and chemical products n.e.c. / 化学品和化学产品的批发 ",
        en: "[46649]Wholesale of chemicals and chemical products n.e.c.",
      },
      {
        value: "[46651]Wholesale of scrap, junk and waste dealers",
        zh: "[46651]Wholesale of scrap, junk and waste dealers / 废料、垃圾和废物经销商的批发",
        en: "[46651]Wholesale of scrap, junk and waste dealers",
      },
      {
        value: "[46659]Wholesale of other intermediate products, waste and scrap n.e.c.",
        zh: "[46659]Wholesale of other intermediate products, waste and scrap n.e.c. / 其他中间产品、废料和废料的批发",
        en: "[46659]Wholesale of other intermediate products, waste and scrap n.e.c.",
      },
      {
        value: "[46661]Ship chandlers",
        zh: "[46661]Ship chandlers / 船钱商",
        en: "[46661]Ship chandlers",
      },
      {
        value: "[46662]Ship bunkering",
        zh: "[46662]Ship bunkering / 船舶加油",
        en: "[46662]Ship bunkering",
      },
      {
        value: "[46900]Wholesale trade of a variety of goods without a dominant product",
        zh: "[46900]Wholesale trade of a variety of goods without a dominant product / 无主导产品的多种商品的批发贸易",
        en: "[46900]Wholesale trade of a variety of goods without a dominant product",
      },
      {
        value: "[47101]Supermarkets and hypermarkets",
        zh: "[47101]Supermarkets and hypermarkets / 超市和大卖场",
        en: "[47101]Supermarkets and hypermarkets",
      },
      {
        value: "[47102]Mini-marts, convenience stores and provision shops",
        zh: "[47102]Mini-marts, convenience stores and provision shops / 小型超市、便利店和杂货店",
        en: "[47102]Mini-marts, convenience stores and provision shops",
      },
      {
        value: "[47103]Department stores",
        zh: "[47103]Department stores / 百货商店",
        en: "[47103]Department stores",
      },
      {
        value: "[47109]Retail sale in other non-specialised stores n.e.c.",
        zh: "[47109]Retail sale in other non-specialised stores n.e.c. / 其他非专卖店的零售",
        en: "[47109]Retail sale in other non-specialised stores n.e.c.",
      },
      {
        value: "[47211]Retail sale of fruits and vegetables",
        zh: "[47211]Retail sale of fruits and vegetables / 水果和蔬菜的零售",
        en: "[47211]Retail sale of fruits and vegetables",
      },
      {
        value: "[47212]Retail sale of meat, poultry, eggs and seafood",
        zh: "[47212]Retail sale of meat, poultry, eggs and seafood / 肉类、家禽、鸡蛋和海鲜的零售",
        en: "[47212]Retail sale of meat, poultry, eggs and seafood",
      },
      {
        value: "[47213]Retail sale of confectionery and bakery products (not manufactured on site)",
        zh: "[47213]Retail sale of confectionery and bakery products (not manufactured on site) / 糖果和烘焙产品的零售（非现场制造）",
        en: "[47213]Retail sale of confectionery and bakery products (not manufactured on site)",
      },
      {
        value: "[47214]Retail sale of health supplements",
        zh: "[47214]Retail sale of health supplements / 保健品零售",
        en: "[47214]Retail sale of health supplements",
      },
      {
        value: "[47219]Retail sale of food n.e.c.",
        zh: "[47219]Retail sale of food n.e.c. / 食品零售",
        en: "[47219]Retail sale of food n.e.c.",
      },
      {
        value: "[47220]Retail sale of beverages",
        zh: "[47220]Retail sale of beverages / 饮料零售",
        en: "[47220]Retail sale of beverages",
      },
      {
        value: "[47230]Retail sale of tobacco products",
        zh: "[47230]Retail sale of tobacco products / 烟草制品零售",
        en: "[47230]Retail sale of tobacco products",
      },
      {
        value: "[47311]Retail sale of motor vehicles except motorcycles and scooters",
        zh: "[47311]Retail sale of motor vehicles except motorcycles and scooters / 机动车辆的零售，但摩托车和踏板车除外",
        en: "[47311]Retail sale of motor vehicles except motorcycles and scooters",
      },
      {
        value: "[47312]Retail sale of motorcycles and scooters",
        zh: "[47312]Retail sale of motorcycles and scooters / 摩托车和踏板车的零售",
        en: "[47312]Retail sale of motorcycles and scooters",
      },
      {
        value: "[47313]Retail sale of tyres and batteries",
        zh: "[47313]Retail sale of tyres and batteries / 轮胎和电池的零售",
        en: "[47313]Retail sale of tyres and batteries",
      },
      {
        value: "[47314]Retail sale of spare parts and accessories for motor vehicles",
        zh: "[47314]Retail sale of spare parts and accessories for motor vehicles / 机动车零配件的零售",
        en: "[47314]Retail sale of spare parts and accessories for motor vehicles",
      },
      {
        value: "[47320]Retail sale of automotive fuel (e.g. petrol kiosks, CNG refilling stations)",
        zh: "[47320]Retail sale of automotive fuel (e.g. petrol kiosks, CNG refilling stations) / 汽车燃料的零售（例如加油站、CNG 加气站）",
        en: "[47320]Retail sale of automotive fuel (e.g. petrol kiosks, CNG refilling stations)",
      },
      {
        value: "[47411]Retail sale of handphones and peripheral equipment",
        zh: "[47411]Retail sale of handphones and peripheral equipment / 手机及周边设备零售",
        en: "[47411]Retail sale of handphones and peripheral equipment",
      },
      {
        value:
          "[47412]Retail sale of computer hardware (including handheld computers) and peripheral equipment, and computer software (except games and cybersecurity hardware and software)",
        zh: "[47412]Retail sale of computer hardware (including handheld computers) and peripheral equipment, and computer software (except games and cybersecurity hardware and software) / 计算机硬件（包括掌上电脑）和外围设备以及计算机软件（游戏和网络安全硬件和软件除外）的零售",
        en: "[47412]Retail sale of computer hardware (including handheld computers) and peripheral equipment, and computer software (except games and cybersecurity hardware and software)",
      },
      {
        value: "[47413]Retail sale of computer games (including electronic games and video game consoles)",
        zh: "[47413]Retail sale of computer games (including electronic games and video game consoles) / 电脑游戏（包括电子游戏和视频游戏机）的零售",
        en: "[47413]Retail sale of computer games (including electronic games and video game consoles)",
      },
      {
        value: "[47414]Retail sale of computer and office equipment consumables (e.g. printer cartridges)",
        zh: "[47414]Retail sale of computer and office equipment consumables (e.g. printer cartridges) / 计算机和办公设备耗材（例如打印机墨盒）的零售",
        en: "[47414]Retail sale of computer and office equipment consumables (e.g. printer cartridges)",
      },
      {
        value: "[47415]Retail sale of cybersecurity software, hardware and peripheral equipment",
        zh: "[47415]Retail sale of cybersecurity software, hardware and peripheral equipment / 网络安全软件、硬件和外围设备的零售",
        en: "[47415]Retail sale of cybersecurity software, hardware and peripheral equipment",
      },
      {
        value: "[47420]Retail sale of audio and video equipment (e.g. radio and television sets, sound reproducing and recording equipment)",
        zh: "[47420]Retail sale of audio and video equipment (e.g. radio and television sets, sound reproducing and recording equipment) / 音像设备的零售（例如收音机和电视机、声音再现和录音设备）",
        en: "[47420]Retail sale of audio and video equipment (e.g. radio and television sets, sound reproducing and recording equipment)",
      },
      {
        value: "[47510]Retail sale of textiles",
        zh: "[47510]Retail sale of textiles / 纺织品零售",
        en: "[47510]Retail sale of textiles",
      },
      {
        value: "[47521]Retail sale of paints",
        zh: "[47521]Retail sale of paints / 油漆零售",
        en: "[47521]Retail sale of paints",
      },
      {
        value: "[47522]Retail sale of hardware (e.g. chains, changkols, axes)",
        zh: "[47522]Retail sale of hardware (e.g. chains, changkols, axes) / 硬件零售（例如链条、长刀、斧头）",
        en: "[47522]Retail sale of hardware (e.g. chains, changkols, axes)",
      },
      {
        value: "[47529]Retail sale of hardware, paint and glass n.e.c. (e.g. wood, glass, sanitary ware, Do-It-Yourself materials)",
        zh: "[47529]Retail sale of hardware, paint and glass n.e.c. (e.g. wood, glass, sanitary ware, Do-It-Yourself materials) / 硬件、油漆和玻璃 （例如木材、玻璃、卫生洁具、DIY 材料）的零售",
        en: "[47529]Retail sale of hardware, paint and glass n.e.c. (e.g. wood, glass, sanitary ware, Do-It-Yourself materials)",
      },
      {
        value: "[47531]Retail sale of furniture (including mattresses, cushions)",
        zh: "[47531]Retail sale of furniture (including mattresses, cushions) / 家具零售（包括床垫、靠垫）",
        en: "[47531]Retail sale of furniture (including mattresses, cushions)",
      },
      {
        value: "[47532]Retail sale of furnishings (e.g. curtains, carpets, pillow cases)",
        zh: "[47532]Retail sale of furnishings (e.g. curtains, carpets, pillow cases) / 家具零售（如窗帘、地毯、枕套）",
        en: "[47532]Retail sale of furnishings (e.g. curtains, carpets, pillow cases)",
      },
      {
        value: "[47533]Retail sale of lighting and lighting accessories",
        zh: "[47533]Retail sale of lighting and lighting accessories / 照明和照明配件的零售",
        en: "[47533]Retail sale of lighting and lighting accessories",
      },
      {
        value: "[47534]Retail sale of crockery, cutlery and kitchen utensils",
        zh: "[47534]Retail sale of crockery, cutlery and kitchen utensils / 餐具、餐具和厨房用具的零售",
        en: "[47534]Retail sale of crockery, cutlery and kitchen utensils",
      },
      {
        value: "[47535]Retail sale of household electrical appliances and equipment (e.g. vacuum cleaners, washing machines, refrigerators)",
        zh: "[47535]Retail sale of household electrical appliances and equipment (e.g. vacuum cleaners, washing machines, refrigerators) / 家用电器及设备的零售（如吸尘器、洗衣机、冰箱）",
        en: "[47535]Retail sale of household electrical appliances and equipment (e.g. vacuum cleaners, washing machines, refrigerators)",
      },
      {
        value: "[47536]Retail sale of musical instruments and scores",
        zh: "[47536]Retail sale of musical instruments and scores / 乐器和乐谱的零售",
        en: "[47536]Retail sale of musical instruments and scores",
      },
      {
        value: "[47537]Retail sale of security and safety equipment",
        zh: "[47537]Retail sale of security and safety equipment / 安保和安全设备的零售",
        en: "[47537]Retail sale of security and safety equipment",
      },
      {
        value: "[47539]Retail sale of electrical household appliances, furniture, lighting equipment and other household articles n.e.c.",
        zh: "[47539]Retail sale of electrical household appliances, furniture, lighting equipment and other household articles n.e.c. / 家用电器、家具、照明设备和其他家居用品的零售",
        en: "[47539]Retail sale of electrical household appliances, furniture, lighting equipment and other household articles n.e.c.",
      },
      {
        value: "[47610]Retail sale of books, newspapers and stationery (including newsvendors)",
        zh: "[47610]Retail sale of books, newspapers and stationery (including newsvendors) / 书籍、报纸和文具的零售（包括报摊）",
        en: "[47610]Retail sale of books, newspapers and stationery (including newsvendors)",
      },
      {
        value: "[47620]Retail sale of music and video recordings (e.g. DVDs, Blu-ray discs)",
        zh: "[47620]Retail sale of music and video recordings (e.g. DVDs, Blu-ray discs) / 音乐和视频记录（例如 DVD、蓝光光盘）的零售",
        en: "[47620]Retail sale of music and video recordings (e.g. DVDs, Blu-ray discs)",
      },
      {
        value: "[47630]Retail sale of sports apparel and equipment (including bicycles, boats and healthcare equipment)",
        zh: "[47630]Retail sale of sports apparel and equipment (including bicycles, boats and healthcare equipment) / 运动服装和设备的零售（包括自行车、船只和医疗设备）",
        en: "[47630]Retail sale of sports apparel and equipment (including bicycles, boats and healthcare equipment)",
      },
      {
        value: "[47640]Retail sale of games and toys",
        zh: "[47640]Retail sale of games and toys / 游戏和玩具的零售",
        en: "[47640]Retail sale of games and toys",
      },
      {
        value: "[47711]Retail sale of clothing for adults",
        zh: "[47711]Retail sale of clothing for adults / 成人服装零售",
        en: "[47711]Retail sale of clothing for adults",
      },
      {
        value: "[47712]Retail sale of children and infants' clothing (including products and accessories for infants)",
        zh: "[47712]Retail sale of children and infants' clothing (including products and accessories for infants) / 儿童和婴儿服装（包括婴儿产品和配件）的零售",
        en: "[47712]Retail sale of children and infants' clothing (including products and accessories for infants)",
      },
      {
        value: "[47713]Retail sale of footwear",
        zh: "[47713]Retail sale of footwear / 鞋类零售",
        en: "[47713]Retail sale of footwear",
      },
      {
        value: "[47714]Retail sale of bags, luggage and travel accessories",
        zh: "[47714]Retail sale of bags, luggage and travel accessories / 箱包、行李箱和旅行配件的零售",
        en: "[47714]Retail sale of bags, luggage and travel accessories",
      },
      {
        value: "[47715]Retail sale of sewing and clothing accessories (e.g. button, thread, lace, zip, belt, tie)",
        zh: "[47715]Retail sale of sewing and clothing accessories (e.g. button, thread, lace, zip, belt, tie) / 缝纫和服装配件（例如纽扣、线、花边、拉链、腰带、领带）的零售",
        en: "[47715]Retail sale of sewing and clothing accessories (e.g. button, thread, lace, zip, belt, tie)",
      },
      {
        value: "[47719]Retail sale of clothing, footwear and leather articles n.e.c.",
        zh: "[47719]Retail sale of clothing, footwear and leather articles n.e.c. / 其他服装、鞋类和皮革制品的零售",
        en: "[47719]Retail sale of clothing, footwear and leather articles n.e.c.",
      },
      {
        value: "[47721]Retail sale of cosmetics and toiletries (including skin care products)",
        zh: "[47721]Retail sale of cosmetics and toiletries (including skin care products) / 化妆品和洗护用品（包括护肤品）的零售",
        en: "[47721]Retail sale of cosmetics and toiletries (including skin care products)",
      },
      {
        value: "[47722]Pharmacies and drug stores (Western)",
        zh: "[47722]Pharmacies and drug stores (Western) / 药房和药店（西）",
        en: "[47722]Pharmacies and drug stores (Western)",
      },
      {
        value: "[47723]Chinese medicine shops",
        zh: "[47723]Chinese medicine shops / 中药店",
        en: "[47723]Chinese medicine shops",
      },
      {
        value: "[47729]Retail sale of pharmaceutical and medical goods n.e.c.",
        zh: "[47729]Retail sale of pharmaceutical and medical goods n.e.c. / 药品和医疗用品的零售",
        en: "[47729]Retail sale of pharmaceutical and medical goods n.e.c.",
      },
      {
        value: "[47731]Retail sale of jewellery made from precious metals and stones",
        zh: "[47731]Retail sale of jewellery made from precious metals and stones / 贵金属和宝石首饰的零售",
        en: "[47731]Retail sale of jewellery made from precious metals and stones",
      },
      {
        value: "[47732]Retail sale of costume jewellery",
        zh: "[47732]Retail sale of costume jewellery / 服装首饰零售",
        en: "[47732]Retail sale of costume jewellery",
      },
      {
        value: "[47733]Retail sale of watches and clocks",
        zh: "[47733]Retail sale of watches and clocks / 钟表零售",
        en: "[47733]Retail sale of watches and clocks",
      },
      {
        value: "[47739]Retail sale of personal effects n.e.c.",
        zh: "[47739]Retail sale of personal effects n.e.c. / 个人物品的零售 ",
        en: "[47739]Retail sale of personal effects n.e.c.",
      },
      {
        value: "[47741]Retail sale of antiques and works of art",
        zh: "[47741]Retail sale of antiques and works of art / 古董和艺术品的零售",
        en: "[47741]Retail sale of antiques and works of art",
      },
      {
        value: "[47742]Retail sale of handicrafts, collectibles and gifts",
        zh: "[47742]Retail sale of handicrafts, collectibles and gifts / 手工艺品、收藏品和礼品的零售",
        en: "[47742]Retail sale of handicrafts, collectibles and gifts",
      },
      {
        value: "[47743]Retail sale of cut flowers (including wreaths)",
        zh: "[47743]Retail sale of cut flowers (including wreaths) / 切花零售（包括花圈）",
        en: "[47743]Retail sale of cut flowers (including wreaths)",
      },
      {
        value: "[47744]Retail sale of artificial flowers and plants",
        zh: "[47744]Retail sale of artificial flowers and plants / 人造花卉和植物的零售",
        en: "[47744]Retail sale of artificial flowers and plants",
      },
      {
        value: "[47745]Retail sale of aquarium fishes (including food and accessories)",
        zh: "[47745]Retail sale of aquarium fishes (including food and accessories) / 观赏鱼的零售（包括食品和配件）",
        en: "[47745]Retail sale of aquarium fishes (including food and accessories)",
      },
      {
        value: "[47746]Retail sale of pet birds and animals (including food and accessories)",
        zh: "[47746]Retail sale of pet birds and animals (including food and accessories) / 宠物鸟和动物的零售（包括食品和配件）",
        en: "[47746]Retail sale of pet birds and animals (including food and accessories)",
      },
      {
        value: "[47749]Retail sale of handicrafts and fancy goods, flowers, plants and pet animals n.e.c.",
        zh: "[47749]Retail sale of handicrafts and fancy goods, flowers, plants and pet animals n.e.c. / 手工艺品和精美商品、花卉、植物和宠物的零售",
        en: "[47749]Retail sale of handicrafts and fancy goods, flowers, plants and pet animals n.e.c.",
      },
      {
        value: "[47751]Retail sale of spectacles and other optical goods",
        zh: "[47751]Retail sale of spectacles and other optical goods / 眼镜和其他光学商品的零售",
        en: "[47751]Retail sale of spectacles and other optical goods",
      },
      {
        value: "[47752]Retail sale of cameras and other photographic goods",
        zh: "[47752]Retail sale of cameras and other photographic goods / 相机和其他摄影商品的零售",
        en: "[47752]Retail sale of cameras and other photographic goods",
      },
      {
        value: "[47759]Retail sale of optical and photographic goods n.e.c.",
        zh: "[47759]Retail sale of optical and photographic goods n.e.c. / 光学和摄影商品的零售",
        en: "[47759]Retail sale of optical and photographic goods n.e.c.",
      },
      {
        value: "[47761]Retail sale of joss paper and other ceremonial products",
        zh: "[47761]Retail sale of joss paper and other ceremonial products / 金纸和其他礼仪产品的零售",
        en: "[47761]Retail sale of joss paper and other ceremonial products",
      },
      {
        value: "[47762]Retail sale of liquefied petroleum gas (LPG)",
        zh: "[47762]Retail sale of liquefied petroleum gas (LPG) / 液化石油气 (LPG) 零售",
        en: "[47762]Retail sale of liquefied petroleum gas (LPG)",
      },
      {
        value: "[47769]Retail sale of specific commodities n.e.c.",
        zh: "[47769]Retail sale of specific commodities n.e.c. / 特定商品的零售",
        en: "[47769]Retail sale of specific commodities n.e.c.",
      },
      {
        value: "[47770]Retail sale of second-hand goods in stores",
        zh: "[47770]Retail sale of second-hand goods in stores / 商店中二手商品的零售",
        en: "[47770]Retail sale of second-hand goods in stores",
      },
      {
        value: "[47801]Stalls (including pushcarts) selling uncooked food",
        zh: "[47801]Stalls (including pushcarts) selling uncooked food / 出售生食的摊位（包括手推车）",
        en: "[47801]Stalls (including pushcarts) selling uncooked food",
      },
      {
        value: "[47802]Stalls (including pushcarts) selling other commodities (other than uncooked food)",
        zh: "[47802]Stalls (including pushcarts) selling other commodities (other than uncooked food) / 出售其他商品（生食除外）的摊位（包括手推车）",
        en: "[47802]Stalls (including pushcarts) selling other commodities (other than uncooked food)",
      },
      {
        value: "[49101]Railroad services",
        zh: "[49101]Railroad services / 铁路服务",
        en: "[49101]Railroad services",
      },
      {
        value: "[49102]Mass rapid transit systems (including light rail)",
        zh: "[49102]Mass rapid transit systems (including light rail) / 大众捷运系统（包括轻轨）",
        en: "[49102]Mass rapid transit systems (including light rail)",
      },
      {
        value: "[49211]Public bus services (scheduled services)",
        zh: "[49211]Public bus services (scheduled services) / 公共巴士服务（定期服务）",
        en: "[49211]Public bus services (scheduled services)",
      },
      {
        value: "[49212]Chartered bus services (including school buses)",
        zh: "[49212]Chartered bus services (including school buses) / 包车服务（包括校车）",
        en: "[49212]Chartered bus services (including school buses)",
      },
      {
        value: "[49213]Inter-country bus services",
        zh: "[49213]Inter-country bus services / 跨国巴士服务",
        en: "[49213]Inter-country bus services",
      },
      {
        value: "[49214]Street-hail and ride-hail service providers",
        zh: "[49214]Street-hail and ride-hail service providers / 叫车和叫车服务提供商",
        en: "[49214]Street-hail and ride-hail service providers",
      },
      {
        value: "[49215]Rental and leasing of cars with driver (excluding street-hail and ride-hail service providers)",
        zh: "[49215]Rental and leasing of cars with driver (excluding street-hail and ride-hail service providers) / 带司机的汽车租赁（不包括街头叫车和叫车服务提供商）",
        en: "[49215]Rental and leasing of cars with driver (excluding street-hail and ride-hail service providers)",
      },
      {
        value: "[49220]Aerial cableways (including cable car services)",
        zh: "[49220]Aerial cableways (including cable car services) / 空中索道（包括缆车服务）",
        en: "[49220]Aerial cableways (including cable car services)",
      },
      {
        value: "[49231]Freight transport by road",
        zh: "[49231]Freight transport by road / 公路货运",
        en: "[49231]Freight transport by road",
      },
      {
        value: "[49232]Moving services",
        zh: "[49232]Moving services / 搬家服务",
        en: "[49232]Moving services",
      },
      {
        value: "[49233]Rental and leasing of freight land transport vehicle (e.g. lorries and trucks) with driver",
        zh: "[49233]Rental and leasing of freight land transport vehicle (e.g. lorries and trucks) with driver / 带司机的陆路货运车辆（如卡车和卡车）的出租和租赁",
        en: "[49233]Rental and leasing of freight land transport vehicle (e.g. lorries and trucks) with driver",
      },
      {
        value: "[49300]Transport via pipelines",
        zh: "[49300]Transport via pipelines / 通过管道运输",
        en: "[49300]Transport via pipelines",
      },
      {
        value: "[50011]International cruise services",
        zh: "[50011]International cruise services / 国际邮轮服务",
        en: "[50011]International cruise services",
      },
      {
        value: "[50012]Other sight-seeing cruise services (e.g. harbour and river cruises)",
        zh: "[50012]Other sight-seeing cruise services (e.g. harbour and river cruises) / 其他观光游轮服务（例如海港游船和内河游船）",
        en: "[50012]Other sight-seeing cruise services (e.g. harbour and river cruises)",
      },
      {
        value: "[50013]Passenger ferry services",
        zh: "[50013]Passenger ferry services / 客运渡轮服务",
        en: "[50013]Passenger ferry services",
      },
      {
        value: "[50014]Chartering of ships and boats with crew (passenger)",
        zh: "[50014]Chartering of ships and boats with crew (passenger) / 租船和有船员（乘客）的船只",
        en: "[50014]Chartering of ships and boats with crew (passenger)",
      },
      {
        value: "[50021]Shipping companies, including chartering of ships and boats with crew (freight)",
        zh: "[50021]Shipping companies, including chartering of ships and boats with crew (freight) / 航运公司，包括租船和有船员的船只（货运）",
        en: "[50021]Shipping companies, including chartering of ships and boats with crew (freight)",
      },
      {
        value: "[50022]Operators and charterers of barges, tugboats and bumboats (freight)",
        zh: "[50022]Operators and charterers of barges, tugboats and bumboats (freight) / 驳船、拖船和手推船（货运）的运营商和承租人",
        en: "[50022]Operators and charterers of barges, tugboats and bumboats (freight)",
      },
      {
        value: "[50023]Branches of foreign shipping lines",
        zh: "[50023]Branches of foreign shipping lines / 国外航运分公司",
        en: "[50023]Branches of foreign shipping lines",
      },
      {
        value: "[51001]Airlines (passenger)",
        zh: "[51001]Airlines (passenger) / 航空公司（乘客）",
        en: "[51001]Airlines (passenger)",
      },
      {
        value: "[51002]Airlines (freight)",
        zh: "[51002]Airlines (freight) / 航空公司（货运）",
        en: "[51002]Airlines (freight)",
      },
      {
        value: "[51003]Branches of foreign airlines (passenger)",
        zh: "[51003]Branches of foreign airlines (passenger) / 外国航空公司（客运）分公司",
        en: "[51003]Branches of foreign airlines (passenger)",
      },
      {
        value: "[51004]Branches of foreign airlines (freight)",
        zh: "[51004]Branches of foreign airlines (freight) / 外航分公司（货运）",
        en: "[51004]Branches of foreign airlines (freight)",
      },
      {
        value: "[51005]Aircraft chartering with operator",
        zh: "[51005]Aircraft chartering with operator / 与运营商包机",
        en: "[51005]Aircraft chartering with operator",
      },
      {
        value: "[52101]General warehousing",
        zh: "[52101]General warehousing / 一般仓储",
        en: "[52101]General warehousing",
      },
      {
        value: "[52102]Refrigerated warehousing and storage",
        zh: "[52102]Refrigerated warehousing and storage / 冷藏仓储",
        en: "[52102]Refrigerated warehousing and storage",
      },
      {
        value: "[52103]Storage for dangerous goods",
        zh: "[52103]Storage for dangerous goods / 危险品储存",
        en: "[52103]Storage for dangerous goods",
      },
      {
        value: "[52109]Specialised storage n.e.c. (e.g. wine warehousing, document storage and warehousing)",
        zh: "[52109]Specialised storage n.e.c. (e.g. wine warehousing, document storage and warehousing) / 专业化仓储（如葡萄酒仓储、文件储存和仓储）",
        en: "[52109]Specialised storage n.e.c. (e.g. wine warehousing, document storage and warehousing)",
      },
      {
        value: "[52211]Carpark management and operation services",
        zh: "[52211]Carpark management and operation services / 停车场管理及营运服务",
        en: "[52211]Carpark management and operation services",
      },
      {
        value: "[52212]Motor vehicle towing services",
        zh: "[52212]Motor vehicle towing services / 机动车牵引服务",
        en: "[52212]Motor vehicle towing services",
      },
      {
        value: "[52219]Supporting services to land transport n.e.c.",
        zh: "[52219]Supporting services to land transport n.e.c. / 陆路运输配套服务",
        en: "[52219]Supporting services to land transport n.e.c.",
      },
      {
        value: "[52221]Representative offices of foreign shipping lines",
        zh: "[52221]Representative offices of foreign shipping lines / 国外航运公司代表处",
        en: "[52221]Representative offices of foreign shipping lines",
      },
      {
        value: "[52222]Shipping agencies (freight)",
        zh: "[52222]Shipping agencies (freight) / 船务代理（货运）",
        en: "[52222]Shipping agencies (freight)",
      },
      {
        value: "[52223]Port operators",
        zh: "[52223]Port operators / 港口经营者",
        en: "[52223]Port operators",
      },
      {
        value: "[52224]Lighterage services",
        zh: "[52224]Lighterage services / 轻型服务",
        en: "[52224]Lighterage services",
      },
      {
        value: "[52225]Salvaging of distressed vessels and cargos",
        zh: "[52225]Salvaging of distressed vessels and cargos / 打捞遇险船舶和货物",
        en: "[52225]Salvaging of distressed vessels and cargos",
      },
      {
        value: "[52226]Ship management services",
        zh: "[52226]Ship management services / 船舶管理服务",
        en: "[52226]Ship management services",
      },
      {
        value: "[52227]Ship brokering services",
        zh: "[52227]Ship brokering services / 船舶经纪服务",
        en: "[52227]Ship brokering services",
      },
      {
        value: "[52229]Supporting services to water transport n.e.c.",
        zh: "[52229]Supporting services to water transport n.e.c. / 水运配套服务",
        en: "[52229]Supporting services to water transport n.e.c.",
      },
      {
        value: "[52231]Representative offices of foreign airlines",
        zh: "[52231]Representative offices of foreign airlines / 外国航空公司代表处",
        en: "[52231]Representative offices of foreign airlines",
      },
      {
        value: "[52232]Airline agencies (freight)",
        zh: "[52232]Airline agencies (freight) / 航空公司代理（货运）",
        en: "[52232]Airline agencies (freight)",
      },
      {
        value: "[52233]Airport operation services",
        zh: "[52233]Airport operation services / 机场运营服务",
        en: "[52233]Airport operation services",
      },
      {
        value: "[52234]Airport terminal services (e.g. ground service activities)",
        zh: "[52234]Airport terminal services (e.g. ground service activities) / 机场航站楼服务（例如地面服务活动）",
        en: "[52234]Airport terminal services (e.g. ground service activities)",
      },
      {
        value: "[52239]Supporting services to air transport n.e.c.",
        zh: "[52239]Supporting services to air transport n.e.c. / 航空运输相关配套服务",
        en: "[52239]Supporting services to air transport n.e.c.",
      },
      {
        value: "[52241]Container depot services",
        zh: "[52241]Container depot services / 集装箱堆场服务",
        en: "[52241]Container depot services",
      },
      {
        value: "[52242]Crane services for all industries except construction",
        zh: "[52242]Crane services for all industries except construction / 为除建筑以外的所有行业提供起重机服务",
        en: "[52242]Crane services for all industries except construction",
      },
      {
        value: "[52243]Stevedoring services",
        zh: "[52243]Stevedoring services / 装卸服务",
        en: "[52243]Stevedoring services",
      },
      {
        value: "[52251]Classification societies",
        zh: "[52251]Classification societies / 船级社",
        en: "[52251]Classification societies",
      },
      {
        value: "[52252]Marine surveying services other than classification societies",
        zh: "[52252]Marine surveying services other than classification societies / 船级社以外的海洋测量服务",
        en: "[52252]Marine surveying services other than classification societies",
      },
      {
        value: "[52291]Cargo surveying services",
        zh: "[52291]Cargo surveying services / 货物测量服务",
        en: "[52291]Cargo surveying services",
      },
      {
        value: "[52292]Freight transport arrangement",
        zh: "[52292]Freight transport arrangement / 货运安排",
        en: "[52292]Freight transport arrangement",
      },
      {
        value: "[53100]National post activities (e.g. postal services)",
        zh: "[53100]National post activities (e.g. postal services) / 国家邮政活动（例如邮政服务）",
        en: "[53100]National post activities (e.g. postal services)",
      },
      {
        value: "[53200]Courier activities other than national post activities",
        zh: "[53200]Courier activities other than national post activities / 国家邮政活动以外的快递活动",
        en: "[53200]Courier activities other than national post activities",
      },
      {
        value: "[55101]Hotels",
        zh: "[55101]Hotels / 酒店",
        en: "[55101]Hotels",
      },
      {
        value: "[55102]Chalets",
        zh: "[55102]Chalets / 木屋",
        en: "[55102]Chalets",
      },
      {
        value: "[55103]Short term accommodation activities other than hotels and chalets",
        zh: "[55103]Short term accommodation activities other than hotels and chalets / 酒店和小木屋以外的短期住宿活动",
        en: "[55103]Short term accommodation activities other than hotels and chalets",
      },
      {
        value: "[55900]Hostels and dormitories for students, workers and other individuals",
        zh: "[55900]Hostels and dormitories for students, workers and other individuals / 学生、工人和其他个人的宿舍和宿舍",
        en: "[55900]Hostels and dormitories for students, workers and other individuals",
      },
      {
        value: "[56111]Restaurants",
        zh: "[56111]Restaurants / 餐厅",
        en: "[56111]Restaurants",
      },
      {
        value: "[56112]Cafes",
        zh: "[56112]Cafes / 咖啡馆",
        en: "[56112]Cafes",
      },
      {
        value: "[56121]Fast food outlets",
        zh: "[56121]Fast food outlets / 快餐店",
        en: "[56121]Fast food outlets",
      },
      {
        value: "[56122]Food courts, coffee shops and canteens (with mainly food and beverage income)",
        zh: "[56122]Food courts, coffee shops and canteens (with mainly food and beverage income) / 美食广场、咖啡店和食堂（以餐饮收入为主）",
        en: "[56122]Food courts, coffee shops and canteens (with mainly food and beverage income)",
      },
      {
        value: "[56123]Food kiosks mainly for takeaway and delivery",
        zh: "[56123]Food kiosks mainly for takeaway and delivery / 食品亭主要用于外卖和送货",
        en: "[56123]Food kiosks mainly for takeaway and delivery",
      },
      {
        value: "[56130]Pubs",
        zh: "[56130]Pubs / 酒馆",
        en: "[56130]Pubs",
      },
      {
        value: "[56140]Stalls selling cooked food and prepared drinks (including stalls at food courts and mobile food hawkers)",
        zh: "[56140]Stalls selling cooked food and prepared drinks (including stalls at food courts and mobile food hawkers) / 出售熟食和预制饮料的摊位（包括美食广场的摊位和流动食品小贩）",
        en: "[56140]Stalls selling cooked food and prepared drinks (including stalls at food courts and mobile food hawkers)",
      },
      {
        value: "[56200]Food caterers",
        zh: "[56200]Food caterers / 餐饮业者",
        en: "[56200]Food caterers",
      },
      {
        value: "[58110]Publishing of books, brochures, musical books and other publications",
        zh: "[58110]Publishing of books, brochures, musical books and other publications / 出版书籍、小册子、音乐书籍和其他出版物",
        en: "[58110]Publishing of books, brochures, musical books and other publications",
      },
      {
        value: "[58120]Publishing of directories and mailing lists (including financial databases)",
        zh: "[58120]Publishing of directories and mailing lists (including financial databases) / 发布目录和邮件列表（包括财务数据库）",
        en: "[58120]Publishing of directories and mailing lists (including financial databases)",
      },
      {
        value: "[58131]Publishing of news",
        zh: "[58131]Publishing of news / 新闻发布",
        en: "[58131]Publishing of news",
      },
      {
        value: "[58132]Publishing of journals, periodicals and magazines",
        zh: "[58132]Publishing of journals, periodicals and magazines / 期刊、期刊和杂志的出版",
        en: "[58132]Publishing of journals, periodicals and magazines",
      },
      {
        value: "[58190]Other publishing activities (excluding online marketplaces)",
        zh: "[58190]Other publishing activities (excluding online marketplaces) / 其他出版活动（不包括在线市场）",
        en: "[58190]Other publishing activities (excluding online marketplaces)",
      },
      {
        value: "[58201]Publishing of games software/applications",
        zh: "[58201]Publishing of games software/applications / 发布游戏软件/应用程序",
        en: "[58201]Publishing of games software/applications",
      },
      {
        value: "[58202]Publishing of software/applications (non-games)",
        zh: "[58202]Publishing of software/applications (non-games) / 软件/应用程序的发布（非游戏）",
        en: "[58202]Publishing of software/applications (non-games)",
      },
      {
        value: "[59111]Movie production",
        zh: "[59111]Movie production / 电影制作",
        en: "[59111]Movie production",
      },
      {
        value: "[59112]Production of advertisements, corporate videos and event videos",
        zh: "[59112]Production of advertisements, corporate videos and event videos / 制作广告、企业宣传片和活动宣传片",
        en: "[59112]Production of advertisements, corporate videos and event videos",
      },
      {
        value: "[59113]Production of dramas, variety shows and documentaries (including production of television programme)",
        zh: "[59113]Production of dramas, variety shows and documentaries (including production of television programme) / 电视剧、综艺、纪录片制作（包括电视节目制作）",
        en: "[59113]Production of dramas, variety shows and documentaries (including production of television programme)",
      },
      {
        value: "[59114]Animation production",
        zh: "[59114]Animation production / 动画制作",
        en: "[59114]Animation production",
      },
      {
        value: "[59119]Movie, video, television and other programme production activities n.e.c.",
        zh: "[59119]Movie, video, television and other programme production activities n.e.c. / 电影、视频、电视和其他节目制作活动 ",
        en: "[59119]Movie, video, television and other programme production activities n.e.c.",
      },
      {
        value: "[59120]Movie, video, television and other programme post-production activities (including remastering)",
        zh: "[59120]Movie, video, television and other programme post-production activities (including remastering) / 电影、视频、电视和其他节目后期制作活动（包括重新制作）",
        en: "[59120]Movie, video, television and other programme post-production activities (including remastering)",
      },
      {
        value: "[59131]Movie distribution",
        zh: "[59131]Movie distribution / 电影发行",
        en: "[59131]Movie distribution",
      },
      {
        value: "[59132]Distribution of television programmes (e.g. dramas, variety shows and documentaries)",
        zh: "[59132]Distribution of television programmes (e.g. dramas, variety shows and documentaries) / 电视节目的发行（例如戏剧、综艺节目和纪录片）",
        en: "[59132]Distribution of television programmes (e.g. dramas, variety shows and documentaries)",
      },
      {
        value: "[59139]Movie, video, television and other programme distribution activities n.e.c.",
        zh: "[59139]Movie, video, television and other programme distribution activities n.e.c. / 电影、视频、电视和其他节目发行活动 ",
        en: "[59139]Movie, video, television and other programme distribution activities n.e.c.",
      },
      {
        value: "[59140]Movie projection activities (including cinemas)",
        zh: "[59140]Movie projection activities (including cinemas) / 电影放映活动（包括电影院）",
        en: "[59140]Movie projection activities (including cinemas)",
      },
      {
        value: "[59201]Sound recording production",
        zh: "[59201]Sound recording production / 录音制作",
        en: "[59201]Sound recording production",
      },
      {
        value: "[59202]Music publishing and distribution activities",
        zh: "[59202]Music publishing and distribution activities / 音乐出版和发行活动",
        en: "[59202]Music publishing and distribution activities",
      },
      {
        value: "[60100]Radio programme production and broadcasting",
        zh: "[60100]Radio programme production and broadcasting / 广播节目制作与播出",
        en: "[60100]Radio programme production and broadcasting",
      },
      {
        value: "[60200]Television programming and broadcasting (including cable, satellite, terrestrial television, internet and mobile)",
        zh: "[60200]Television programming and broadcasting (including cable, satellite, terrestrial television, internet and mobile) / 电视节目和广播（包括有线、卫星、地面电视、互联网和移动）",
        en: "[60200]Television programming and broadcasting (including cable, satellite, terrestrial television, internet and mobile)",
      },
      {
        value: "[61011]Wired telecommunications network operation (including fixed-line, fibre optics, local/international PSTN and leased circuits)",
        zh: "[61011]Wired telecommunications network operation (including fixed-line, fibre optics, local/international PSTN and leased circuits) / 有线电信网络运营（包括固网、光纤、本地/国际 PSTN 和租用电路）",
        en: "[61011]Wired telecommunications network operation (including fixed-line, fibre optics, local/international PSTN and leased circuits)",
      },
      {
        value: "[61012]Mobile cellular and other wireless telecommunications network operation",
        zh: "[61012]Mobile cellular and other wireless telecommunications network operation / 移动蜂窝和其他无线电信网络运营",
        en: "[61012]Mobile cellular and other wireless telecommunications network operation",
      },
      {
        value: "[61013]Satellite telecommunications network operation",
        zh: "[61013]Satellite telecommunications network operation / 卫星通信网络运营",
        en: "[61013]Satellite telecommunications network operation",
      },
      {
        value: "[61091]Telecommunications resellers/third party telecommunications providers (including value-added network operators)",
        zh: "[61091]Telecommunications resellers/third party telecommunications providers (including value-added network operators) / 电信经销商/第三方电信供应商（包括增值网络运营商）",
        en: "[61091]Telecommunications resellers/third party telecommunications providers (including value-added network operators)",
      },
      {
        value: "[61092]Internet access providers, include ISPs",
        zh: "[61092]Internet access providers, include ISPs / 互联网接入提供商，包括 ISP",
        en: "[61092]Internet access providers, include ISPs",
      },
      {
        value: "[61099]Other telecommunications activities n.e.c. (e.g. provision of VoIP (Voice over Internet Protocol services))",
        zh: "[61099]Other telecommunications activities n.e.c. (e.g. provision of VoIP (Voice over Internet Protocol services)) / 其他电信活动（例如提供 VoIP（互联网协议语音服务））",
        en: "[61099]Other telecommunications activities n.e.c. (e.g. provision of VoIP (Voice over Internet Protocol services))",
      },
      {
        value: "[62011]Development of software and applications (except games and cybersecurity)",
        zh: "[62011]Development of software and applications (except games and cybersecurity) / 软件和应用程序的开发（游戏和网络安全除外）",
        en: "[62011]Development of software and applications (except games and cybersecurity)",
      },
      {
        value: "[62012]Development of computer games",
        zh: "[62012]Development of computer games / 电脑游戏的开发",
        en: "[62012]Development of computer games",
      },
      {
        value: "[62013]Development of software for cybersecurity",
        zh: "[62013]Development of software for cybersecurity / 网络安全软件的开发",
        en: "[62013]Development of software for cybersecurity",
      },
      {
        value: "[62021]Information technology consultancy (except cybersecurity)",
        zh: "[62021]Information technology consultancy (except cybersecurity) / 信息技术咨询（网络安全除外）",
        en: "[62021]Information technology consultancy (except cybersecurity)",
      },
      {
        value: "[62022]Information technology cybersecurity consultancy",
        zh: "[62022]Information technology cybersecurity consultancy / 信息技术网络安全咨询",
        en: "[62022]Information technology cybersecurity consultancy",
      },
      {
        value: "[62023]Computer facilities management activities",
        zh: "[62023]Computer facilities management activities / 计算机设施管理活动",
        en: "[62023]Computer facilities management activities",
      },
      {
        value: "[62090]Other information technology and computer service activities (e.g. disaster recovery services)",
        zh: "[62090]Other information technology and computer service activities (e.g. disaster recovery services) / 其他信息技术和计算机服务活动（例如灾难恢复服务）",
        en: "[62090]Other information technology and computer service activities (e.g. disaster recovery services)",
      },
      {
        value: "[63111]Data centres",
        zh: "[63111]Data centres / 数据中心",
        en: "[63111]Data centres",
      },
      {
        value: "[63112]Hosting services by non-data centres",
        zh: "[63112]Hosting services by non-data centres / 非数据中心托管服务",
        en: "[63112]Hosting services by non-data centres",
      },
      {
        value: "[63119]Data analytics, processing and related activities n.e.c.",
        zh: "[63119]Data analytics, processing and related activities n.e.c. / 数据分析、处理和相关活动 ",
        en: "[63119]Data analytics, processing and related activities n.e.c.",
      },
      {
        value: "[63120]Internet search engines",
        zh: "[63120]Internet search engines / 互联网搜索引擎",
        en: "[63120]Internet search engines",
      },
      {
        value: "[63201]Online marketplaces for goods (including food)",
        zh: "[63201]Online marketplaces for goods (including food) / 商品（包括食品）的在线市场",
        en: "[63201]Online marketplaces for goods (including food)",
      },
      {
        value: "[63202]Online marketplaces for health services",
        zh: "[63202]Online marketplaces for health services / 医疗服务在线市场",
        en: "[63202]Online marketplaces for health services",
      },
      {
        value: "[63203]Online marketplaces for education services",
        zh: "[63203]Online marketplaces for education services / 教育服务的在线市场",
        en: "[63203]Online marketplaces for education services",
      },
      {
        value: "[63204]Online marketplaces for travel services",
        zh: "[63204]Online marketplaces for travel services / 旅游服务在线市场",
        en: "[63204]Online marketplaces for travel services",
      },
      {
        value: "[63205]Online marketplaces for real estate services",
        zh: "[63205]Online marketplaces for real estate services / 房地产服务在线市场",
        en: "[63205]Online marketplaces for real estate services",
      },
      {
        value: "[63209]Online marketplaces for services n.e.c.",
        zh: "[63209]Online marketplaces for services n.e.c. / 在线服务市场",
        en: "[63209]Online marketplaces for services n.e.c.",
      },
      {
        value: "[63901]News agency activities",
        zh: "[63901]News agency activities / 通讯社活动",
        en: "[63901]News agency activities",
      },
      {
        value: "[63909]Other information service activities n.e.c.",
        zh: "[63909]Other information service activities n.e.c. / 其他信息服务活动 ",
        en: "[63909]Other information service activities n.e.c.",
      },
      {
        value: "[64110]Central bank",
        zh: "[64110]Central bank / 中央银行",
        en: "[64110]Central bank",
      },
      {
        value: "[64120]Full banks",
        zh: "[64120]Full banks / 满银行",
        en: "[64120]Full banks",
      },
      {
        value: "[64130]Wholesale banks",
        zh: "[64130]Wholesale banks / 批发银行",
        en: "[64130]Wholesale banks",
      },
      {
        value: "[64140]Merchant banks",
        zh: "[64140]Merchant banks / 商业银行",
        en: "[64140]Merchant banks",
      },
      {
        value: "[64150]Finance companies (with deposit taking functions)",
        zh: "[64150]Finance companies (with deposit taking functions) / 财务公司（具有存款功能）",
        en: "[64150]Finance companies (with deposit taking functions)",
      },
      {
        value: "[64190]Other monetary intermediation",
        zh: "[64190]Other monetary intermediation / 其他货币中介",
        en: "[64190]Other monetary intermediation",
      },
      {
        value: "[64201]Bank/Financial holding companies (including insurance holding company)",
        zh: "[64201]Bank/Financial holding companies (including insurance holding company) / 银行/金融控股公司（包括保险控股公司）",
        en: "[64201]Bank/Financial holding companies (including insurance holding company)",
      },
      {
        value: "[64202]Other holding companies",
        zh: "[64202]Other holding companies / 其他控股公司",
        en: "[64202]Other holding companies",
      },
      {
        value: "[64300]Trusts, funds and similar financial entities (e.g. collective portfolio investment funds (excluding those with rental income))",
        zh: "[64300]Trusts, funds and similar financial entities (e.g. collective portfolio investment funds (excluding those with rental income)) / 信托、基金和类似的金融实体（例如集体证券投资基金（不包括那些有租金收入的））",
        en: "[64300]Trusts, funds and similar financial entities (e.g. collective portfolio investment funds (excluding those with rental income))",
      },
      {
        value: "[64910]Financial leasing companies",
        zh: "[64910]Financial leasing companies / 融资租赁公司",
        en: "[64910]Financial leasing companies",
      },
      {
        value: "[64921]Thrift and loan societies and credit associations",
        zh: "[64921]Thrift and loan societies and credit associations / 储蓄和贷款协会和信用协会",
        en: "[64921]Thrift and loan societies and credit associations",
      },
      {
        value: "[64922]Credit card services",
        zh: "[64922]Credit card services / 信用卡服务",
        en: "[64922]Credit card services",
      },
      {
        value: "[64923]Mutual benefits organisations",
        zh: "[64923]Mutual benefits organisations / 互惠组织",
        en: "[64923]Mutual benefits organisations",
      },
      {
        value: "[64924]Money-lending",
        zh: "[64924]Money-lending / 放债",
        en: "[64924]Money-lending",
      },
      {
        value: "[64925]Pawnbrokerage",
        zh: "[64925]Pawnbrokerage / 典当行",
        en: "[64925]Pawnbrokerage",
      },
      {
        value: "[64929]Other credit agencies n.e.c. (e.g. motor finance)",
        zh: "[64929]Other credit agencies n.e.c. (e.g. motor finance) / 其他信贷机构（例如汽车金融）",
        en: "[64929]Other credit agencies n.e.c. (e.g. motor finance)",
      },
      {
        value: "[64991]Factoring companies",
        zh: "[64991]Factoring companies / 保理公司",
        en: "[64991]Factoring companies",
      },
      {
        value: "[64992]Representative offices of foreign banks",
        zh: "[64992]Representative offices of foreign banks / 外资银行代表处",
        en: "[64992]Representative offices of foreign banks",
      },
      {
        value: "[64993]Remittance services",
        zh: "[64993]Remittance services / 汇款服务",
        en: "[64993]Remittance services",
      },
      {
        value: "[64994]Treasury centres",
        zh: "[64994]Treasury centres / 财资中心",
        en: "[64994]Treasury centres",
      },
      {
        value: "[64999]Other financial service activities, except insurance and pension funding activities n.e.c.",
        zh: "[64999]Other financial service activities, except insurance and pension funding activities n.e.c. / 其他金融服务活动，除保险和养老基金活动外",
        en: "[64999]Other financial service activities, except insurance and pension funding activities n.e.c.",
      },
      {
        value: "[65110]Life insurance",
        zh: "[65110]Life insurance / 人寿保险",
        en: "[65110]Life insurance",
      },
      {
        value: "[65121]Marine insurance",
        zh: "[65121]Marine insurance / 海运保险",
        en: "[65121]Marine insurance",
      },
      {
        value: "[65122]Captive insurance",
        zh: "[65122]Captive insurance / 专属保险",
        en: "[65122]Captive insurance",
      },
      {
        value: "[65123]Import, export and credit insurance",
        zh: "[65123]Import, export and credit insurance / 进出口和信用保险",
        en: "[65123]Import, export and credit insurance",
      },
      {
        value: "[65124]General insurance (except marine and import, export & credit insurance)",
        zh: "[65124]General insurance (except marine and import, export & credit insurance) / 一般保险（海运及进出口及信用保险除外）",
        en: "[65124]General insurance (except marine and import, export & credit insurance)",
      },
      {
        value: "[65201]Life reinsurance",
        zh: "[65201]Life reinsurance / 人寿再保险",
        en: "[65201]Life reinsurance",
      },
      {
        value: "[65202]General reinsurance",
        zh: "[65202]General reinsurance / 一般再保险",
        en: "[65202]General reinsurance",
      },
      {
        value: "[65301]Provident funding",
        zh: "[65301]Provident funding / 公积金",
        en: "[65301]Provident funding",
      },
      {
        value: "[65302]Pension funding",
        zh: "[65302]Pension funding / 养老金资金",
        en: "[65302]Pension funding",
      },
      {
        value: "[66110]Securities and commodities exchange",
        zh: "[66110]Securities and commodities exchange / 证券及商品交易所",
        en: "[66110]Securities and commodities exchange",
      },
      {
        value: "[66121]Stock, share and bond brokers and dealers",
        zh: "[66121]Stock, share and bond brokers and dealers / 股票、股票和债券经纪人和交易商",
        en: "[66121]Stock, share and bond brokers and dealers",
      },
      {
        value: "[66122]Foreign exchange brokers and dealers",
        zh: "[66122]Foreign exchange brokers and dealers / 外汇经纪商和交易商",
        en: "[66122]Foreign exchange brokers and dealers",
      },
      {
        value: "[66123]Gold bullion brokers and dealers",
        zh: "[66123]Gold bullion brokers and dealers / 金条经纪人和交易商",
        en: "[66123]Gold bullion brokers and dealers",
      },
      {
        value: "[66124]Commodity (excluding gold) and futures brokers and dealers",
        zh: "[66124]Commodity (excluding gold) and futures brokers and dealers / 商品（不包括黄金）和期货经纪人和交易商",
        en: "[66124]Commodity (excluding gold) and futures brokers and dealers",
      },
      {
        value: "[66125]Carbon credit brokers/traders",
        zh: "[66125]Carbon credit brokers/traders / 碳信用经纪人/交易商",
        en: "[66125]Carbon credit brokers/traders",
      },
      {
        value: "[66126]Money-changing services",
        zh: "[66126]Money-changing services / 货币兑换服务",
        en: "[66126]Money-changing services",
      },
      {
        value: "[66129]Security dealings and commodity contracts brokerage activities n.e.c.",
        zh: "[66129]Security dealings and commodity contracts brokerage activities n.e.c. / 证券交易和商品合同经纪活动 ",
        en: "[66129]Security dealings and commodity contracts brokerage activities n.e.c.",
      },
      {
        value: "[66191]Trustee, fiduciary and custody services firms (including nominee companies, trustees and REIT trustees)",
        zh: "[66191]Trustee, fiduciary and custody services firms (including nominee companies, trustees and REIT trustees) / 受托人、受托人和托管服务公司（包括代理人公司、受托人和 REIT 受托人）",
        en: "[66191]Trustee, fiduciary and custody services firms (including nominee companies, trustees and REIT trustees)",
      },
      {
        value: "[66192]Corporate finance advisory services",
        zh: "[66192]Corporate finance advisory services / 企业融资顾问服务",
        en: "[66192]Corporate finance advisory services",
      },
      {
        value: "[66193]Clearing and settlement of financial instruments",
        zh: "[66193]Clearing and settlement of financial instruments / 金融工具的清算和结算",
        en: "[66193]Clearing and settlement of financial instruments",
      },
      {
        value: "[66194]Activities auxiliary to fund management activities (e.g. independent fund administration firms)",
        zh: "[66194]Activities auxiliary to fund management activities (e.g. independent fund administration firms) / 基金管理活动的辅助活动（例如独立的基金管理公司）",
        en: "[66194]Activities auxiliary to fund management activities (e.g. independent fund administration firms)",
      },
      {
        value: "[66195]Transaction/Payment processing services",
        zh: "[66195]Transaction/Payment processing services / 交易/支付处理服务",
        en: "[66195]Transaction/Payment processing services",
      },
      {
        value: "[66199]Other activities auxiliary to financial service activities n.e.c. (e.g. mortgage advisory firms)",
        zh: "[66199]Other activities auxiliary to financial service activities n.e.c. (e.g. mortgage advisory firms) / 其他辅助金融服务活动的活动（例如抵押贷款咨询公司）",
        en: "[66199]Other activities auxiliary to financial service activities n.e.c. (e.g. mortgage advisory firms)",
      },
      {
        value: "[66210]Risk and damage evaluation (e.g. loss adjusting, claims adjusting)",
        zh: "[66210]Risk and damage evaluation (e.g. loss adjusting, claims adjusting) / 风险和损害评估（例如损失调整、索赔调整）",
        en: "[66210]Risk and damage evaluation (e.g. loss adjusting, claims adjusting)",
      },
      {
        value: "[66221]Insurance agencies and agents (including financial planning services)",
        zh: "[66221]Insurance agencies and agents (including financial planning services) / 保险机构和代理人（包括财务规划服务）",
        en: "[66221]Insurance agencies and agents (including financial planning services)",
      },
      {
        value: "[66222]Insurance brokers",
        zh: "[66222]Insurance brokers / 保险经纪人",
        en: "[66222]Insurance brokers",
      },
      {
        value: "[66291]Representative offices of foreign insurers and professional reinsurers",
        zh: "[66291]Representative offices of foreign insurers and professional reinsurers / 外国保险公司和专业再保险公司代表处",
        en: "[66291]Representative offices of foreign insurers and professional reinsurers",
      },
      {
        value: "[66292]Captive managers",
        zh: "[66292]Captive managers / 专属经理人",
        en: "[66292]Captive managers",
      },
      {
        value: "[66299]Other activities auxiliary to insurance and pension funding n.e.c. (e.g. activities of actuaries)",
        zh: "[66299]Other activities auxiliary to insurance and pension funding n.e.c. (e.g. activities of actuaries) / 其他辅助保险和养老金基金的活动（例如精算师的活动）",
        en: "[66299]Other activities auxiliary to insurance and pension funding n.e.c. (e.g. activities of actuaries)",
      },
      {
        value: "[66301]Traditional/Long-only asset/Portfolio management",
        zh: "[66301]Traditional/Long-only asset/Portfolio management / 传统/只做多的资产/投资组合管理",
        en: "[66301]Traditional/Long-only asset/Portfolio management",
      },
      {
        value: "[66302]Hedge fund management",
        zh: "[66302]Hedge fund management / 对冲基金管理",
        en: "[66302]Hedge fund management",
      },
      {
        value: "[66303]Property fund management (including REIT management and direct property fund management)",
        zh: "[66303]Property fund management (including REIT management and direct property fund management) / 物业基金管理（包括REIT管理和直接物业基金管理）",
        en: "[66303]Property fund management (including REIT management and direct property fund management)",
      },
      {
        value: "[66304]Private equity firms",
        zh: "[66304]Private equity firms / 私募股权公司",
        en: "[66304]Private equity firms",
      },
      {
        value: "[66305]Venture capital activities",
        zh: "[66305]Venture capital activities / 风险投资活动",
        en: "[66305]Venture capital activities",
      },
      {
        value: "[66306]Single/Multiple family offices activities (e.g. managing investments and trusts for a single or multiple families)",
        zh: "[66306]Single/Multiple family offices activities (e.g. managing investments and trusts for a single or multiple families) / 单个/多个家族办公室活动（例如管理单个或多个家族的投资和信托）",
        en: "[66306]Single/Multiple family offices activities (e.g. managing investments and trusts for a single or multiple families)",
      },
      {
        value: "[66307]Private debt funds",
        zh: "[66307]Private debt funds / 私人债务基金",
        en: "[66307]Private debt funds",
      },
      {
        value: "[66309]Fund management activities n.e.c.",
        zh: "[66309]Fund management activities n.e.c. / 基金管理活动 ",
        en: "[66309]Fund management activities n.e.c.",
      },
      {
        value: "[68101]Real estate developers",
        zh: "[68101]Real estate developers / 房地产开发商",
        en: "[68101]Real estate developers",
      },
      {
        value: "[68102]Operating of serviced apartments",
        zh: "[68102]Operating of serviced apartments / 经营服务式公寓",
        en: "[68102]Operating of serviced apartments",
      },
      {
        value:
          "[68103]Letting of self-owned or leased real estate property except food courts, coffee shops and canteens (e.g. office/exhibition space, shopping mall, self-storage facilities)",
        zh: "[68103]Letting of self-owned or leased real estate property except food courts, coffee shops and canteens (e.g. office/exhibition space, shopping mall, self-storage facilities) / 出租自有或租赁不动产，不包括美食广场、咖啡厅和食堂（例如办公/展览空间、商场、自助仓储设施）",
        en: "[68103]Letting of self-owned or leased real estate property except food courts, coffee shops and canteens (e.g. office/exhibition space, shopping mall, self-storage facilities)",
      },
      {
        value: "[68104]Letting and operating of self-owned or leased food courts, coffee shops and canteens (with mainly rental income)",
        zh: "[68104]Letting and operating of self-owned or leased food courts, coffee shops and canteens (with mainly rental income) / 自有或租用美食广场、咖啡店、食堂的出租、经营（以租金收入为主）",
        en: "[68104]Letting and operating of self-owned or leased food courts, coffee shops and canteens (with mainly rental income)",
      },
      {
        value: "[68105]Collective portfolio investment funds with rental income",
        zh: "[68105]Collective portfolio investment funds with rental income / 具有租金收入的集体证券投资基金",
        en: "[68105]Collective portfolio investment funds with rental income",
      },
      {
        value: "[68106]Management of self-owned strata titled property (i.e. Management Corporation Strata Title)",
        zh: "[68106]Management of self-owned strata titled property (i.e. Management Corporation Strata Title) / 自有分层产权物业的管理（即管理公司分层产权）",
        en: "[68106]Management of self-owned strata titled property (i.e. Management Corporation Strata Title)",
      },
      {
        value: "[68201]Real estate agencies and valuation services",
        zh: "[68201]Real estate agencies and valuation services / 房地产代理和估价服务",
        en: "[68201]Real estate agencies and valuation services",
      },
      {
        value: "[68202]Town councils",
        zh: "[68202]Town councils / 镇议会",
        en: "[68202]Town councils",
      },
      {
        value: "[68203]Residential (other than town councils), commercial and industrial real estate management",
        zh: "[68203]Residential (other than town councils), commercial and industrial real estate management / 住宅（镇议会除外），商业和工业房地产管理",
        en: "[68203]Residential (other than town councils), commercial and industrial real estate management",
      },
      {
        value: "[68209]Real estate activities on a fee or commission basis n.e.c. (excluding online marketplaces)",
        zh: "[68209]Real estate activities on a fee or commission basis n.e.c. (excluding online marketplaces) / 收费或佣金的房地产活动（不包括在线市场）",
        en: "[68209]Real estate activities on a fee or commission basis n.e.c. (excluding online marketplaces)",
      },
      {
        value: "[69101]Legal activities (excluding online marketplaces)",
        zh: "[69101]Legal activities (excluding online marketplaces) / 法律活动（不包括在线市场）",
        en: "[69101]Legal activities (excluding online marketplaces)",
      },
      {
        value: "[69102]Arbitration and mediation services (excluding online marketplaces)",
        zh: "[69102]Arbitration and mediation services (excluding online marketplaces) / 仲裁和调解服务（不包括在线市场）",
        en: "[69102]Arbitration and mediation services (excluding online marketplaces)",
      },
      {
        value: "[69201]Accounting and auditing services (excluding online marketplaces)",
        zh: "[69201]Accounting and auditing services (excluding online marketplaces) / 会计和审计服务（不包括在线市场）",
        en: "[69201]Accounting and auditing services (excluding online marketplaces)",
      },
      {
        value: "[69202]Book-keeping services (excluding online marketplaces)",
        zh: "[69202]Book-keeping services (excluding online marketplaces) / 簿记服务（不包括在线市场）",
        en: "[69202]Book-keeping services (excluding online marketplaces)",
      },
      {
        value: "[70101]Activities of head and regional head offices; Centralised administrative offices and subsidiary management offices",
        zh: "[70101]Activities of head and regional head offices; Centralised administrative offices and subsidiary management offices / 总部和区域总部的活动；集中行政办公室和子公司管理办公室",
        en: "[70101]Activities of head and regional head offices; Centralised administrative offices and subsidiary management offices",
      },
      {
        value: "[70102]Business representative offices",
        zh: "[70102]Business representative offices / 业务代表处",
        en: "[70102]Business representative offices",
      },
      {
        value: "[70201]Management consultancy services",
        zh: "[70201]Management consultancy services / 管理咨询服务",
        en: "[70201]Management consultancy services",
      },
      {
        value: "[70202]Management consultancy services for healthcare organisations",
        zh: "[70202]Management consultancy services for healthcare organisations / 为医疗机构提供管理咨询服务",
        en: "[70202]Management consultancy services for healthcare organisations",
      },
      {
        value: "[70203]Management consultancy services for hotels",
        zh: "[70203]Management consultancy services for hotels / 酒店管理咨询服务",
        en: "[70203]Management consultancy services for hotels",
      },
      {
        value: "[70204]Human resource consultancy services",
        zh: "[70204]Human resource consultancy services / 人力资源咨询服务",
        en: "[70204]Human resource consultancy services",
      },
      {
        value: "[70205]Public relations, marketing and brand consultancy services",
        zh: "[70205]Public relations, marketing and brand consultancy services / 公共关系、营销和品牌咨询服务",
        en: "[70205]Public relations, marketing and brand consultancy services",
      },
      {
        value: "[70206]Port, shipping and maritime-related consultancy services",
        zh: "[70206]Port, shipping and maritime-related consultancy services / 港口、航运和海事相关咨询服务",
        en: "[70206]Port, shipping and maritime-related consultancy services",
      },
      {
        value: "[70209]Management consultancy services n.e.c.",
        zh: "[70209]Management consultancy services n.e.c. / 管理咨询服务 ",
        en: "[70209]Management consultancy services n.e.c.",
      },
      {
        value: "[71111]Architectural services",
        zh: "[71111]Architectural services / 建筑服务",
        en: "[71111]Architectural services",
      },
      {
        value: "[71112]Landscape design and landscape architecture",
        zh: "[71112]Landscape design and landscape architecture / 景观设计与景观建筑",
        en: "[71112]Landscape design and landscape architecture",
      },
      {
        value: "[71113]Quantity surveying services",
        zh: "[71113]Quantity surveying services / 工料测量服务",
        en: "[71113]Quantity surveying services",
      },
      {
        value: "[71114]Land surveying services",
        zh: "[71114]Land surveying services / 土地测量服务",
        en: "[71114]Land surveying services",
      },
      {
        value: "[71119]Other surveying services n.e.c. (e.g. geophysical, geologic, seismic, hydrographic surveying services)",
        zh: "[71119]Other surveying services n.e.c. (e.g. geophysical, geologic, seismic, hydrographic surveying services) / 其他测量服务（如地球物理、地质、地震、水文测量服务）",
        en: "[71119]Other surveying services n.e.c. (e.g. geophysical, geologic, seismic, hydrographic surveying services)",
      },
      {
        value: "[71121]General building engineering design and consultancy services",
        zh: "[71121]General building engineering design and consultancy services / 一般建筑工程设计和咨询服务",
        en: "[71121]General building engineering design and consultancy services",
      },
      {
        value: "[71122]Process and industrial plant engineering design and consultancy services",
        zh: "[71122]Process and industrial plant engineering design and consultancy services / 过程和工业设备工程设计和咨询服务",
        en: "[71122]Process and industrial plant engineering design and consultancy services",
      },
      {
        value: "[71123]Engineering design and consultancy services in energy management and clean energy systems",
        zh: "[71123]Engineering design and consultancy services in energy management and clean energy systems / 能源管理和清洁能源系统的工程设计和咨询服务",
        en: "[71123]Engineering design and consultancy services in energy management and clean energy systems",
      },
      {
        value: "[71124]Environmental engineering design and consultancy services (except clean energy)",
        zh: "[71124]Environmental engineering design and consultancy services (except clean energy) / 环境工程设计及咨询服务（清洁能源除外）",
        en: "[71124]Environmental engineering design and consultancy services (except clean energy)",
      },
      {
        value: "[71125]Infrastructure engineering design and consultancy services",
        zh: "[71125]Infrastructure engineering design and consultancy services / 基础设施工程设计和咨询服务",
        en: "[71125]Infrastructure engineering design and consultancy services",
      },
      {
        value: "[71126]Engineering design and consultancy services supporting mining, oil and gas extraction and offshore exploration activities",
        zh: "[71126]Engineering design and consultancy services supporting mining, oil and gas extraction and offshore exploration activities / 支持采矿、石油和天然气开采以及海上勘探活动的工程设计和咨询服务",
        en: "[71126]Engineering design and consultancy services supporting mining, oil and gas extraction and offshore exploration activities",
      },
      {
        value: "[71129]Engineering design and consultancy activities n.e.c.",
        zh: "[71129]Engineering design and consultancy activities n.e.c. / 工程设计和咨询活动 ",
        en: "[71129]Engineering design and consultancy activities n.e.c.",
      },
      {
        value: "[71200]Technical testing and analysis services (including certification of products and services)",
        zh: "[71200]Technical testing and analysis services (including certification of products and services) / 技术测试和分析服务（包括产品和服务的认证）",
        en: "[71200]Technical testing and analysis services (including certification of products and services)",
      },
      {
        value: "[72101]Research and experimental development on biotechnology (excluding medical science)",
        zh: "[72101]Research and experimental development on biotechnology (excluding medical science) / 生物技术研究和实验开发（不包括医学科学）",
        en: "[72101]Research and experimental development on biotechnology (excluding medical science)",
      },
      {
        value: "[72102]Research and experimental development on electronics (excluding medical science)",
        zh: "[72102]Research and experimental development on electronics (excluding medical science) / 电子学研究与实验发展（医学除外）",
        en: "[72102]Research and experimental development on electronics (excluding medical science)",
      },
      {
        value: "[72103]Research and experimental development on chemicals (excluding medical science)",
        zh: "[72103]Research and experimental development on chemicals (excluding medical science) / 化学品的研究和实验开发（不包括医学科学）",
        en: "[72103]Research and experimental development on chemicals (excluding medical science)",
      },
      {
        value: "[72104]Research and experimental development on engineering",
        zh: "[72104]Research and experimental development on engineering / 工程研究和实验开发",
        en: "[72104]Research and experimental development on engineering",
      },
      {
        value: "[72105]Research and experimental development on environment and clean technologies (excluding biotechnology)",
        zh: "[72105]Research and experimental development on environment and clean technologies (excluding biotechnology) / 环境和清洁技术（不包括生物技术）的研究和实验开发",
        en: "[72105]Research and experimental development on environment and clean technologies (excluding biotechnology)",
      },
      {
        value: "[72106]Research and experimental development on medical science",
        zh: "[72106]Research and experimental development on medical science / 医学科学的研究和实验发展",
        en: "[72106]Research and experimental development on medical science",
      },
      {
        value: "[72109]Research and experimental development on natural sciences n.e.c.",
        zh: "[72109]Research and experimental development on natural sciences n.e.c. / 自然科学  的研究和实验发展",
        en: "[72109]Research and experimental development on natural sciences n.e.c.",
      },
      {
        value: "[72200]Research and experimental development on social sciences and humanities",
        zh: "[72200]Research and experimental development on social sciences and humanities / 社会科学和人文学科的研究和实验发展",
        en: "[72200]Research and experimental development on social sciences and humanities",
      },
      {
        value: "[73100]Advertising activities",
        zh: "[73100]Advertising activities / 广告活动",
        en: "[73100]Advertising activities",
      },
      {
        value: "[73200]Market research and public opinion polling",
        zh: "[73200]Market research and public opinion polling / 市场调查和民意调查",
        en: "[73200]Market research and public opinion polling",
      },
      {
        value: "[74111]Electronics-related industrial design services",
        zh: "[74111]Electronics-related industrial design services / 电子相关工业设计服务",
        en: "[74111]Electronics-related industrial design services",
      },
      {
        value: "[74112]Transport-related industrial design services",
        zh: "[74112]Transport-related industrial design services / 与交通有关的工业设计服务",
        en: "[74112]Transport-related industrial design services",
      },
      {
        value: "[74113]Furniture design services",
        zh: "[74113]Furniture design services / 家具设计服务",
        en: "[74113]Furniture design services",
      },
      {
        value: "[74119]Industrial design activities n.e.c.",
        zh: "[74119]Industrial design activities n.e.c. / 工业设计活动 ",
        en: "[74119]Industrial design activities n.e.c.",
      },
      {
        value: "[74191]Interior design services",
        zh: "[74191]Interior design services / 室内设计服务",
        en: "[74191]Interior design services",
      },
      {
        value: "[74192]Art and graphic design services",
        zh: "[74192]Art and graphic design services / 艺术和平面设计服务",
        en: "[74192]Art and graphic design services",
      },
      {
        value: "[74193]Fashion (including accessories) design services",
        zh: "[74193]Fashion (including accessories) design services / 时装（包括配饰）设计服务",
        en: "[74193]Fashion (including accessories) design services",
      },
      {
        value: "[74194]Exhibition stand design services",
        zh: "[74194]Exhibition stand design services / 展台设计服务",
        en: "[74194]Exhibition stand design services",
      },
      {
        value: "[74199]Other specialised design activities n.e.c.",
        zh: "[74199]Other specialised design activities n.e.c. / 其他专业设计活动 ",
        en: "[74199]Other specialised design activities n.e.c.",
      },
      {
        value: "[74200]Photographic activities",
        zh: "[74200]Photographic activities / 摄影活动",
        en: "[74200]Photographic activities",
      },
      {
        value: "[74901]Translation services",
        zh: "[74901]Translation services / 翻译服务",
        en: "[74901]Translation services",
      },
      {
        value: "[74902]Brokerage and consultancy services of intellectual property assets",
        zh: "[74902]Brokerage and consultancy services of intellectual property assets / 知识产权资产经纪和咨询服务",
        en: "[74902]Brokerage and consultancy services of intellectual property assets",
      },
      {
        value: "[74903]Agrotechnology consultancy services",
        zh: "[74903]Agrotechnology consultancy services / 农业技术咨询服务",
        en: "[74903]Agrotechnology consultancy services",
      },
      {
        value: "[74904]Carbon consultancy services",
        zh: "[74904]Carbon consultancy services / 碳咨询服务",
        en: "[74904]Carbon consultancy services",
      },
      {
        value: "[74905]Agents for artistes, athletes, models and other performers",
        zh: "[74905]Agents for artistes, athletes, models and other performers / 艺人、运动员、模特和其他表演者的经纪人",
        en: "[74905]Agents for artistes, athletes, models and other performers",
      },
      {
        value: "[74909]Other professional, scientific and technical activities n.e.c.",
        zh: "[74909]Other professional, scientific and technical activities n.e.c. / 其他专业、科学和技术活动",
        en: "[74909]Other professional, scientific and technical activities n.e.c.",
      },
      {
        value: "[75000]Veterinary activities",
        zh: "[75000]Veterinary activities / 兽医活动",
        en: "[75000]Veterinary activities",
      },
      {
        value: "[77101]Renting and leasing of private cars without driver (excluding online marketplaces)",
        zh: "[77101]Renting and leasing of private cars without driver (excluding online marketplaces) / 无司机私家车租赁（不包括网络市场）",
        en: "[77101]Renting and leasing of private cars without driver (excluding online marketplaces)",
      },
      {
        value: "[77102]Renting and leasing of bicycles and inline/roller skates",
        zh: "[77102]Renting and leasing of bicycles and inline/roller skates / 出租和租赁自行车和直排轮/旱冰鞋",
        en: "[77102]Renting and leasing of bicycles and inline/roller skates",
      },
      {
        value: "[77109]Renting and leasing of land transport equipment (except cars) without driver n.e.c. (excluding online marketplaces)",
        zh: "[77109]Renting and leasing of land transport equipment (except cars) without driver n.e.c. (excluding online marketplaces) / 无需司机的陆路运输设备（汽车除外）租赁（不包括在线市场）",
        en: "[77109]Renting and leasing of land transport equipment (except cars) without driver n.e.c. (excluding online marketplaces)",
      },
      {
        value: "[77210]Renting and leasing of recreational and sports goods",
        zh: "[77210]Renting and leasing of recreational and sports goods / 娱乐和体育用品的出租和租赁",
        en: "[77210]Renting and leasing of recreational and sports goods",
      },
      {
        value: "[77220]Renting of VCDs and DVDs",
        zh: "[77220]Renting of VCDs and DVDs / 出租 VCD 和 DVD",
        en: "[77220]Renting of VCDs and DVDs",
      },
      {
        value: "[77291]Renting and leasing of furniture, utensils and electronic equipment for household use",
        zh: "[77291]Renting and leasing of furniture, utensils and electronic equipment for household use / 家庭用家具、器具和电子设备的出租和租赁",
        en: "[77291]Renting and leasing of furniture, utensils and electronic equipment for household use",
      },
      {
        value: "[77292]Renting of attire (e.g. costumes)",
        zh: "[77292]Renting of attire (e.g. costumes) / 服装租赁（如服装）",
        en: "[77292]Renting of attire (e.g. costumes)",
      },
      {
        value: "[77299]Renting and leasing of other personal and household goods n.e.c. (excluding online marketplaces)",
        zh: "[77299]Renting and leasing of other personal and household goods n.e.c. (excluding online marketplaces) / 其他个人和家庭用品的出租和租赁（不包括在线市场）",
        en: "[77299]Renting and leasing of other personal and household goods n.e.c. (excluding online marketplaces)",
      },
      {
        value: "[77310]Renting of water transport equipment without operator (e.g. commercial boats and ships without operator)",
        zh: "[77310]Renting of water transport equipment without operator (e.g. commercial boats and ships without operator) / 租用没有操作员的水上运输设备（例如没有操作员的商船和船舶）",
        en: "[77310]Renting of water transport equipment without operator (e.g. commercial boats and ships without operator)",
      },
      {
        value: "[77320]Renting of air transport equipment without operator (e.g. airplanes without operator)",
        zh: "[77320]Renting of air transport equipment without operator (e.g. airplanes without operator) / 租用没有操作员的航空运输设备（例如没有操作员的飞机）",
        en: "[77320]Renting of air transport equipment without operator (e.g. airplanes without operator)",
      },
      {
        value: "[77330]Renting of construction and civil engineering machinery and equipment",
        zh: "[77330]Renting of construction and civil engineering machinery and equipment / 建筑和土木工程机械设备的租赁",
        en: "[77330]Renting of construction and civil engineering machinery and equipment",
      },
      {
        value: "[77341]Renting of computers and peripheral equipment",
        zh: "[77341]Renting of computers and peripheral equipment / 租用电脑及周边设备",
        en: "[77341]Renting of computers and peripheral equipment",
      },
      {
        value: "[77342]Renting of office machinery and equipment",
        zh: "[77342]Renting of office machinery and equipment / 办公机械设备租赁",
        en: "[77342]Renting of office machinery and equipment",
      },
      {
        value: "[77391]Renting and leasing of professional radio and television sets and sound reproducing and recording equipment",
        zh: "[77391]Renting and leasing of professional radio and television sets and sound reproducing and recording equipment / 专业广播电视设备及放音、录音设备的出租、租赁",
        en: "[77391]Renting and leasing of professional radio and television sets and sound reproducing and recording equipment",
      },
      {
        value: "[77392]Renting of industrial machinery and equipment",
        zh: "[77392]Renting of industrial machinery and equipment / 工业机械设备租赁",
        en: "[77392]Renting of industrial machinery and equipment",
      },
      {
        value: "[77399]Renting of other machinery, equipment and tangible goods n.e.c. (excluding online marketplaces)",
        zh: "[77399]Renting of other machinery, equipment and tangible goods n.e.c. (excluding online marketplaces) / 其他机器、设备和有形商品的租赁（不包括在线市场）",
        en: "[77399]Renting of other machinery, equipment and tangible goods n.e.c. (excluding online marketplaces)",
      },
      {
        value: "[77400]Leasing of non-financial intangible assets (e.g. patents, trade marks, brand names etc)",
        zh: "[77400]Leasing of non-financial intangible assets (e.g. patents, trade marks, brand names etc) / 租赁非金融无形资产（如专利、商标、品牌等）",
        en: "[77400]Leasing of non-financial intangible assets (e.g. patents, trade marks, brand names etc)",
      },
      {
        value: "[78101]IT manpower contracting services",
        zh: "[78101]IT manpower contracting services / IT人力承包服务",
        en: "[78101]IT manpower contracting services",
      },
      {
        value: "[78102]Manpower contracting services (excluding IT manpower)",
        zh: "[78102]Manpower contracting services (excluding IT manpower) / 人力承包服务（不包括 IT 人力）",
        en: "[78102]Manpower contracting services (excluding IT manpower)",
      },
      {
        value: "[78103]Domestic worker employment placement agencies (excluding online marketplaces)",
        zh: "[78103]Domestic worker employment placement agencies (excluding online marketplaces) / 家庭工人就业安置机构（不包括在线市场）",
        en: "[78103]Domestic worker employment placement agencies (excluding online marketplaces)",
      },
      {
        value: "[78104]Employment agencies (excluding domestic worker employment placement agencies and online marketplaces)",
        zh: "[78104]Employment agencies (excluding domestic worker employment placement agencies and online marketplaces) / 就业机构（不包括家庭工人就业安置机构和在线市场）",
        en: "[78104]Employment agencies (excluding domestic worker employment placement agencies and online marketplaces)",
      },
      {
        value: "[78300]Management of human resource functions",
        zh: "[78300]Management of human resource functions / 人力资源职能管理",
        en: "[78300]Management of human resource functions",
      },
      {
        value: "[79101]Travel agencies and tour operators (mainly inbound)",
        zh: "[79101]Travel agencies and tour operators (mainly inbound) / 旅行社和旅行社（主要是入境）",
        en: "[79101]Travel agencies and tour operators (mainly inbound)",
      },
      {
        value: "[79102]Travel agencies and tour operators (mainly outbound)",
        zh: "[79102]Travel agencies and tour operators (mainly outbound) / 旅行社和旅行社（主要是出境）",
        en: "[79102]Travel agencies and tour operators (mainly outbound)",
      },
      {
        value: "[79200]Timesharing service activities",
        zh: "[79200]Timesharing service activities / 分时服务活动",
        en: "[79200]Timesharing service activities",
      },
      {
        value: "[80100]Private security activities",
        zh: "[80100]Private security activities / 私人保安活动",
        en: "[80100]Private security activities",
      },
      {
        value: "[80200]Detective and investigation activities",
        zh: "[80200]Detective and investigation activities / 侦探和调查活动",
        en: "[80200]Detective and investigation activities",
      },
      {
        value: "[81211]General cleaning services (including cleaning of public areas, offices and factories) except household cleaning and online marketplaces",
        zh: "[81211]General cleaning services (including cleaning of public areas, offices and factories) except household cleaning and online marketplaces / 一般清洁服务（包括公共区域、办公室和工厂的清洁），家庭清洁和在线市场除外",
        en: "[81211]General cleaning services (including cleaning of public areas, offices and factories) except household cleaning and online marketplaces",
      },
      {
        value: "[81212]Domestic/Household cleaning services (excluding online marketplaces)",
        zh: "[81212]Domestic/Household cleaning services (excluding online marketplaces) / 家庭/家居清洁服务（不包括在线市场）",
        en: "[81212]Domestic/Household cleaning services (excluding online marketplaces)",
      },
      {
        value: "[81291]Pest control services not in connection with agriculture",
        zh: "[81291]Pest control services not in connection with agriculture / 与农业无关的害虫防治服务",
        en: "[81291]Pest control services not in connection with agriculture",
      },
      {
        value: "[81292]Cleaning of swimming pools, spas and fountains",
        zh: "[81292]Cleaning of swimming pools, spas and fountains / 游泳池、水疗中心和喷泉的清洁",
        en: "[81292]Cleaning of swimming pools, spas and fountains",
      },
      {
        value: "[81299]Other cleaning services n.e.c. (excluding online marketplaces)",
        zh: "[81299]Other cleaning services n.e.c. (excluding online marketplaces) / 其他清洁服务（不包括在线市场）",
        en: "[81299]Other cleaning services n.e.c. (excluding online marketplaces)",
      },
      {
        value: "[81300]Landscape planting, care and maintenance service activities (e.g. garden installation and maintenance, grass cutting, tree felling, pruning)",
        zh: "[81300]Landscape planting, care and maintenance service activities (e.g. garden installation and maintenance, grass cutting, tree felling, pruning) / 景观种植、护理和维护服务活动（例如花园安装和维护、割草、砍伐树木、修剪）",
        en: "[81300]Landscape planting, care and maintenance service activities (e.g. garden installation and maintenance, grass cutting, tree felling, pruning)",
      },
      {
        value: "[82110]Office administrative services on a fee or contract basis (e.g. billing and record keeping)",
        zh: "[82110]Office administrative services on a fee or contract basis (e.g. billing and record keeping) / 以收费或合同为基础的办公室行政服务（例如计费和记录保存）",
        en: "[82110]Office administrative services on a fee or contract basis (e.g. billing and record keeping)",
      },
      {
        value: "[82191]Stenographic and secretarial services",
        zh: "[82191]Stenographic and secretarial services / 速记和秘书服务",
        en: "[82191]Stenographic and secretarial services",
      },
      {
        value: "[82192]Duplicating and photo-copying services",
        zh: "[82192]Duplicating and photo-copying services / 复印和影印服务",
        en: "[82192]Duplicating and photo-copying services",
      },
      {
        value: "[82199]Other specialised office support activities n.e.c.",
        zh: "[82199]Other specialised office support activities n.e.c. / 其他专门的办公室支持活动 ",
        en: "[82199]Other specialised office support activities n.e.c.",
      },
      {
        value: "[82200]Call centres",
        zh: "[82200]Call centres / 呼叫中心",
        en: "[82200]Call centres",
      },
      {
        value: "[82301]Exhibition organisers",
        zh: "[82301]Exhibition organisers / 展会主办方",
        en: "[82301]Exhibition organisers",
      },
      {
        value: "[82302]Convention/Conference organisers",
        zh: "[82302]Convention/Conference organisers / 大会/会议组织者",
        en: "[82302]Convention/Conference organisers",
      },
      {
        value: "[82303]Event/Concert organisers",
        zh: "[82303]Event/Concert organisers / 活动/音乐会组织者",
        en: "[82303]Event/Concert organisers",
      },
      {
        value: "[82304]Exhibition stand contractors",
        zh: "[82304]Exhibition stand contractors / 展台承建商",
        en: "[82304]Exhibition stand contractors",
      },
      {
        value: "[82911]Debt collection services",
        zh: "[82911]Debt collection services / 收债服务",
        en: "[82911]Debt collection services",
      },
      {
        value: "[82912]Credit rating agencies",
        zh: "[82912]Credit rating agencies / 信用评级机构",
        en: "[82912]Credit rating agencies",
      },
      {
        value: "[82920]Packaging activities",
        zh: "[82920]Packaging activities / 包装活动",
        en: "[82920]Packaging activities",
      },
      {
        value: "[82991]Activities of auction houses",
        zh: "[82991]Activities of auction houses / 拍卖行的活动",
        en: "[82991]Activities of auction houses",
      },
      {
        value: "[82999]Other business support service activities (e.g. administration of loyalty programmes)",
        zh: "[82999]Other business support service activities (e.g. administration of loyalty programmes) / 其他业务支持服务活动（例如忠诚度计划的管理）",
        en: "[82999]Other business support service activities (e.g. administration of loyalty programmes)",
      },
      {
        value: "[84110]Executive, legislative and other general public administration (e.g. Istana, parliament, tax authority)",
        zh: "[84110]Executive, legislative and other general public administration (e.g. Istana, parliament, tax authority) / 行政、立法和其他一般公共行政（如总统府、议会、税务机关）",
        en: "[84110]Executive, legislative and other general public administration (e.g. Istana, parliament, tax authority)",
      },
      {
        value: "[84120]Public administration of economic and social programmes",
        zh: "[84120]Public administration of economic and social programmes / 经济和社会计划的公共行政",
        en: "[84120]Public administration of economic and social programmes",
      },
      {
        value: "[84210]Foreign affairs",
        zh: "[84210]Foreign affairs / 外交事务",
        en: "[84210]Foreign affairs",
      },
      {
        value: "[84221]Armed forces",
        zh: "[84221]Armed forces / 武装部队",
        en: "[84221]Armed forces",
      },
      {
        value: "[84229]Defence activities n.e.c.",
        zh: "[84229]Defence activities n.e.c. / 国防活动 ",
        en: "[84229]Defence activities n.e.c.",
      },
      {
        value: "[84231]Judiciary and related services",
        zh: "[84231]Judiciary and related services / 司法及相关服务",
        en: "[84231]Judiciary and related services",
      },
      {
        value: "[84232]Police",
        zh: "[84232]Police / 警察",
        en: "[84232]Police",
      },
      {
        value: "[84233]Prisons",
        zh: "[84233]Prisons / 监狱",
        en: "[84233]Prisons",
      },
      {
        value: "[84234]Other places of detention, correction and rehabilitation",
        zh: "[84234]Other places of detention, correction and rehabilitation / 其他拘留、矫正和改造场所",
        en: "[84234]Other places of detention, correction and rehabilitation",
      },
      {
        value: "[84235]Civil defence",
        zh: "[84235]Civil defence / 民防",
        en: "[84235]Civil defence",
      },
      {
        value: "[84239]Public order and safety activities n.e.c.",
        zh: "[84239]Public order and safety activities n.e.c. / 公共秩序和安全活动 ",
        en: "[84239]Public order and safety activities n.e.c.",
      },
      {
        value: "[85101]Nurseries and kindergartens",
        zh: "[85101]Nurseries and kindergartens / 托儿所和幼儿园",
        en: "[85101]Nurseries and kindergartens",
      },
      {
        value: "[85102]Primary schools",
        zh: "[85102]Primary schools / 小学",
        en: "[85102]Primary schools",
      },
      {
        value: "[85211]Secondary schools including combined primary and secondary schools",
        zh: "[85211]Secondary schools including combined primary and secondary schools / 中学包括中小学联合",
        en: "[85211]Secondary schools including combined primary and secondary schools",
      },
      {
        value:
          "[85212]Junior colleges and centralised pre-university institutes (post-secondary non-tertiary) including combined secondary schools and post-secondary non-tertiary schools",
        zh: "[85212]Junior colleges and centralised pre-university institutes (post-secondary non-tertiary) including combined secondary schools and post-secondary non-tertiary schools / 初级学院和集中的大学预科机构（专上非高等教育），包括联合中学和专上非高等教育学校",
        en: "[85212]Junior colleges and centralised pre-university institutes (post-secondary non-tertiary) including combined secondary schools and post-secondary non-tertiary schools",
      },
      {
        value: "[85213]Commercial schools offering general secondary and post-secondary non-tertiary education programmes",
        zh: "[85213]Commercial schools offering general secondary and post-secondary non-tertiary education programmes / 提供普通中学和中学后非高等教育课程的商业学校",
        en: "[85213]Commercial schools offering general secondary and post-secondary non-tertiary education programmes",
      },
      {
        value: "[85220]Technical and vocational secondary and post-secondary non-tertiary education",
        zh: "[85220]Technical and vocational secondary and post-secondary non-tertiary education / 技术和职业中等教育和专上非高等教育",
        en: "[85220]Technical and vocational secondary and post-secondary non-tertiary education",
      },
      {
        value: "[85230]International and foreign system schools",
        zh: "[85230]International and foreign system schools / 国际和国外系统学校",
        en: "[85230]International and foreign system schools",
      },
      {
        value: "[85240]Schools for special needs",
        zh: "[85240]Schools for special needs / 特殊需要学校",
        en: "[85240]Schools for special needs",
      },
      {
        value: "[85250]Specialised education schools",
        zh: "[85250]Specialised education schools / 专业教育学校",
        en: "[85250]Specialised education schools",
      },
      {
        value: "[85301]Polytechnics",
        zh: "[85301]Polytechnics / 理工学院",
        en: "[85301]Polytechnics",
      },
      {
        value: "[85302]Universities",
        zh: "[85302]Universities / 大学",
        en: "[85302]Universities",
      },
      {
        value: "[85303]Teachers' training institute",
        zh: "[85303]Teachers' training institute / 师资培训机构",
        en: "[85303]Teachers' training institute",
      },
      {
        value: "[85304]Commercial schools offering higher education programmes",
        zh: "[85304]Commercial schools offering higher education programmes / 提供高等教育课程的商业学校",
        en: "[85304]Commercial schools offering higher education programmes",
      },
      {
        value: "[85401]Training courses for construction, real estate, security and investigation services, cleaning, landscaping, waste management and pest management",
        zh: "[85401]Training courses for construction, real estate, security and investigation services, cleaning, landscaping, waste management and pest management / 建筑、房地产、安全和调查服务、清洁、景观美化、废物管理和害虫管理的培训课程",
        en: "[85401]Training courses for construction, real estate, security and investigation services, cleaning, landscaping, waste management and pest management",
      },
      {
        value: "[85402]Training courses for healthcare, education, community and social services",
        zh: "[85402]Training courses for healthcare, education, community and social services / 医疗保健、教育、社区和社会服务培训课程",
        en: "[85402]Training courses for healthcare, education, community and social services",
      },
      {
        value: "[85403]Training courses for food and beverage, retail and accommodation, tour operators, travel agencies & travel-related reservation services",
        zh: "[85403]Training courses for food and beverage, retail and accommodation, tour operators, travel agencies & travel-related reservation services / 餐饮、零售和住宿、旅游经营者、旅行社和旅游相关预订服务的培训课程",
        en: "[85403]Training courses for food and beverage, retail and accommodation, tour operators, travel agencies & travel-related reservation services",
      },
      {
        value: "[85404]Training courses for manufacturing",
        zh: "[85404]Training courses for manufacturing / 制造业培训课程",
        en: "[85404]Training courses for manufacturing",
      },
      {
        value: "[85405]Training courses for information and communications, finance and professional services",
        zh: "[85405]Training courses for information and communications, finance and professional services / 信息和通信、金融和专业服务培训课程",
        en: "[85405]Training courses for information and communications, finance and professional services",
      },
      {
        value: "[85406]Training courses for wholesale trade, logistics and transport",
        zh: "[85406]Training courses for wholesale trade, logistics and transport / 批发贸易、物流和运输培训课程",
        en: "[85406]Training courses for wholesale trade, logistics and transport",
      },
      {
        value: "[85407]Training courses for sports and games",
        zh: "[85407]Training courses for sports and games / 体育和游戏培训课程",
        en: "[85407]Training courses for sports and games",
      },
      {
        value: "[85408]Training courses for music, dancing, art, speech and drama",
        zh: "[85408]Training courses for music, dancing, art, speech and drama / 音乐、舞蹈、艺术、演讲和戏剧培训课程",
        en: "[85408]Training courses for music, dancing, art, speech and drama",
      },
      {
        value: "[85409]Training courses n.e.c.",
        zh: "[85409]Training courses n.e.c. / 培训课程 ",
        en: "[85409]Training courses n.e.c.",
      },
      {
        value: "[85501]Student recruitment agencies",
        zh: "[85501]Student recruitment agencies / 招生机构",
        en: "[85501]Student recruitment agencies",
      },
      {
        value: "[85502]Examination and accreditation agencies for education services",
        zh: "[85502]Examination and accreditation agencies for education services / 教育服务考试认证机构",
        en: "[85502]Examination and accreditation agencies for education services",
      },
      {
        value: "[85509]Educational support services n.e.c. (excluding online marketplaces)",
        zh: "[85509]Educational support services n.e.c. (excluding online marketplaces) / 教育支持服务 （不包括在线市场）",
        en: "[85509]Educational support services n.e.c. (excluding online marketplaces)",
      },
      {
        value: "[86101]Acute hospitals",
        zh: "[86101]Acute hospitals / 急症医院",
        en: "[86101]Acute hospitals",
      },
      {
        value: "[86102]Community hospitals",
        zh: "[86102]Community hospitals / 社区医院",
        en: "[86102]Community hospitals",
      },
      {
        value: "[86109]Other hospitals n.e.c. (e.g. psychiatric hospital)",
        zh: "[86109]Other hospitals n.e.c. (e.g. psychiatric hospital) / 其他医院（如精神病院）",
        en: "[86109]Other hospitals n.e.c. (e.g. psychiatric hospital)",
      },
      {
        value: "[86201]Clinics and other general medical services (Western)",
        zh: "[86201]Clinics and other general medical services (Western) / 诊所和其他一般医疗服务（西方）",
        en: "[86201]Clinics and other general medical services (Western)",
      },
      {
        value: "[86202]Clinics and other general medical services (Non-Western)",
        zh: "[86202]Clinics and other general medical services (Non-Western) / 诊所和其他一般医疗服务（非西方）",
        en: "[86202]Clinics and other general medical services (Non-Western)",
      },
      {
        value: "[86203]Specialised medical services (including day surgical centres)",
        zh: "[86203]Specialised medical services (including day surgical centres) / 专业医疗服务（包括日间手术中心）",
        en: "[86203]Specialised medical services (including day surgical centres)",
      },
      {
        value: "[86204]Dental services",
        zh: "[86204]Dental services / 牙科服务",
        en: "[86204]Dental services",
      },
      {
        value: "[86901]Medical laboratories (e.g. blood analysis laboratories)",
        zh: "[86901]Medical laboratories (e.g. blood analysis laboratories) / 医学实验室（例如血液分析实验室）",
        en: "[86901]Medical laboratories (e.g. blood analysis laboratories)",
      },
      {
        value: "[86902]Medical diagnostic imaging centres (e.g. X-ray services)",
        zh: "[86902]Medical diagnostic imaging centres (e.g. X-ray services) / 医学诊断成像中心（例如 X 射线服务）",
        en: "[86902]Medical diagnostic imaging centres (e.g. X-ray services)",
      },
      {
        value: "[86903]Ambulance and medical evacuation services",
        zh: "[86903]Ambulance and medical evacuation services / 救护车和医疗后送服务",
        en: "[86903]Ambulance and medical evacuation services",
      },
      {
        value: "[86904]Home healthcare services",
        zh: "[86904]Home healthcare services / 家庭保健服务",
        en: "[86904]Home healthcare services",
      },
      {
        value: "[86905]Dialysis services",
        zh: "[86905]Dialysis services / 透析服务",
        en: "[86905]Dialysis services",
      },
      {
        value: "[86909]Other health services n.e.c. (excluding online marketplaces)",
        zh: "[86909]Other health services n.e.c. (excluding online marketplaces) / 其他健康服务（不包括在线市场）",
        en: "[86909]Other health services n.e.c. (excluding online marketplaces)",
      },
      {
        value: "[87010]Nursing and personal care facilities (including nursing homes and hospices)",
        zh: "[87010]Nursing and personal care facilities (including nursing homes and hospices) / 护理和个人护理设施（包括疗养院和收容所）",
        en: "[87010]Nursing and personal care facilities (including nursing homes and hospices)",
      },
      {
        value: "[87021]Residential care services for the elderly (e.g. home for the aged)",
        zh: "[87021]Residential care services for the elderly (e.g. home for the aged) / 安老院舍服务（例如安老院）",
        en: "[87021]Residential care services for the elderly (e.g. home for the aged)",
      },
      {
        value: "[87022]Residential care services for children (e.g. children's homes, orphanages)",
        zh: "[87022]Residential care services for children (e.g. children's homes, orphanages) / 儿童住宿照顾服务（例如儿童之家、孤儿院）",
        en: "[87022]Residential care services for children (e.g. children's homes, orphanages)",
      },
      {
        value: "[87029]Other residential care services n.e.c.",
        zh: "[87029]Other residential care services n.e.c. / 其他住宿照顾服务 ",
        en: "[87029]Other residential care services n.e.c.",
      },
      {
        value: "[88101]Social services for the elderly (e.g. befriender services, meal services, drop-in centres)",
        zh: "[88101]Social services for the elderly (e.g. befriender services, meal services, drop-in centres) / 老年人的社会服务（例如，朋友服务、膳食服务、临时中心）",
        en: "[88101]Social services for the elderly (e.g. befriender services, meal services, drop-in centres)",
      },
      {
        value: "[88102]Social services for persons with disabilities (e.g. day activity centres for people with disabilities)",
        zh: "[88102]Social services for persons with disabilities (e.g. day activity centres for people with disabilities) / 残疾人社会服务（例如残疾人日间活动中心）",
        en: "[88102]Social services for persons with disabilities (e.g. day activity centres for people with disabilities)",
      },
      {
        value: "[88911]Child care services for pre-school children (including infant care services)",
        zh: "[88911]Child care services for pre-school children (including infant care services) / 学龄前儿童保育服务（包括婴儿保育服务）",
        en: "[88911]Child care services for pre-school children (including infant care services)",
      },
      {
        value: "[88912]Child/Student care services for school-going children (e.g. before and after-school care centres, student care centres)",
        zh: "[88912]Child/Student care services for school-going children (e.g. before and after-school care centres, student care centres) / 为在校儿童提供的儿童/学生托管服务（例如，课前和课后托管中心、学生托管中心）",
        en: "[88912]Child/Student care services for school-going children (e.g. before and after-school care centres, student care centres)",
      },
      {
        value: "[88913]Social services for children and youths (e.g. youth outreach services, adoption services)",
        zh: "[88913]Social services for children and youths (e.g. youth outreach services, adoption services) / 面向儿童和青少年的社会服务（例如青少年外展服务、收养服务）",
        en: "[88913]Social services for children and youths (e.g. youth outreach services, adoption services)",
      },
      {
        value: "[88919]Social services without accommodation for children, youth and families n.e.c.",
        zh: "[88919]Social services without accommodation for children, youth and families n.e.c. / 不为儿童、青少年和家庭提供住宿的社会服务",
        en: "[88919]Social services without accommodation for children, youth and families n.e.c.",
      },
      {
        value: "[88920]Community development councils and grassroots organisations",
        zh: "[88920]Community development councils and grassroots organisations / 社区发展委员会和基层组织",
        en: "[88920]Community development councils and grassroots organisations",
      },
      {
        value: "[88991]Job training and vocational rehabilitation services",
        zh: "[88991]Job training and vocational rehabilitation services / 职业培训和职业康复服务",
        en: "[88991]Job training and vocational rehabilitation services",
      },
      {
        value: "[88992]Charitable and other supporting activities aimed at humanitarian work",
        zh: "[88992]Charitable and other supporting activities aimed at humanitarian work / 针对人道主义工作的慈善和其他支持活动",
        en: "[88992]Charitable and other supporting activities aimed at humanitarian work",
      },
      {
        value: "[88999]Other social services without accommodation n.e.c.",
        zh: "[88999]Other social services without accommodation n.e.c. / 其他无需住宿的社会服务",
        en: "[88999]Other social services without accommodation n.e.c.",
      },
      {
        value: "[90001]Production of live stage presentations",
        zh: "[90001]Production of live stage presentations / 现场舞台演示的制作",
        en: "[90001]Production of live stage presentations",
      },
      {
        value: "[90002]Performing arts venue operation",
        zh: "[90002]Performing arts venue operation / 演艺场馆运营",
        en: "[90002]Performing arts venue operation",
      },
      {
        value: "[90003]Orchestras, musical bands, choirs and dance groups",
        zh: "[90003]Orchestras, musical bands, choirs and dance groups / 管弦乐队、乐队、合唱团和舞蹈团",
        en: "[90003]Orchestras, musical bands, choirs and dance groups",
      },
      {
        value: "[90009]Dramatic arts, music and other arts production-related activities n.e.c. (e.g. stage, lighting and sound services)",
        zh: "[90009]Dramatic arts, music and other arts production-related activities n.e.c. (e.g. stage, lighting and sound services) / 戏剧艺术、音乐和其他与艺术制作相关的活动（例如舞台、灯光和音响服务）",
        en: "[90009]Dramatic arts, music and other arts production-related activities n.e.c. (e.g. stage, lighting and sound services)",
      },
      {
        value: "[91010]Libraries and archives activities",
        zh: "[91010]Libraries and archives activities / 图书馆和档案馆活动",
        en: "[91010]Libraries and archives activities",
      },
      {
        value: "[91021]Museums",
        zh: "[91021]Museums / 博物馆",
        en: "[91021]Museums",
      },
      {
        value: "[91029]Preservation of historical sites, buildings, artefacts and paintings, cultural villages and other related activities n.e.c.",
        zh: "[91029]Preservation of historical sites, buildings, artefacts and paintings, cultural villages and other related activities n.e.c. / 历史遗迹、建筑、手工艺品和绘画、文化村落和其他相关活动的保护",
        en: "[91029]Preservation of historical sites, buildings, artefacts and paintings, cultural villages and other related activities n.e.c.",
      },
      {
        value: "[91030]Botanical and zoological gardens and nature reserves activities",
        zh: "[91030]Botanical and zoological gardens and nature reserves activities / 植物园、动物园和自然保护区活动",
        en: "[91030]Botanical and zoological gardens and nature reserves activities",
      },
      {
        value: "[92001]Horse-racing and other betting activities",
        zh: "[92001]Horse-racing and other betting activities / 赛马和其他博彩活动",
        en: "[92001]Horse-racing and other betting activities",
      },
      {
        value: "[92002]Casinos",
        zh: "[92002]Casinos / 赌场",
        en: "[92002]Casinos",
      },
      {
        value: "[93111]Fitness centres and gymnasiums",
        zh: "[93111]Fitness centres and gymnasiums / 健身中心和体育馆",
        en: "[93111]Fitness centres and gymnasiums",
      },
      {
        value: "[93119]Operation of sports facilities n.e.c. (e.g. bowling alleys, tennis centres, billiard halls, football stadium)",
        zh: "[93119]Operation of sports facilities n.e.c. (e.g. bowling alleys, tennis centres, billiard halls, football stadium) / 其他体育设施的运营（例如保龄球馆、网球中心、台球厅、足球场）",
        en: "[93119]Operation of sports facilities n.e.c. (e.g. bowling alleys, tennis centres, billiard halls, football stadium)",
      },
      {
        value: "[93120]Activities of sports clubs/associations and related activities",
        zh: "[93120]Activities of sports clubs/associations and related activities / 体育俱乐部/协会的活动及相关活动",
        en: "[93120]Activities of sports clubs/associations and related activities",
      },
      {
        value: "[93201]Amusement theme parks",
        zh: "[93201]Amusement theme parks / 游乐园",
        en: "[93201]Amusement theme parks",
      },
      {
        value: "[93202]Game arcade, online game aggregator, LAN game operators and gaming centres",
        zh: "[93202]Game arcade, online game aggregator, LAN game operators and gaming centres / 游戏街机、在线游戏聚合器、局域网游戏运营商和游戏中心",
        en: "[93202]Game arcade, online game aggregator, LAN game operators and gaming centres",
      },
      {
        value: "[93203]Night clubs, discotheques, dance clubs and karaoke lounges",
        zh: "[93203]Night clubs, discotheques, dance clubs and karaoke lounges / 夜总会、迪斯科舞厅、舞厅和卡拉 OK 厅",
        en: "[93203]Night clubs, discotheques, dance clubs and karaoke lounges",
      },
      {
        value: "[93204]Recreation clubs (including country clubs)",
        zh: "[93204]Recreation clubs (including country clubs) / 休闲俱乐部（包括乡村俱乐部）",
        en: "[93204]Recreation clubs (including country clubs)",
      },
      {
        value: "[93209]Other amusement and recreation activities n.e.c. (including recreation parks/beaches and recreational fishing)",
        zh: "[93209]Other amusement and recreation activities n.e.c. (including recreation parks/beaches and recreational fishing) / 其他娱乐和休闲活动（包括休闲公园/海滩和休闲钓鱼）",
        en: "[93209]Other amusement and recreation activities n.e.c. (including recreation parks/beaches and recreational fishing)",
      },
      {
        value: "[94110]Activities of business and employers' membership organisations",
        zh: "[94110]Activities of business and employers' membership organisations / 企业和雇主会员组织的活动",
        en: "[94110]Activities of business and employers' membership organisations",
      },
      {
        value: "[94120]Activities of professional membership organisations (e.g. medical associations, law societies, accountancy bodies)",
        zh: "[94120]Activities of professional membership organisations (e.g. medical associations, law societies, accountancy bodies) / 专业会员组织的活动（例如医学协会、法律协会、会计机构）",
        en: "[94120]Activities of professional membership organisations (e.g. medical associations, law societies, accountancy bodies)",
      },
      {
        value: "[94200]Activities of trade unions",
        zh: "[94200]Activities of trade unions / 工会活动",
        en: "[94200]Activities of trade unions",
      },
      {
        value: "[94911]Churches",
        zh: "[94911]Churches / 教堂",
        en: "[94911]Churches",
      },
      {
        value: "[94912]Mosques",
        zh: "[94912]Mosques / 清真寺",
        en: "[94912]Mosques",
      },
      {
        value: "[94913]Buddhist/Taoist temples",
        zh: "[94913]Buddhist/Taoist temples / 佛教/道教寺庙",
        en: "[94913]Buddhist/Taoist temples",
      },
      {
        value: "[94914]Hindu/Sikh temples",
        zh: "[94914]Hindu/Sikh temples / 印度教/锡克教寺庙",
        en: "[94914]Hindu/Sikh temples",
      },
      {
        value: "[94919]Activities of religious organisations n.e.c.",
        zh: "[94919]Activities of religious organisations n.e.c. / 宗教组织的活动 ",
        en: "[94919]Activities of religious organisations n.e.c.",
      },
      {
        value: "[94920]Activities of political organisations",
        zh: "[94920]Activities of political organisations / 政治组织的活动",
        en: "[94920]Activities of political organisations",
      },
      {
        value: "[94991]Philanthropic trusts, foundations and related activities",
        zh: "[94991]Philanthropic trusts, foundations and related activities / 慈善信托、基金会和相关活动",
        en: "[94991]Philanthropic trusts, foundations and related activities",
      },
      {
        value: "[94992]Ethnic associations (including clan associations, huay kuans)",
        zh: "[94992]Ethnic associations (including clan associations, huay kuans) / 族群（包括宗亲会、会馆）",
        en: "[94992]Ethnic associations (including clan associations, huay kuans)",
      },
      {
        value:
          "[94993]Associations for hobbies, recreational, cultural and extra-curricular activities (e.g. scouts/girl guides association, book clubs and photo, music, art and craft clubs)",
        zh: "[94993]Associations for hobbies, recreational, cultural and extra-curricular activities (e.g. scouts/girl guides association, book clubs and photo, music, art and craft clubs) / 爱好、娱乐、文化和课外活动协会（例如童子军/女童军协会、读书俱乐部和摄影、音乐、艺术和工艺俱乐部）",
        en: "[94993]Associations for hobbies, recreational, cultural and extra-curricular activities (e.g. scouts/girl guides association, book clubs and photo, music, art and craft clubs)",
      },
      {
        value: "[94994]Student/Alumni bodies and related associations (e.g. parent-teacher associations, old boys' associations)",
        zh: "[94994]Student/Alumni bodies and related associations (e.g. parent-teacher associations, old boys' associations) / 学生/校友团体和相关协会（例如家长教师协会、老男孩协会）",
        en: "[94994]Student/Alumni bodies and related associations (e.g. parent-teacher associations, old boys' associations)",
      },
      {
        value: "[94995]Organisations for the protection of the environment and animals",
        zh: "[94995]Organisations for the protection of the environment and animals / 保护环境和动物的组织",
        en: "[94995]Organisations for the protection of the environment and animals",
      },
      {
        value: "[94999]Activities of other membership organisations n.e.c.",
        zh: "[94999]Activities of other membership organisations n.e.c. / 其他会员组织的活动 ",
        en: "[94999]Activities of other membership organisations n.e.c.",
      },
      {
        value: "[95110]Repair and maintenance of computer hardware, data processing equipment and computer peripherals",
        zh: "[95110]Repair and maintenance of computer hardware, data processing equipment and computer peripherals / 计算机硬件、数据处理设备和计算机外围设备的维修和保养",
        en: "[95110]Repair and maintenance of computer hardware, data processing equipment and computer peripherals",
      },
      {
        value: "[95120]Repair of communications equipment (e.g. mobile phones and fax machines)",
        zh: "[95120]Repair of communications equipment (e.g. mobile phones and fax machines) / 通讯设备维修（如手机、传真机）",
        en: "[95120]Repair of communications equipment (e.g. mobile phones and fax machines)",
      },
      {
        value: "[95210]Repair of audio and video equipment (e.g. television sets, speakers and DVD players)",
        zh: "[95210]Repair of audio and video equipment (e.g. television sets, speakers and DVD players) / 维修音频和视频设备（例如电视机、扬声器和 DVD 播放器）",
        en: "[95210]Repair of audio and video equipment (e.g. television sets, speakers and DVD players)",
      },
      {
        value: "[95220]Repair of domestic electrical/electronic appliances except audio and video equipment (e.g. refrigerators, washing machines and room air-conditioners)",
        zh: "[95220]Repair of domestic electrical/electronic appliances except audio and video equipment (e.g. refrigerators, washing machines and room air-conditioners) / 修理除影音设备外的家用电器/电子设备（如冰箱、洗衣机和房间空调）",
        en: "[95220]Repair of domestic electrical/electronic appliances except audio and video equipment (e.g. refrigerators, washing machines and room air-conditioners)",
      },
      {
        value: "[95230]Repair of footwear and leather goods",
        zh: "[95230]Repair of footwear and leather goods / 鞋类和皮革制品的修理",
        en: "[95230]Repair of footwear and leather goods",
      },
      {
        value: "[95240]Repair and restoration of cabinets, furniture, upholstery, window shades and other fixtures",
        zh: "[95240]Repair and restoration of cabinets, furniture, upholstery, window shades and other fixtures / 橱柜、家具、室内装潢、窗帘和其他固定装置的维修和修复",
        en: "[95240]Repair and restoration of cabinets, furniture, upholstery, window shades and other fixtures",
      },
      {
        value: "[95291]Repair of bicycles and tricycles",
        zh: "[95291]Repair of bicycles and tricycles / 自行车和三轮车的修理",
        en: "[95291]Repair of bicycles and tricycles",
      },
      {
        value: "[95292]Repair of watches and clocks",
        zh: "[95292]Repair of watches and clocks / 钟表修理",
        en: "[95292]Repair of watches and clocks",
      },
      {
        value: "[95293]Repair of jewellery",
        zh: "[95293]Repair of jewellery / 珠宝修复",
        en: "[95293]Repair of jewellery",
      },
      {
        value: "[95299]Repair of other personal and household goods n.e.c. (excluding online marketplaces)",
        zh: "[95299]Repair of other personal and household goods n.e.c. (excluding online marketplaces) / 修理其他个人和家庭用品（不包括在线市场）",
        en: "[95299]Repair of other personal and household goods n.e.c. (excluding online marketplaces)",
      },
      {
        value: "[95301]Repair and maintenance of motor vehicles (including installation of parts & accessories)",
        zh: "[95301]Repair and maintenance of motor vehicles (including installation of parts & accessories) / 机动车辆的维修和保养（包括零件和配件的安装）",
        en: "[95301]Repair and maintenance of motor vehicles (including installation of parts & accessories)",
      },
      {
        value: "[95302]Car washing and related services",
        zh: "[95302]Car washing and related services / 洗车及相关服务",
        en: "[95302]Car washing and related services",
      },
      {
        value: "[95303]Vehicle inspection and valuation services",
        zh: "[95303]Vehicle inspection and valuation services / 车辆检验和估价服务",
        en: "[95303]Vehicle inspection and valuation services",
      },
      {
        value: "[96011]Laundry and dry cleaning services except self-operated laundries",
        zh: "[96011]Laundry and dry cleaning services except self-operated laundries / 洗衣及干洗服务，自营洗衣店除外",
        en: "[96011]Laundry and dry cleaning services except self-operated laundries",
      },
      {
        value: "[96012]Self-operated laundries",
        zh: "[96012]Self-operated laundries / 自营洗衣店",
        en: "[96012]Self-operated laundries",
      },
      {
        value: "[96021]Hairdressing salons/shops (including barber shops)",
        zh: "[96021]Hairdressing salons/shops (including barber shops) / 美发沙龙/商店（包括理发店）",
        en: "[96021]Hairdressing salons/shops (including barber shops)",
      },
      {
        value: "[96022]Beauty salons and spas (including slimming, skin care and hair care centres)",
        zh: "[96022]Beauty salons and spas (including slimming, skin care and hair care centres) / 美容院和水疗中心（包括瘦身、护肤和护发中心）",
        en: "[96022]Beauty salons and spas (including slimming, skin care and hair care centres)",
      },
      {
        value: "[96023]Manicure and pedicure services",
        zh: "[96023]Manicure and pedicure services / 美甲和修脚服务",
        en: "[96023]Manicure and pedicure services",
      },
      {
        value: "[96024]Massage parlours and foot reflexology",
        zh: "[96024]Massage parlours and foot reflexology / 按摩院和足部反射疗法",
        en: "[96024]Massage parlours and foot reflexology",
      },
      {
        value: "[96029]Beauty and other personal care services n.e.c. (excluding online marketplaces)",
        zh: "[96029]Beauty and other personal care services n.e.c. (excluding online marketplaces) / 美容和其他个人护理服务（不包括在线市场）",
        en: "[96029]Beauty and other personal care services n.e.c. (excluding online marketplaces)",
      },
      {
        value: "[96030]Funeral and related activities (including embalming, cremating and cemetery services, upkeep of cemeteries)",
        zh: "[96030]Funeral and related activities (including embalming, cremating and cemetery services, upkeep of cemeteries) / 葬礼及相关活动（包括防腐、火化和墓地服务、墓地维护）",
        en: "[96030]Funeral and related activities (including embalming, cremating and cemetery services, upkeep of cemeteries)",
      },
      {
        value: "[96040]Wedding and related activities (including bridal studios and wedding planners)",
        zh: "[96040]Wedding and related activities (including bridal studios and wedding planners) / 婚礼及相关活动（包括婚纱工作室和婚礼策划师）",
        en: "[96040]Wedding and related activities (including bridal studios and wedding planners)",
      },
      {
        value: "[96091]Friendship, match-making and dating services",
        zh: "[96091]Friendship, match-making and dating services / 交友、婚介和约会服务",
        en: "[96091]Friendship, match-making and dating services",
      },
      {
        value: "[96092]Social escort services",
        zh: "[96092]Social escort services / 社会护送服务",
        en: "[96092]Social escort services",
      },
      {
        value: "[96093]Astrology, palmistry and other fortune telling services",
        zh: "[96093]Astrology, palmistry and other fortune telling services / 占星术、手相和其他算命服务",
        en: "[96093]Astrology, palmistry and other fortune telling services",
      },
      {
        value: "[96094]Training of pets and animals",
        zh: "[96094]Training of pets and animals / 宠物和动物的训练",
        en: "[96094]Training of pets and animals",
      },
      {
        value: "[96095]Care services for pets and animals",
        zh: "[96095]Care services for pets and animals / 宠物和动物护理服务",
        en: "[96095]Care services for pets and animals",
      },
      {
        value: "[96099]Other personal service activities n.e.c. (excluding online marketplaces)",
        zh: "[96099]Other personal service activities n.e.c. (excluding online marketplaces) / 其他个人服务活动（不包括在线市场）",
        en: "[96099]Other personal service activities n.e.c. (excluding online marketplaces)",
      },
      {
        value: "[97001]Activities of households as employers of domestic workers",
        zh: "[97001]Activities of households as employers of domestic workers / 家庭作为家庭工人雇主的活动",
        en: "[97001]Activities of households as employers of domestic workers",
      },
      {
        value: "[97002]Activities of households as employers of other domestic personnel (e.g. housekeepers)",
        zh: "[97002]Activities of households as employers of other domestic personnel (e.g. housekeepers) / 家庭作为其他家政人员（如管家）雇主的活动",
        en: "[97002]Activities of households as employers of other domestic personnel (e.g. housekeepers)",
      },
      {
        value: "[99010]Foreign embassies and trade representative offices",
        zh: "[99010]Foreign embassies and trade representative offices / 外国大使馆和贸易代表处",
        en: "[99010]Foreign embassies and trade representative offices",
      },
      {
        value: "[99020]Foreign armed forces",
        zh: "[99020]Foreign armed forces / 外国武装力量",
        en: "[99020]Foreign armed forces",
      },
      {
        value: "[99090]Other extra-territorial organisations and bodies",
        zh: "[99090]Other extra-territorial organisations and bodies / 其他域外组织和机构",
        en: "[99090]Other extra-territorial organisations and bodies",
      },
    ],
  ],
  Malaysia: [
    [
      // {
      //   value: "[00000]NOT APPLICABLE",
      //   zh: "[00000]NOT APPLICABLE / 不适用",
      //   en: "[00000]NOT APPLICABLE",
      // },
      {
        value: "[01111]Growing of maize",
        zh: "[01111]Growing of maize / 种植玉米",
        en: "[01111]Growing of maize",
      },
      {
        value: "[01112]Growing of leguminous crops",
        zh: "[01112]Growing of leguminous crops / 种植豆科作物",
        en: "[01112]Growing of leguminous crops",
      },
      {
        value: "[01113]Growing of oil seeds",
        zh: "[01113]Growing of oil seeds / 油料种子种植",
        en: "[01113]Growing of oil seeds",
      },
      {
        value: "[01119]Growing of other cereals n.e.c.",
        zh: "[01119]Growing of other cereals n.e.c. / 其他谷物的种植",
        en: "[01119]Growing of other cereals n.e.c.",
      },
      {
        value: "[01120]Growing of paddy",
        zh: "[01120]Growing of paddy / 种植水稻",
        en: "[01120]Growing of paddy",
      },
      {
        value: "[01131]Growing of leafy or stem vegetables",
        zh: "[01131]Growing of leafy or stem vegetables / 叶菜或茎类蔬菜的种植",
        en: "[01131]Growing of leafy or stem vegetables",
      },
      {
        value: "[01132]Growing of fruits bearing vegetables",
        zh: "[01132]Growing of fruits bearing vegetables / 水果蔬菜的种植",
        en: "[01132]Growing of fruits bearing vegetables",
      },
      {
        value: "[01133]Growing of melons",
        zh: "[01133]Growing of melons / 瓜类种植",
        en: "[01133]Growing of melons",
      },
      {
        value: "[01134]Growing of mushrooms and truffles",
        zh: "[01134]Growing of mushrooms and truffles / 蘑菇和块菌的种植",
        en: "[01134]Growing of mushrooms and truffles",
      },
      {
        value: "[01135]Growing of vegetables seeds, except beet seeds",
        zh: "[01135]Growing of vegetables seeds, except beet seeds / 蔬菜种子的种植（甜菜种子除外）",
        en: "[01135]Growing of vegetables seeds, except beet seeds",
      },
      {
        value: "[01136]Growing of other vegetables",
        zh: "[01136]Growing of other vegetables / 其他蔬菜种植",
        en: "[01136]Growing of other vegetables",
      },
      {
        value: "[01137]Growing of sugar beet",
        zh: "[01137]Growing of sugar beet / 甜菜种植",
        en: "[01137]Growing of sugar beet",
      },
      {
        value: "[01138]Growing of roots, tubers, bulb or tuberous vegetables",
        zh: "[01138]Growing of roots, tubers, bulb or tuberous vegetables / 根、块茎、球茎或块根蔬菜的种植",
        en: "[01138]Growing of roots, tubers, bulb or tuberous vegetables",
      },
      {
        value: "[01140]Growing of sugar cane",
        zh: "[01140]Growing of sugar cane / 种植甘蔗",
        en: "[01140]Growing of sugar cane",
      },
      {
        value: "[01150]Growing of tobacco",
        zh: "[01150]Growing of tobacco / 烟草种植",
        en: "[01150]Growing of tobacco",
      },
      {
        value: "[01160]Growing of fibre crops",
        zh: "[01160]Growing of fibre crops / 纤维作物种植",
        en: "[01160]Growing of fibre crops",
      },
      {
        value: "[01191]Growing of flowers",
        zh: "[01191]Growing of flowers / 花卉种植",
        en: "[01191]Growing of flowers",
      },
      {
        value: "[01192]Growing of flower seeds",
        zh: "[01192]Growing of flower seeds / 花卉种子的种植",
        en: "[01192]Growing of flower seeds",
      },
      {
        value: "[01193]Growing of sago (rumbia)",
        zh: "[01193]Growing of sago (rumbia) / 西米（龙舌兰）的种植",
        en: "[01193]Growing of sago (rumbia)",
      },
      {
        value: "[01199]Growing of other non-perennial crops n.e.c.",
        zh: "[01199]Growing of other non-perennial crops n.e.c. / 种植其他非多年生作物",
        en: "[01199]Growing of other non-perennial crops n.e.c.",
      },
      {
        value: "[01210]Growing of grapes",
        zh: "[01210]Growing of grapes / 葡萄种植",
        en: "[01210]Growing of grapes",
      },
      {
        value: "[01221]Growing of banana",
        zh: "[01221]Growing of banana / 种植香蕉",
        en: "[01221]Growing of banana",
      },
      {
        value: "[01222]Growing of mango",
        zh: "[01222]Growing of mango / 种植芒果",
        en: "[01222]Growing of mango",
      },
      {
        value: "[01223]Growing of durian",
        zh: "[01223]Growing of durian / 榴莲种植",
        en: "[01223]Growing of durian",
      },
      {
        value: "[01224]Growing of rambutan",
        zh: "[01224]Growing of rambutan / 红毛丹种植",
        en: "[01224]Growing of rambutan",
      },
      {
        value: "[01225]Growing of star fruit",
        zh: "[01225]Growing of star fruit / 种植星形水果",
        en: "[01225]Growing of star fruit",
      },
      {
        value: "[01226]Growing of papaya",
        zh: "[01226]Growing of papaya / 种植木瓜",
        en: "[01226]Growing of papaya",
      },
      {
        value: "[01227]Growing of pineapple",
        zh: "[01227]Growing of pineapple / 菠萝种植",
        en: "[01227]Growing of pineapple",
      },
      {
        value: "[01228]Growing of pitaya (dragon fruit)",
        zh: "[01228]Growing of pitaya (dragon fruit) / 火龙果种植",
        en: "[01228]Growing of pitaya (dragon fruit)",
      },
      {
        value: "[01229]Growing of other tropical and subtropical fruits n.e.c.",
        zh: "[01229]Growing of other tropical and subtropical fruits n.e.c. / 其他热带和亚热带水果的种植",
        en: "[01229]Growing of other tropical and subtropical fruits n.e.c.",
      },
      {
        value: "[01231]Growing of pomelo",
        zh: "[01231]Growing of pomelo / 种植柚子",
        en: "[01231]Growing of pomelo",
      },
      {
        value: "[01232]Growing of lemon and limes",
        zh: "[01232]Growing of lemon and limes / 柠檬和酸橙的种植",
        en: "[01232]Growing of lemon and limes",
      },
      {
        value: "[01233]Growing of tangerines and mandarin",
        zh: "[01233]Growing of tangerines and mandarin / 种植柑橘和橘子",
        en: "[01233]Growing of tangerines and mandarin",
      },
      {
        value: "[01239]Growing of other citrus fruits n.e.c.",
        zh: "[01239]Growing of other citrus fruits n.e.c. / 种植其他未列明的柑橘类水果",
        en: "[01239]Growing of other citrus fruits n.e.c.",
      },
      {
        value: "[01241]Growing of guava",
        zh: "[01241]Growing of guava / 番石榴种植",
        en: "[01241]Growing of guava",
      },
      {
        value: "[01249]Growing of other pome fruits and stones fruits n.e.c.",
        zh: "[01249]Growing of other pome fruits and stones fruits n.e.c. / 其他仁果类和核果类水果的种植",
        en: "[01249]Growing of other pome fruits and stones fruits n.e.c.",
      },
      {
        value: "[01251]Growing of berries",
        zh: "[01251]Growing of berries / 浆果种植",
        en: "[01251]Growing of berries",
      },
      {
        value: "[01252]Growing of fruit seeds",
        zh: "[01252]Growing of fruit seeds / 水果种子的种植",
        en: "[01252]Growing of fruit seeds",
      },
      {
        value: "[01253]Growing of edible nuts",
        zh: "[01253]Growing of edible nuts / 食用坚果种植",
        en: "[01253]Growing of edible nuts",
      },
      {
        value: "[01259]Growing of other tree and bush fruits",
        zh: "[01259]Growing of other tree and bush fruits / 其他树木和灌木水果的种植",
        en: "[01259]Growing of other tree and bush fruits",
      },
      {
        value: "[01261]Growing of oil palm (estate)",
        zh: "[01261]Growing of oil palm (estate) / 油棕（种植园）的种植",
        en: "[01261]Growing of oil palm (estate)",
      },
      {
        value: "[01262]Growing of oil palm (smallholdings)",
        zh: "[01262]Growing of oil palm (smallholdings) / 油棕的种植（小农场）",
        en: "[01262]Growing of oil palm (smallholdings)",
      },
      {
        value: "[01263]Growing of coconut (estate and smallholdings)",
        zh: "[01263]Growing of coconut (estate and smallholdings) / 种植椰子（种植园和小农场）",
        en: "[01263]Growing of coconut (estate and smallholdings)",
      },
      {
        value: "[01269]Growing of other oleaginous fruits n.e.c.",
        zh: "[01269]Growing of other oleaginous fruits n.e.c. / 其他非特定油料作物种植",
        en: "[01269]Growing of other oleaginous fruits n.e.c.",
      },
      {
        value: "[01271]Growing of coffee",
        zh: "[01271]Growing of coffee / 咖啡种植",
        en: "[01271]Growing of coffee",
      },
      {
        value: "[01272]Growing of tea",
        zh: "[01272]Growing of tea / 茶叶种植",
        en: "[01272]Growing of tea",
      },
      {
        value: "[01273]Growing of cocoa",
        zh: "[01273]Growing of cocoa / 可可种植",
        en: "[01273]Growing of cocoa",
      },
      {
        value: "[01279]Growing of other beverage crops n.e.c.",
        zh: "[01279]Growing of other beverage crops n.e.c. / 其他饮料作物种植",
        en: "[01279]Growing of other beverage crops n.e.c.",
      },
      {
        value: "[01281]Growing of pepper (piper nigrum)",
        zh: "[01281]Growing of pepper (piper nigrum) / 胡椒（黑胡椒）种植",
        en: "[01281]Growing of pepper (piper nigrum)",
      },
      {
        value: "[01282]Growing of chilies and pepper (capsicum spp.)",
        zh: "[01282]Growing of chilies and pepper (capsicum spp.) / 辣椒和胡椒（Capsicum spp.）的种植",
        en: "[01282]Growing of chilies and pepper (capsicum spp.)",
      },
      {
        value: "[01283]Growing of nutmeg",
        zh: "[01283]Growing of nutmeg / 肉豆蔻种植",
        en: "[01283]Growing of nutmeg",
      },
      {
        value: "[01284]Growing of ginger",
        zh: "[01284]Growing of ginger / 生姜种植",
        en: "[01284]Growing of ginger",
      },
      {
        value: "[01285]Growing of plants used primarily in perfumery, in pharmacy or for insecticidal, fungicidal or similar purposes",
        zh: "[01285]Growing of plants used primarily in perfumery, in pharmacy or for insecticidal, fungicidal or similar purposes / 主要用于香料、药用或杀虫、杀菌等目的的植物种植",
        en: "[01285]Growing of plants used primarily in perfumery, in pharmacy or for insecticidal, fungicidal or similar purposes",
      },
      {
        value: "[01289]Growing of other spices and aromatic crops n.e.c.",
        zh: "[01289]Growing of other spices and aromatic crops n.e.c. / 其他香料和芳香作物的种植",
        en: "[01289]Growing of other spices and aromatic crops n.e.c.",
      },
      {
        value: "[01291]Growing  of rubber trees (estate)",
        zh: "[01291]Growing  of rubber trees (estate) / 橡胶树种植（庄园）",
        en: "[01291]Growing  of rubber trees (estate)",
      },
      {
        value: "[01292]Growing of rubber trees (smallholdings)",
        zh: "[01292]Growing of rubber trees (smallholdings) / 橡胶树种植（小农场）",
        en: "[01292]Growing of rubber trees (smallholdings)",
      },
      {
        value: "[01293]Growing of trees for extraction of sap",
        zh: "[01293]Growing of trees for extraction of sap / 提取树液的树木种植",
        en: "[01293]Growing of trees for extraction of sap",
      },
      {
        value: "[01294]Growing of nipa palm",
        zh: "[01294]Growing of nipa palm / 海枣种植",
        en: "[01294]Growing of nipa palm",
      },
      {
        value: "[01295]Growing of areca",
        zh: "[01295]Growing of areca / 槟榔种植",
        en: "[01295]Growing of areca",
      },
      {
        value: "[01296]Growing of roselle",
        zh: "[01296]Growing of roselle / 种植罗望子",
        en: "[01296]Growing of roselle",
      },
      {
        value: "[01299]Growing of other perennial crops n.e.c.",
        zh: "[01299]Growing of other perennial crops n.e.c. / 其他多年生作物的种植",
        en: "[01299]Growing of other perennial crops n.e.c.",
      },
      {
        value: "[01301]Growing of plants for planting",
        zh: "[01301]Growing of plants for planting / 种植用于种植的植物",
        en: "[01301]Growing of plants for planting",
      },
      {
        value: "[01302]Growing of plants for ornamental purposes",
        zh: "[01302]Growing of plants for ornamental purposes / 种植观赏用植物",
        en: "[01302]Growing of plants for ornamental purposes",
      },
      {
        value: "[01303]Growing of live plants for bulbs, tubers and roots; cuttings and slips; mushroom spawn",
        zh: "[01303]Growing of live plants for bulbs, tubers and roots; cuttings and slips; mushroom spawn / 用于球茎、块茎和根的活植物的种植；插条和幼苗；蘑菇菌种",
        en: "[01303]Growing of live plants for bulbs, tubers and roots; cuttings and slips; mushroom spawn",
      },
      {
        value: "[01304]Operation of tree nurseries",
        zh: "[01304]Operation of tree nurseries / 树木苗圃运营",
        en: "[01304]Operation of tree nurseries",
      },
      {
        value: "[01411]Raising, breeding and production of cattle or buffaloes",
        zh: "[01411]Raising, breeding and production of cattle or buffaloes / 牛或水牛的饲养、繁殖及生产",
        en: "[01411]Raising, breeding and production of cattle or buffaloes",
      },
      {
        value: "[01412]Production of raw milk from cows or buffaloes",
        zh: "[01412]Production of raw milk from cows or buffaloes / 从牛或水牛中生产原奶",
        en: "[01412]Production of raw milk from cows or buffaloes",
      },
      {
        value: "[01413]Production of bovine semen",
        zh: "[01413]Production of bovine semen / 生产牛精液",
        en: "[01413]Production of bovine semen",
      },
      {
        value: "[01420]Raising and breeding of horses, asses, mules or hinnes",
        zh: "[01420]Raising and breeding of horses, asses, mules or hinnes / 马、驴、骡或母驴的饲养与繁殖",
        en: "[01420]Raising and breeding of horses, asses, mules or hinnes",
      },
      {
        value: "[01430]Raising and breeding of camels (dromedary) and camelids",
        zh: "[01430]Raising and breeding of camels (dromedary) and camelids / 骆驼（单峰）和骆驼科动物的饲养和繁殖",
        en: "[01430]Raising and breeding of camels (dromedary) and camelids",
      },
      {
        value: "[01441]Raising, breeding and production of sheep and goats",
        zh: "[01441]Raising, breeding and production of sheep and goats / 羊和山羊的饲养、繁殖和生产",
        en: "[01441]Raising, breeding and production of sheep and goats",
      },
      {
        value: "[01442]Production of raw sheep or goat’s milk",
        zh: "[01442]Production of raw sheep or goat’s milk / 原绵羊或山羊奶的生产",
        en: "[01442]Production of raw sheep or goat’s milk",
      },
      {
        value: "[01443]Production of raw wool",
        zh: "[01443]Production of raw wool / 原羊毛的生产",
        en: "[01443]Production of raw wool",
      },
      {
        value: "[01450]Raising, breeding and production of swine/pigs",
        zh: "[01450]Raising, breeding and production of swine/pigs / 养猪/猪的饲养和生产",
        en: "[01450]Raising, breeding and production of swine/pigs",
      },
      {
        value: "[01461]Raising, breeding and production of chicken, broiler",
        zh: "[01461]Raising, breeding and production of chicken, broiler / 鸡、肉鸡的养殖与生产",
        en: "[01461]Raising, breeding and production of chicken, broiler",
      },
      {
        value: "[01462]Raising, breeding and production of ducks",
        zh: "[01462]Raising, breeding and production of ducks / 鸭子的饲养、繁殖和生产",
        en: "[01462]Raising, breeding and production of ducks",
      },
      {
        value: "[01463]Raising, breeding and production of geese",
        zh: "[01463]Raising, breeding and production of geese / 鹅的养殖与生产",
        en: "[01463]Raising, breeding and production of geese",
      },
      {
        value: "[01464]Raising, breeding and production of quails",
        zh: "[01464]Raising, breeding and production of quails / 饲养、繁殖和生产鹌鹑",
        en: "[01464]Raising, breeding and production of quails",
      },
      {
        value: "[01465]Raising and breeding of other poultry n.e.c.",
        zh: "[01465]Raising and breeding of other poultry n.e.c. / 其他家禽的饲养",
        en: "[01465]Raising and breeding of other poultry n.e.c.",
      },
      {
        value: "[01466]Production of chicken eggs",
        zh: "[01466]Production of chicken eggs / 生产鸡蛋",
        en: "[01466]Production of chicken eggs",
      },
      {
        value: "[01467]Production of duck eggs",
        zh: "[01467]Production of duck eggs / 鸭蛋的生产",
        en: "[01467]Production of duck eggs",
      },
      {
        value: "[01468]Production of other poultry eggs n.e.c.",
        zh: "[01468]Production of other poultry eggs n.e.c. / 其他禽蛋生产",
        en: "[01468]Production of other poultry eggs n.e.c.",
      },
      {
        value: "[01469]Operation of poultry hatcheries",
        zh: "[01469]Operation of poultry hatcheries / 家禽孵化场的运营",
        en: "[01469]Operation of poultry hatcheries",
      },
      {
        value: "[01491]Raising, breeding and production of semi-domesticated",
        zh: "[01491]Raising, breeding and production of semi-domesticated / 半驯化动物的饲养和生产",
        en: "[01491]Raising, breeding and production of semi-domesticated",
      },
      {
        value: "[01492]Production of fur skins, reptile or bird’s skin from ranching operation",
        zh: "[01492]Production of fur skins, reptile or bird’s skin from ranching operation / 牧场养殖的皮草、爬行动物或鸟类皮肤生产",
        en: "[01492]Production of fur skins, reptile or bird’s skin from ranching operation",
      },
      {
        value: "[01493]Operation of worm farms, land mollusc farms, snail farms",
        zh: "[01493]Operation of worm farms, land mollusc farms, snail farms / 运营蠕虫农场、陆生软体动物农场、蜗牛农场",
        en: "[01493]Operation of worm farms, land mollusc farms, snail farms",
      },
      {
        value: "[01494]Raising of silk worms and production of silk worm cocoons",
        zh: "[01494]Raising of silk worms and production of silk worm cocoons / 蚕的养殖及蚕茧的生产",
        en: "[01494]Raising of silk worms and production of silk worm cocoons",
      },
      {
        value: "[01495]Bee keeping and production of honey and beeswax",
        zh: "[01495]Bee keeping and production of honey and beeswax / 养蜂及生产蜂蜜和蜂蜡",
        en: "[01495]Bee keeping and production of honey and beeswax",
      },
      {
        value: "[01496]Raising and breeding of pet animals",
        zh: "[01496]Raising and breeding of pet animals / 宠物动物的饲养和繁殖",
        en: "[01496]Raising and breeding of pet animals",
      },
      {
        value: "[01497]Raising and breeding of swiflet",
        zh: "[01497]Raising and breeding of swiflet / 金丝燕养殖",
        en: "[01497]Raising and breeding of swiflet",
      },
      {
        value: "[01499]Raising of diverse/other animals n.e.c.",
        zh: "[01499]Raising of diverse/other animals n.e.c. / 养殖其他种类/其他动物",
        en: "[01499]Raising of diverse/other animals n.e.c.",
      },
      {
        value: "[01500]Mixed Farming",
        zh: "[01500]Mixed Farming / 混合农业",
        en: "[01500]Mixed Farming",
      },
      {
        value: "[01610]Agricultural activities for crops production on a fee or contract basis",
        zh: "[01610]Agricultural activities for crops production on a fee or contract basis / 按费用或合同基础进行的农作物生产农业活动",
        en: "[01610]Agricultural activities for crops production on a fee or contract basis",
      },
      {
        value: "[01620]Agricultural activities for animal production on a fee or contract basis",
        zh: "[01620]Agricultural activities for animal production on a fee or contract basis / 按费用或合同基础的动物生产农业活动",
        en: "[01620]Agricultural activities for animal production on a fee or contract basis",
      },
      {
        value: "[01631]Preparation of crops for primary markets",
        zh: "[01631]Preparation of crops for primary markets / 为初级市场准备作物",
        en: "[01631]Preparation of crops for primary markets",
      },
      {
        value: "[01632]Preparation of tobacco leaves",
        zh: "[01632]Preparation of tobacco leaves / 烟草叶片的准备",
        en: "[01632]Preparation of tobacco leaves",
      },
      {
        value: "[01633]Preparation of cocoa beans",
        zh: "[01633]Preparation of cocoa beans / 可可豆的准备",
        en: "[01633]Preparation of cocoa beans",
      },
      {
        value: "[01634]Sun-drying of fruits and vegetables",
        zh: "[01634]Sun-drying of fruits and vegetables / 水果和蔬菜的阳光晾晒",
        en: "[01634]Sun-drying of fruits and vegetables",
      },
      {
        value: "[01640]Seed processing for propagation",
        zh: "[01640]Seed processing for propagation / 种子处理用于繁殖",
        en: "[01640]Seed processing for propagation",
      },
      {
        value: "[01701]Hunting and trapping on a commercial basis",
        zh: "[01701]Hunting and trapping on a commercial basis / 商业性狩猎和捕猎",
        en: "[01701]Hunting and trapping on a commercial basis",
      },
      {
        value: "[01702]Taking of animals (dead or alive)",
        zh: "[01702]Taking of animals (dead or alive) / 取动物（死的或活的）",
        en: "[01702]Taking of animals (dead or alive)",
      },
      {
        value: "[02101]Planting, replanting, transplanting, thinning and conserving of forests and timber tracts",
        zh: "[02101]Planting, replanting, transplanting, thinning and conserving of forests and timber tracts / 种植、重新种植、移植、疏伐和森林及林地的保育",
        en: "[02101]Planting, replanting, transplanting, thinning and conserving of forests and timber tracts",
      },
      {
        value: "[02102]Growing of coppice, pulpwood and fire wood",
        zh: "[02102]Growing of coppice, pulpwood and fire wood / 短轮伐期林、纸浆用材林和柴火的种植",
        en: "[02102]Growing of coppice, pulpwood and fire wood",
      },
      {
        value: "[02103]Operation of forest tree nurseries",
        zh: "[02103]Operation of forest tree nurseries / 森林树木苗圃运营",
        en: "[02103]Operation of forest tree nurseries",
      },
      {
        value: "[02104]Collection and raising of wildings (peat swamp forest tree species)",
        zh: "[02104]Collection and raising of wildings (peat swamp forest tree species) / 收集和培养野生植物（泥炭沼泽森林树种）",
        en: "[02104]Collection and raising of wildings (peat swamp forest tree species)",
      },
      {
        value: "[02105]Forest plantation",
        zh: "[02105]Forest plantation / 植树造林",
        en: "[02105]Forest plantation",
      },
      {
        value: "[02201]Production of round wood for forest-based manufacturing industries",
        zh: "[02201]Production of round wood for forest-based manufacturing industries / 为基于森林的制造业生产圆木",
        en: "[02201]Production of round wood for forest-based manufacturing industries",
      },
      {
        value: "[02202]Production of round wood used in an unprocessed form",
        zh: "[02202]Production of round wood used in an unprocessed form / 生产未经加工的原木",
        en: "[02202]Production of round wood used in an unprocessed form",
      },
      {
        value: "[02203]Production of charcoal in the forest (using traditional methods)",
        zh: "[02203]Production of charcoal in the forest (using traditional methods) / 森林中使用传统方法生产木炭",
        en: "[02203]Production of charcoal in the forest (using traditional methods)",
      },
      {
        value: "[02204]Rubber wood logging",
        zh: "[02204]Rubber wood logging / 橡胶木采伐",
        en: "[02204]Rubber wood logging",
      },
      {
        value: "[02301]Collection of rattan, bamboo",
        zh: "[02301]Collection of rattan, bamboo / 收集藤条和竹子",
        en: "[02301]Collection of rattan, bamboo",
      },
      {
        value: "[02302]Bird’s nest collection",
        zh: "[02302]Bird’s nest collection / 收集鸟巢",
        en: "[02302]Bird’s nest collection",
      },
      {
        value: "[02303]Wild sago palm collection",
        zh: "[02303]Wild sago palm collection / 野生西米棕榈收集",
        en: "[02303]Wild sago palm collection",
      },
      {
        value: "[02309]Gathering of non-wood forest products n.e.c.",
        zh: "[02309]Gathering of non-wood forest products n.e.c. / 非木材林产品采集",
        en: "[02309]Gathering of non-wood forest products n.e.c.",
      },
      {
        value: "[02401]Carrying out part of the forestry and forest plantation operation on a fee or contract basis for forestry service activities",
        zh: "[02401]Carrying out part of the forestry and forest plantation operation on a fee or contract basis for forestry service activities / 基于收费或合同的林业服务活动的森林和森林种植作业的一部分",
        en: "[02401]Carrying out part of the forestry and forest plantation operation on a fee or contract basis for forestry service activities",
      },
      {
        value: "[02402]Carrying out part of the forestry operation on a fee or contract basis for logging service activities",
        zh: "[02402]Carrying out part of the forestry operation on a fee or contract basis for logging service activities / 为伐木服务活动按费用或合同基础进行部分林业作业",
        en: "[02402]Carrying out part of the forestry operation on a fee or contract basis for logging service activities",
      },
      {
        value: "[03111]Fishing on a commercial basis in ocean and coastal waters",
        zh: "[03111]Fishing on a commercial basis in ocean and coastal waters / 在海洋和沿海水域进行商业捕鱼",
        en: "[03111]Fishing on a commercial basis in ocean and coastal waters",
      },
      {
        value: "[03112]Collection of marine crustaceans and molluscs",
        zh: "[03112]Collection of marine crustaceans and molluscs / 收集海洋甲壳类动物和软体动物",
        en: "[03112]Collection of marine crustaceans and molluscs",
      },
      {
        value: "[03113]Taking of aquatic animals: sea squirts, tunicates, sea urchins",
        zh: "[03113]Taking of aquatic animals: sea squirts, tunicates, sea urchins / 捕捞海洋生物：海鞘、被囊动物、海胆",
        en: "[03113]Taking of aquatic animals: sea squirts, tunicates, sea urchins",
      },
      {
        value: "[03114]Activities of vessels engaged both in fishing and in processing and preserving of fish",
        zh: "[03114]Activities of vessels engaged both in fishing and in processing and preserving of fish / 同时从事捕鱼和鱼类加工及保存的船只活动",
        en: "[03114]Activities of vessels engaged both in fishing and in processing and preserving of fish",
      },
      {
        value: "[03115]Gathering of other marine organisms and materials (natural pearls, sponges, coral and algae)",
        zh: "[03115]Gathering of other marine organisms and materials (natural pearls, sponges, coral and algae) / 收集其他海洋生物和材料（天然珍珠、海绵、珊瑚和藻类）",
        en: "[03115]Gathering of other marine organisms and materials (natural pearls, sponges, coral and algae)",
      },
      {
        value: "[03119]Marine fishing n.e.c.",
        zh: "[03119]Marine fishing n.e.c. / 其他海洋捕捞",
        en: "[03119]Marine fishing n.e.c.",
      },
      {
        value: "[03121]Fishing on a commercial basis in inland waters",
        zh: "[03121]Fishing on a commercial basis in inland waters / 内陆水域商业性捕鱼",
        en: "[03121]Fishing on a commercial basis in inland waters",
      },
      {
        value: "[03122]Taking of freshwater crustaceans and molluscs",
        zh: "[03122]Taking of freshwater crustaceans and molluscs / 淡水甲壳类动物和软体动物的捕捞",
        en: "[03122]Taking of freshwater crustaceans and molluscs",
      },
      {
        value: "[03123]Taking of freshwater aquatic animals",
        zh: "[03123]Taking of freshwater aquatic animals / 捕捞淡水水生动物",
        en: "[03123]Taking of freshwater aquatic animals",
      },
      {
        value: "[03124]Gathering of freshwater flora and fauna",
        zh: "[03124]Gathering of freshwater flora and fauna / 淡水植物和动物的采集",
        en: "[03124]Gathering of freshwater flora and fauna",
      },
      {
        value: "[03129]Freshwater fishing n.e.c.",
        zh: "[03129]Freshwater fishing n.e.c. / 淡水捕捞",
        en: "[03129]Freshwater fishing n.e.c.",
      },
      {
        value: "[03211]Fish farming in sea water",
        zh: "[03211]Fish farming in sea water / 海水养殖",
        en: "[03211]Fish farming in sea water",
      },
      {
        value: "[03212]Production of bivalve spat (oyster, mussel), lobster lings, shrimp post-larvae, fish fry and fingerlings",
        zh: "[03212]Production of bivalve spat (oyster, mussel), lobster lings, shrimp post-larvae, fish fry and fingerlings / 双壳类幼体（牡蛎、贻贝）、龙虾幼体、虾后幼体、鱼苗和鱼种的生产",
        en: "[03212]Production of bivalve spat (oyster, mussel), lobster lings, shrimp post-larvae, fish fry and fingerlings",
      },
      {
        value: "[03213]Growing of laver and other edible seaweeds",
        zh: "[03213]Growing of laver and other edible seaweeds / 紫菜和其他可食用海藻的养殖",
        en: "[03213]Growing of laver and other edible seaweeds",
      },
      {
        value: "[03214]Culture of crustaceans, bivalves, other molluscs and other aquatic animals in sea water",
        zh: "[03214]Culture of crustaceans, bivalves, other molluscs and other aquatic animals in sea water / 海水甲壳类、双壳类、其他软体动物和其他水生动物的养殖",
        en: "[03214]Culture of crustaceans, bivalves, other molluscs and other aquatic animals in sea water",
      },
      {
        value: "[03215]Aquaculture activities in brackish water",
        zh: "[03215]Aquaculture activities in brackish water / 咸水养殖活动",
        en: "[03215]Aquaculture activities in brackish water",
      },
      {
        value: "[03216]Aquaculture activities in salt water filled tanks or reservoirs",
        zh: "[03216]Aquaculture activities in salt water filled tanks or reservoirs / 海水养殖活动",
        en: "[03216]Aquaculture activities in salt water filled tanks or reservoirs",
      },
      {
        value: "[03217]Operation of  hatcheries (marine)",
        zh: "[03217]Operation of  hatcheries (marine) / 孵化场（海洋）的操作",
        en: "[03217]Operation of  hatcheries (marine)",
      },
      {
        value: "[03218]Operation of marine worm farms for fish feed",
        zh: "[03218]Operation of marine worm farms for fish feed / 海洋蠕虫农场的运营，用于鱼饲料",
        en: "[03218]Operation of marine worm farms for fish feed",
      },
      {
        value: "[03219]Marine aquaculture n.e.c.",
        zh: "[03219]Marine aquaculture n.e.c. / 其他海洋水产养殖",
        en: "[03219]Marine aquaculture n.e.c.",
      },
      {
        value: "[03221]Fish farming in freshwater",
        zh: "[03221]Fish farming in freshwater / 淡水鱼类养殖",
        en: "[03221]Fish farming in freshwater",
      },
      {
        value: "[03222]Shrimp farming in freshwater",
        zh: "[03222]Shrimp farming in freshwater / 淡水虾养殖",
        en: "[03222]Shrimp farming in freshwater",
      },
      {
        value: "[03223]Culture of freshwater crustaceans, bivalves, other molluscs and other aquatic animals",
        zh: "[03223]Culture of freshwater crustaceans, bivalves, other molluscs and other aquatic animals / 淡水甲壳类、双壳类、其他软体动物和其他水生动物的养殖",
        en: "[03223]Culture of freshwater crustaceans, bivalves, other molluscs and other aquatic animals",
      },
      {
        value: "[03224]Operation of hatcheries (freshwater)",
        zh: "[03224]Operation of hatcheries (freshwater) / 孵化场的运营（淡水）",
        en: "[03224]Operation of hatcheries (freshwater)",
      },
      {
        value: "[03225]Farming of frogs",
        zh: "[03225]Farming of frogs / 青蛙养殖",
        en: "[03225]Farming of frogs",
      },
      {
        value: "[03229]Freshwater aquaculture n.e.c.",
        zh: "[03229]Freshwater aquaculture n.e.c. / 淡水水产养殖（不包括其他类）",
        en: "[03229]Freshwater aquaculture n.e.c.",
      },
      {
        value: "[05100]Mining of hard coal",
        zh: "[05100]Mining of hard coal / 硬煤矿开采",
        en: "[05100]Mining of hard coal",
      },
      {
        value: "[05200]Mining of lignite (brown coal)",
        zh: "[05200]Mining of lignite (brown coal) / 褐煤（ lignite）开采",
        en: "[05200]Mining of lignite (brown coal)",
      },
      {
        value: "[06101]Extraction of crude petroleum oils",
        zh: "[06101]Extraction of crude petroleum oils / 原油开采",
        en: "[06101]Extraction of crude petroleum oils",
      },
      {
        value: "[06102]Extraction of bituminous or oil shale and tar sand",
        zh: "[06102]Extraction of bituminous or oil shale and tar sand / 沥青或油页岩及焦油砂的提取",
        en: "[06102]Extraction of bituminous or oil shale and tar sand",
      },
      {
        value: "[06103]Production of crude petroleum from bituminous shale and sand",
        zh: "[06103]Production of crude petroleum from bituminous shale and sand / 从沥青页岩和砂中生产原油",
        en: "[06103]Production of crude petroleum from bituminous shale and sand",
      },
      {
        value: "[06104]Processes to obtain crude oils",
        zh: "[06104]Processes to obtain crude oils / 获取原油的加工过程",
        en: "[06104]Processes to obtain crude oils",
      },
      {
        value: "[06201]Production of crude gaseous hydrocarbon (natural gas)",
        zh: "[06201]Production of crude gaseous hydrocarbon (natural gas) / 生产粗制气态碳氢化合物（天然气）",
        en: "[06201]Production of crude gaseous hydrocarbon (natural gas)",
      },
      {
        value: "[06202]Extraction of condensates",
        zh: "[06202]Extraction of condensates / 冷凝物的提取",
        en: "[06202]Extraction of condensates",
      },
      {
        value: "[06203]Draining and separation of liquid hydrocarbon fractions",
        zh: "[06203]Draining and separation of liquid hydrocarbon fractions / 液体烃类的分离和分离",
        en: "[06203]Draining and separation of liquid hydrocarbon fractions",
      },
      {
        value: "[06204]Gas desulphurization",
        zh: "[06204]Gas desulphurization / 气体脱硫",
        en: "[06204]Gas desulphurization",
      },
      {
        value: "[06205]Mining of hydrocarbon liquids, obtain through liquefaction or pyrolysis",
        zh: "[06205]Mining of hydrocarbon liquids, obtain through liquefaction or pyrolysis / 液化或热解获取的烃类液体开采",
        en: "[06205]Mining of hydrocarbon liquids, obtain through liquefaction or pyrolysis",
      },
      {
        value: "[07101]Mining of ores valued chiefly for iron content",
        zh: "[07101]Mining of ores valued chiefly for iron content / 主要价值在于含铁量的矿石开采",
        en: "[07101]Mining of ores valued chiefly for iron content",
      },
      {
        value: "[07102]Beneficiation and agglomeration of iron ores",
        zh: "[07102]Beneficiation and agglomeration of iron ores / 铁矿石的选矿和造块",
        en: "[07102]Beneficiation and agglomeration of iron ores",
      },
      {
        value: "[07210]Mining of uranium and thorium ores",
        zh: "[07210]Mining of uranium and thorium ores / 铀和钍矿石开采",
        en: "[07210]Mining of uranium and thorium ores",
      },
      {
        value: "[07291]Mining of tin ores",
        zh: "[07291]Mining of tin ores / 锡矿开采",
        en: "[07291]Mining of tin ores",
      },
      {
        value: "[07292]Mining of copper",
        zh: "[07292]Mining of copper / 铜矿开采",
        en: "[07292]Mining of copper",
      },
      {
        value: "[07293]Mining of bauxite (aluminium)",
        zh: "[07293]Mining of bauxite (aluminium) / 铝土矿（铝）的开采",
        en: "[07293]Mining of bauxite (aluminium)",
      },
      {
        value: "[07294]Mining of ilmenite",
        zh: "[07294]Mining of ilmenite / 钛铁矿的开采",
        en: "[07294]Mining of ilmenite",
      },
      {
        value: "[07295]Mining of gold",
        zh: "[07295]Mining of gold / 金矿开采",
        en: "[07295]Mining of gold",
      },
      {
        value: "[07296]Mining of silver",
        zh: "[07296]Mining of silver / 银矿开采",
        en: "[07296]Mining of silver",
      },
      {
        value: "[07297]Mining of platinum",
        zh: "[07297]Mining of platinum / 铂金开采",
        en: "[07297]Mining of platinum",
      },
      {
        value: "[07298]Amang retreatment",
        zh: "[07298]Amang retreatment / 锰矿石的再处理",
        en: "[07298]Amang retreatment",
      },
      {
        value: "[07299]Mining of other non-ferrous metal ores n.e.c.",
        zh: "[07299]Mining of other non-ferrous metal ores n.e.c. / 其他非铁金属矿的开采",
        en: "[07299]Mining of other non-ferrous metal ores n.e.c.",
      },
      {
        value: "[08101]Quarrying, rough trimming and sawing of monumental and building stone such as marble, granite (dimension stone), sandstone",
        zh: "[08101]Quarrying, rough trimming and sawing of monumental and building stone such as marble, granite (dimension stone), sandstone / 采石、石料的粗加工和锯切，如大理石、花岗岩（板材）、砂岩",
        en: "[08101]Quarrying, rough trimming and sawing of monumental and building stone such as marble, granite (dimension stone), sandstone",
      },
      {
        value: "[08102]Quarrying, crushing and breaking of limestone",
        zh: "[08102]Quarrying, crushing and breaking of limestone / 石灰石的开采、破碎和分解",
        en: "[08102]Quarrying, crushing and breaking of limestone",
      },
      {
        value: "[08103]Mining of gypsum and anhydrite",
        zh: "[08103]Mining of gypsum and anhydrite / 石膏和硬石膏的开采",
        en: "[08103]Mining of gypsum and anhydrite",
      },
      {
        value: "[08104]Mining of chalk and uncalcined dolomite",
        zh: "[08104]Mining of chalk and uncalcined dolomite / 白垩矿和未煅烧白云石开采",
        en: "[08104]Mining of chalk and uncalcined dolomite",
      },
      {
        value: "[08105]Extraction and dredging of industrial sand, sand for construction and gravel",
        zh: "[08105]Extraction and dredging of industrial sand, sand for construction and gravel / 工业用沙、建筑用沙和砾石的开采与疏浚",
        en: "[08105]Extraction and dredging of industrial sand, sand for construction and gravel",
      },
      {
        value: "[08106]Breaking and crushing of stone and gravel",
        zh: "[08106]Breaking and crushing of stone and gravel / 石头和砾石的破碎和粉碎",
        en: "[08106]Breaking and crushing of stone and gravel",
      },
      {
        value: "[08107]Quarrying of sand",
        zh: "[08107]Quarrying of sand / 采砂",
        en: "[08107]Quarrying of sand",
      },
      {
        value: "[08108]Mining of clays, refractory clays and kaolin",
        zh: "[08108]Mining of clays, refractory clays and kaolin / 粘土、耐火粘土和高岭土的开采",
        en: "[08108]Mining of clays, refractory clays and kaolin",
      },
      {
        value: "[08109]Quarrying, crushing and breaking of granite",
        zh: "[08109]Quarrying, crushing and breaking of granite / 花岗岩开采、破碎和粉碎",
        en: "[08109]Quarrying, crushing and breaking of granite",
      },
      {
        value: "[08911]Mining of natural phosphates",
        zh: "[08911]Mining of natural phosphates / 天然磷酸盐矿开采",
        en: "[08911]Mining of natural phosphates",
      },
      {
        value: "[08912]Mining of natural potassium salts",
        zh: "[08912]Mining of natural potassium salts / 天然钾盐开采",
        en: "[08912]Mining of natural potassium salts",
      },
      {
        value: "[08913]Mining of native sulphur",
        zh: "[08913]Mining of native sulphur / 开采天然硫磺",
        en: "[08913]Mining of native sulphur",
      },
      {
        value: "[08914]Extraction and preparation of pyrites and pyrrhotite, except roasting",
        zh: "[08914]Extraction and preparation of pyrites and pyrrhotite, except roasting / 提取和准备黄铁矿和磁黄铁矿，不包括焙烧",
        en: "[08914]Extraction and preparation of pyrites and pyrrhotite, except roasting",
      },
      {
        value: "[08915]Mining of natural barium sulphate and carbonate (barytes and witherite)",
        zh: "[08915]Mining of natural barium sulphate and carbonate (barytes and witherite) / 天然重晶石和碳酸钡(重晶石和毒重石)的开采",
        en: "[08915]Mining of natural barium sulphate and carbonate (barytes and witherite)",
      },
      {
        value: "[08916]Mining of natural borates, natural magnesium sulphates (kieserite)",
        zh: "[08916]Mining of natural borates, natural magnesium sulphates (kieserite) / 天然硼酸盐、天然硫酸镁（水滑石）的开采",
        en: "[08916]Mining of natural borates, natural magnesium sulphates (kieserite)",
      },
      {
        value: "[08917]Mining of earth colours, fluorspar and other minerals valued chiefly as a source of chemicals",
        zh: "[08917]Mining of earth colours, fluorspar and other minerals valued chiefly as a source of chemicals / 地球颜色、萤石和其他主要作为化学品来源的矿物的开采",
        en: "[08917]Mining of earth colours, fluorspar and other minerals valued chiefly as a source of chemicals",
      },
      {
        value: "[08918]Guano mining",
        zh: "[08918]Guano mining / 鸟粪矿开采",
        en: "[08918]Guano mining",
      },
      {
        value: "[08921]Peat digging",
        zh: "[08921]Peat digging / 泥炭挖掘",
        en: "[08921]Peat digging",
      },
      {
        value: "[08922]Peat agglomeration",
        zh: "[08922]Peat agglomeration / 泥炭团聚",
        en: "[08922]Peat agglomeration",
      },
      {
        value: "[08923]Preparation of peat to improve quality or facilitate transport or storage",
        zh: "[08923]Preparation of peat to improve quality or facilitate transport or storage / 准备泥炭以改善质量或便于运输或储存",
        en: "[08923]Preparation of peat to improve quality or facilitate transport or storage",
      },
      {
        value: "[08931]Extraction of salt from underground",
        zh: "[08931]Extraction of salt from underground / 从地下提取盐",
        en: "[08931]Extraction of salt from underground",
      },
      {
        value: "[08932]Salt production by evaporation of sea water or other saline waters",
        zh: "[08932]Salt production by evaporation of sea water or other saline waters / 海水或其他咸水蒸发制盐",
        en: "[08932]Salt production by evaporation of sea water or other saline waters",
      },
      {
        value: "[08933]Crushing, purification and refining of salt by the producer",
        zh: "[08933]Crushing, purification and refining of salt by the producer / 生产者压碎、净化和精炼盐",
        en: "[08933]Crushing, purification and refining of salt by the producer",
      },
      {
        value: "[08991]Mining and quarrying of abrasive materials",
        zh: "[08991]Mining and quarrying of abrasive materials / 磨料材料的开采和采石",
        en: "[08991]Mining and quarrying of abrasive materials",
      },
      {
        value: "[08992]Mining and quarrying of asbestos",
        zh: "[08992]Mining and quarrying of asbestos / 石棉的开采和采石",
        en: "[08992]Mining and quarrying of asbestos",
      },
      {
        value: "[08993]Mining and quarrying of siliceous fossil meals",
        zh: "[08993]Mining and quarrying of siliceous fossil meals / 硅质化石餐料的开采和采石",
        en: "[08993]Mining and quarrying of siliceous fossil meals",
      },
      {
        value: "[08994]Mining and quarrying of natural graphite",
        zh: "[08994]Mining and quarrying of natural graphite / 天然石墨的开采和采石",
        en: "[08994]Mining and quarrying of natural graphite",
      },
      {
        value: "[08995]Mining and quarrying of steatite (talc)",
        zh: "[08995]Mining and quarrying of steatite (talc) / 滑石（タルク）的开采与采石",
        en: "[08995]Mining and quarrying of steatite (talc)",
      },
      {
        value: "[08996]Mining and quarrying of gemstones",
        zh: "[08996]Mining and quarrying of gemstones / 宝石的开采和采石",
        en: "[08996]Mining and quarrying of gemstones",
      },
      {
        value: "[08999]Other mining and quarrying n.e.c.",
        zh: "[08999]Other mining and quarrying n.e.c. / 其他矿产开采和采石",
        en: "[08999]Other mining and quarrying n.e.c.",
      },
      {
        value: "[09101]Oil and gas extraction service activities provided on a fee or contract basis",
        zh: "[09101]Oil and gas extraction service activities provided on a fee or contract basis / 按费用或合同提供石油和天然气开采服务活动",
        en: "[09101]Oil and gas extraction service activities provided on a fee or contract basis",
      },
      {
        value: "[09102]Oil and gas field fire fighting services",
        zh: "[09102]Oil and gas field fire fighting services / 油田和天然气田消防服务",
        en: "[09102]Oil and gas field fire fighting services",
      },
      {
        value: "[09900]Support activities for other mining and quarrying",
        zh: "[09900]Support activities for other mining and quarrying / 其他采矿和采石的支持活动",
        en: "[09900]Support activities for other mining and quarrying",
      },
      {
        value: "[10101]Processing and preserving of meat and production of meat products",
        zh: "[10101]Processing and preserving of meat and production of meat products / 肉类加工及肉制品生产",
        en: "[10101]Processing and preserving of meat and production of meat products",
      },
      {
        value: "[10102]Processing and preserving of poultry and poultry products",
        zh: "[10102]Processing and preserving of poultry and poultry products / 家禽及其产品的加工和保存",
        en: "[10102]Processing and preserving of poultry and poultry products",
      },
      {
        value: "[10103]Production of hides and skins originating from slaughterhouses",
        zh: "[10103]Production of hides and skins originating from slaughterhouses / 屠宰场产生的皮革和毛皮生产",
        en: "[10103]Production of hides and skins originating from slaughterhouses",
      },
      {
        value: "[10104]Operation of slaughterhouses engaged in killing, houses dressing or packing meat",
        zh: "[10104]Operation of slaughterhouses engaged in killing, houses dressing or packing meat / 运营屠宰场，从事屠宰、肉类处理或包装",
        en: "[10104]Operation of slaughterhouses engaged in killing, houses dressing or packing meat",
      },
      {
        value: "[10109]Processing and preserving of meat n.e.c.",
        zh: "[10109]Processing and preserving of meat n.e.c. / 肉类加工和保存（未列明的）",
        en: "[10109]Processing and preserving of meat n.e.c.",
      },
      {
        value: "[10201]Canning of fish, crustaceans and mollusks",
        zh: "[10201]Canning of fish, crustaceans and mollusks / 鱼类、甲壳类和软体动物的罐头加工",
        en: "[10201]Canning of fish, crustaceans and mollusks",
      },
      {
        value: "[10202]Processing, curing and preserving of fish, crustacean and molluscs",
        zh: "[10202]Processing, curing and preserving of fish, crustacean and molluscs / 鱼类、甲壳类和软体动物的加工、腌制和保存",
        en: "[10202]Processing, curing and preserving of fish, crustacean and molluscs",
      },
      {
        value: "[10203]Production of fish meals for human consumption or animal feed",
        zh: "[10203]Production of fish meals for human consumption or animal feed / 生产供人类消费或动物饲料的鱼粉",
        en: "[10203]Production of fish meals for human consumption or animal feed",
      },
      {
        value: "[10204]Production of keropok including keropok lekor",
        zh: "[10204]Production of keropok including keropok lekor / 包括Keropok Lekor在内的Keropok生产",
        en: "[10204]Production of keropok including keropok lekor",
      },
      {
        value: "[10205]Processing of seaweed",
        zh: "[10205]Processing of seaweed / 海藻加工",
        en: "[10205]Processing of seaweed",
      },
      {
        value: "[10301]Manufacture of fruits and vegetable food products",
        zh: "[10301]Manufacture of fruits and vegetable food products / 水果和蔬菜食品制造",
        en: "[10301]Manufacture of fruits and vegetable food products",
      },
      {
        value: "[10302]Manufacture of fruit and vegetable juices",
        zh: "[10302]Manufacture of fruit and vegetable juices / 制造果汁和蔬菜汁",
        en: "[10302]Manufacture of fruit and vegetable juices",
      },
      {
        value: "[10303]Pineapple canning",
        zh: "[10303]Pineapple canning / 菠萝罐头",
        en: "[10303]Pineapple canning",
      },
      {
        value: "[10304]Manufacture of jams, marmalades and table jellies",
        zh: "[10304]Manufacture of jams, marmalades and table jellies / 果酱、橘子酱和餐用果冻的制造",
        en: "[10304]Manufacture of jams, marmalades and table jellies",
      },
      {
        value: "[10305]Manufacture of nuts and nut products",
        zh: "[10305]Manufacture of nuts and nut products / 坚果及坚果制品制造",
        en: "[10305]Manufacture of nuts and nut products",
      },
      {
        value: "[10306]Manufacture of bean curd products",
        zh: "[10306]Manufacture of bean curd products / 豆腐产品制造",
        en: "[10306]Manufacture of bean curd products",
      },
      {
        value: "[10401]Manufacture of crude palm oil",
        zh: "[10401]Manufacture of crude palm oil / 粗棕榈油制造",
        en: "[10401]Manufacture of crude palm oil",
      },
      {
        value: "[10402]Manufacture of refined palm oil",
        zh: "[10402]Manufacture of refined palm oil / 精炼棕榈油的制造",
        en: "[10402]Manufacture of refined palm oil",
      },
      {
        value: "[10403]Manufacture of palm kernel oil",
        zh: "[10403]Manufacture of palm kernel oil / 棕榈仁油的制造",
        en: "[10403]Manufacture of palm kernel oil",
      },
      {
        value: "[10404]Manufacture of crude and refined vegetable oil",
        zh: "[10404]Manufacture of crude and refined vegetable oil / 制造粗加工和精炼植物油",
        en: "[10404]Manufacture of crude and refined vegetable oil",
      },
      {
        value: "[10405]Manufacture of coconut oil",
        zh: "[10405]Manufacture of coconut oil / 椰子油生产",
        en: "[10405]Manufacture of coconut oil",
      },
      {
        value: "[10406]Manufacture of compound cooking fats",
        zh: "[10406]Manufacture of compound cooking fats / 复合烹饪油脂的制造",
        en: "[10406]Manufacture of compound cooking fats",
      },
      {
        value: "[10407]Manufacture of animal oils and fats",
        zh: "[10407]Manufacture of animal oils and fats / 动物油脂和脂肪的制造",
        en: "[10407]Manufacture of animal oils and fats",
      },
      {
        value: "[10501]Manufacture of ice cream and other edible ice such as sorbet",
        zh: "[10501]Manufacture of ice cream and other edible ice such as sorbet / 冰淇淋及其他可食用冰制备，如果汁冰糕",
        en: "[10501]Manufacture of ice cream and other edible ice such as sorbet",
      },
      {
        value: "[10502]Manufacture of condensed, powdered and evaporated milk",
        zh: "[10502]Manufacture of condensed, powdered and evaporated milk / 浓缩、粉状和蒸发牛奶的制造",
        en: "[10502]Manufacture of condensed, powdered and evaporated milk",
      },
      {
        value: "[10509]Manufacture of other dairy products n.e.c.",
        zh: "[10509]Manufacture of other dairy products n.e.c. / 其他未列明的奶制品制造",
        en: "[10509]Manufacture of other dairy products n.e.c.",
      },
      {
        value: "[10611]Rice milling",
        zh: "[10611]Rice milling / 碾米",
        en: "[10611]Rice milling",
      },
      {
        value: "[10612]Provision of milling services",
        zh: "[10612]Provision of milling services / 提供磨粉服务",
        en: "[10612]Provision of milling services",
      },
      {
        value: "[10613]Flour milling",
        zh: "[10613]Flour milling / 面粉加工",
        en: "[10613]Flour milling",
      },
      {
        value: "[10619]Manufacture of grain mill products n.e.c.",
        zh: "[10619]Manufacture of grain mill products n.e.c. / 粮食磨制产品制造",
        en: "[10619]Manufacture of grain mill products n.e.c.",
      },
      {
        value: "[10621]Manufacture of starches and starch products",
        zh: "[10621]Manufacture of starches and starch products / 淀粉及淀粉产品的制造",
        en: "[10621]Manufacture of starches and starch products",
      },
      {
        value: "[10622]Manufacture of glucose, glucose syrup, maltose, inulin",
        zh: "[10622]Manufacture of glucose, glucose syrup, maltose, inulin / 制造葡萄糖、葡萄糖浆、麦芽糖、菊粉",
        en: "[10622]Manufacture of glucose, glucose syrup, maltose, inulin",
      },
      {
        value: "[10623]Manufacture of sago and tapioca flour/products",
        zh: "[10623]Manufacture of sago and tapioca flour/products / 制造木薯和西米粉/产品",
        en: "[10623]Manufacture of sago and tapioca flour/products",
      },
      {
        value: "[10711]Manufacture of biscuits and cookies",
        zh: "[10711]Manufacture of biscuits and cookies / 饼干和小甜饼的制造",
        en: "[10711]Manufacture of biscuits and cookies",
      },
      {
        value: "[10712]Manufacture of bread, cakes and other bakery products",
        zh: "[10712]Manufacture of bread, cakes and other bakery products / 面包、蛋糕及其他烘焙产品的制造",
        en: "[10712]Manufacture of bread, cakes and other bakery products",
      },
      {
        value: "[10713]Manufacture of snack products",
        zh: "[10713]Manufacture of snack products / 制作小吃产品",
        en: "[10713]Manufacture of snack products",
      },
      {
        value: "[10714]Manufacture of frozen bakery products",
        zh: "[10714]Manufacture of frozen bakery products / 冷冻烘焙产品的制造",
        en: "[10714]Manufacture of frozen bakery products",
      },
      {
        value: "[10721]Manufacture of sugar",
        zh: "[10721]Manufacture of sugar / 糖的制造",
        en: "[10721]Manufacture of sugar",
      },
      {
        value: "[10722]Manufacture of sugar products",
        zh: "[10722]Manufacture of sugar products / 糖产品制造",
        en: "[10722]Manufacture of sugar products",
      },
      {
        value: "[10731]Manufacture of cocoa products",
        zh: "[10731]Manufacture of cocoa products / 可可制品的制造",
        en: "[10731]Manufacture of cocoa products",
      },
      {
        value: "[10732]Manufacture of chocolate and chocolate products",
        zh: "[10732]Manufacture of chocolate and chocolate products / 巧克力及巧克力制品制造",
        en: "[10732]Manufacture of chocolate and chocolate products",
      },
      {
        value: "[10733]Manufacture of sugar confectionery",
        zh: "[10733]Manufacture of sugar confectionery / 糖果制造",
        en: "[10733]Manufacture of sugar confectionery",
      },
      {
        value: "[10741]Manufacture of meehoon, noodles and other related products",
        zh: "[10741]Manufacture of meehoon, noodles and other related products / 米粉、面条及其他相关产品的制造",
        en: "[10741]Manufacture of meehoon, noodles and other related products",
      },
      {
        value: "[10742]Manufacture of pastas",
        zh: "[10742]Manufacture of pastas / 意大利面的制造",
        en: "[10742]Manufacture of pastas",
      },
      {
        value: "[10750]Manufacture of prepared meals and dishes",
        zh: "[10750]Manufacture of prepared meals and dishes / 预制餐和菜肴的制造",
        en: "[10750]Manufacture of prepared meals and dishes",
      },
      {
        value: "[10791]Manufacture of coffee",
        zh: "[10791]Manufacture of coffee / 咖啡制造",
        en: "[10791]Manufacture of coffee",
      },
      {
        value: "[10792]Manufacture of tea",
        zh: "[10792]Manufacture of tea / 茶叶制造",
        en: "[10792]Manufacture of tea",
      },
      {
        value: "[10793]Manufacture of sauces and condiments",
        zh: "[10793]Manufacture of sauces and condiments / 调味品和佐料的制造",
        en: "[10793]Manufacture of sauces and condiments",
      },
      {
        value: "[10794]Manufacture of spices and curry powder",
        zh: "[10794]Manufacture of spices and curry powder / 香料及咖喱粉制造",
        en: "[10794]Manufacture of spices and curry powder",
      },
      {
        value: "[10795]Manufacture of egg products",
        zh: "[10795]Manufacture of egg products / 蛋制品制造",
        en: "[10795]Manufacture of egg products",
      },
      {
        value: "[10799]Manufacture of other food products n.e.c.",
        zh: "[10799]Manufacture of other food products n.e.c. / 其他食品制造",
        en: "[10799]Manufacture of other food products n.e.c.",
      },
      {
        value: "[10800]Manufacture of prepared animal feeds",
        zh: "[10800]Manufacture of prepared animal feeds / 动物饲料制造",
        en: "[10800]Manufacture of prepared animal feeds",
      },
      {
        value: "[11010]Distilling, rectifying and blending of spirits",
        zh: "[11010]Distilling, rectifying and blending of spirits / 蒸馏、精馏及混合酒精饮料",
        en: "[11010]Distilling, rectifying and blending of spirits",
      },
      {
        value: "[11020]Manufacture of wines",
        zh: "[11020]Manufacture of wines / 葡萄酒制造",
        en: "[11020]Manufacture of wines",
      },
      {
        value: "[11030]Manufacture of malt liquors and malt",
        zh: "[11030]Manufacture of malt liquors and malt / 制造麦芽饮料和麦芽",
        en: "[11030]Manufacture of malt liquors and malt",
      },
      {
        value: "[11041]Manufacture of soft drinks",
        zh: "[11041]Manufacture of soft drinks / 软饮料制造",
        en: "[11041]Manufacture of soft drinks",
      },
      {
        value: "[11042]Production of natural mineral water and other bottled water",
        zh: "[11042]Production of natural mineral water and other bottled water / 天然矿泉水及其他瓶装水生产",
        en: "[11042]Production of natural mineral water and other bottled water",
      },
      {
        value: "[12000]MANUFACTURE OF TOBACCO PRODUCTS",
        zh: "[12000]MANUFACTURE OF TOBACCO PRODUCTS / 烟草制品制造",
        en: "[12000]MANUFACTURE OF TOBACCO PRODUCTS",
      },
      {
        value: "[13110]Preparation and spinning of textile fibres",
        zh: "[13110]Preparation and spinning of textile fibres / 纺织纤维的准备和纺纱",
        en: "[13110]Preparation and spinning of textile fibres",
      },
      {
        value: "[13120]Weaving of textiles",
        zh: "[13120]Weaving of textiles / 织物编织",
        en: "[13120]Weaving of textiles",
      },
      {
        value: "[13131]Batik making",
        zh: "[13131]Batik making / 蜡染制作",
        en: "[13131]Batik making",
      },
      {
        value: "[13132]Dyeing, bleaching, printing and finishing of yarns and fabrics",
        zh: "[13132]Dyeing, bleaching, printing and finishing of yarns and fabrics / 纱线和织物的染色、漂白、印花和整理",
        en: "[13132]Dyeing, bleaching, printing and finishing of yarns and fabrics",
      },
      {
        value: "[13139]Other finishing textiles",
        zh: "[13139]Other finishing textiles / 其他纺织品后处理",
        en: "[13139]Other finishing textiles",
      },
      {
        value: "[13910]Manufacture of knitted and crocheted fabrics",
        zh: "[13910]Manufacture of knitted and crocheted fabrics / 针织和钩织织物制造",
        en: "[13910]Manufacture of knitted and crocheted fabrics",
      },
      {
        value: "[13921]Manufacture of made-up articles of any textile materials, including of knitted or crocheted fabrics",
        zh: "[13921]Manufacture of made-up articles of any textile materials, including of knitted or crocheted fabrics / 纺织材料制成的成衣制造，包括针织或钩编织物",
        en: "[13921]Manufacture of made-up articles of any textile materials, including of knitted or crocheted fabrics",
      },
      {
        value: "[13922]Manufacture of made-up furnishing articles",
        zh: "[13922]Manufacture of made-up furnishing articles / 制成品装饰品制造",
        en: "[13922]Manufacture of made-up furnishing articles",
      },
      {
        value: "[13930]Manufacture of carpets and rugs",
        zh: "[13930]Manufacture of carpets and rugs / 地毯和地垫的制造",
        en: "[13930]Manufacture of carpets and rugs",
      },
      {
        value: "[13940]Manufacture of cordage, rope, twine and netting",
        zh: "[13940]Manufacture of cordage, rope, twine and netting / 绳索、绳、线和网的制造",
        en: "[13940]Manufacture of cordage, rope, twine and netting",
      },
      {
        value: "[13990]Manufacture of other textiles n.e.c.",
        zh: "[13990]Manufacture of other textiles n.e.c. / 其他纺织品的制造",
        en: "[13990]Manufacture of other textiles n.e.c.",
      },
      {
        value: "[14101]Manufacture of specific wearing apparel",
        zh: "[14101]Manufacture of specific wearing apparel / 特定穿着服装的制造",
        en: "[14101]Manufacture of specific wearing apparel",
      },
      {
        value: "[14102]Manufacture of clothings",
        zh: "[14102]Manufacture of clothings / 服装的制造",
        en: "[14102]Manufacture of clothings",
      },
      {
        value: "[14103]Custom tailoring",
        zh: "[14103]Custom tailoring / 定制服装",
        en: "[14103]Custom tailoring",
      },
      {
        value: "[14109]Manufacture of other clothing accessories",
        zh: "[14109]Manufacture of other clothing accessories / 其他服装配件的制造",
        en: "[14109]Manufacture of other clothing accessories",
      },
      {
        value: "[14200]Manufacture of articles made of fur skins",
        zh: "[14200]Manufacture of articles made of fur skins / 毛皮制成品的制造",
        en: "[14200]Manufacture of articles made of fur skins",
      },
      {
        value: "[14300]Manufacture of knitted and crocheted apparel",
        zh: "[14300]Manufacture of knitted and crocheted apparel / 针织和钩编服装制造",
        en: "[14300]Manufacture of knitted and crocheted apparel",
      },
      {
        value: "[15110]Tanning and dressing of leather; dressing and dyeing of fur",
        zh: "[15110]Tanning and dressing of leather; dressing and dyeing of fur / 皮革的鞣制和整饰；毛皮的染色和整饰",
        en: "[15110]Tanning and dressing of leather; dressing and dyeing of fur",
      },
      {
        value: "[15120]Manufacture of luggage, handbags and the like, saddlery and harness",
        zh: "[15120]Manufacture of luggage, handbags and the like, saddlery and harness / 行李箱、手提包及类似物品、马具和鞍具的制造",
        en: "[15120]Manufacture of luggage, handbags and the like, saddlery and harness",
      },
      {
        value: "[15201]Manufacture of leather footwear",
        zh: "[15201]Manufacture of leather footwear / 皮革鞋类制造",
        en: "[15201]Manufacture of leather footwear",
      },
      {
        value: "[15202]Manufacture of plastic footwear",
        zh: "[15202]Manufacture of plastic footwear / 塑料鞋制造",
        en: "[15202]Manufacture of plastic footwear",
      },
      {
        value: "[15203]Manufacture of rubber footwear",
        zh: "[15203]Manufacture of rubber footwear / 橡胶鞋类制造",
        en: "[15203]Manufacture of rubber footwear",
      },
      {
        value: "[15209]Manufacture of other footwear n.e.c.",
        zh: "[15209]Manufacture of other footwear n.e.c. / 其他鞋类的制造",
        en: "[15209]Manufacture of other footwear n.e.c.",
      },
      {
        value: "[16100]Sawmilling and planning of wood",
        zh: "[16100]Sawmilling and planning of wood / 锯木和木材刨切",
        en: "[16100]Sawmilling and planning of wood",
      },
      {
        value: "[16211]Manufacture of veneer sheets and plywood",
        zh: "[16211]Manufacture of veneer sheets and plywood / 制造胶合板和胶合板",
        en: "[16211]Manufacture of veneer sheets and plywood",
      },
      {
        value: "[16212]Manufacture of particle board and fibreboard",
        zh: "[16212]Manufacture of particle board and fibreboard / 制造颗粒板和纤维板",
        en: "[16212]Manufacture of particle board and fibreboard",
      },
      {
        value: "[16221]Manufacture of builders’ carpentry",
        zh: "[16221]Manufacture of builders’ carpentry / 建筑用木工制品制造",
        en: "[16221]Manufacture of builders’ carpentry",
      },
      {
        value: "[16222]Manufacture of joinery wood products",
        zh: "[16222]Manufacture of joinery wood products / 制造木工产品",
        en: "[16222]Manufacture of joinery wood products",
      },
      {
        value: "[16230]Manufacture of wooden containers",
        zh: "[16230]Manufacture of wooden containers / 制造木制容器",
        en: "[16230]Manufacture of wooden containers",
      },
      {
        value: "[16291]Manufacture of wood charcoal",
        zh: "[16291]Manufacture of wood charcoal / 木炭制造",
        en: "[16291]Manufacture of wood charcoal",
      },
      {
        value: "[16292]Manufacture of other products of wood, cane, articles of cork, straw and plaiting materials",
        zh: "[16292]Manufacture of other products of wood, cane, articles of cork, straw and plaiting materials / 其他木制品、藤制品、软木制品、稻草和编织材料制品的制造",
        en: "[16292]Manufacture of other products of wood, cane, articles of cork, straw and plaiting materials",
      },
      {
        value: "[17010]Manufacture of pulp, paper and paperboard",
        zh: "[17010]Manufacture of pulp, paper and paperboard / 纸浆、纸及纸板的制造",
        en: "[17010]Manufacture of pulp, paper and paperboard",
      },
      {
        value: "[17020]Manufacture of corrugated paper and paperboard and of containers of paper and paperboard",
        zh: "[17020]Manufacture of corrugated paper and paperboard and of containers of paper and paperboard / 制造瓦楞纸和纸板以及纸和纸板容器",
        en: "[17020]Manufacture of corrugated paper and paperboard and of containers of paper and paperboard",
      },
      {
        value: "[17091]Manufacture of envelopes and letter-card",
        zh: "[17091]Manufacture of envelopes and letter-card / 信封和信卡制造",
        en: "[17091]Manufacture of envelopes and letter-card",
      },
      {
        value: "[17092]Manufacture of household and personal hygiene paper",
        zh: "[17092]Manufacture of household and personal hygiene paper / 家用和个人卫生用纸的制造",
        en: "[17092]Manufacture of household and personal hygiene paper",
      },
      {
        value: "[17093]Manufacture of gummed or adhesive paper in strips or rolls and labels and wall paper",
        zh: "[17093]Manufacture of gummed or adhesive paper in strips or rolls and labels and wall paper / 制造胶带或粘合纸条或卷纸、标签和墙纸",
        en: "[17093]Manufacture of gummed or adhesive paper in strips or rolls and labels and wall paper",
      },
      {
        value: "[17094]Manufacture of effigies, funeral paper goods, joss paper",
        zh: "[17094]Manufacture of effigies, funeral paper goods, joss paper / 制作偶像、丧葬纸制品、冥纸",
        en: "[17094]Manufacture of effigies, funeral paper goods, joss paper",
      },
      {
        value: "[17099]Manufacture of other articles of paper and paperboard n.e.c.",
        zh: "[17099]Manufacture of other articles of paper and paperboard n.e.c. / 其他纸和纸板制品的制造",
        en: "[17099]Manufacture of other articles of paper and paperboard n.e.c.",
      },
      {
        value: "[18110]Printing",
        zh: "[18110]Printing / 印刷",
        en: "[18110]Printing",
      },
      {
        value: "[18120]Service activities related to printing",
        zh: "[18120]Service activities related to printing / 与印刷相关的服务活动",
        en: "[18120]Service activities related to printing",
      },
      {
        value: "[18200]Reproduction of recorded media",
        zh: "[18200]Reproduction of recorded media / 录制媒介的复制",
        en: "[18200]Reproduction of recorded media",
      },
      {
        value: "[19100]Manufacture of coke oven products",
        zh: "[19100]Manufacture of coke oven products / 焦炉产品制造",
        en: "[19100]Manufacture of coke oven products",
      },
      {
        value: "[19201]Manufacture of refined petroleum products",
        zh: "[19201]Manufacture of refined petroleum products / 制造精炼石油产品",
        en: "[19201]Manufacture of refined petroleum products",
      },
      {
        value: "[19202]Manufacture of bio-diesel products",
        zh: "[19202]Manufacture of bio-diesel products / 生物柴油产品的制造",
        en: "[19202]Manufacture of bio-diesel products",
      },
      {
        value: "[20111]Manufacture of liquefied or compressed inorganic industrial or medical gases",
        zh: "[20111]Manufacture of liquefied or compressed inorganic industrial or medical gases / 液化或压缩无机工业或医用气体的制造",
        en: "[20111]Manufacture of liquefied or compressed inorganic industrial or medical gases",
      },
      {
        value: "[20112]Manufacture of basic organic chemicals",
        zh: "[20112]Manufacture of basic organic chemicals / 基础有机化学品制造",
        en: "[20112]Manufacture of basic organic chemicals",
      },
      {
        value: "[20113]Manufacture of inorganic compounds",
        zh: "[20113]Manufacture of inorganic compounds / 无机化合物制造",
        en: "[20113]Manufacture of inorganic compounds",
      },
      {
        value: "[20119]Manufacture of other basic chemicals n.e.c.",
        zh: "[20119]Manufacture of other basic chemicals n.e.c. / 其他基础化学品的制造",
        en: "[20119]Manufacture of other basic chemicals n.e.c.",
      },
      {
        value: "[20121]Manufacture of fertilizers",
        zh: "[20121]Manufacture of fertilizers / 肥料制造",
        en: "[20121]Manufacture of fertilizers",
      },
      {
        value: "[20129]Manufacture of associated nitrogen products",
        zh: "[20129]Manufacture of associated nitrogen products / 相关氮产品的制造",
        en: "[20129]Manufacture of associated nitrogen products",
      },
      {
        value: "[20131]Manufacture of plastic in primary forms",
        zh: "[20131]Manufacture of plastic in primary forms / 塑料初级形态的制造",
        en: "[20131]Manufacture of plastic in primary forms",
      },
      {
        value: "[20132]Manufacture of synthetic rubber in primary forms: synthetic rubber, factice",
        zh: "[20132]Manufacture of synthetic rubber in primary forms: synthetic rubber, factice / 初级形态合成橡胶制造；合成橡胶、硫化橡胶",
        en: "[20132]Manufacture of synthetic rubber in primary forms: synthetic rubber, factice",
      },
      {
        value: "[20133]Manufacture of mixtures of synthetic rubber and natural rubber or rubber - like gums",
        zh: "[20133]Manufacture of mixtures of synthetic rubber and natural rubber or rubber - like gums / 合成橡胶与天然橡胶或橡胶状胶体混合物的制造",
        en: "[20133]Manufacture of mixtures of synthetic rubber and natural rubber or rubber - like gums",
      },
      {
        value: "[20210]Manufacture of pesticides and other agrochemical products",
        zh: "[20210]Manufacture of pesticides and other agrochemical products / 农药及其他农用化学品的制造",
        en: "[20210]Manufacture of pesticides and other agrochemical products",
      },
      {
        value: "[20221]Manufacture of paints, varnishes and similar coatings ink and mastics",
        zh: "[20221]Manufacture of paints, varnishes and similar coatings ink and mastics / 涂料、清漆及类似产品制造，墨水及密封剂制造",
        en: "[20221]Manufacture of paints, varnishes and similar coatings ink and mastics",
      },
      {
        value: "[20222]Manufacture of printing ink",
        zh: "[20222]Manufacture of printing ink / 印刷油墨的制造",
        en: "[20222]Manufacture of printing ink",
      },
      {
        value: "[20231]Manufacture of soap and detergents, cleaning and polishing preparations",
        zh: "[20231]Manufacture of soap and detergents, cleaning and polishing preparations / 肥皂和洗涤剂、清洁和抛光制剂制造",
        en: "[20231]Manufacture of soap and detergents, cleaning and polishing preparations",
      },
      {
        value: "[20232]Manufacture of perfumes and toilet preparations",
        zh: "[20232]Manufacture of perfumes and toilet preparations / 香水和化妆品的制造",
        en: "[20232]Manufacture of perfumes and toilet preparations",
      },
      {
        value: "[20291]Manufacture of photographic plates, films, sensitized paper and other sensitized unexposed materials",
        zh: "[20291]Manufacture of photographic plates, films, sensitized paper and other sensitized unexposed materials / 摄影板、胶片、感光纸及其他未曝光感光材料的制造",
        en: "[20291]Manufacture of photographic plates, films, sensitized paper and other sensitized unexposed materials",
      },
      {
        value: "[20292]Manufacture of writing and drawing ink",
        zh: "[20292]Manufacture of writing and drawing ink / 制造书写和绘图墨水",
        en: "[20292]Manufacture of writing and drawing ink",
      },
      {
        value: "[20299]Manufacture of other chemical products n.e.c.",
        zh: "[20299]Manufacture of other chemical products n.e.c. / 制造其他化学产品（不包括化肥和农药）",
        en: "[20299]Manufacture of other chemical products n.e.c.",
      },
      {
        value: "[20300]Manufacture of man-made fibres",
        zh: "[20300]Manufacture of man-made fibres / 人造纤维的制造",
        en: "[20300]Manufacture of man-made fibres",
      },
      {
        value: "[21001]Manufacture of medicinal active substances to be used for their pharmacological properties in the manufacture of medicaments",
        zh: "[21001]Manufacture of medicinal active substances to be used for their pharmacological properties in the manufacture of medicaments / 制造用于药理属性的药用活性物质",
        en: "[21001]Manufacture of medicinal active substances to be used for their pharmacological properties in the manufacture of medicaments",
      },
      {
        value: "[21002]Processing of blood",
        zh: "[21002]Processing of blood / 血液处理",
        en: "[21002]Processing of blood",
      },
      {
        value: "[21003]Manufacture of medicaments",
        zh: "[21003]Manufacture of medicaments / 药品制造",
        en: "[21003]Manufacture of medicaments",
      },
      {
        value: "[21004]Manufacture of chemical contraceptive products",
        zh: "[21004]Manufacture of chemical contraceptive products / 化学避孕产品的制造",
        en: "[21004]Manufacture of chemical contraceptive products",
      },
      {
        value: "[21005]Manufacture of medical diagnostic preparation",
        zh: "[21005]Manufacture of medical diagnostic preparation / 制造医疗诊断制剂",
        en: "[21005]Manufacture of medical diagnostic preparation",
      },
      {
        value: "[21006]Manufacture of radioactive in-vivo diagnostic substances",
        zh: "[21006]Manufacture of radioactive in-vivo diagnostic substances / 放射性体内诊断物质的制造",
        en: "[21006]Manufacture of radioactive in-vivo diagnostic substances",
      },
      {
        value: "[21007]Manufacture of biotech pharmaceuticals",
        zh: "[21007]Manufacture of biotech pharmaceuticals / 生物技术药品制造",
        en: "[21007]Manufacture of biotech pharmaceuticals",
      },
      {
        value: "[21009]Manufacture of other pharmaceuticals, medicinal chemical and botanical products n.e.c.",
        zh: "[21009]Manufacture of other pharmaceuticals, medicinal chemical and botanical products n.e.c. / 其他未列明的药品、医药化学品和植物产品的制造",
        en: "[21009]Manufacture of other pharmaceuticals, medicinal chemical and botanical products n.e.c.",
      },
      {
        value: "[22111]Manufacture of rubber tyres for vehicles",
        zh: "[22111]Manufacture of rubber tyres for vehicles / 车辆橡胶轮胎的制造",
        en: "[22111]Manufacture of rubber tyres for vehicles",
      },
      {
        value: "[22112]Manufacture of interchangeable tyre treads and retreading rubber tyres",
        zh: "[22112]Manufacture of interchangeable tyre treads and retreading rubber tyres / 可互换轮胎胎面的制造和翻新橡胶轮胎",
        en: "[22112]Manufacture of interchangeable tyre treads and retreading rubber tyres",
      },
      {
        value: "[22191]Manufacture of other products of natural or synthetic rubber, unvulcanized, vulcanized or hardened",
        zh: "[22191]Manufacture of other products of natural or synthetic rubber, unvulcanized, vulcanized or hardened / 其他天然或合成橡胶、未硫化、硫化或硬化的其他产品制造",
        en: "[22191]Manufacture of other products of natural or synthetic rubber, unvulcanized, vulcanized or hardened",
      },
      {
        value: "[22192]Manufacture of rubber gloves",
        zh: "[22192]Manufacture of rubber gloves / 橡胶手套的制造",
        en: "[22192]Manufacture of rubber gloves",
      },
      {
        value: "[22193]Rubber remilling and latex processing",
        zh: "[22193]Rubber remilling and latex processing / 橡胶再磨和乳胶处理",
        en: "[22193]Rubber remilling and latex processing",
      },
      {
        value: "[22199]Manufacture of other rubber products n.e.c",
        zh: "[22199]Manufacture of other rubber products n.e.c / 其他橡胶制品制造",
        en: "[22199]Manufacture of other rubber products n.e.c",
      },
      {
        value: "[22201]Manufacture of semi-manufactures of plastic products",
        zh: "[22201]Manufacture of semi-manufactures of plastic products / 塑料制品半成品制造",
        en: "[22201]Manufacture of semi-manufactures of plastic products",
      },
      {
        value: "[22202]Manufacture of finished plastic products",
        zh: "[22202]Manufacture of finished plastic products / 制造成品塑料产品",
        en: "[22202]Manufacture of finished plastic products",
      },
      {
        value: "[22203]Manufacture of plastic articles for the packing of goods",
        zh: "[22203]Manufacture of plastic articles for the packing of goods / 商品包装用塑料制品的制造",
        en: "[22203]Manufacture of plastic articles for the packing of goods",
      },
      {
        value: "[22204]Manufacture of builders’ plastics ware",
        zh: "[22204]Manufacture of builders’ plastics ware / 建筑用塑料制品的制造",
        en: "[22204]Manufacture of builders’ plastics ware",
      },
      {
        value: "[22205]Manufacture of plastic tableware, kitchenware and toilet articles",
        zh: "[22205]Manufacture of plastic tableware, kitchenware and toilet articles / 塑料餐具、厨具和卫生用品的制造",
        en: "[22205]Manufacture of plastic tableware, kitchenware and toilet articles",
      },
      {
        value: "[22209]Manufacture of diverse plastic products n.e.c.",
        zh: "[22209]Manufacture of diverse plastic products n.e.c. / 制造各种塑料产品",
        en: "[22209]Manufacture of diverse plastic products n.e.c.",
      },
      {
        value: "[23101]Manufacture of flat glass, including wired, coloured or tinted flat glass",
        zh: "[23101]Manufacture of flat glass, including wired, coloured or tinted flat glass / 平板玻璃的制造，包括拉丝、彩色或着色平板玻璃",
        en: "[23101]Manufacture of flat glass, including wired, coloured or tinted flat glass",
      },
      {
        value: "[23102]Manufacture of laboratory, hygienic or pharmaceutical glassware",
        zh: "[23102]Manufacture of laboratory, hygienic or pharmaceutical glassware / 实验室、卫生或制药玻璃器皿制造",
        en: "[23102]Manufacture of laboratory, hygienic or pharmaceutical glassware",
      },
      {
        value: "[23109]Manufacture of other glass products n.e.c.",
        zh: "[23109]Manufacture of other glass products n.e.c. / 其他玻璃制品的制造",
        en: "[23109]Manufacture of other glass products n.e.c.",
      },
      {
        value: "[23911]Manufacture of refractory mortars and concretes",
        zh: "[23911]Manufacture of refractory mortars and concretes / 耐火砂浆和混凝土的制造",
        en: "[23911]Manufacture of refractory mortars and concretes",
      },
      {
        value: "[23912]Manufacture of refractory ceramic goods",
        zh: "[23912]Manufacture of refractory ceramic goods / 耐火陶瓷制品的制造",
        en: "[23912]Manufacture of refractory ceramic goods",
      },
      {
        value: "[23921]Manufacture of non-refractory ceramic",
        zh: "[23921]Manufacture of non-refractory ceramic / 非耐火陶瓷制造",
        en: "[23921]Manufacture of non-refractory ceramic",
      },
      {
        value: "[23929]Manufacture of other clay building materials",
        zh: "[23929]Manufacture of other clay building materials / 其他粘土建筑材料制造",
        en: "[23929]Manufacture of other clay building materials",
      },
      {
        value: "[23930]Manufacture of other porcelain and ceramic products",
        zh: "[23930]Manufacture of other porcelain and ceramic products / 其他瓷质和陶瓷制品制造",
        en: "[23930]Manufacture of other porcelain and ceramic products",
      },
      {
        value: "[23941]Manufacture of hydraulic cement",
        zh: "[23941]Manufacture of hydraulic cement / 水硬性水泥的制造",
        en: "[23941]Manufacture of hydraulic cement",
      },
      {
        value: "[23942]Manufacture of lime and plaster",
        zh: "[23942]Manufacture of lime and plaster / 石灰和石膏制造",
        en: "[23942]Manufacture of lime and plaster",
      },
      {
        value: "[23951]Manufacture of ready-mix and dry-mix concrete and mortars",
        zh: "[23951]Manufacture of ready-mix and dry-mix concrete and mortars / 预拌和干混混凝土及砂浆的制造",
        en: "[23951]Manufacture of ready-mix and dry-mix concrete and mortars",
      },
      {
        value: "[23952]Manufacture of precast concrete, cement or artificial stone articles for use in construction",
        zh: "[23952]Manufacture of precast concrete, cement or artificial stone articles for use in construction / 预制混凝土、水泥或人造石制品的制造，用于建筑",
        en: "[23952]Manufacture of precast concrete, cement or artificial stone articles for use in construction",
      },
      {
        value: "[23953]Manufacture of prefabricated structural components for building or civil engineering of cement, concrete or artificial stone",
        zh: "[23953]Manufacture of prefabricated structural components for building or civil engineering of cement, concrete or artificial stone / 水泥、混凝土或人造石的预制建筑或土木工程结构组件的制造",
        en: "[23953]Manufacture of prefabricated structural components for building or civil engineering of cement, concrete or artificial stone",
      },
      {
        value: "[23959]Manufacture of other articles of concrete, cement and plaster n.e.c.",
        zh: "[23959]Manufacture of other articles of concrete, cement and plaster n.e.c. / 制造其他混凝土、水泥和石膏制品",
        en: "[23959]Manufacture of other articles of concrete, cement and plaster n.e.c.",
      },
      {
        value: "[23960]Cutting, shaping and finishing of stone",
        zh: "[23960]Cutting, shaping and finishing of stone / 石材的切割、造型和完成",
        en: "[23960]Cutting, shaping and finishing of stone",
      },
      {
        value: "[23990]Manufacture of other non-metallic mineral products n.e.c.",
        zh: "[23990]Manufacture of other non-metallic mineral products n.e.c. / 其他非金属矿物制品制造",
        en: "[23990]Manufacture of other non-metallic mineral products n.e.c.",
      },
      {
        value: "[24101]Production of pig iron and spiegeleisen in pigs, blocks or other primary forms",
        zh: "[24101]Production of pig iron and spiegeleisen in pigs, blocks or other primary forms / 生铁和镜铁的生产，以锭、块或其他初级形态",
        en: "[24101]Production of pig iron and spiegeleisen in pigs, blocks or other primary forms",
      },
      {
        value: "[24102]Production of bars and rods of stainless steel or other alloy steel",
        zh: "[24102]Production of bars and rods of stainless steel or other alloy steel / 不锈钢或其他合金钢棒材和条材的生产",
        en: "[24102]Production of bars and rods of stainless steel or other alloy steel",
      },
      {
        value: "[24103]Manufacture of seamless tubes, by hot rolling, hot extrusion or hot drawing, or by cold drawing or cold rolling",
        zh: "[24103]Manufacture of seamless tubes, by hot rolling, hot extrusion or hot drawing, or by cold drawing or cold rolling / 通过热轧、热挤压或热拉拔，或冷拔或冷轧制造无缝管",
        en: "[24103]Manufacture of seamless tubes, by hot rolling, hot extrusion or hot drawing, or by cold drawing or cold rolling",
      },
      {
        value: "[24104]Manufacture of steel tube fittings",
        zh: "[24104]Manufacture of steel tube fittings / 钢管配件制造",
        en: "[24104]Manufacture of steel tube fittings",
      },
      {
        value: "[24109]Manufacture of other basic iron and steel products n.e.c.",
        zh: "[24109]Manufacture of other basic iron and steel products n.e.c. / 其他基础铁和钢产品制造",
        en: "[24109]Manufacture of other basic iron and steel products n.e.c.",
      },
      {
        value: "[24201]Tin smelting",
        zh: "[24201]Tin smelting / 锡冶炼",
        en: "[24201]Tin smelting",
      },
      {
        value: "[24202]Production of aluminium from alumina",
        zh: "[24202]Production of aluminium from alumina / 从氧化铝中生产铝",
        en: "[24202]Production of aluminium from alumina",
      },
      {
        value: "[24209]Manufacture of other basic precious and other non-ferrous metals n.e.c.",
        zh: "[24209]Manufacture of other basic precious and other non-ferrous metals n.e.c. / 其他基本贵金属及其他有色金属的制造",
        en: "[24209]Manufacture of other basic precious and other non-ferrous metals n.e.c.",
      },
      {
        value: "[24311]Casting of iron",
        zh: "[24311]Casting of iron / 铁的铸造",
        en: "[24311]Casting of iron",
      },
      {
        value: "[24312]Casting of steel",
        zh: "[24312]Casting of steel / 钢的铸造",
        en: "[24312]Casting of steel",
      },
      {
        value: "[24320]Casting of non-ferrous metals",
        zh: "[24320]Casting of non-ferrous metals / 有色金属的铸造",
        en: "[24320]Casting of non-ferrous metals",
      },
      {
        value: "[25111]Manufacture of industrial frameworks in metal",
        zh: "[25111]Manufacture of industrial frameworks in metal / 金属制工业框架制造",
        en: "[25111]Manufacture of industrial frameworks in metal",
      },
      {
        value: "[25112]Manufacture of prefabricated buildings mainly of metal",
        zh: "[25112]Manufacture of prefabricated buildings mainly of metal / 主要由金属制成的预制建筑的制造",
        en: "[25112]Manufacture of prefabricated buildings mainly of metal",
      },
      {
        value: "[25113]Manufacture of metal doors, windows and their frames, shutters and gates",
        zh: "[25113]Manufacture of metal doors, windows and their frames, shutters and gates / 金属门、窗户及其框架、百叶窗和大门的制造",
        en: "[25113]Manufacture of metal doors, windows and their frames, shutters and gates",
      },
      {
        value: "[25119]Manufacture of other structural metal products",
        zh: "[25119]Manufacture of other structural metal products / 其他金属结构产品制造",
        en: "[25119]Manufacture of other structural metal products",
      },
      {
        value: "[25120]Manufacture of tanks, reservoirs and containers of metal",
        zh: "[25120]Manufacture of tanks, reservoirs and containers of metal / 金属制罐、储罐和容器的制造",
        en: "[25120]Manufacture of tanks, reservoirs and containers of metal",
      },
      {
        value: "[25130]Manufacture of steam generators, except central heating hot water boilers",
        zh: "[25130]Manufacture of steam generators, except central heating hot water boilers / 制造蒸汽发电机，不包括中央供暖热水锅炉",
        en: "[25130]Manufacture of steam generators, except central heating hot water boilers",
      },
      {
        value: "[25200]Manufacture of weapons and ammunition",
        zh: "[25200]Manufacture of weapons and ammunition / 武器和弹药制造",
        en: "[25200]Manufacture of weapons and ammunition",
      },
      {
        value: "[25910]Forging, pressing, stamping and roll-forming of metal; powder metallurgy",
        zh: "[25910]Forging, pressing, stamping and roll-forming of metal; powder metallurgy / 金属的锻造、压制、冲压和滚制；粉末冶金",
        en: "[25910]Forging, pressing, stamping and roll-forming of metal; powder metallurgy",
      },
      {
        value: "[25920]Treatment and coating of metals; machining",
        zh: "[25920]Treatment and coating of metals; machining / 金属的处理和涂层；机械加工",
        en: "[25920]Treatment and coating of metals; machining",
      },
      {
        value: "[25930]Manufacture of cutlery, hand tools and general hardware",
        zh: "[25930]Manufacture of cutlery, hand tools and general hardware / 餐具、手工工具及一般五金制品制造",
        en: "[25930]Manufacture of cutlery, hand tools and general hardware",
      },
      {
        value: "[25991]Manufacture of tins and cans for food products, collapsible tubes and boxes",
        zh: "[25991]Manufacture of tins and cans for food products, collapsible tubes and boxes / 食品用罐头、易拉罐和盒子的制造",
        en: "[25991]Manufacture of tins and cans for food products, collapsible tubes and boxes",
      },
      {
        value: "[25992]Manufacture of metal cable, plaited bands and similar articles",
        zh: "[25992]Manufacture of metal cable, plaited bands and similar articles / 金属电缆、编织带及类似物品的制造",
        en: "[25992]Manufacture of metal cable, plaited bands and similar articles",
      },
      {
        value: "[25993]Manufacture of bolts, screws, nuts and similar threaded products",
        zh: "[25993]Manufacture of bolts, screws, nuts and similar threaded products / 螺栓、螺丝、螺母及类似螺纹产品的制造",
        en: "[25993]Manufacture of bolts, screws, nuts and similar threaded products",
      },
      {
        value: "[25994]Manufacture of metal household articles",
        zh: "[25994]Manufacture of metal household articles / 金属家用制品制造",
        en: "[25994]Manufacture of metal household articles",
      },
      {
        value: "[25999]Manufacture of any other fabricated metal products n.e.c.",
        zh: "[25999]Manufacture of any other fabricated metal products n.e.c. / 其他未列明的金属制品制造",
        en: "[25999]Manufacture of any other fabricated metal products n.e.c.",
      },
      {
        value: "[26101]Manufacture of diodes, transistors and similar semiconductor devices",
        zh: "[26101]Manufacture of diodes, transistors and similar semiconductor devices / 二极管、晶体管及类似半导体器件的制造",
        en: "[26101]Manufacture of diodes, transistors and similar semiconductor devices",
      },
      {
        value: "[26102]Manufacture electronic integrated circuits micro assemblies",
        zh: "[26102]Manufacture electronic integrated circuits micro assemblies / 电子集成电路微组装制造",
        en: "[26102]Manufacture electronic integrated circuits micro assemblies",
      },
      {
        value: "[26103]Manufacture of electrical capacitors and resistors",
        zh: "[26103]Manufacture of electrical capacitors and resistors / 电容器和电阻器制造",
        en: "[26103]Manufacture of electrical capacitors and resistors",
      },
      {
        value: "[26104]Manufacture of printed circuit boards",
        zh: "[26104]Manufacture of printed circuit boards / 印刷电路板的制造",
        en: "[26104]Manufacture of printed circuit boards",
      },
      {
        value: "[26105]Manufacture of display components",
        zh: "[26105]Manufacture of display components / 显示组件制造",
        en: "[26105]Manufacture of display components",
      },
      {
        value: "[26109]Manufacture of other components for electronic applications",
        zh: "[26109]Manufacture of other components for electronic applications / 电子应用的其他组件制造",
        en: "[26109]Manufacture of other components for electronic applications",
      },
      {
        value: "[26201]Manufacture of computers",
        zh: "[26201]Manufacture of computers / 计算机制造",
        en: "[26201]Manufacture of computers",
      },
      {
        value: "[26202]Manufacture of peripheral equipment",
        zh: "[26202]Manufacture of peripheral equipment / 外围设备的制造",
        en: "[26202]Manufacture of peripheral equipment",
      },
      {
        value: "[26300]Manufacture of communication equipment",
        zh: "[26300]Manufacture of communication equipment / 制造通信设备",
        en: "[26300]Manufacture of communication equipment",
      },
      {
        value: "[26400]Manufacture of consumer electronics",
        zh: "[26400]Manufacture of consumer electronics / 消费类电子产品的制造",
        en: "[26400]Manufacture of consumer electronics",
      },
      {
        value: "[26511]Manufacture of measuring, testing, navigating and control equipment",
        zh: "[26511]Manufacture of measuring, testing, navigating and control equipment / 测量、测试、导航及控制设备的制造",
        en: "[26511]Manufacture of measuring, testing, navigating and control equipment",
      },
      {
        value: "[26512]Manufacture of industrial process control equipment",
        zh: "[26512]Manufacture of industrial process control equipment / 工业过程控制设备的制造",
        en: "[26512]Manufacture of industrial process control equipment",
      },
      {
        value: "[26520]Manufacture of watches and clocks and parts",
        zh: "[26520]Manufacture of watches and clocks and parts / 手表和钟表及部件的制造",
        en: "[26520]Manufacture of watches and clocks and parts",
      },
      {
        value: "[26600]Manufacture of irradiation, electro medical and electrotherapeutic equipment",
        zh: "[26600]Manufacture of irradiation, electro medical and electrotherapeutic equipment / 制造放射治疗、电医疗和电治疗设备",
        en: "[26600]Manufacture of irradiation, electro medical and electrotherapeutic equipment",
      },
      {
        value: "[26701]Manufacture of optical instruments and equipment",
        zh: "[26701]Manufacture of optical instruments and equipment / 光学仪器和设备的制造",
        en: "[26701]Manufacture of optical instruments and equipment",
      },
      {
        value: "[26702]Manufacture of photographic equipment",
        zh: "[26702]Manufacture of photographic equipment / 摄影设备制造",
        en: "[26702]Manufacture of photographic equipment",
      },
      {
        value: "[26800]Manufacture of magnetic and optical recording media",
        zh: "[26800]Manufacture of magnetic and optical recording media / 制造磁性和光学记录介质",
        en: "[26800]Manufacture of magnetic and optical recording media",
      },
      {
        value: "[27101]Manufacture of electric motors, generators and transformers",
        zh: "[27101]Manufacture of electric motors, generators and transformers / 制造电动机、发电机和变压器",
        en: "[27101]Manufacture of electric motors, generators and transformers",
      },
      {
        value: "[27102]Manufacture of electricity distribution and control apparatus",
        zh: "[27102]Manufacture of electricity distribution and control apparatus / 制造电力分配和控制设备",
        en: "[27102]Manufacture of electricity distribution and control apparatus",
      },
      {
        value: "[27200]Manufacture of batteries and accumulators",
        zh: "[27200]Manufacture of batteries and accumulators / 电池和蓄电池制造",
        en: "[27200]Manufacture of batteries and accumulators",
      },
      {
        value: "[27310]Manufacture of fibre optic cables",
        zh: "[27310]Manufacture of fibre optic cables / 光纤电缆的制造",
        en: "[27310]Manufacture of fibre optic cables",
      },
      {
        value: "[27320]Manufacture of other electronic and electric wires and cables",
        zh: "[27320]Manufacture of other electronic and electric wires and cables / 其他电子和电气线缆的制造",
        en: "[27320]Manufacture of other electronic and electric wires and cables",
      },
      {
        value: "[27330]Manufacture of current-carrying and non current-carrying wiring devices for electrical circuits regardless of material",
        zh: "[27330]Manufacture of current-carrying and non current-carrying wiring devices for electrical circuits regardless of material / 制造用于电气电路的带电和不带电导线装置，不考虑材料",
        en: "[27330]Manufacture of current-carrying and non current-carrying wiring devices for electrical circuits regardless of material",
      },
      {
        value: "[27400]Manufacture of electric lighting equipment",
        zh: "[27400]Manufacture of electric lighting equipment / 电照明设备的制造",
        en: "[27400]Manufacture of electric lighting equipment",
      },
      {
        value: "[27500]Manufacture of domestic appliances",
        zh: "[27500]Manufacture of domestic appliances / 家用电器制造",
        en: "[27500]Manufacture of domestic appliances",
      },
      {
        value:
          "[27900]Manufacture of miscellaneous electrical equipment other than motors, generators and transformers, batteries and accumulators, wires and wiring devices, lighting equipment or domestic appliances",
        zh: "[27900]Manufacture of miscellaneous electrical equipment other than motors, generators and transformers, batteries and accumulators, wires and wiring devices, lighting equipment or domestic appliances / 除电动机、发电机和变压器、电池和蓄电池、电线和布线装置、照明设备或家用电器之外的其他杂项电气设备的制造",
        en: "[27900]Manufacture of miscellaneous electrical equipment other than motors, generators and transformers, batteries and accumulators, wires and wiring devices, lighting equipment or domestic appliances",
      },
      {
        value: "[28110]Manufacture of engines and turbines, except aircraft, vehicle and cycle engines",
        zh: "[28110]Manufacture of engines and turbines, except aircraft, vehicle and cycle engines / 发动机和涡轮机的制造（除飞机、车辆和自行车发动机外）",
        en: "[28110]Manufacture of engines and turbines, except aircraft, vehicle and cycle engines",
      },
      {
        value: "[28120]Manufacture of fluid power equipment",
        zh: "[28120]Manufacture of fluid power equipment / 流体动力设备制造",
        en: "[28120]Manufacture of fluid power equipment",
      },
      {
        value: "[28130]Manufacture of other pumps, compressors, taps and valves",
        zh: "[28130]Manufacture of other pumps, compressors, taps and valves / 其他泵、压缩机、龙头和阀门的制造",
        en: "[28130]Manufacture of other pumps, compressors, taps and valves",
      },
      {
        value: "[28140]Manufacture of bearings, gears, gearing and driving elements",
        zh: "[28140]Manufacture of bearings, gears, gearing and driving elements / 轴承、齿轮、传动装置及零件的制造",
        en: "[28140]Manufacture of bearings, gears, gearing and driving elements",
      },
      {
        value: "[28150]Manufacture of ovens, furnaces and furnace burners",
        zh: "[28150]Manufacture of ovens, furnaces and furnace burners / 炉具、炉子及燃烧器的制造",
        en: "[28150]Manufacture of ovens, furnaces and furnace burners",
      },
      {
        value: "[28160]Manufacture of lifting and handling equipment",
        zh: "[28160]Manufacture of lifting and handling equipment / 制造升降和搬运设备",
        en: "[28160]Manufacture of lifting and handling equipment",
      },
      {
        value: "[28170]Manufacture of office machinery and equipment (except computers and peripheral equipment)",
        zh: "[28170]Manufacture of office machinery and equipment (except computers and peripheral equipment) / 办公机械和设备（除计算机和外围设备）的制造",
        en: "[28170]Manufacture of office machinery and equipment (except computers and peripheral equipment)",
      },
      {
        value: "[28180]Manufacture of power-driven hand tools with self-contained electric or non-electric motor or pneumatic drives",
        zh: "[28180]Manufacture of power-driven hand tools with self-contained electric or non-electric motor or pneumatic drives / 带有自备电动或非电动马达或气动驱动的电动工具的制造",
        en: "[28180]Manufacture of power-driven hand tools with self-contained electric or non-electric motor or pneumatic drives",
      },
      {
        value: "[28191]Manufacture of refrigerating or freezing industrial equipment",
        zh: "[28191]Manufacture of refrigerating or freezing industrial equipment / 制造制冷或冷冻工业设备",
        en: "[28191]Manufacture of refrigerating or freezing industrial equipment",
      },
      {
        value: "[28192]Manufacture of air-conditioning machines, including for motor vehicles",
        zh: "[28192]Manufacture of air-conditioning machines, including for motor vehicles / 制造空调机，包括为机动车辆制造",
        en: "[28192]Manufacture of air-conditioning machines, including for motor vehicles",
      },
      {
        value: "[28199]Manufacture of other general-purpose machinery n.e.c.",
        zh: "[28199]Manufacture of other general-purpose machinery n.e.c. / 其他通用机械制造",
        en: "[28199]Manufacture of other general-purpose machinery n.e.c.",
      },
      {
        value: "[28210]Manufacture of agricultural and forestry machinery",
        zh: "[28210]Manufacture of agricultural and forestry machinery / 农业和林业机械制造",
        en: "[28210]Manufacture of agricultural and forestry machinery",
      },
      {
        value: "[28220]Manufacture of metal-forming machinery and machine tools",
        zh: "[28220]Manufacture of metal-forming machinery and machine tools / 金属成型机械和机床的制造",
        en: "[28220]Manufacture of metal-forming machinery and machine tools",
      },
      {
        value: "[28230]Manufacture of machinery for metallurgy",
        zh: "[28230]Manufacture of machinery for metallurgy / 冶金机械制造",
        en: "[28230]Manufacture of machinery for metallurgy",
      },
      {
        value: "[28240]Manufacture of machinery for mining, quarrying and construction",
        zh: "[28240]Manufacture of machinery for mining, quarrying and construction / 矿业、采石及建筑用机械设备制造",
        en: "[28240]Manufacture of machinery for mining, quarrying and construction",
      },
      {
        value: "[28250]Manufacture of machinery for food, beverage and tobacco processing",
        zh: "[28250]Manufacture of machinery for food, beverage and tobacco processing / 食品、饮料及烟草加工机械制造",
        en: "[28250]Manufacture of machinery for food, beverage and tobacco processing",
      },
      {
        value: "[28260]Manufacture of machinery for textile, apparel and leather production",
        zh: "[28260]Manufacture of machinery for textile, apparel and leather production / 纺织、服装和皮革制品生产用机械设备的制造",
        en: "[28260]Manufacture of machinery for textile, apparel and leather production",
      },
      {
        value: "[28290]Manufacture of other special-purpose machinery n.e.c.",
        zh: "[28290]Manufacture of other special-purpose machinery n.e.c. / 其他特殊用途机械的制造",
        en: "[28290]Manufacture of other special-purpose machinery n.e.c.",
      },
      {
        value: "[29101]Manufacture of passenger cars",
        zh: "[29101]Manufacture of passenger cars / 乘用车制造",
        en: "[29101]Manufacture of passenger cars",
      },
      {
        value: "[29102]Manufacture of commercial vehicles",
        zh: "[29102]Manufacture of commercial vehicles / 商用车辆的制造",
        en: "[29102]Manufacture of commercial vehicles",
      },
      {
        value: "[29200]Manufacture of bodies (coachwork) for motor vehicles; manufacture of trailers and semi- trailers",
        zh: "[29200]Manufacture of bodies (coachwork) for motor vehicles; manufacture of trailers and semi- trailers / 机动车辆车身（驾驶室）制造；拖车及半拖车制造",
        en: "[29200]Manufacture of bodies (coachwork) for motor vehicles; manufacture of trailers and semi- trailers",
      },
      {
        value: "[29300]Manufacture of parts and accessories for motor vehicles",
        zh: "[29300]Manufacture of parts and accessories for motor vehicles / 汽车零件及配件制造",
        en: "[29300]Manufacture of parts and accessories for motor vehicles",
      },
      {
        value: "[30110]Building of ships and floating structures",
        zh: "[30110]Building of ships and floating structures / 建造船舶和浮动结构",
        en: "[30110]Building of ships and floating structures",
      },
      {
        value: "[30120]Building of pleasure and sporting boats",
        zh: "[30120]Building of pleasure and sporting boats / 建造休闲和运动用船只",
        en: "[30120]Building of pleasure and sporting boats",
      },
      {
        value: "[30200]Manufacture of railway locomotives and rolling stock",
        zh: "[30200]Manufacture of railway locomotives and rolling stock / 铁路机车和车辆的制造",
        en: "[30200]Manufacture of railway locomotives and rolling stock",
      },
      {
        value: "[30300]Manufacture of air and spacecraft and related machinery",
        zh: "[30300]Manufacture of air and spacecraft and related machinery / 航空航天及相关机械的制造",
        en: "[30300]Manufacture of air and spacecraft and related machinery",
      },
      {
        value: "[30400]Manufacture of military fighting vehicles",
        zh: "[30400]Manufacture of military fighting vehicles / 制造军用战斗车辆",
        en: "[30400]Manufacture of military fighting vehicles",
      },
      {
        value: "[30910]Manufacture of motorcycles",
        zh: "[30910]Manufacture of motorcycles / 摩托车的制造",
        en: "[30910]Manufacture of motorcycles",
      },
      {
        value: "[30920]Manufacture of bicycles and invalid carriages",
        zh: "[30920]Manufacture of bicycles and invalid carriages / 制造自行车和残疾人车辆",
        en: "[30920]Manufacture of bicycles and invalid carriages",
      },
      {
        value: "[30990]Manufacture of other transport equipments n.e.c.",
        zh: "[30990]Manufacture of other transport equipments n.e.c. / 其他运输设备的制造",
        en: "[30990]Manufacture of other transport equipments n.e.c.",
      },
      {
        value: "[31001]Manufacture of wooden and cane furniture",
        zh: "[31001]Manufacture of wooden and cane furniture / 木材和藤制家具的制造",
        en: "[31001]Manufacture of wooden and cane furniture",
      },
      {
        value: "[31002]Manufacture of metal furniture",
        zh: "[31002]Manufacture of metal furniture / 金属家具制造",
        en: "[31002]Manufacture of metal furniture",
      },
      {
        value: "[31003]Manufacture of mattress",
        zh: "[31003]Manufacture of mattress / 床垫制造",
        en: "[31003]Manufacture of mattress",
      },
      {
        value: "[31009]Manufacture of other furniture, except of stone, concrete or ceramic",
        zh: "[31009]Manufacture of other furniture, except of stone, concrete or ceramic / 除石、混凝土或陶瓷外的其他家具制造",
        en: "[31009]Manufacture of other furniture, except of stone, concrete or ceramic",
      },
      {
        value: "[32110]Manufacture of jewellery and related articles",
        zh: "[32110]Manufacture of jewellery and related articles / 珠宝及有关物品的制造",
        en: "[32110]Manufacture of jewellery and related articles",
      },
      {
        value: "[32120]Manufacture of imitation jewellery and related articles",
        zh: "[32120]Manufacture of imitation jewellery and related articles / 仿制珠宝及相关物品制造",
        en: "[32120]Manufacture of imitation jewellery and related articles",
      },
      {
        value: "[32200]Manufacture of musical instruments",
        zh: "[32200]Manufacture of musical instruments / 制造乐器",
        en: "[32200]Manufacture of musical instruments",
      },
      {
        value: "[32300]Manufacture of sports goods",
        zh: "[32300]Manufacture of sports goods / 体育用品制造",
        en: "[32300]Manufacture of sports goods",
      },
      {
        value: "[32400]Manufacture of games and toys",
        zh: "[32400]Manufacture of games and toys / 游戏和玩具的制造",
        en: "[32400]Manufacture of games and toys",
      },
      {
        value: "[32500]Manufacture of medical and dental instrument and supplies",
        zh: "[32500]Manufacture of medical and dental instrument and supplies / 医疗和牙科仪器及用品制造",
        en: "[32500]Manufacture of medical and dental instrument and supplies",
      },
      {
        value: "[32901]Manufacture of stationery",
        zh: "[32901]Manufacture of stationery / 文具制造",
        en: "[32901]Manufacture of stationery",
      },
      {
        value: "[32909]Other manufacturing n.e.c.",
        zh: "[32909]Other manufacturing n.e.c. / 其他制造业",
        en: "[32909]Other manufacturing n.e.c.",
      },
      {
        value: "[33110]Repair of fabricated metal products",
        zh: "[33110]Repair of fabricated metal products / 金属制品修理",
        en: "[33110]Repair of fabricated metal products",
      },
      {
        value: "[33120]Repair and maintenance of industrial machinery and equipment",
        zh: "[33120]Repair and maintenance of industrial machinery and equipment / 工业机械和设备的修理和维护",
        en: "[33120]Repair and maintenance of industrial machinery and equipment",
      },
      {
        value: "[33131]Repair and maintenance of the measuring, testing, navigating and control equipment",
        zh: "[33131]Repair and maintenance of the measuring, testing, navigating and control equipment / 测量、测试、导航和控制设备的修理和维护",
        en: "[33131]Repair and maintenance of the measuring, testing, navigating and control equipment",
      },
      {
        value: "[33132]Repair and maintenance of irradiation, electro medical and electrotherapeutic equipment",
        zh: "[33132]Repair and maintenance of irradiation, electro medical and electrotherapeutic equipment / 辐射、电医疗和电疗设备的修理与维护",
        en: "[33132]Repair and maintenance of irradiation, electro medical and electrotherapeutic equipment",
      },
      {
        value: "[33133]Repair of optical instruments and photographic equipment",
        zh: "[33133]Repair of optical instruments and photographic equipment / 光学仪器和摄影设备修理",
        en: "[33133]Repair of optical instruments and photographic equipment",
      },
      {
        value: "[33140]Repair and maintenance of electrical equipment except domestic appliances",
        zh: "[33140]Repair and maintenance of electrical equipment except domestic appliances / 除家用电器外的电器设备的修理和维护",
        en: "[33140]Repair and maintenance of electrical equipment except domestic appliances",
      },
      {
        value: "[33150]Repair and maintenance of transport equipment except motorcycles and bicycles",
        zh: "[33150]Repair and maintenance of transport equipment except motorcycles and bicycles / 运输设备（摩托车和自行车除外）的修理和维护",
        en: "[33150]Repair and maintenance of transport equipment except motorcycles and bicycles",
      },
      {
        value: "[33190]Repair and maintenance of other equipment n.e.c.",
        zh: "[33190]Repair and maintenance of other equipment n.e.c. / 其他设备的修理和维护",
        en: "[33190]Repair and maintenance of other equipment n.e.c.",
      },
      {
        value: "[33200]Installation of industrial machinery and equipment",
        zh: "[33200]Installation of industrial machinery and equipment / 安装工业机械和设备",
        en: "[33200]Installation of industrial machinery and equipment",
      },
      {
        value: "[35101]Operation of generation facilities that produce electric energy",
        zh: "[35101]Operation of generation facilities that produce electric energy / 发电设施的操作",
        en: "[35101]Operation of generation facilities that produce electric energy",
      },
      {
        value: "[35102]Operation of transmission, distribution and sales of electricity",
        zh: "[35102]Operation of transmission, distribution and sales of electricity / 电力的传输、分配和销售",
        en: "[35102]Operation of transmission, distribution and sales of electricity",
      },
      {
        value:
          "[35201]Manufacture of gaseous fuels with a specified calorific value, by purification, blending and other processes from gases of various types including natural gas",
        zh: "[35201]Manufacture of gaseous fuels with a specified calorific value, by purification, blending and other processes from gases of various types including natural gas / 通过净化、混合和其他过程从各种类型气体包括天然气生产具有指定热值的气体燃料",
        en: "[35201]Manufacture of gaseous fuels with a specified calorific value, by purification, blending and other processes from gases of various types including natural gas",
      },
      {
        value: "[35202]Transportation, distribution and supply of gaseous fuels of all kinds through a system of mains",
        zh: "[35202]Transportation, distribution and supply of gaseous fuels of all kinds through a system of mains / 通过管道系统供应各种气体燃料的运输、分配和供应",
        en: "[35202]Transportation, distribution and supply of gaseous fuels of all kinds through a system of mains",
      },
      {
        value: "[35203]Sale of gas to the user through mains",
        zh: "[35203]Sale of gas to the user through mains / 通过主干线向用户供应燃气",
        en: "[35203]Sale of gas to the user through mains",
      },
      {
        value: "[35301]Production, collection and distribution of steam and hot water for heating, power and other purposes",
        zh: "[35301]Production, collection and distribution of steam and hot water for heating, power and other purposes / 生产和分配用于供暖、发电等目的的蒸汽和热水",
        en: "[35301]Production, collection and distribution of steam and hot water for heating, power and other purposes",
      },
      {
        value: "[35302]Production and distribution of cooled air, chilled water for cooling purposes",
        zh: "[35302]Production and distribution of cooled air, chilled water for cooling purposes / 生产和分配冷却空气、冷却用的冷水",
        en: "[35302]Production and distribution of cooled air, chilled water for cooling purposes",
      },
      {
        value: "[35303]Production of ice, including ice for food and non-food (e.g. cooling) purposes",
        zh: "[35303]Production of ice, including ice for food and non-food (e.g. cooling) purposes / 生产冰，包括食品和非食品（例如冷却）用途的冰",
        en: "[35303]Production of ice, including ice for food and non-food (e.g. cooling) purposes",
      },
      {
        value: "[36001]Purification and distribution of water for water supply purposes",
        zh: "[36001]Purification and distribution of water for water supply purposes / 供水目的的水净化和分配",
        en: "[36001]Purification and distribution of water for water supply purposes",
      },
      {
        value: "[36002]Desalting of sea or ground water to produce water as the principal product of interest",
        zh: "[36002]Desalting of sea or ground water to produce water as the principal product of interest / 海水或地下水淡化以生产水作为主要产品",
        en: "[36002]Desalting of sea or ground water to produce water as the principal product of interest",
      },
      {
        value: "[37000]Sewerage and similar activities",
        zh: "[37000]Sewerage and similar activities / 污水排放及相关活动",
        en: "[37000]Sewerage and similar activities",
      },
      {
        value: "[38111]Collection of non-hazardous solid waste (i.e. garbage) within a local area",
        zh: "[38111]Collection of non-hazardous solid waste (i.e. garbage) within a local area / 在本地区域内收集非危险性固体废物（如垃圾）",
        en: "[38111]Collection of non-hazardous solid waste (i.e. garbage) within a local area",
      },
      {
        value: "[38112]Collection of recyclable materials",
        zh: "[38112]Collection of recyclable materials / 可回收材料的收集",
        en: "[38112]Collection of recyclable materials",
      },
      {
        value: "[38113]Collection of refuse in litter-bins in public places",
        zh: "[38113]Collection of refuse in litter-bins in public places / 公共场所垃圾箱的垃圾收集",
        en: "[38113]Collection of refuse in litter-bins in public places",
      },
      {
        value: "[38114]Collection of construction and demolition waste",
        zh: "[38114]Collection of construction and demolition waste / 建筑和拆除废物的收集",
        en: "[38114]Collection of construction and demolition waste",
      },
      {
        value: "[38115]Operation of waste transfer stations for non-hazardous waste",
        zh: "[38115]Operation of waste transfer stations for non-hazardous waste / 非危险废物转移站运营",
        en: "[38115]Operation of waste transfer stations for non-hazardous waste",
      },
      {
        value: "[38121]Collection of hazardous waste",
        zh: "[38121]Collection of hazardous waste / 危险废物的收集",
        en: "[38121]Collection of hazardous waste",
      },
      {
        value: "[38122]Operation of waste transfer stations for hazardous waste",
        zh: "[38122]Operation of waste transfer stations for hazardous waste / 危险废物转运站的运营",
        en: "[38122]Operation of waste transfer stations for hazardous waste",
      },
      {
        value: "[38210]Treatment and disposal of non-hazardous waste",
        zh: "[38210]Treatment and disposal of non-hazardous waste / 非危险性废物的处理和处置",
        en: "[38210]Treatment and disposal of non-hazardous waste",
      },
      {
        value: "[38220]Treatment and disposal of hazardous waste",
        zh: "[38220]Treatment and disposal of hazardous waste / 危险废物的处理和处置",
        en: "[38220]Treatment and disposal of hazardous waste",
      },
      {
        value: "[38301]Mechanical crushing of metal waste",
        zh: "[38301]Mechanical crushing of metal waste / 金属废料的机械破碎",
        en: "[38301]Mechanical crushing of metal waste",
      },
      {
        value: "[38302]Dismantling of automobiles, computers, televisions and other equipment for material recover",
        zh: "[38302]Dismantling of automobiles, computers, televisions and other equipment for material recover / 拆解汽车、电脑、电视等设备以回收材料",
        en: "[38302]Dismantling of automobiles, computers, televisions and other equipment for material recover",
      },
      {
        value: "[38303]Reclaiming of rubber such as used tires to produce secondary raw material",
        zh: "[38303]Reclaiming of rubber such as used tires to produce secondary raw material / 回收橡胶，如旧轮胎，以生产再生原材料",
        en: "[38303]Reclaiming of rubber such as used tires to produce secondary raw material",
      },
      {
        value: "[38304]Reuse of rubber products",
        zh: "[38304]Reuse of rubber products / 橡胶产品的再利用",
        en: "[38304]Reuse of rubber products",
      },
      {
        value: "[38309]Materials recovery n.e.c.",
        zh: "[38309]Materials recovery n.e.c. / 其他材料回收",
        en: "[38309]Materials recovery n.e.c.",
      },
      {
        value: "[39000]Remediation activities and other waste management services",
        zh: "[39000]Remediation activities and other waste management services / 修复活动和其他废物管理服务",
        en: "[39000]Remediation activities and other waste management services",
      },
      {
        value: "[41001]Residential buildings",
        zh: "[41001]Residential buildings / 住宅建筑物",
        en: "[41001]Residential buildings",
      },
      {
        value: "[41002]Non-residential buildings",
        zh: "[41002]Non-residential buildings / 非住宅建筑",
        en: "[41002]Non-residential buildings",
      },
      {
        value: "[41003]Assembly and erection of prefabricated constructions on the site",
        zh: "[41003]Assembly and erection of prefabricated constructions on the site / 预制构件现场组装和搭建",
        en: "[41003]Assembly and erection of prefabricated constructions on the site",
      },
      {
        value: "[41009]Construction of buildings n.e.c.",
        zh: "[41009]Construction of buildings n.e.c. / 其他未列明建筑物的建设",
        en: "[41009]Construction of buildings n.e.c.",
      },
      {
        value: "[42101]Construction of motorways, streets, roads, other vehicular and pedestrian ways",
        zh: "[42101]Construction of motorways, streets, roads, other vehicular and pedestrian ways / 高速公路、街道、道路和其他车辆及行人道路的建设",
        en: "[42101]Construction of motorways, streets, roads, other vehicular and pedestrian ways",
      },
      {
        value: "[42102]Surface work on streets, roads, highways, bridges or tunnels",
        zh: "[42102]Surface work on streets, roads, highways, bridges or tunnels / 街道、道路、高速公路、桥梁或隧道的路面工作",
        en: "[42102]Surface work on streets, roads, highways, bridges or tunnels",
      },
      {
        value: "[42103]Construction of bridges, including those for elevated highways",
        zh: "[42103]Construction of bridges, including those for elevated highways / 桥梁建设，包括高架公路桥",
        en: "[42103]Construction of bridges, including those for elevated highways",
      },
      {
        value: "[42104]Construction of tunnels",
        zh: "[42104]Construction of tunnels / 隧道建设",
        en: "[42104]Construction of tunnels",
      },
      {
        value: "[42105]Construction of railways and subways",
        zh: "[42105]Construction of railways and subways / 铁路和地铁建设",
        en: "[42105]Construction of railways and subways",
      },
      {
        value: "[42106]Construction of airfield/airports runways",
        zh: "[42106]Construction of airfield/airports runways / 建造飞机跑道/机场跑道",
        en: "[42106]Construction of airfield/airports runways",
      },
      {
        value: "[42109]Construction of roads and railways n.e.c.",
        zh: "[42109]Construction of roads and railways n.e.c. / 道路和铁路建设",
        en: "[42109]Construction of roads and railways n.e.c.",
      },
      {
        value: "[42201]Long-distance pipelines, communication and power lines",
        zh: "[42201]Long-distance pipelines, communication and power lines / 长途管道、通信和电力线路",
        en: "[42201]Long-distance pipelines, communication and power lines",
      },
      {
        value: "[42202]Urban pipelines, urban communication and power lines; ancillary urban works",
        zh: "[42202]Urban pipelines, urban communication and power lines; ancillary urban works / 城市管道、城市通信和电力线路；城市辅助工程",
        en: "[42202]Urban pipelines, urban communication and power lines; ancillary urban works",
      },
      {
        value: "[42203]Water main and line construction",
        zh: "[42203]Water main and line construction / 自来水管道及线路建设",
        en: "[42203]Water main and line construction",
      },
      {
        value: "[42204]Reservoirs",
        zh: "[42204]Reservoirs / 水库",
        en: "[42204]Reservoirs",
      },
      {
        value: "[42205]Construction of irrigation systems (canals)",
        zh: "[42205]Construction of irrigation systems (canals) / 灌溉系统（渠道）建设",
        en: "[42205]Construction of irrigation systems (canals)",
      },
      {
        value: "[42206]Construction of sewer systems (including repair) and sewage disposal plants",
        zh: "[42206]Construction of sewer systems (including repair) and sewage disposal plants / 下水道系统（包括维修）和污水处理厂的建设",
        en: "[42206]Construction of sewer systems (including repair) and sewage disposal plants",
      },
      {
        value: "[42207]Construction of power plants",
        zh: "[42207]Construction of power plants / 电站的建设",
        en: "[42207]Construction of power plants",
      },
      {
        value: "[42209]Construction of utility projects n.e.c.",
        zh: "[42209]Construction of utility projects n.e.c. / 公用事业项目（不包括其他类别）的建设",
        en: "[42209]Construction of utility projects n.e.c.",
      },
      {
        value: "[42901]Construction of refineries",
        zh: "[42901]Construction of refineries / 炼油厂的建设",
        en: "[42901]Construction of refineries",
      },
      {
        value: "[42902]Construction of waterways, harbour and river works, pleasure ports (marinas), locks",
        zh: "[42902]Construction of waterways, harbour and river works, pleasure ports (marinas), locks / 水道、港口和河流工程、娱乐港（码头）、水闸的建设",
        en: "[42902]Construction of waterways, harbour and river works, pleasure ports (marinas), locks",
      },
      {
        value: "[42903]Construction of dams and dykes",
        zh: "[42903]Construction of dams and dykes / 大坝和堤坝的建设",
        en: "[42903]Construction of dams and dykes",
      },
      {
        value: "[42904]Dredging of waterways",
        zh: "[42904]Dredging of waterways / 航道疏浚",
        en: "[42904]Dredging of waterways",
      },
      {
        value: "[42905]Outdoor sports facilities",
        zh: "[42905]Outdoor sports facilities / 户外体育设施",
        en: "[42905]Outdoor sports facilities",
      },
      {
        value: "[42906]Land subdivision with land improvement",
        zh: "[42906]Land subdivision with land improvement / 土地细分及土地改善",
        en: "[42906]Land subdivision with land improvement",
      },
      {
        value: "[42909]Construction of other engineering projects n.e.c.",
        zh: "[42909]Construction of other engineering projects n.e.c. / 其他工程项目的建设",
        en: "[42909]Construction of other engineering projects n.e.c.",
      },
      {
        value: "[43110]Demolition or wrecking of buildings and other structures",
        zh: "[43110]Demolition or wrecking of buildings and other structures / 建筑物和其他结构的拆除或摧毁",
        en: "[43110]Demolition or wrecking of buildings and other structures",
      },
      {
        value: "[43121]Clearing of building sites",
        zh: "[43121]Clearing of building sites / 清理建筑场地",
        en: "[43121]Clearing of building sites",
      },
      {
        value: "[43122]Earth moving",
        zh: "[43122]Earth moving / 土地平整",
        en: "[43122]Earth moving",
      },
      {
        value: "[43123]Drilling, boring and core sampling for construction, geophysical, geological or similar purposes",
        zh: "[43123]Drilling, boring and core sampling for construction, geophysical, geological or similar purposes / 为建筑、地球物理、地质或其他类似目的进行的钻探、打孔和取芯采样",
        en: "[43123]Drilling, boring and core sampling for construction, geophysical, geological or similar purposes",
      },
      {
        value: "[43124]Site preparation for mining",
        zh: "[43124]Site preparation for mining / 采矿场地准备",
        en: "[43124]Site preparation for mining",
      },
      {
        value: "[43125]Drainage of agricultural or forestry land",
        zh: "[43125]Drainage of agricultural or forestry land / 农业或林业土地的排水",
        en: "[43125]Drainage of agricultural or forestry land",
      },
      {
        value: "[43126]Land reclamation work",
        zh: "[43126]Land reclamation work / 土地复垦工作",
        en: "[43126]Land reclamation work",
      },
      {
        value: "[43129]Other site preparation activities n.e.c.",
        zh: "[43129]Other site preparation activities n.e.c. / 其他场地准备活动",
        en: "[43129]Other site preparation activities n.e.c.",
      },
      {
        value: "[43211]Electrical wiring and fittings",
        zh: "[43211]Electrical wiring and fittings / 电气布线和配件",
        en: "[43211]Electrical wiring and fittings",
      },
      {
        value: "[43212]Telecommunications wiring",
        zh: "[43212]Telecommunications wiring / 电信布线",
        en: "[43212]Telecommunications wiring",
      },
      {
        value: "[43213]Computer network and cable television wiring",
        zh: "[43213]Computer network and cable television wiring / 计算机网络和有线电视布线",
        en: "[43213]Computer network and cable television wiring",
      },
      {
        value: "[43214]Satellite dishes",
        zh: "[43214]Satellite dishes / 卫星天线",
        en: "[43214]Satellite dishes",
      },
      {
        value: "[43215]Lighting systems",
        zh: "[43215]Lighting systems / 照明系统",
        en: "[43215]Lighting systems",
      },
      {
        value: "[43216]Security systems",
        zh: "[43216]Security systems / 安全系统",
        en: "[43216]Security systems",
      },
      {
        value: "[43219]Electrical installation n.e.c.",
        zh: "[43219]Electrical installation n.e.c. / 电气安装",
        en: "[43219]Electrical installation n.e.c.",
      },
      {
        value: "[43221]Installation of heating systems (electric, gas and oil)",
        zh: "[43221]Installation of heating systems (electric, gas and oil) / 安装加热系统（电，气和油）",
        en: "[43221]Installation of heating systems (electric, gas and oil)",
      },
      {
        value: "[43222]Installation of furnaces, cooling towers",
        zh: "[43222]Installation of furnaces, cooling towers / 炉子、冷却塔的安装",
        en: "[43222]Installation of furnaces, cooling towers",
      },
      {
        value: "[43223]Installation of non-electric solar energy collectors",
        zh: "[43223]Installation of non-electric solar energy collectors / 非电力太阳能收集器安装",
        en: "[43223]Installation of non-electric solar energy collectors",
      },
      {
        value: "[43224]Installation of plumbing and sanitary equipment",
        zh: "[43224]Installation of plumbing and sanitary equipment / 安装管道和卫生设备",
        en: "[43224]Installation of plumbing and sanitary equipment",
      },
      {
        value: "[43225]Installation of ventilation, refrigeration or air-conditioning equipment and ducts",
        zh: "[43225]Installation of ventilation, refrigeration or air-conditioning equipment and ducts / 通风、制冷或空调设备及管道安装",
        en: "[43225]Installation of ventilation, refrigeration or air-conditioning equipment and ducts",
      },
      {
        value: "[43226]Installation of gas fittings",
        zh: "[43226]Installation of gas fittings / 燃气装置的安装",
        en: "[43226]Installation of gas fittings",
      },
      {
        value: "[43227]Installation of fire and lawn sprinkler systems",
        zh: "[43227]Installation of fire and lawn sprinkler systems / 安装消防和草坪喷水系统",
        en: "[43227]Installation of fire and lawn sprinkler systems",
      },
      {
        value: "[43228]Steam piping",
        zh: "[43228]Steam piping / 蒸汽管道",
        en: "[43228]Steam piping",
      },
      {
        value: "[43229]Plumbing, heat and air-conditioning installation n.e.c.",
        zh: "[43229]Plumbing, heat and air-conditioning installation n.e.c. / 管道、供暖和空调安装等其他工作",
        en: "[43229]Plumbing, heat and air-conditioning installation n.e.c.",
      },
      {
        value: "[43291]Installation of elevators, escalators in buildings or other construction projects",
        zh: "[43291]Installation of elevators, escalators in buildings or other construction projects / 安装电梯、自动扶梯等建筑或其它建设项目",
        en: "[43291]Installation of elevators, escalators in buildings or other construction projects",
      },
      {
        value: "[43292]Installation of automated and revolving doors in buildings or other construction projects",
        zh: "[43292]Installation of automated and revolving doors in buildings or other construction projects / 建筑物或其他建筑项目中自动和旋转门的安装",
        en: "[43292]Installation of automated and revolving doors in buildings or other construction projects",
      },
      {
        value: "[43293]Installation of lighting conductors in buildings or other construction projects",
        zh: "[43293]Installation of lighting conductors in buildings or other construction projects / 建筑物或其他建设项目中安装避雷导线",
        en: "[43293]Installation of lighting conductors in buildings or other construction projects",
      },
      {
        value: "[43294]Installation vacuum cleaning systems in buildings or other construction projects",
        zh: "[43294]Installation vacuum cleaning systems in buildings or other construction projects / 建筑物或其他建筑项目中安装真空清洁系统",
        en: "[43294]Installation vacuum cleaning systems in buildings or other construction projects",
      },
      {
        value: "[43295]Installation thermal, sound or vibration insulation in buildings or other construction projects",
        zh: "[43295]Installation thermal, sound or vibration insulation in buildings or other construction projects / 建筑物或其他建筑项目中安装热、声或振动绝缘",
        en: "[43295]Installation thermal, sound or vibration insulation in buildings or other construction projects",
      },
      {
        value: "[43299]Other construction installation n.e.c.",
        zh: "[43299]Other construction installation n.e.c. / 其他建筑安装（未列明的）",
        en: "[43299]Other construction installation n.e.c.",
      },
      {
        value: "[43301]Installation of doors, windows, door and window frames of wood or other materials, fitted kitchens, staircases, shop fittings and furniture",
        zh: "[43301]Installation of doors, windows, door and window frames of wood or other materials, fitted kitchens, staircases, shop fittings and furniture / 安装木质或其他材料的门窗、定做厨房、楼梯、商店装修及家具",
        en: "[43301]Installation of doors, windows, door and window frames of wood or other materials, fitted kitchens, staircases, shop fittings and furniture",
      },
      {
        value: "[43302]Laying, tiling, hanging or fitting in buildings or other construction projects of various types of materials",
        zh: "[43302]Laying, tiling, hanging or fitting in buildings or other construction projects of various types of materials / 在建筑物或其他建筑项目中铺设、铺设瓷砖、悬挂或安装各种材料",
        en: "[43302]Laying, tiling, hanging or fitting in buildings or other construction projects of various types of materials",
      },
      {
        value: "[43303]Interior and exterior painting of buildings",
        zh: "[43303]Interior and exterior painting of buildings / 建筑物内外壁的涂漆",
        en: "[43303]Interior and exterior painting of buildings",
      },
      {
        value: "[43304]Painting of civil engineering structures",
        zh: "[43304]Painting of civil engineering structures / 民用工程结构绘画",
        en: "[43304]Painting of civil engineering structures",
      },
      {
        value: "[43305]Installation of glass, mirrors",
        zh: "[43305]Installation of glass, mirrors / 安装玻璃、镜子",
        en: "[43305]Installation of glass, mirrors",
      },
      {
        value: "[43306]Interior completion",
        zh: "[43306]Interior completion / 室内装修完成",
        en: "[43306]Interior completion",
      },
      {
        value: "[43307]Cleaning of new buildings after construction",
        zh: "[43307]Cleaning of new buildings after construction / 建筑后新建筑物的清洁",
        en: "[43307]Cleaning of new buildings after construction",
      },
      {
        value: "[43309]Other building completion and finishing work n.e.c.",
        zh: "[43309]Other building completion and finishing work n.e.c. / 其他建筑竣工和精装修工程",
        en: "[43309]Other building completion and finishing work n.e.c.",
      },
      {
        value: "[43901]Construction of foundations, including pile driving",
        zh: "[43901]Construction of foundations, including pile driving / 基础建设，包括打桩",
        en: "[43901]Construction of foundations, including pile driving",
      },
      {
        value: "[43902]Erection of non-self-manufactured steel elements",
        zh: "[43902]Erection of non-self-manufactured steel elements / 安装非自产的钢结构元素",
        en: "[43902]Erection of non-self-manufactured steel elements",
      },
      {
        value: "[43903]Scaffolds and work platform erecting and dismantling",
        zh: "[43903]Scaffolds and work platform erecting and dismantling / 脚手架和工作平台搭建与拆卸",
        en: "[43903]Scaffolds and work platform erecting and dismantling",
      },
      {
        value: "[43904]Bricklaying and stone setting",
        zh: "[43904]Bricklaying and stone setting / 砌砖和石料铺设",
        en: "[43904]Bricklaying and stone setting",
      },
      {
        value: "[43905]Construction of outdoor swimming pools",
        zh: "[43905]Construction of outdoor swimming pools / 室外游泳池建设",
        en: "[43905]Construction of outdoor swimming pools",
      },
      {
        value: "[43906]Steam cleaning, sand blasting and similar activities for building exteriors",
        zh: "[43906]Steam cleaning, sand blasting and similar activities for building exteriors / 建筑物外立面的蒸汽清洗、喷砂和其他类似活动",
        en: "[43906]Steam cleaning, sand blasting and similar activities for building exteriors",
      },
      {
        value: "[43907]Renting of construction machinery and equipment with operator (e.g. cranes)",
        zh: "[43907]Renting of construction machinery and equipment with operator (e.g. cranes) / 带操作员的建筑机械和设备租赁（例如：起重机）",
        en: "[43907]Renting of construction machinery and equipment with operator (e.g. cranes)",
      },
      {
        value: "[43909]Other specialized construction activities, n.e.c.",
        zh: "[43909]Other specialized construction activities, n.e.c. / 其他专业建筑活动，不包括在内",
        en: "[43909]Other specialized construction activities, n.e.c.",
      },
      {
        value: "[45101]Wholesale and retail of new motor vehicles",
        zh: "[45101]Wholesale and retail of new motor vehicles / 新机动车辆的批发和零售",
        en: "[45101]Wholesale and retail of new motor vehicles",
      },
      {
        value: "[45102]Wholesale and retail of used motor vehicles",
        zh: "[45102]Wholesale and retail of used motor vehicles / 二手汽车的批发和零售",
        en: "[45102]Wholesale and retail of used motor vehicles",
      },
      {
        value: "[45103]Sale of industrial, commercial and agriculture vehicles – new",
        zh: "[45103]Sale of industrial, commercial and agriculture vehicles – new / 销售工业、商业和农业车辆 - 新车",
        en: "[45103]Sale of industrial, commercial and agriculture vehicles – new",
      },
      {
        value: "[45104]Sale of industrial, commercial and agriculture vehicles – used",
        zh: "[45104]Sale of industrial, commercial and agriculture vehicles – used / 工业、商业和农业车辆 - 二手车销售",
        en: "[45104]Sale of industrial, commercial and agriculture vehicles – used",
      },
      {
        value: "[45105]Sale by commission agents",
        zh: "[45105]Sale by commission agents / 通过佣金代理销售",
        en: "[45105]Sale by commission agents",
      },
      {
        value: "[45106]Car auctions",
        zh: "[45106]Car auctions / 汽车拍卖",
        en: "[45106]Car auctions",
      },
      {
        value: "[45109]Sale of other motor vehicles n.e.c.",
        zh: "[45109]Sale of other motor vehicles n.e.c. / 其他机动车销售",
        en: "[45109]Sale of other motor vehicles n.e.c.",
      },
      {
        value: "[45201]Maintenance and repair of motor vehicles",
        zh: "[45201]Maintenance and repair of motor vehicles / 机动车辆的维护和修理",
        en: "[45201]Maintenance and repair of motor vehicles",
      },
      {
        value: "[45202]Spraying and painting",
        zh: "[45202]Spraying and painting / 喷漆和绘画",
        en: "[45202]Spraying and painting",
      },
      {
        value: "[45203]Washing and polishing (car wash)",
        zh: "[45203]Washing and polishing (car wash) / 洗涤和抛光（洗车）",
        en: "[45203]Washing and polishing (car wash)",
      },
      {
        value: "[45204]Repair of motor vehicle seats",
        zh: "[45204]Repair of motor vehicle seats / 机动车座椅修理",
        en: "[45204]Repair of motor vehicle seats",
      },
      {
        value: "[45205]Installation of parts and accessories not as part of the manufacturing process",
        zh: "[45205]Installation of parts and accessories not as part of the manufacturing process / 不属于制造过程的零部件和配件安装",
        en: "[45205]Installation of parts and accessories not as part of the manufacturing process",
      },
      {
        value: "[45300]Wholesale and retail sale of all kinds of parts, components, supplies, tools and accessories for motor vehicles",
        zh: "[45300]Wholesale and retail sale of all kinds of parts, components, supplies, tools and accessories for motor vehicles / 所有种类的汽车零部件、组件、用品、工具及配件的批发和零售",
        en: "[45300]Wholesale and retail sale of all kinds of parts, components, supplies, tools and accessories for motor vehicles",
      },
      {
        value: "[45401]Wholesale and retail sale of motorcycles",
        zh: "[45401]Wholesale and retail sale of motorcycles / 摩托车批发和零售",
        en: "[45401]Wholesale and retail sale of motorcycles",
      },
      {
        value: "[45402]Wholesale and retail sale of parts and accessories for motorcycles",
        zh: "[45402]Wholesale and retail sale of parts and accessories for motorcycles / 摩托车零部件和配件的批发及零售",
        en: "[45402]Wholesale and retail sale of parts and accessories for motorcycles",
      },
      {
        value: "[45403]Repair and maintenance of motorcycles",
        zh: "[45403]Repair and maintenance of motorcycles / 摩托车的修理和维护",
        en: "[45403]Repair and maintenance of motorcycles",
      },
      {
        value: "[46100]Wholesale on a fee or contract basis",
        zh: "[46100]Wholesale on a fee or contract basis / 按费用或合同基础批发",
        en: "[46100]Wholesale on a fee or contract basis",
      },
      {
        value: "[46201]Wholesale of rubber",
        zh: "[46201]Wholesale of rubber / 橡胶批发",
        en: "[46201]Wholesale of rubber",
      },
      {
        value: "[46202]Wholesale of palm oil",
        zh: "[46202]Wholesale of palm oil / 棕榈油批发",
        en: "[46202]Wholesale of palm oil",
      },
      {
        value: "[46203]Wholesale of lumber and timber",
        zh: "[46203]Wholesale of lumber and timber / 木材和原木批发",
        en: "[46203]Wholesale of lumber and timber",
      },
      {
        value: "[46204]Wholesale of flowers and plants",
        zh: "[46204]Wholesale of flowers and plants / 花卉和植物的批发",
        en: "[46204]Wholesale of flowers and plants",
      },
      {
        value: "[46205]Wholesale of livestock",
        zh: "[46205]Wholesale of livestock / 牲畜批发",
        en: "[46205]Wholesale of livestock",
      },
      {
        value: "[46209]Wholesale of agricultural raw material and live animal n.e.c.",
        zh: "[46209]Wholesale of agricultural raw material and live animal n.e.c. / 农业原材料及活畜批发（不包括其他类）",
        en: "[46209]Wholesale of agricultural raw material and live animal n.e.c.",
      },
      {
        value: "[46311]Wholesale of meat, poultry and eggs",
        zh: "[46311]Wholesale of meat, poultry and eggs / 肉类、家禽和蛋类的批发",
        en: "[46311]Wholesale of meat, poultry and eggs",
      },
      {
        value: "[46312]Wholesale of fish and other seafood",
        zh: "[46312]Wholesale of fish and other seafood / 鱼类和其他海产品的批发",
        en: "[46312]Wholesale of fish and other seafood",
      },
      {
        value: "[46313]Wholesale of fruits",
        zh: "[46313]Wholesale of fruits / 水果批发",
        en: "[46313]Wholesale of fruits",
      },
      {
        value: "[46314]Wholesale of vegetables",
        zh: "[46314]Wholesale of vegetables / 蔬菜批发",
        en: "[46314]Wholesale of vegetables",
      },
      {
        value: "[46319]Wholesale of meat, fish, fruits and vegetables n.e.c.",
        zh: "[46319]Wholesale of meat, fish, fruits and vegetables n.e.c. / 肉、鱼、水果及蔬菜的杂项批发",
        en: "[46319]Wholesale of meat, fish, fruits and vegetables n.e.c.",
      },
      {
        value: "[46321]Wholesale of rice, other grains, flour and sugars",
        zh: "[46321]Wholesale of rice, other grains, flour and sugars / 大米、其他谷物、面粉和糖的批发",
        en: "[46321]Wholesale of rice, other grains, flour and sugars",
      },
      {
        value: "[46322]Wholesale of dairy products",
        zh: "[46322]Wholesale of dairy products / 乳制品批发",
        en: "[46322]Wholesale of dairy products",
      },
      {
        value: "[46323]Wholesale of confectionary",
        zh: "[46323]Wholesale of confectionary / 糖果批发",
        en: "[46323]Wholesale of confectionary",
      },
      {
        value: "[46324]Wholesale of  biscuits, cakes, breads and other bakery products",
        zh: "[46324]Wholesale of  biscuits, cakes, breads and other bakery products / 饼干、蛋糕、面包及其他烘焙产品的批发",
        en: "[46324]Wholesale of  biscuits, cakes, breads and other bakery products",
      },
      {
        value: "[46325]Wholesale of coffee, tea, cocoa and other beverages",
        zh: "[46325]Wholesale of coffee, tea, cocoa and other beverages / 咖啡、茶、可可及其他饮料批发",
        en: "[46325]Wholesale of coffee, tea, cocoa and other beverages",
      },
      {
        value: "[46326]Wholesale of beer, wine and spirits",
        zh: "[46326]Wholesale of beer, wine and spirits / 啤酒、葡萄酒和烈酒批发",
        en: "[46326]Wholesale of beer, wine and spirits",
      },
      {
        value: "[46327]Wholesale of tobacco, cigar, cigarettes",
        zh: "[46327]Wholesale of tobacco, cigar, cigarettes / 烟草、雪茄、香烟批发",
        en: "[46327]Wholesale of tobacco, cigar, cigarettes",
      },
      {
        value: "[46329]Wholesale of other foodstuffs",
        zh: "[46329]Wholesale of other foodstuffs / 其他食品批发",
        en: "[46329]Wholesale of other foodstuffs",
      },
      {
        value: "[46411]Wholesale of yarn and fabrics",
        zh: "[46411]Wholesale of yarn and fabrics / 纱线和织物批发",
        en: "[46411]Wholesale of yarn and fabrics",
      },
      {
        value: "[46412]Wholesale of household linen, towels, blankets",
        zh: "[46412]Wholesale of household linen, towels, blankets / 家用亚麻布、毛巾、毯子的批发",
        en: "[46412]Wholesale of household linen, towels, blankets",
      },
      {
        value: "[46413]Wholesale of clothing",
        zh: "[46413]Wholesale of clothing / 服装批发",
        en: "[46413]Wholesale of clothing",
      },
      {
        value: "[46414]Wholesale of clothing accessories",
        zh: "[46414]Wholesale of clothing accessories / 服装配件批发",
        en: "[46414]Wholesale of clothing accessories",
      },
      {
        value: "[46415]Wholesale of fur articles",
        zh: "[46415]Wholesale of fur articles / 毛皮制品批发",
        en: "[46415]Wholesale of fur articles",
      },
      {
        value: "[46416]Wholesale of footwear",
        zh: "[46416]Wholesale of footwear / 鞋类批发",
        en: "[46416]Wholesale of footwear",
      },
      {
        value: "[46417]Wholesale of haberdashery",
        zh: "[46417]Wholesale of haberdashery / 服饰配件批发",
        en: "[46417]Wholesale of haberdashery",
      },
      {
        value: "[46419]Wholesale of textiles, clothing n.e.c.",
        zh: "[46419]Wholesale of textiles, clothing n.e.c. / 纺织品、服装等的批发",
        en: "[46419]Wholesale of textiles, clothing n.e.c.",
      },
      {
        value: "[46421]Wholesale of pharmaceutical and medical goods",
        zh: "[46421]Wholesale of pharmaceutical and medical goods / 药品和医疗用品批发",
        en: "[46421]Wholesale of pharmaceutical and medical goods",
      },
      {
        value: "[46422]Wholesale of perfumeries, cosmetics, soap and toiletries",
        zh: "[46422]Wholesale of perfumeries, cosmetics, soap and toiletries / 香水、化妆品、肥皂和卫生用品的批发",
        en: "[46422]Wholesale of perfumeries, cosmetics, soap and toiletries",
      },
      {
        value: "[46431]Wholesale of bicycles and their parts and accessories",
        zh: "[46431]Wholesale of bicycles and their parts and accessories / 自行车及其零部件和配件的批发",
        en: "[46431]Wholesale of bicycles and their parts and accessories",
      },
      {
        value: "[46432]Wholesale of photographic and optical goods",
        zh: "[46432]Wholesale of photographic and optical goods / 摄影和光学商品批发",
        en: "[46432]Wholesale of photographic and optical goods",
      },
      {
        value: "[46433]Wholesale of leather goods and travel accessories",
        zh: "[46433]Wholesale of leather goods and travel accessories / 批发皮革制品和旅行配件",
        en: "[46433]Wholesale of leather goods and travel accessories",
      },
      {
        value: "[46434]Wholesale of musical instruments, games and toys, sports goods",
        zh: "[46434]Wholesale of musical instruments, games and toys, sports goods / 乐器、游戏和玩具、体育用品的批发",
        en: "[46434]Wholesale of musical instruments, games and toys, sports goods",
      },
      {
        value: "[46441]Wholesale of handicrafts and artificial flowers",
        zh: "[46441]Wholesale of handicrafts and artificial flowers / 手工艺品和人造花的批发",
        en: "[46441]Wholesale of handicrafts and artificial flowers",
      },
      {
        value: "[46442]Wholesale of cut flowers and plants",
        zh: "[46442]Wholesale of cut flowers and plants / 批发切花和植物",
        en: "[46442]Wholesale of cut flowers and plants",
      },
      {
        value: "[46443]Wholesale of watches and clocks",
        zh: "[46443]Wholesale of watches and clocks / 钟表和手表的批发",
        en: "[46443]Wholesale of watches and clocks",
      },
      {
        value: "[46444]Wholesale of jewellery",
        zh: "[46444]Wholesale of jewellery / 珠宝批发",
        en: "[46444]Wholesale of jewellery",
      },
      {
        value: "[46491]Wholesale of household furniture",
        zh: "[46491]Wholesale of household furniture / 家用家具批发",
        en: "[46491]Wholesale of household furniture",
      },
      {
        value: "[46492]Wholesale of household appliances",
        zh: "[46492]Wholesale of household appliances / 家用电器的批发",
        en: "[46492]Wholesale of household appliances",
      },
      {
        value: "[46493]Wholesale of lighting equipment",
        zh: "[46493]Wholesale of lighting equipment / 照明设备批发",
        en: "[46493]Wholesale of lighting equipment",
      },
      {
        value: "[46494]Wholesale of household utensils and cutlery, crockery, glassware, chinaware and pottery",
        zh: "[46494]Wholesale of household utensils and cutlery, crockery, glassware, chinaware and pottery / 家用器具及餐具、瓷器、玻璃器皿、陶器和瓷器的批发",
        en: "[46494]Wholesale of household utensils and cutlery, crockery, glassware, chinaware and pottery",
      },
      {
        value: "[46495]Wholesale of woodenware, wickerwork and corkware",
        zh: "[46495]Wholesale of woodenware, wickerwork and corkware / 批发木制、藤制及软木制品",
        en: "[46495]Wholesale of woodenware, wickerwork and corkware",
      },
      {
        value: "[46496]Wholesale of electrical and electronic goods",
        zh: "[46496]Wholesale of electrical and electronic goods / 电气和电子商品批发",
        en: "[46496]Wholesale of electrical and electronic goods",
      },
      {
        value: "[46497]Wholesale of stationery, books, magazines and newspapers",
        zh: "[46497]Wholesale of stationery, books, magazines and newspapers / 文具、书籍、杂志及报纸的批发",
        en: "[46497]Wholesale of stationery, books, magazines and newspapers",
      },
      {
        value: "[46499]Wholesale of other household goods n.e.c.",
        zh: "[46499]Wholesale of other household goods n.e.c. / 其他家用商品的批发",
        en: "[46499]Wholesale of other household goods n.e.c.",
      },
      {
        value: "[46510]Wholesale of computer hardware, software and peripherals",
        zh: "[46510]Wholesale of computer hardware, software and peripherals / 计算机硬件、软件及外围设备的批发",
        en: "[46510]Wholesale of computer hardware, software and peripherals",
      },
      {
        value: "[46521]Wholesale of telephone and telecommunications equipment, cell phones, pagers",
        zh: "[46521]Wholesale of telephone and telecommunications equipment, cell phones, pagers / 电话和电信设备、手机、寻呼机的批发",
        en: "[46521]Wholesale of telephone and telecommunications equipment, cell phones, pagers",
      },
      {
        value: "[46522]Wholesale of electronic components and wiring accessories",
        zh: "[46522]Wholesale of electronic components and wiring accessories / 电子元件和配线配件的批发",
        en: "[46522]Wholesale of electronic components and wiring accessories",
      },
      {
        value: "[46531]Wholesale of agricultural machinery, equipment and supplies",
        zh: "[46531]Wholesale of agricultural machinery, equipment and supplies / 农业机械、设备及用品的批发",
        en: "[46531]Wholesale of agricultural machinery, equipment and supplies",
      },
      {
        value: "[46532]Wholesale of lawn mowers however operated",
        zh: "[46532]Wholesale of lawn mowers however operated / 割草机批发",
        en: "[46532]Wholesale of lawn mowers however operated",
      },
      {
        value: "[46591]Wholesale of office machinery and business equipment, except computers and computer peripheral equipment",
        zh: "[46591]Wholesale of office machinery and business equipment, except computers and computer peripheral equipment / 批发办公机械及商务设备（计算机及外围设备除外）",
        en: "[46591]Wholesale of office machinery and business equipment, except computers and computer peripheral equipment",
      },
      {
        value: "[46592]Wholesale of office furniture",
        zh: "[46592]Wholesale of office furniture / 办公家具批发",
        en: "[46592]Wholesale of office furniture",
      },
      {
        value: "[46593]Wholesale of computer-controlled machines tools",
        zh: "[46593]Wholesale of computer-controlled machines tools / 计算机控制机床的批发",
        en: "[46593]Wholesale of computer-controlled machines tools",
      },
      {
        value: "[46594]Wholesale of industrial machinery, equipment and supplies",
        zh: "[46594]Wholesale of industrial machinery, equipment and supplies / 工业机械、设备及用品批发",
        en: "[46594]Wholesale of industrial machinery, equipment and supplies",
      },
      {
        value: "[46595]Wholesale of construction and civil engineering machinery and equipment",
        zh: "[46595]Wholesale of construction and civil engineering machinery and equipment / 建筑和土木工程机械设备的批发",
        en: "[46595]Wholesale of construction and civil engineering machinery and equipment",
      },
      {
        value: "[46596]Wholesale of lift escalators, air-conditioning, security and fire fighting equipment",
        zh: "[46596]Wholesale of lift escalators, air-conditioning, security and fire fighting equipment / 升降梯、空调、安全和消防设备的批发",
        en: "[46596]Wholesale of lift escalators, air-conditioning, security and fire fighting equipment",
      },
      {
        value: "[46599]Wholesale of other machinery for use in industry, trade and navigation and other services n.e.c.",
        zh: "[46599]Wholesale of other machinery for use in industry, trade and navigation and other services n.e.c. / 批发其他工业、贸易和航海用机械以及其他服务",
        en: "[46599]Wholesale of other machinery for use in industry, trade and navigation and other services n.e.c.",
      },
      {
        value: "[46611]Wholesale of petrol, diesel, lubricants",
        zh: "[46611]Wholesale of petrol, diesel, lubricants / 汽油、柴油、润滑油的批发",
        en: "[46611]Wholesale of petrol, diesel, lubricants",
      },
      {
        value: "[46612]Wholesale of liquefied petroleum gas",
        zh: "[46612]Wholesale of liquefied petroleum gas / 批发液化石油气",
        en: "[46612]Wholesale of liquefied petroleum gas",
      },
      {
        value: "[46619]Wholesale of other solid, liquid and gaseous fuels and related products n.e.c.",
        zh: "[46619]Wholesale of other solid, liquid and gaseous fuels and related products n.e.c. / 其他固体、液体和气体燃料及相关产品批发",
        en: "[46619]Wholesale of other solid, liquid and gaseous fuels and related products n.e.c.",
      },
      {
        value: "[46621]Wholesale of ferrous and non-ferrous metal ores and metals",
        zh: "[46621]Wholesale of ferrous and non-ferrous metal ores and metals / 批发铁矿石、有色金属矿石和金属",
        en: "[46621]Wholesale of ferrous and non-ferrous metal ores and metals",
      },
      {
        value: "[46622]Wholesale of ferrous and non-ferrous semi-finished metal ores and products n.e.c.",
        zh: "[46622]Wholesale of ferrous and non-ferrous semi-finished metal ores and products n.e.c. / 未列明的黑色和有色金属半成品及产品的批发",
        en: "[46622]Wholesale of ferrous and non-ferrous semi-finished metal ores and products n.e.c.",
      },
      {
        value: "[46631]Wholesale of logs, sawn timber, plywood, veneer and related products",
        zh: "[46631]Wholesale of logs, sawn timber, plywood, veneer and related products / 原木、锯材、胶合板、单板及相关产品的批发",
        en: "[46631]Wholesale of logs, sawn timber, plywood, veneer and related products",
      },
      {
        value: "[46632]Wholesale of paints and varnish",
        zh: "[46632]Wholesale of paints and varnish / 油漆和清漆的批发",
        en: "[46632]Wholesale of paints and varnish",
      },
      {
        value: "[46633]Wholesale of construction materials",
        zh: "[46633]Wholesale of construction materials / 建筑材料批发",
        en: "[46633]Wholesale of construction materials",
      },
      {
        value: "[46634]Wholesale of fittings and fixtures",
        zh: "[46634]Wholesale of fittings and fixtures / 配件及装置批发",
        en: "[46634]Wholesale of fittings and fixtures",
      },
      {
        value: "[46635]Wholesale of hot water heaters",
        zh: "[46635]Wholesale of hot water heaters / 热水加热器批发",
        en: "[46635]Wholesale of hot water heaters",
      },
      {
        value: "[46636]Wholesale of sanitary installation and equipment",
        zh: "[46636]Wholesale of sanitary installation and equipment / 卫生安装和设备批发",
        en: "[46636]Wholesale of sanitary installation and equipment",
      },
      {
        value: "[46637]Wholesale of tools",
        zh: "[46637]Wholesale of tools / 工具批发",
        en: "[46637]Wholesale of tools",
      },
      {
        value: "[46639]Wholesale of other construction materials, hardware, plumbing and heating equipment and supplies n.e.c.",
        zh: "[46639]Wholesale of other construction materials, hardware, plumbing and heating equipment and supplies n.e.c. / 其他建筑材料、五金、管道和供暖设备及供应品的批发 n.e.c.",
        en: "[46639]Wholesale of other construction materials, hardware, plumbing and heating equipment and supplies n.e.c.",
      },
      {
        value: "[46691]Wholesale of industrial chemicals",
        zh: "[46691]Wholesale of industrial chemicals / 批发工业化学品",
        en: "[46691]Wholesale of industrial chemicals",
      },
      {
        value: "[46692]Wholesale of fertilizers and agrochemical products",
        zh: "[46692]Wholesale of fertilizers and agrochemical products / 肥料和农药产品的批发",
        en: "[46692]Wholesale of fertilizers and agrochemical products",
      },
      {
        value: "[46693]Wholesale of plastic materials in primary forms",
        zh: "[46693]Wholesale of plastic materials in primary forms / 塑料原料批发",
        en: "[46693]Wholesale of plastic materials in primary forms",
      },
      {
        value: "[46694]Wholesale of rubber scrap",
        zh: "[46694]Wholesale of rubber scrap / 橡胶废料批发",
        en: "[46694]Wholesale of rubber scrap",
      },
      {
        value: "[46695]Wholesale of textile fibres",
        zh: "[46695]Wholesale of textile fibres / 纺织纤维的批发",
        en: "[46695]Wholesale of textile fibres",
      },
      {
        value: "[46696]Wholesale of paper in bulk, packaging materials",
        zh: "[46696]Wholesale of paper in bulk, packaging materials / 批量批发纸张、包装材料",
        en: "[46696]Wholesale of paper in bulk, packaging materials",
      },
      {
        value: "[46697]Wholesale of precious stones",
        zh: "[46697]Wholesale of precious stones / 宝石批发",
        en: "[46697]Wholesale of precious stones",
      },
      {
        value: "[46698]Wholesale of metal and non-metal waste and scrap and materials for recycling",
        zh: "[46698]Wholesale of metal and non-metal waste and scrap and materials for recycling / 金属和非金属废料及回收材料批发",
        en: "[46698]Wholesale of metal and non-metal waste and scrap and materials for recycling",
      },
      {
        value: "[46699]Dismantling of automobiles, computer, televisions and other equipment to obtain and re-sell usable parts",
        zh: "[46699]Dismantling of automobiles, computer, televisions and other equipment to obtain and re-sell usable parts / 拆解汽车、电脑、电视等设备以获取并转售可使用的部件",
        en: "[46699]Dismantling of automobiles, computer, televisions and other equipment to obtain and re-sell usable parts",
      },
      {
        value: "[46901]Wholesale of aquarium fishes, pet birds and animals",
        zh: "[46901]Wholesale of aquarium fishes, pet birds and animals / 水族鱼类、宠物鸟和动物批发",
        en: "[46901]Wholesale of aquarium fishes, pet birds and animals",
      },
      {
        value: "[46902]Wholesale of animal/pet food",
        zh: "[46902]Wholesale of animal/pet food / 动物/宠物食品批发",
        en: "[46902]Wholesale of animal/pet food",
      },
      {
        value: "[46909]Wholesale of a variety of goods without any particular specialization n.e.c.",
        zh: "[46909]Wholesale of a variety of goods without any particular specialization n.e.c. / 无特定专业化的各种商品批发",
        en: "[46909]Wholesale of a variety of goods without any particular specialization n.e.c.",
      },
      {
        value: "[47111]Provision stores",
        zh: "[47111]Provision stores / 便利店",
        en: "[47111]Provision stores",
      },
      {
        value: "[47112]Supermarket",
        zh: "[47112]Supermarket / 超市",
        en: "[47112]Supermarket",
      },
      {
        value: "[47113]Mini market",
        zh: "[47113]Mini market / 便利店",
        en: "[47113]Mini market",
      },
      {
        value: "[47114]Convenience stores",
        zh: "[47114]Convenience stores / 便利店",
        en: "[47114]Convenience stores",
      },
      {
        value: "[47191]Department stores",
        zh: "[47191]Department stores / 百货商店",
        en: "[47191]Department stores",
      },
      {
        value: "[47192]Department stores and supermarket",
        zh: "[47192]Department stores and supermarket / 百货商店和超市",
        en: "[47192]Department stores and supermarket",
      },
      {
        value: "[47193]Hypermarket",
        zh: "[47193]Hypermarket / 超级市场",
        en: "[47193]Hypermarket",
      },
      {
        value: "[47194]News agent and miscellaneous goods store",
        zh: "[47194]News agent and miscellaneous goods store / 新闻代理商和杂货店",
        en: "[47194]News agent and miscellaneous goods store",
      },
      {
        value: "[47199]Other retail sale in non-specialized stores n.e.c.",
        zh: "[47199]Other retail sale in non-specialized stores n.e.c. / 其他非专业商店的零售销售",
        en: "[47199]Other retail sale in non-specialized stores n.e.c.",
      },
      {
        value: "[47211]Retail sale of rice, flour, other grains and sugars",
        zh: "[47211]Retail sale of rice, flour, other grains and sugars / 大米、面粉、其他谷物和糖的零售",
        en: "[47211]Retail sale of rice, flour, other grains and sugars",
      },
      {
        value: "[47212]Retail sale of fresh or preserved vegetables and fruits",
        zh: "[47212]Retail sale of fresh or preserved vegetables and fruits / 新鲜或保存的蔬菜和水果零售",
        en: "[47212]Retail sale of fresh or preserved vegetables and fruits",
      },
      {
        value: "[47213]Retail sale of dairy products and eggs",
        zh: "[47213]Retail sale of dairy products and eggs / 零售销售乳制品和鸡蛋",
        en: "[47213]Retail sale of dairy products and eggs",
      },
      {
        value: "[47214]Retail sale of meat and meat products (including poultry)",
        zh: "[47214]Retail sale of meat and meat products (including poultry) / 零售肉及肉制品（包括家禽）",
        en: "[47214]Retail sale of meat and meat products (including poultry)",
      },
      {
        value: "[47215]Retail sale of fish, other seafood and products thereof",
        zh: "[47215]Retail sale of fish, other seafood and products thereof / 鱼类和其他海产品的零售",
        en: "[47215]Retail sale of fish, other seafood and products thereof",
      },
      {
        value: "[47216]Retail sale of bakery products and sugar confectionery",
        zh: "[47216]Retail sale of bakery products and sugar confectionery / 烘焙产品和糖果的零售",
        en: "[47216]Retail sale of bakery products and sugar confectionery",
      },
      {
        value: "[47217]Retail sale of mee, kuey teow, mee hoon, wantan skins and other food products made from flour or soya",
        zh: "[47217]Retail sale of mee, kuey teow, mee hoon, wantan skins and other food products made from flour or soya / 零售面粉或大豆制成的面食产品，如米粉、河粉、米线、云吞皮以及其他食品",
        en: "[47217]Retail sale of mee, kuey teow, mee hoon, wantan skins and other food products made from flour or soya",
      },
      {
        value: "[47219]Retail sale of other food products n.e.c.",
        zh: "[47219]Retail sale of other food products n.e.c. / 其他食品零售",
        en: "[47219]Retail sale of other food products n.e.c.",
      },
      {
        value: "[47221]Retail sale of beer, wine and spirits",
        zh: "[47221]Retail sale of beer, wine and spirits / 零售啤酒、葡萄酒和烈酒",
        en: "[47221]Retail sale of beer, wine and spirits",
      },
      {
        value: "[47222]Retail sale of tea, coffee, soft drinks, mineral water and other beverages",
        zh: "[47222]Retail sale of tea, coffee, soft drinks, mineral water and other beverages / 茶叶、咖啡、软饮料、矿泉水及其他饮料零售",
        en: "[47222]Retail sale of tea, coffee, soft drinks, mineral water and other beverages",
      },
      {
        value: "[47230]Retail sale of tobacco products in specialized store",
        zh: "[47230]Retail sale of tobacco products in specialized store / 在专业商店零售烟草产品",
        en: "[47230]Retail sale of tobacco products in specialized store",
      },
      {
        value: "[47300]Retail sale of automotive fuel in specialized stores",
        zh: "[47300]Retail sale of automotive fuel in specialized stores / 专业商店的汽车燃料零售",
        en: "[47300]Retail sale of automotive fuel in specialized stores",
      },
      {
        value: "[47411]Retail sale of computers, computer equipment and supplies",
        zh: "[47411]Retail sale of computers, computer equipment and supplies / 计算机、计算机设备及用品零售",
        en: "[47411]Retail sale of computers, computer equipment and supplies",
      },
      {
        value: "[47412]Retail sale of video game consoles and non-customized software",
        zh: "[47412]Retail sale of video game consoles and non-customized software / 零售视频游戏机及非定制软件",
        en: "[47412]Retail sale of video game consoles and non-customized software",
      },
      {
        value: "[47413]Retail sale of telecommunication equipment",
        zh: "[47413]Retail sale of telecommunication equipment / 电信设备的零售",
        en: "[47413]Retail sale of telecommunication equipment",
      },
      {
        value: "[47420]Retail sale of audio and video equipment in specialized store",
        zh: "[47420]Retail sale of audio and video equipment in specialized store / 专业店音频和视频设备零售",
        en: "[47420]Retail sale of audio and video equipment in specialized store",
      },
      {
        value: "[47510]Retail sale of textiles in specialized stores",
        zh: "[47510]Retail sale of textiles in specialized stores / 专业店零售纺织品",
        en: "[47510]Retail sale of textiles in specialized stores",
      },
      {
        value: "[47520]Retail sale of construction materials, hardware, paints and glass",
        zh: "[47520]Retail sale of construction materials, hardware, paints and glass / 零售建筑材料、五金、油漆和玻璃",
        en: "[47520]Retail sale of construction materials, hardware, paints and glass",
      },
      {
        value: "[47531]Retail sale of carpets and rugs",
        zh: "[47531]Retail sale of carpets and rugs / 地毯和小地毯的零售",
        en: "[47531]Retail sale of carpets and rugs",
      },
      {
        value: "[47532]Retail sale of curtains and net curtains",
        zh: "[47532]Retail sale of curtains and net curtains / 窗帘及网眼窗帘的零售",
        en: "[47532]Retail sale of curtains and net curtains",
      },
      {
        value: "[47533]Retail sale of wallpaper and floor coverings",
        zh: "[47533]Retail sale of wallpaper and floor coverings / 墙纸和地面覆盖物零售",
        en: "[47533]Retail sale of wallpaper and floor coverings",
      },
      {
        value: "[47591]Retail sale of household furniture",
        zh: "[47591]Retail sale of household furniture / 家用家具零售",
        en: "[47591]Retail sale of household furniture",
      },
      {
        value: "[47592]Retail sale of articles for lighting",
        zh: "[47592]Retail sale of articles for lighting / 照明用品的零售",
        en: "[47592]Retail sale of articles for lighting",
      },
      {
        value: "[47593]Retail sale of household utensils and cutlery, crockery, glassware, chinaware and pottery",
        zh: "[47593]Retail sale of household utensils and cutlery, crockery, glassware, chinaware and pottery / 家用器具和餐具、瓷器、玻璃器皿、陶瓷及陶器的零售",
        en: "[47593]Retail sale of household utensils and cutlery, crockery, glassware, chinaware and pottery",
      },
      {
        value: "[47594]Retail sale of wood, cork goods and wickerwork goods",
        zh: "[47594]Retail sale of wood, cork goods and wickerwork goods / 木材、软木制品和藤制品的零售",
        en: "[47594]Retail sale of wood, cork goods and wickerwork goods",
      },
      {
        value: "[47595]Retail sale of household appliances",
        zh: "[47595]Retail sale of household appliances / 家用电器零售",
        en: "[47595]Retail sale of household appliances",
      },
      {
        value: "[47596]Retail sale of musical instruments and scores",
        zh: "[47596]Retail sale of musical instruments and scores / 乐器和乐谱的零售",
        en: "[47596]Retail sale of musical instruments and scores",
      },
      {
        value: "[47597]Retail sale of security systems",
        zh: "[47597]Retail sale of security systems / 零售安全系统的销售",
        en: "[47597]Retail sale of security systems",
      },
      {
        value: "[47598]Retail sale of household articles and equipment n.e.c.",
        zh: "[47598]Retail sale of household articles and equipment n.e.c. / 家庭用品及设备的零售（不包括其他类）",
        en: "[47598]Retail sale of household articles and equipment n.e.c.",
      },
      {
        value: "[47611]Retail sale of office supplies and equipment",
        zh: "[47611]Retail sale of office supplies and equipment / 零售办公用品和设备",
        en: "[47611]Retail sale of office supplies and equipment",
      },
      {
        value: "[47612]Retail sale of books, newspapers and stationary",
        zh: "[47612]Retail sale of books, newspapers and stationary / 书籍、报纸和文具零售",
        en: "[47612]Retail sale of books, newspapers and stationary",
      },
      {
        value: "[47620]Retail sale of musical records, audio tapes, compact discs , cassettes, video tapes, VCDs and DVDs, blank tapes and discs",
        zh: "[47620]Retail sale of musical records, audio tapes, compact discs , cassettes, video tapes, VCDs and DVDs, blank tapes and discs / 零售音乐唱片、录音带、光盘、磁带、录像带、VCD和DVD、空白磁带和光盘",
        en: "[47620]Retail sale of musical records, audio tapes, compact discs , cassettes, video tapes, VCDs and DVDs, blank tapes and discs",
      },
      {
        value: "[47631]Retail sale of sports goods and equipments",
        zh: "[47631]Retail sale of sports goods and equipments / 零售体育用品和设备",
        en: "[47631]Retail sale of sports goods and equipments",
      },
      {
        value: "[47632]Retail sale of fishing equipment",
        zh: "[47632]Retail sale of fishing equipment / 零售销售钓鱼设备",
        en: "[47632]Retail sale of fishing equipment",
      },
      {
        value: "[47633]Retail sale of camping goods",
        zh: "[47633]Retail sale of camping goods / 露营用品零售",
        en: "[47633]Retail sale of camping goods",
      },
      {
        value: "[47634]Retail sale of boats and equipments",
        zh: "[47634]Retail sale of boats and equipments / 船舶及设备零售",
        en: "[47634]Retail sale of boats and equipments",
      },
      {
        value: "[47635]Retail sale of bicycles and related parts and accessories",
        zh: "[47635]Retail sale of bicycles and related parts and accessories / 零售销售自行车及相关零部件和配件",
        en: "[47635]Retail sale of bicycles and related parts and accessories",
      },
      {
        value: "[47640]Retail sale of games and toys, made of all materials",
        zh: "[47640]Retail sale of games and toys, made of all materials / 零售销售所有材料制成的游戏和玩具",
        en: "[47640]Retail sale of games and toys, made of all materials",
      },
      {
        value: "[47711]Retail sale of articles of clothing, articles of fur and clothing accessories",
        zh: "[47711]Retail sale of articles of clothing, articles of fur and clothing accessories / 服装、皮草及服饰配件的零售",
        en: "[47711]Retail sale of articles of clothing, articles of fur and clothing accessories",
      },
      {
        value: "[47712]Retail sale of footwear",
        zh: "[47712]Retail sale of footwear / 鞋类零售销售",
        en: "[47712]Retail sale of footwear",
      },
      {
        value: "[47713]Retail sale of leather goods, accessories of leather and leather substitutes",
        zh: "[47713]Retail sale of leather goods, accessories of leather and leather substitutes / 皮革商品零售，皮革和皮革替代品的配件",
        en: "[47713]Retail sale of leather goods, accessories of leather and leather substitutes",
      },
      {
        value: "[47721]Stores specialized in retail sale of pharmaceuticals, medical and orthopaedic goods",
        zh: "[47721]Stores specialized in retail sale of pharmaceuticals, medical and orthopaedic goods / 专门零售药品、医疗和骨科商品的商店",
        en: "[47721]Stores specialized in retail sale of pharmaceuticals, medical and orthopaedic goods",
      },
      {
        value: "[47722]Stores specialized in retail sale of perfumery, cosmetic and toilet articles",
        zh: "[47722]Stores specialized in retail sale of perfumery, cosmetic and toilet articles / 专门零售香水、化妆品和卫生用品的商店",
        en: "[47722]Stores specialized in retail sale of perfumery, cosmetic and toilet articles",
      },
      {
        value: "[47731]Retail sale of photographic and precision equipment",
        zh: "[47731]Retail sale of photographic and precision equipment / 摄影和精密设备的零售",
        en: "[47731]Retail sale of photographic and precision equipment",
      },
      {
        value: "[47732]Retail sale of watches and clocks",
        zh: "[47732]Retail sale of watches and clocks / 手表和钟表的零售",
        en: "[47732]Retail sale of watches and clocks",
      },
      {
        value: "[47733]Retail sale of jewellery",
        zh: "[47733]Retail sale of jewellery / 珠宝零售",
        en: "[47733]Retail sale of jewellery",
      },
      {
        value: "[47734]Retail sale of flowers, plants, seeds, fertilizers",
        zh: "[47734]Retail sale of flowers, plants, seeds, fertilizers / 花卉、植物、种子、肥料的零售",
        en: "[47734]Retail sale of flowers, plants, seeds, fertilizers",
      },
      {
        value: "[47735]Retail sale of souvenirs, craftwork and religious articles",
        zh: "[47735]Retail sale of souvenirs, craftwork and religious articles / 零售纪念品、工艺品和宗教物品",
        en: "[47735]Retail sale of souvenirs, craftwork and religious articles",
      },
      {
        value: "[47736]Retail sale of household fuel oil, cooking gas, coal and fuel wood",
        zh: "[47736]Retail sale of household fuel oil, cooking gas, coal and fuel wood / 家庭燃料油、烹饪用气、煤炭和木柴的零售",
        en: "[47736]Retail sale of household fuel oil, cooking gas, coal and fuel wood",
      },
      {
        value: "[47737]Retail sale of spectacles and other optical goods",
        zh: "[47737]Retail sale of spectacles and other optical goods / 零售销售眼镜和其他光学商品",
        en: "[47737]Retail sale of spectacles and other optical goods",
      },
      {
        value: "[47738]Retail sale of aquarium fishes, pet animals and pet food",
        zh: "[47738]Retail sale of aquarium fishes, pet animals and pet food / 水族馆鱼类、宠物动物及宠物食品的零售",
        en: "[47738]Retail sale of aquarium fishes, pet animals and pet food",
      },
      {
        value: "[47739]Other retail sale of new goods in specialized stores n.e.c.",
        zh: "[47739]Other retail sale of new goods in specialized stores n.e.c. / 在专业商店中其他零售销售新的商品 n.e.c.",
        en: "[47739]Other retail sale of new goods in specialized stores n.e.c.",
      },
      {
        value: "[47741]Retail sale of second-hand books",
        zh: "[47741]Retail sale of second-hand books / 二手书籍零售",
        en: "[47741]Retail sale of second-hand books",
      },
      {
        value: "[47742]Retail sale of second-hand electrical and electronic goods",
        zh: "[47742]Retail sale of second-hand electrical and electronic goods / 二手电气和电子商品零售",
        en: "[47742]Retail sale of second-hand electrical and electronic goods",
      },
      {
        value: "[47743]Retail sale of antiques",
        zh: "[47743]Retail sale of antiques / 零售古董",
        en: "[47743]Retail sale of antiques",
      },
      {
        value: "[47744]Activities of auctioning houses (retail)",
        zh: "[47744]Activities of auctioning houses (retail) / 拍卖行活动（零售）",
        en: "[47744]Activities of auctioning houses (retail)",
      },
      {
        value: "[47749]Retail sale of second-hand goods n.e.c.",
        zh: "[47749]Retail sale of second-hand goods n.e.c. / 二手商品的零售",
        en: "[47749]Retail sale of second-hand goods n.e.c.",
      },
      {
        value: "[47810]Retail sale of food, beverages and tobacco products via stalls or markets",
        zh: "[47810]Retail sale of food, beverages and tobacco products via stalls or markets / 通过摊位或市场零售销售食品、饮料和烟草产品",
        en: "[47810]Retail sale of food, beverages and tobacco products via stalls or markets",
      },
      {
        value: "[47820]Retail sale of textiles, clothing and footwear via stalls or markets",
        zh: "[47820]Retail sale of textiles, clothing and footwear via stalls or markets / 通过摊位或市场零售纺织品、服装和鞋类",
        en: "[47820]Retail sale of textiles, clothing and footwear via stalls or markets",
      },
      {
        value: "[47891]Retail sale of carpets and rugs via stalls or markets",
        zh: "[47891]Retail sale of carpets and rugs via stalls or markets / 通过摊位或市场零售销售地毯和地垫",
        en: "[47891]Retail sale of carpets and rugs via stalls or markets",
      },
      {
        value: "[47892]Retail sale of books via stalls or markets",
        zh: "[47892]Retail sale of books via stalls or markets / 通过摊位或市场零售书籍",
        en: "[47892]Retail sale of books via stalls or markets",
      },
      {
        value: "[47893]Retail sale of games and toys via stalls or markets",
        zh: "[47893]Retail sale of games and toys via stalls or markets / 通过摊位或市场零售销售游戏和玩具",
        en: "[47893]Retail sale of games and toys via stalls or markets",
      },
      {
        value: "[47894]Retail sale of household appliances and consumer electronics via stall or markets",
        zh: "[47894]Retail sale of household appliances and consumer electronics via stall or markets / 通过摊位或市场零售家用电器和消费电子",
        en: "[47894]Retail sale of household appliances and consumer electronics via stall or markets",
      },
      {
        value: "[47895]Retail sale of music and video recordings via stall or markets",
        zh: "[47895]Retail sale of music and video recordings via stall or markets / 通过摊位或市场零售音乐和视频录制",
        en: "[47895]Retail sale of music and video recordings via stall or markets",
      },
      {
        value: "[47911]Retail sale of any kind of product by mail order",
        zh: "[47911]Retail sale of any kind of product by mail order / 通过邮购方式零售任何产品",
        en: "[47911]Retail sale of any kind of product by mail order",
      },
      {
        value: "[47912]Retail sale of any kind of product over the Internet",
        zh: "[47912]Retail sale of any kind of product over the Internet / 通过互联网零售任何类型的产品",
        en: "[47912]Retail sale of any kind of product over the Internet",
      },
      {
        value: "[47913]Direct sale via television, radio and telephone",
        zh: "[47913]Direct sale via television, radio and telephone / 通过电视、广播和电话直接销售",
        en: "[47913]Direct sale via television, radio and telephone",
      },
      {
        value: "[47914]Internet retail auctions",
        zh: "[47914]Internet retail auctions / 互联网零售拍卖",
        en: "[47914]Internet retail auctions",
      },
      {
        value: "[47991]Retail sale of any kind of product by direct sales or door-to-door sales persons",
        zh: "[47991]Retail sale of any kind of product by direct sales or door-to-door sales persons / 直销或上门销售任何形式的产品",
        en: "[47991]Retail sale of any kind of product by direct sales or door-to-door sales persons",
      },
      {
        value: "[47992]Retail sale of any kind of product through vending machines",
        zh: "[47992]Retail sale of any kind of product through vending machines / 通过自动售货机零售各种产品",
        en: "[47992]Retail sale of any kind of product through vending machines",
      },
      {
        value: "[47999]Other retail sale not in stores, stalls or markets n.e.c.",
        zh: "[47999]Other retail sale not in stores, stalls or markets n.e.c. / 其他非店铺、摊位或市场销售的零售",
        en: "[47999]Other retail sale not in stores, stalls or markets n.e.c.",
      },
      {
        value: "[49110]Passenger transport by inter-urban railways",
        zh: "[49110]Passenger transport by inter-urban railways / 城际铁路客运",
        en: "[49110]Passenger transport by inter-urban railways",
      },
      {
        value: "[49120]Freight transport by inter-urban, suburban and urban railways",
        zh: "[49120]Freight transport by inter-urban, suburban and urban railways / 城际、郊区和城市铁路的货物运输",
        en: "[49120]Freight transport by inter-urban, suburban and urban railways",
      },
      {
        value: "[49211]City bus services",
        zh: "[49211]City bus services / 城市公交服务",
        en: "[49211]City bus services",
      },
      {
        value: "[49212]Urban and suburban railway passenger transport service",
        zh: "[49212]Urban and suburban railway passenger transport service / 城市和郊区铁路客运服务",
        en: "[49212]Urban and suburban railway passenger transport service",
      },
      {
        value: "[49221]Express bus services",
        zh: "[49221]Express bus services / 快速公交服务",
        en: "[49221]Express bus services",
      },
      {
        value: "[49222]Employees bus services",
        zh: "[49222]Employees bus services / 员工巴士服务",
        en: "[49222]Employees bus services",
      },
      {
        value: "[49223]School bus services",
        zh: "[49223]School bus services / 校车服务",
        en: "[49223]School bus services",
      },
      {
        value: "[49224]Taxi operation and limousine services",
        zh: "[49224]Taxi operation and limousine services / 出租车运营和豪华轿车服务",
        en: "[49224]Taxi operation and limousine services",
      },
      {
        value: "[49225]Rental of cars with driver",
        zh: "[49225]Rental of cars with driver / 带司机的汽车租赁",
        en: "[49225]Rental of cars with driver",
      },
      {
        value: "[49229]Other passenger land transport n.e.c.",
        zh: "[49229]Other passenger land transport n.e.c. / 其他乘客陆上运输",
        en: "[49229]Other passenger land transport n.e.c.",
      },
      {
        value: "[49230]Freight transport by road",
        zh: "[49230]Freight transport by road / 公路货运",
        en: "[49230]Freight transport by road",
      },
      {
        value: "[49300]Transport via pipeline",
        zh: "[49300]Transport via pipeline / 通过管道运输",
        en: "[49300]Transport via pipeline",
      },
      {
        value: "[50111]Operation of excursion, cruise or sightseeing boats",
        zh: "[50111]Operation of excursion, cruise or sightseeing boats / 观光、游轮或观光船的运营",
        en: "[50111]Operation of excursion, cruise or sightseeing boats",
      },
      {
        value: "[50112]Operation of ferries, water taxis",
        zh: "[50112]Operation of ferries, water taxis / 渡轮和水上出租车的运营",
        en: "[50112]Operation of ferries, water taxis",
      },
      {
        value: "[50113]Rental of pleasure boats with crew for sea and coastal water transport",
        zh: "[50113]Rental of pleasure boats with crew for sea and coastal water transport / 带船员的海上和沿海水上运输的租赁",
        en: "[50113]Rental of pleasure boats with crew for sea and coastal water transport",
      },
      {
        value: "[50121]Transport of freight overseas and coastal waters, whether scheduled or not",
        zh: "[50121]Transport of freight overseas and coastal waters, whether scheduled or not / 海外及沿海水域的货物运输，无论是否定期",
        en: "[50121]Transport of freight overseas and coastal waters, whether scheduled or not",
      },
      {
        value: "[50122]Transport by towing or pushing of barges, oil rigs",
        zh: "[50122]Transport by towing or pushing of barges, oil rigs / 拖曳或推动驳船、石油平台的运输",
        en: "[50122]Transport by towing or pushing of barges, oil rigs",
      },
      {
        value: "[50211]Transport of passenger via rivers, canals, lakes and other inland waterways",
        zh: "[50211]Transport of passenger via rivers, canals, lakes and other inland waterways / 通过河流、运河、湖泊和其他内陆水道的客运运输",
        en: "[50211]Transport of passenger via rivers, canals, lakes and other inland waterways",
      },
      {
        value: "[50212]Rental of pleasure boats with crew for inland water transport",
        zh: "[50212]Rental of pleasure boats with crew for inland water transport / 内河运输带船员的游艇租赁",
        en: "[50212]Rental of pleasure boats with crew for inland water transport",
      },
      {
        value: "[50220]Transport of freight via rivers, canals, lakes and other inland waterways",
        zh: "[50220]Transport of freight via rivers, canals, lakes and other inland waterways / 通过河流、运河、湖泊及其他内陆水道运输货物",
        en: "[50220]Transport of freight via rivers, canals, lakes and other inland waterways",
      },
      {
        value: "[51101]Transport of passengers by air over regular routes and on regular schedules",
        zh: "[51101]Transport of passengers by air over regular routes and on regular schedules / 按固定路线和时间表的空中乘客运输",
        en: "[51101]Transport of passengers by air over regular routes and on regular schedules",
      },
      {
        value: "[51102]Non-scheduled transport of passenger by air",
        zh: "[51102]Non-scheduled transport of passenger by air / 非定期航空客运",
        en: "[51102]Non-scheduled transport of passenger by air",
      },
      {
        value: "[51103]Renting of air-transport equipment with operator for the purpose of passenger transportation",
        zh: "[51103]Renting of air-transport equipment with operator for the purpose of passenger transportation / 出租配有操作员的航空运输设备以供客运",
        en: "[51103]Renting of air-transport equipment with operator for the purpose of passenger transportation",
      },
      {
        value: "[51201]Transport freight by air over regular routes and on regular schedules",
        zh: "[51201]Transport freight by air over regular routes and on regular schedules / 定期航班和固定时间的航空货运",
        en: "[51201]Transport freight by air over regular routes and on regular schedules",
      },
      {
        value: "[51202]Non-scheduled transport of freight by air",
        zh: "[51202]Non-scheduled transport of freight by air / 非定期空运货物",
        en: "[51202]Non-scheduled transport of freight by air",
      },
      {
        value: "[51203]Renting of air-transport equipment with operator for the purpose of freight transportation",
        zh: "[51203]Renting of air-transport equipment with operator for the purpose of freight transportation / 带操作员的航空运输设备的租赁，用于货物运输",
        en: "[51203]Renting of air-transport equipment with operator for the purpose of freight transportation",
      },
      {
        value: "[52100]Warehousing and storage services",
        zh: "[52100]Warehousing and storage services / 仓储和存储服务",
        en: "[52100]Warehousing and storage services",
      },
      {
        value: "[52211]Operation of terminal facilities",
        zh: "[52211]Operation of terminal facilities / 终端设施的操作",
        en: "[52211]Operation of terminal facilities",
      },
      {
        value: "[52212]Towing and road side assistance",
        zh: "[52212]Towing and road side assistance / 拖车和路边紧急援助",
        en: "[52212]Towing and road side assistance",
      },
      {
        value: "[52213]Operation of parking facilities for motor vehicles (parking lots)",
        zh: "[52213]Operation of parking facilities for motor vehicles (parking lots) / 机动车辆停车场设施的运营",
        en: "[52213]Operation of parking facilities for motor vehicles (parking lots)",
      },
      {
        value: "[52214]Highway, bridge and tunnel operation services",
        zh: "[52214]Highway, bridge and tunnel operation services / 公路、桥梁和隧道运营服务",
        en: "[52214]Highway, bridge and tunnel operation services",
      },
      {
        value: "[52219]Other service activities incidental to land transportation n.e.c.",
        zh: "[52219]Other service activities incidental to land transportation n.e.c. / 与陆地运输相关的其他服务活动",
        en: "[52219]Other service activities incidental to land transportation n.e.c.",
      },
      {
        value: "[52221]Port, harbours and piers operation services",
        zh: "[52221]Port, harbours and piers operation services / 港口、码头和码头运营服务",
        en: "[52221]Port, harbours and piers operation services",
      },
      {
        value: "[52222]Vessel salvage and refloating services",
        zh: "[52222]Vessel salvage and refloating services / 船舶救援和重新浮起服务",
        en: "[52222]Vessel salvage and refloating services",
      },
      {
        value: "[52229]Other service activities incidental to water transportation n.e.c.",
        zh: "[52229]Other service activities incidental to water transportation n.e.c. / 与水路运输相关的其他服务活动",
        en: "[52229]Other service activities incidental to water transportation n.e.c.",
      },
      {
        value: "[52231]Operation of terminal facilities",
        zh: "[52231]Operation of terminal facilities / 运营终端设施",
        en: "[52231]Operation of terminal facilities",
      },
      {
        value: "[52232]Airport and air-traffic-control activities",
        zh: "[52232]Airport and air-traffic-control activities / 机场和空中交通控制活动",
        en: "[52232]Airport and air-traffic-control activities",
      },
      {
        value: "[52233]Ground service activities on airfields",
        zh: "[52233]Ground service activities on airfields / 机场地面服务活动",
        en: "[52233]Ground service activities on airfields",
      },
      {
        value: "[52234]Fire fighting and fire-prevention services at airports",
        zh: "[52234]Fire fighting and fire-prevention services at airports / 机场消防和防火服务",
        en: "[52234]Fire fighting and fire-prevention services at airports",
      },
      {
        value: "[52239]Other service activities incidental to air transportation n.e.c.",
        zh: "[52239]Other service activities incidental to air transportation n.e.c. / 航空运输附带的其他服务活动",
        en: "[52239]Other service activities incidental to air transportation n.e.c.",
      },
      {
        value: "[52241]Stevedoring services",
        zh: "[52241]Stevedoring services / 装卸服务",
        en: "[52241]Stevedoring services",
      },
      {
        value: "[52249]Other cargo handling activities n.e.c.",
        zh: "[52249]Other cargo handling activities n.e.c. / 其他杂项货物处理活动",
        en: "[52249]Other cargo handling activities n.e.c.",
      },
      {
        value: "[52291]Forwarding of freight",
        zh: "[52291]Forwarding of freight / 货物的转运",
        en: "[52291]Forwarding of freight",
      },
      {
        value: "[52292]Brokerage for ship and aircraft space",
        zh: "[52292]Brokerage for ship and aircraft space / 船舶和航空器空间的经纪",
        en: "[52292]Brokerage for ship and aircraft space",
      },
      {
        value: "[52299]Other transportation support activities n.e.c.",
        zh: "[52299]Other transportation support activities n.e.c. / 其他运输支持活动",
        en: "[52299]Other transportation support activities n.e.c.",
      },
      {
        value: "[53100]National postal services",
        zh: "[53100]National postal services / 国家邮政服务",
        en: "[53100]National postal services",
      },
      {
        value: "[53200]Courier activities other than national post activities",
        zh: "[53200]Courier activities other than national post activities / 非国家邮政活动的快递服务",
        en: "[53200]Courier activities other than national post activities",
      },
      {
        value: "[55101]Hotels and resort hotels",
        zh: "[55101]Hotels and resort hotels / 酒店和度假酒店",
        en: "[55101]Hotels and resort hotels",
      },
      {
        value: "[55102]Motels",
        zh: "[55102]Motels / 汽车旅馆",
        en: "[55102]Motels",
      },
      {
        value: "[55103]Apartment hotels",
        zh: "[55103]Apartment hotels / 公寓式酒店",
        en: "[55103]Apartment hotels",
      },
      {
        value: "[55104]Chalets",
        zh: "[55104]Chalets / 小木屋",
        en: "[55104]Chalets",
      },
      {
        value: "[55105]Rest house/guest house",
        zh: "[55105]Rest house/guest house / 休息室/宾馆",
        en: "[55105]Rest house/guest house",
      },
      {
        value: "[55106]Bed and breakfast units",
        zh: "[55106]Bed and breakfast units / 提供住宿和早餐的单位",
        en: "[55106]Bed and breakfast units",
      },
      {
        value: "[55107]Hostels",
        zh: "[55107]Hostels / 宿舍",
        en: "[55107]Hostels",
      },
      {
        value: "[55108]Home stay",
        zh: "[55108]Home stay / 家庭住宿",
        en: "[55108]Home stay",
      },
      {
        value: "[55109]Other short term accommodation activities n.e.c.",
        zh: "[55109]Other short term accommodation activities n.e.c. / 其他短期住宿活动",
        en: "[55109]Other short term accommodation activities n.e.c.",
      },
      {
        value: "[55200]Camping grounds, recreational vehicle parks and trailer parks",
        zh: "[55200]Camping grounds, recreational vehicle parks and trailer parks / 露营地、房车公园和拖车公园",
        en: "[55200]Camping grounds, recreational vehicle parks and trailer parks",
      },
      {
        value: "[55900]Other accommodation",
        zh: "[55900]Other accommodation / 其他住宿服务",
        en: "[55900]Other accommodation",
      },
      {
        value: "[56101]Restaurants and restaurant cum night clubs",
        zh: "[56101]Restaurants and restaurant cum night clubs / 餐厅和餐厅兼夜总会",
        en: "[56101]Restaurants and restaurant cum night clubs",
      },
      {
        value: "[56102]Cafeterias/canteens",
        zh: "[56102]Cafeterias/canteens / 食堂/餐厅",
        en: "[56102]Cafeterias/canteens",
      },
      {
        value: "[56103]Fast-food restaurants",
        zh: "[56103]Fast-food restaurants / 快餐店",
        en: "[56103]Fast-food restaurants",
      },
      {
        value: "[56104]Ice cream truck vendors and parlours",
        zh: "[56104]Ice cream truck vendors and parlours / 冰淇淋车商和冷饮店",
        en: "[56104]Ice cream truck vendors and parlours",
      },
      {
        value: "[56105]Mobile food carts",
        zh: "[56105]Mobile food carts / 流动食品车",
        en: "[56105]Mobile food carts",
      },
      {
        value: "[56106]Food stalls/hawkers",
        zh: "[56106]Food stalls/hawkers / 食品摊贩/小贩",
        en: "[56106]Food stalls/hawkers",
      },
      {
        value: "[56107]Food or beverage, food and beverage preparation in market stalls/hawkers",
        zh: "[56107]Food or beverage, food and beverage preparation in market stalls/hawkers / 市场摊位/小贩处的食品或饮料，食品和饮料制备",
        en: "[56107]Food or beverage, food and beverage preparation in market stalls/hawkers",
      },
      {
        value: "[56210]Event/food caterers",
        zh: "[56210]Event/food caterers / 活动/食品承办商",
        en: "[56210]Event/food caterers",
      },
      {
        value: "[56290]Other food service activities",
        zh: "[56290]Other food service activities / 其他食品服务活动",
        en: "[56290]Other food service activities",
      },
      {
        value: "[56301]Pubs, bars, discotheques, coffee houses, cocktail lounges and karaoke",
        zh: "[56301]Pubs, bars, discotheques, coffee houses, cocktail lounges and karaoke / 酒吧、夜总会、迪斯科舞厅、咖啡馆、鸡尾酒休息室和卡拉OK",
        en: "[56301]Pubs, bars, discotheques, coffee houses, cocktail lounges and karaoke",
      },
      {
        value: "[56302]Coffee shops",
        zh: "[56302]Coffee shops / 咖啡店",
        en: "[56302]Coffee shops",
      },
      {
        value: "[56303]Drink stalls/hawkers",
        zh: "[56303]Drink stalls/hawkers / 饮料摊/小贩",
        en: "[56303]Drink stalls/hawkers",
      },
      {
        value: "[56304]Mobile beverage",
        zh: "[56304]Mobile beverage / 移动饮料",
        en: "[56304]Mobile beverage",
      },
      {
        value: "[56309]Others drinking places n.e.c.",
        zh: "[56309]Others drinking places n.e.c. / 其他未列明的饮料场所",
        en: "[56309]Others drinking places n.e.c.",
      },
      {
        value: "[58110]Publishing of books, brochures and other publications",
        zh: "[58110]Publishing of books, brochures and other publications / 书籍、小册子和其他出版物的出版",
        en: "[58110]Publishing of books, brochures and other publications",
      },
      {
        value: "[58120]Publishing of mailing lists, telephone book, other directories",
        zh: "[58120]Publishing of mailing lists, telephone book, other directories / 邮寄名单、电话簿、其他目录的出版",
        en: "[58120]Publishing of mailing lists, telephone book, other directories",
      },
      {
        value: "[58130]Publishing of newspapers, journals, magazines and periodicals in print or electronic form",
        zh: "[58130]Publishing of newspapers, journals, magazines and periodicals in print or electronic form / 报纸、期刊、杂志和电子形式的定期刊物的出版",
        en: "[58130]Publishing of newspapers, journals, magazines and periodicals in print or electronic form",
      },
      {
        value:
          "[58190]Publishing of catalogues, photos, engraving and postcards, greeting cards, forms, posters, reproduction of works of art, advertising material and other printed matter n.e.c.",
        zh: "[58190]Publishing of catalogues, photos, engraving and postcards, greeting cards, forms, posters, reproduction of works of art, advertising material and other printed matter n.e.c. / 出版目录、照片、雕刻和明信片、问候卡、表格、海报、艺术品复制品、广告材料及其他印刷品等",
        en: "[58190]Publishing of catalogues, photos, engraving and postcards, greeting cards, forms, posters, reproduction of works of art, advertising material and other printed matter n.e.c.",
      },
      {
        value: "[58201]Business and other applications",
        zh: "[58201]Business and other applications / 商业和其他应用",
        en: "[58201]Business and other applications",
      },
      {
        value: "[58202]Computer games for all platforms",
        zh: "[58202]Computer games for all platforms / 各种平台的电脑游戏",
        en: "[58202]Computer games for all platforms",
      },
      {
        value: "[58203]Operating systems",
        zh: "[58203]Operating systems / 操作系统",
        en: "[58203]Operating systems",
      },
      {
        value: "[59110]Motion picture, video and television programme production activities",
        zh: "[59110]Motion picture, video and television programme production activities / 电影、视频和电视节目制作活动",
        en: "[59110]Motion picture, video and television programme production activities",
      },
      {
        value: "[59120]Motion picture, video and television programme post-production activities",
        zh: "[59120]Motion picture, video and television programme post-production activities / 电影、视频和电视节目后期制作活动",
        en: "[59120]Motion picture, video and television programme post-production activities",
      },
      {
        value: "[59130]Motion picture, video and television programme distribution activities",
        zh: "[59130]Motion picture, video and television programme distribution activities / 电影、视频和电视节目的发行活动",
        en: "[59130]Motion picture, video and television programme distribution activities",
      },
      {
        value: "[59140]Motion picture projection activities",
        zh: "[59140]Motion picture projection activities / 电影放映活动",
        en: "[59140]Motion picture projection activities",
      },
      {
        value: "[59200]Sound recording and music publishing activities",
        zh: "[59200]Sound recording and music publishing activities / 声音录制和音乐出版活动",
        en: "[59200]Sound recording and music publishing activities",
      },
      {
        value: "[60100]Radio broadcasting",
        zh: "[60100]Radio broadcasting / 广播电台广播",
        en: "[60100]Radio broadcasting",
      },
      {
        value: "[60200]Television programming and broadcasting activities",
        zh: "[60200]Television programming and broadcasting activities / 电视节目制作和广播活动",
        en: "[60200]Television programming and broadcasting activities",
      },
      {
        value: "[61101]Wired telecommunications services",
        zh: "[61101]Wired telecommunications services / 有线电信服务",
        en: "[61101]Wired telecommunications services",
      },
      {
        value: "[61102]Internet access providers by the operator of the wired infrastructure",
        zh: "[61102]Internet access providers by the operator of the wired infrastructure / 通过有线基础设施运营商提供的互联网接入服务",
        en: "[61102]Internet access providers by the operator of the wired infrastructure",
      },
      {
        value: "[61201]Wireless telecommunications services",
        zh: "[61201]Wireless telecommunications services / 无线电信服务",
        en: "[61201]Wireless telecommunications services",
      },
      {
        value: "[61202]Internet access providers by the operator of the wireless infrastructure",
        zh: "[61202]Internet access providers by the operator of the wireless infrastructure / 无线基础设施运营商的互联网接入服务提供商",
        en: "[61202]Internet access providers by the operator of the wireless infrastructure",
      },
      {
        value: "[61300]Satellite telecommunications services",
        zh: "[61300]Satellite telecommunications services / 卫星电信服务",
        en: "[61300]Satellite telecommunications services",
      },
      {
        value: "[61901]Provision of Internet access over networks between the client and the ISP not owned or controlled by the ISP",
        zh: "[61901]Provision of Internet access over networks between the client and the ISP not owned or controlled by the ISP / 在客户与ISP之间通过非ISP拥有或控制的网络提供互联网接入",
        en: "[61901]Provision of Internet access over networks between the client and the ISP not owned or controlled by the ISP",
      },
      {
        value: "[61902]Provision of telecommunications services over existing telecom connection",
        zh: "[61902]Provision of telecommunications services over existing telecom connection / 通过现有电信连接提供电信服务",
        en: "[61902]Provision of telecommunications services over existing telecom connection",
      },
      {
        value: "[61903]Telecommunications resellers",
        zh: "[61903]Telecommunications resellers / 电信转售",
        en: "[61903]Telecommunications resellers",
      },
      {
        value: "[61904]Provision of telecommunications services over existing telecom connections VOIP (Voice Over Internet Protocol) provision",
        zh: "[61904]Provision of telecommunications services over existing telecom connections VOIP (Voice Over Internet Protocol) provision / 通过现有电信连接提供电信服务 VOIP（基于互联网协议的语音）提供",
        en: "[61904]Provision of telecommunications services over existing telecom connections VOIP (Voice Over Internet Protocol) provision",
      },
      {
        value: "[61905]Provision of specialized telecommunications applications",
        zh: "[61905]Provision of specialized telecommunications applications / 提供专门的电信应用服务",
        en: "[61905]Provision of specialized telecommunications applications",
      },
      {
        value: "[61909]Other telecommunications activities n.e.c.",
        zh: "[61909]Other telecommunications activities n.e.c. / 其他电信活动",
        en: "[61909]Other telecommunications activities n.e.c.",
      },
      {
        value: "[62010]Computer programming activities",
        zh: "[62010]Computer programming activities / 计算机编程活动",
        en: "[62010]Computer programming activities",
      },
      {
        value: "[62021]Computer consultancy",
        zh: "[62021]Computer consultancy / 计算机咨询",
        en: "[62021]Computer consultancy",
      },
      {
        value: "[62022]Computer facilities management activities",
        zh: "[62022]Computer facilities management activities / 计算机设施管理活动",
        en: "[62022]Computer facilities management activities",
      },
      {
        value: "[62091]Information Communication Technology (ICT) system security",
        zh: "[62091]Information Communication Technology (ICT) system security / 信息通信技术（ICT）系统安全",
        en: "[62091]Information Communication Technology (ICT) system security",
      },
      {
        value: "[62099]Other information technology service activities n.e.c.",
        zh: "[62099]Other information technology service activities n.e.c. / 其他信息技术服务活动",
        en: "[62099]Other information technology service activities n.e.c.",
      },
      {
        value: "[63111]Activities of providing infrastructure for hosting, data processing services and related activities",
        zh: "[63111]Activities of providing infrastructure for hosting, data processing services and related activities / 提供用于托管、数据处理服务及相关活动的基础设施",
        en: "[63111]Activities of providing infrastructure for hosting, data processing services and related activities",
      },
      {
        value: "[63112]Data processing activities",
        zh: "[63112]Data processing activities / 数据处理活动",
        en: "[63112]Data processing activities",
      },
      {
        value: "[63120]Web portals",
        zh: "[63120]Web portals / 网络门户",
        en: "[63120]Web portals",
      },
      {
        value: "[63910]News syndicate and news agency activities",
        zh: "[63910]News syndicate and news agency activities / 新闻联合社和新闻代理机构活动",
        en: "[63910]News syndicate and news agency activities",
      },
      {
        value: "[63990]Other information service activities n.e.c.",
        zh: "[63990]Other information service activities n.e.c. / 其他信息服务活动",
        en: "[63990]Other information service activities n.e.c.",
      },
      {
        value: "[64110]Central banking",
        zh: "[64110]Central banking / 中央银行",
        en: "[64110]Central banking",
      },
      {
        value: "[64191]Commercial Banks",
        zh: "[64191]Commercial Banks / 商业银行",
        en: "[64191]Commercial Banks",
      },
      {
        value: "[64192]Islamic Banks",
        zh: "[64192]Islamic Banks / 伊斯兰银行",
        en: "[64192]Islamic Banks",
      },
      {
        value: "[64193]Offshore Banks",
        zh: "[64193]Offshore Banks / 离岸银行",
        en: "[64193]Offshore Banks",
      },
      {
        value: "[64194]Investment Banks",
        zh: "[64194]Investment Banks / 投资银行",
        en: "[64194]Investment Banks",
      },
      {
        value: "[64195]Development financial institutions (with deposit taking functions)",
        zh: "[64195]Development financial institutions (with deposit taking functions) / 发展金融机构（具有存款功能）",
        en: "[64195]Development financial institutions (with deposit taking functions)",
      },
      {
        value: "[64199]Other monetary intermediation (with deposit taking functions) n.e.c.",
        zh: "[64199]Other monetary intermediation (with deposit taking functions) n.e.c. / 其他货币中介服务（包括存款功能）",
        en: "[64199]Other monetary intermediation (with deposit taking functions) n.e.c.",
      },
      {
        value: "[64200]Activities of holding companies",
        zh: "[64200]Activities of holding companies / 控股公司的活动",
        en: "[64200]Activities of holding companies",
      },
      {
        value: "[64301]Venture capital companies",
        zh: "[64301]Venture capital companies / 风险投资公司",
        en: "[64301]Venture capital companies",
      },
      {
        value: "[64302]Unit trust fund excludes REITs",
        zh: "[64302]Unit trust fund excludes REITs / 单位信托基金不包括房地产投资信托基金(REITs)",
        en: "[64302]Unit trust fund excludes REITs",
      },
      {
        value: "[64303]Property unit trust (REITs)",
        zh: "[64303]Property unit trust (REITs) / 房地产单位信托（REITs）",
        en: "[64303]Property unit trust (REITs)",
      },
      {
        value: "[64304]Other administration of trusts accounts",
        zh: "[64304]Other administration of trusts accounts / 其他信托账户管理",
        en: "[64304]Other administration of trusts accounts",
      },
      {
        value: "[64309]Trusts, funds and similar financial entities n.e.c.",
        zh: "[64309]Trusts, funds and similar financial entities n.e.c. / 信托、基金及类似金融实体（未特指）",
        en: "[64309]Trusts, funds and similar financial entities n.e.c.",
      },
      {
        value: "[64910]Financial leasing activities",
        zh: "[64910]Financial leasing activities / 金融租赁活动",
        en: "[64910]Financial leasing activities",
      },
      {
        value: "[64921]Development financial institutions (without deposit taking functions)",
        zh: "[64921]Development financial institutions (without deposit taking functions) / 发展性金融机构（不具有吸收存款功能）",
        en: "[64921]Development financial institutions (without deposit taking functions)",
      },
      {
        value: "[64922]Credit card services",
        zh: "[64922]Credit card services / 信用卡服务",
        en: "[64922]Credit card services",
      },
      {
        value: "[64923]Licensed money lending activities",
        zh: "[64923]Licensed money lending activities / 持牌放贷活动",
        en: "[64923]Licensed money lending activities",
      },
      {
        value: "[64924]Pawnshops and pawnbrokers includes Ar-Rahnu",
        zh: "[64924]Pawnshops and pawnbrokers includes Ar-Rahnu / 当铺和典当行包括Ar-Rahnu",
        en: "[64924]Pawnshops and pawnbrokers includes Ar-Rahnu",
      },
      {
        value: "[64925]Co-operative with credits functions",
        zh: "[64925]Co-operative with credits functions / 信用功能的合作",
        en: "[64925]Co-operative with credits functions",
      },
      {
        value: "[64929]Other credit granting n.e.c.",
        zh: "[64929]Other credit granting n.e.c. / 其他信贷授予（不包括银行）",
        en: "[64929]Other credit granting n.e.c.",
      },
      {
        value: "[64991]Factoring companies",
        zh: "[64991]Factoring companies / 保理公司",
        en: "[64991]Factoring companies",
      },
      {
        value: "[64992]Representative office of foreign banks",
        zh: "[64992]Representative office of foreign banks / 外国银行代表处",
        en: "[64992]Representative office of foreign banks",
      },
      {
        value: "[64993]Nominee companies",
        zh: "[64993]Nominee companies / 名义公司",
        en: "[64993]Nominee companies",
      },
      {
        value: "[64999]Other financial service activities, except insurance/takaful and pension funding n.e.c.",
        zh: "[64999]Other financial service activities, except insurance/takaful and pension funding n.e.c. / 其他金融服务活动，不包括保险/伊斯兰保险和养老金资金筹集",
        en: "[64999]Other financial service activities, except insurance/takaful and pension funding n.e.c.",
      },
      {
        value: "[65111]Life insurance",
        zh: "[65111]Life insurance / 人寿保险",
        en: "[65111]Life insurance",
      },
      {
        value: "[65112]Family takaful",
        zh: "[65112]Family takaful / 家庭相互保险",
        en: "[65112]Family takaful",
      },
      {
        value: "[65121]General insurance",
        zh: "[65121]General insurance / 一般保险",
        en: "[65121]General insurance",
      },
      {
        value: "[65122]General takaful",
        zh: "[65122]General takaful / 一般相互保险",
        en: "[65122]General takaful",
      },
      {
        value: "[65123]Composite insurance",
        zh: "[65123]Composite insurance / 综合保险",
        en: "[65123]Composite insurance",
      },
      {
        value: "[65124]Offshore insurance",
        zh: "[65124]Offshore insurance / 海上保险",
        en: "[65124]Offshore insurance",
      },
      {
        value: "[65125]Offshore takaful",
        zh: "[65125]Offshore takaful / 离岸伊斯兰保险",
        en: "[65125]Offshore takaful",
      },
      {
        value: "[65201]Life reinsurance",
        zh: "[65201]Life reinsurance / 寿险再保险",
        en: "[65201]Life reinsurance",
      },
      {
        value: "[65202]Family retakaful",
        zh: "[65202]Family retakaful / 家庭再保险",
        en: "[65202]Family retakaful",
      },
      {
        value: "[65203]General reinsurance",
        zh: "[65203]General reinsurance / 一般再保险",
        en: "[65203]General reinsurance",
      },
      {
        value: "[65204]General retakaful",
        zh: "[65204]General retakaful / 一般再保险",
        en: "[65204]General retakaful",
      },
      {
        value: "[65205]Composite retakaful",
        zh: "[65205]Composite retakaful / 复合再保险",
        en: "[65205]Composite retakaful",
      },
      {
        value: "[65206]Offshore reinsurance",
        zh: "[65206]Offshore reinsurance / 离岸再保险",
        en: "[65206]Offshore reinsurance",
      },
      {
        value: "[65207]Offshore retakaful",
        zh: "[65207]Offshore retakaful / 离岸再保险",
        en: "[65207]Offshore retakaful",
      },
      {
        value: "[65301]Pension funding",
        zh: "[65301]Pension funding / 养老金资金",
        en: "[65301]Pension funding",
      },
      {
        value: "[65302]Provident funding",
        zh: "[65302]Provident funding / 养老基金",
        en: "[65302]Provident funding",
      },
      {
        value: "[66111]Stock exchanges",
        zh: "[66111]Stock exchanges / 证券交易所",
        en: "[66111]Stock exchanges",
      },
      {
        value: "[66112]Exchanges for commodity contracts",
        zh: "[66112]Exchanges for commodity contracts / 商品合约交易",
        en: "[66112]Exchanges for commodity contracts",
      },
      {
        value: "[66113]Securities exchange",
        zh: "[66113]Securities exchange / 证券交易所",
        en: "[66113]Securities exchange",
      },
      {
        value: "[66114]Exchanges for commodity futures contracts",
        zh: "[66114]Exchanges for commodity futures contracts / 商品期货合约交易",
        en: "[66114]Exchanges for commodity futures contracts",
      },
      {
        value: "[66119]Administration of financial markets n.e.c.",
        zh: "[66119]Administration of financial markets n.e.c. / 金融市场管理（不包括银行、保险、养老基金）",
        en: "[66119]Administration of financial markets n.e.c.",
      },
      {
        value: "[66121]Stock, share and bond brokers",
        zh: "[66121]Stock, share and bond brokers / 股票、证券和债券经纪人",
        en: "[66121]Stock, share and bond brokers",
      },
      {
        value: "[66122]Commodity brokers and dealers",
        zh: "[66122]Commodity brokers and dealers / 商品经纪人和经销商",
        en: "[66122]Commodity brokers and dealers",
      },
      {
        value: "[66123]Gold bullion dealers",
        zh: "[66123]Gold bullion dealers / 金条经销商",
        en: "[66123]Gold bullion dealers",
      },
      {
        value: "[66124]Foreign exchange broker and dealers (Bureaux de change)",
        zh: "[66124]Foreign exchange broker and dealers (Bureaux de change) / 外汇经纪人和经销商（货币兑换所）",
        en: "[66124]Foreign exchange broker and dealers (Bureaux de change)",
      },
      {
        value: "[66125]Money-changing services",
        zh: "[66125]Money-changing services / 货币兑换服务",
        en: "[66125]Money-changing services",
      },
      {
        value: "[66129]Other financial and commodity futures brokers and dealers",
        zh: "[66129]Other financial and commodity futures brokers and dealers / 其他金融和商品期货经纪人及交易商",
        en: "[66129]Other financial and commodity futures brokers and dealers",
      },
      {
        value: "[66191]Investment advisory services",
        zh: "[66191]Investment advisory services / 投资顾问服务",
        en: "[66191]Investment advisory services",
      },
      {
        value: "[66192]Financial consultancy services",
        zh: "[66192]Financial consultancy services / 财务咨询服务",
        en: "[66192]Financial consultancy services",
      },
      {
        value: "[66199]Activities auxiliary to finance n.e.c.",
        zh: "[66199]Activities auxiliary to finance n.e.c. / 金融辅助活动",
        en: "[66199]Activities auxiliary to finance n.e.c.",
      },
      {
        value: "[66211]Insurance adjusting service",
        zh: "[66211]Insurance adjusting service / 保险理赔服务",
        en: "[66211]Insurance adjusting service",
      },
      {
        value: "[66212]Takaful adjusting service",
        zh: "[66212]Takaful adjusting service / 伊斯兰保险调整服务",
        en: "[66212]Takaful adjusting service",
      },
      {
        value: "[66221]Insurance agents",
        zh: "[66221]Insurance agents / 保险代理",
        en: "[66221]Insurance agents",
      },
      {
        value: "[66222]Takaful agents",
        zh: "[66222]Takaful agents / 伊斯兰互助保险代理",
        en: "[66222]Takaful agents",
      },
      {
        value: "[66223]Insurance brokers",
        zh: "[66223]Insurance brokers / 保险经纪人",
        en: "[66223]Insurance brokers",
      },
      {
        value: "[66224]Takaful brokers",
        zh: "[66224]Takaful brokers / 塔库法尔经纪人",
        en: "[66224]Takaful brokers",
      },
      {
        value: "[66290]Other activities auxiliary to insurance, takaful and pension funding",
        zh: "[66290]Other activities auxiliary to insurance, takaful and pension funding / 其他辅助保险、互惠基金和养老金资金活动",
        en: "[66290]Other activities auxiliary to insurance, takaful and pension funding",
      },
      {
        value: "[66301]Management of pension funds",
        zh: "[66301]Management of pension funds / 养老金基金管理",
        en: "[66301]Management of pension funds",
      },
      {
        value: "[66302]Assets/portfolio management",
        zh: "[66302]Assets/portfolio management / 资产/投资组合管理",
        en: "[66302]Assets/portfolio management",
      },
      {
        value: "[66303]Unit trust management companies",
        zh: "[66303]Unit trust management companies / 单位信托管理公司",
        en: "[66303]Unit trust management companies",
      },
      {
        value: "[68101]Buying, selling, renting and operating of self-owned or leased real estate – residential buildings",
        zh: "[68101]Buying, selling, renting and operating of self-owned or leased real estate – residential buildings / 购买、销售、租赁和经营自有的或租赁的房地产 - 住宅建筑",
        en: "[68101]Buying, selling, renting and operating of self-owned or leased real estate – residential buildings",
      },
      {
        value: "[68102]Buying, selling, renting and operating of self-owned or leased real estate – non-residential buildings",
        zh: "[68102]Buying, selling, renting and operating of self-owned or leased real estate – non-residential buildings / 购买、销售、租赁和经营自有或租赁的非住宅建筑房地产",
        en: "[68102]Buying, selling, renting and operating of self-owned or leased real estate – non-residential buildings",
      },
      {
        value: "[68103]Buying, selling, renting and operating of self-owned or leased real estate – land",
        zh: "[68103]Buying, selling, renting and operating of self-owned or leased real estate – land / 购买、出售、租赁和运营自有或租赁的房地产 - 土地",
        en: "[68103]Buying, selling, renting and operating of self-owned or leased real estate – land",
      },
      {
        value: "[68104]Development of building projects for own operation, i.e. for renting of space in these buildings",
        zh: "[68104]Development of building projects for own operation, i.e. for renting of space in these buildings / 开发建筑项目以供自己运营，即出租这些建筑物中的空间",
        en: "[68104]Development of building projects for own operation, i.e. for renting of space in these buildings",
      },
      {
        value: "[68109]Real estate activities with own or leased property n.e.c.",
        zh: "[68109]Real estate activities with own or leased property n.e.c. / 自有或租赁物业的房地产活动，未列明",
        en: "[68109]Real estate activities with own or leased property n.e.c.",
      },
      {
        value: "[68201]Activities of real estate agents and brokers for buying, selling and renting of real estate",
        zh: "[68201]Activities of real estate agents and brokers for buying, selling and renting of real estate / 房地产代理和经纪人的活动，包括购买、销售和出租房地产",
        en: "[68201]Activities of real estate agents and brokers for buying, selling and renting of real estate",
      },
      {
        value: "[68202]Management of real estate on a fee or contract basis",
        zh: "[68202]Management of real estate on a fee or contract basis / 以收费或合同为基础管理房地产",
        en: "[68202]Management of real estate on a fee or contract basis",
      },
      {
        value: "[68203]Appraisal services for real estate",
        zh: "[68203]Appraisal services for real estate / 房地产评估服务",
        en: "[68203]Appraisal services for real estate",
      },
      {
        value: "[68209]Real estate activities on a fee or contract basis n.e.c.",
        zh: "[68209]Real estate activities on a fee or contract basis n.e.c. / 按费用或合同基础的房地产活动",
        en: "[68209]Real estate activities on a fee or contract basis n.e.c.",
      },
      {
        value: "[69100]Legal activities",
        zh: "[69100]Legal activities / 法律活动",
        en: "[69100]Legal activities",
      },
      {
        value: "[69200]Accounting, bookkeeping and auditing activities; tax consultancy",
        zh: "[69200]Accounting, bookkeeping and auditing activities; tax consultancy / 会计、簿记和审计活动；税务咨询",
        en: "[69200]Accounting, bookkeeping and auditing activities; tax consultancy",
      },
      {
        value: "[70100]Activities of head offices",
        zh: "[70100]Activities of head offices / 总部活动",
        en: "[70100]Activities of head offices",
      },
      {
        value: "[70201]Business management consultancy services",
        zh: "[70201]Business management consultancy services / 商业管理咨询服务",
        en: "[70201]Business management consultancy services",
      },
      {
        value: "[70202]Human resource consultancy services",
        zh: "[70202]Human resource consultancy services / 人力资源咨询顾问服务",
        en: "[70202]Human resource consultancy services",
      },
      {
        value: "[70203]Consultancy services in public relation and communications",
        zh: "[70203]Consultancy services in public relation and communications / 公共关系和通讯领域的咨询服务",
        en: "[70203]Consultancy services in public relation and communications",
      },
      {
        value: "[70209]Other management consultancy activities n.e.c",
        zh: "[70209]Other management consultancy activities n.e.c / 其他管理咨询活动",
        en: "[70209]Other management consultancy activities n.e.c",
      },
      {
        value: "[71101]Architectural services",
        zh: "[71101]Architectural services / 建筑设计服务",
        en: "[71101]Architectural services",
      },
      {
        value: "[71102]Engineering services",
        zh: "[71102]Engineering services / 工程服务",
        en: "[71102]Engineering services",
      },
      {
        value: "[71103]Land surveying services",
        zh: "[71103]Land surveying services / 土地测量服务",
        en: "[71103]Land surveying services",
      },
      {
        value: "[71109]Other architectural and engineering activities and related technical consultancy n.e.c.",
        zh: "[71109]Other architectural and engineering activities and related technical consultancy n.e.c. / 其他建筑和工程活动及相关的技术咨询",
        en: "[71109]Other architectural and engineering activities and related technical consultancy n.e.c.",
      },
      {
        value: "[71200]Technical testing and analysis",
        zh: "[71200]Technical testing and analysis / 技术检测与分析",
        en: "[71200]Technical testing and analysis",
      },
      {
        value: "[72101]Research and development on natural sciences",
        zh: "[72101]Research and development on natural sciences / 自然科学的研究与开发",
        en: "[72101]Research and development on natural sciences",
      },
      {
        value: "[72102]Research and development on engineering and technology",
        zh: "[72102]Research and development on engineering and technology / 工程技术研究与开发",
        en: "[72102]Research and development on engineering and technology",
      },
      {
        value: "[72103]Research and development on medical sciences",
        zh: "[72103]Research and development on medical sciences / 医学科学的研究与开发",
        en: "[72103]Research and development on medical sciences",
      },
      {
        value: "[72104]Research and development on biotechnology",
        zh: "[72104]Research and development on biotechnology / 生物技术的研发",
        en: "[72104]Research and development on biotechnology",
      },
      {
        value: "[72105]Research and development on agricultural sciences",
        zh: "[72105]Research and development on agricultural sciences / 农业科学研发",
        en: "[72105]Research and development on agricultural sciences",
      },
      {
        value: "[72106]Research and development on Information Communication Technology (ICT)",
        zh: "[72106]Research and development on Information Communication Technology (ICT) / 信息通信技术(ICT)研发",
        en: "[72106]Research and development on Information Communication Technology (ICT)",
      },
      {
        value: "[72109]Research and development on other natural science and engineering n.e.c.",
        zh: "[72109]Research and development on other natural science and engineering n.e.c. / 其他自然科学和工程研究与开发",
        en: "[72109]Research and development on other natural science and engineering n.e.c.",
      },
      {
        value: "[72201]Research and development on social sciences",
        zh: "[72201]Research and development on social sciences / 社会科学的研究与开发",
        en: "[72201]Research and development on social sciences",
      },
      {
        value: "[72202]Research and development on humanities",
        zh: "[72202]Research and development on humanities / 人文领域的研究与开发",
        en: "[72202]Research and development on humanities",
      },
      {
        value: "[72209]Research and development of other social sciences and humanities n.e.c.",
        zh: "[72209]Research and development of other social sciences and humanities n.e.c. / 其他社会科学和人文学科的研究与开发",
        en: "[72209]Research and development of other social sciences and humanities n.e.c.",
      },
      {
        value: "[73100]Advertising",
        zh: "[73100]Advertising / 广告",
        en: "[73100]Advertising",
      },
      {
        value: "[73200]Market research and public opinion polling",
        zh: "[73200]Market research and public opinion polling / 市场研究和民意调查",
        en: "[73200]Market research and public opinion polling",
      },
      {
        value: "[74101]Activities of interior decorators",
        zh: "[74101]Activities of interior decorators / 室内装饰设计师的活动",
        en: "[74101]Activities of interior decorators",
      },
      {
        value: "[74102]Services of graphic designers",
        zh: "[74102]Services of graphic designers / 平面设计师服务",
        en: "[74102]Services of graphic designers",
      },
      {
        value: "[74103]Fashion design services",
        zh: "[74103]Fashion design services / 时尚设计服务",
        en: "[74103]Fashion design services",
      },
      {
        value: "[74109]Specialized design activities n.e.c.",
        zh: "[74109]Specialized design activities n.e.c. / 专业设计活动",
        en: "[74109]Specialized design activities n.e.c.",
      },
      {
        value: "[74200]Photographic activities",
        zh: "[74200]Photographic activities / 摄影活动",
        en: "[74200]Photographic activities",
      },
      {
        value: "[74901]Translation and interpretation activities",
        zh: "[74901]Translation and interpretation activities / 翻译和口译活动",
        en: "[74901]Translation and interpretation activities",
      },
      {
        value: "[74902]Business brokerage activities",
        zh: "[74902]Business brokerage activities / 商业经纪活动",
        en: "[74902]Business brokerage activities",
      },
      {
        value: "[74903]Security consulting",
        zh: "[74903]Security consulting / 安全咨询",
        en: "[74903]Security consulting",
      },
      {
        value: "[74904]Activities of quantity surveyors",
        zh: "[74904]Activities of quantity surveyors / 数量测量师活动",
        en: "[74904]Activities of quantity surveyors",
      },
      {
        value: "[74905]Activities of consultants other than architecture, engineering and management consultants",
        zh: "[74905]Activities of consultants other than architecture, engineering and management consultants / 除建筑、工程和管理顾问以外的顾问活动",
        en: "[74905]Activities of consultants other than architecture, engineering and management consultants",
      },
      {
        value: "[74909]Any other professional, scientific and technical activities n.e.c.",
        zh: "[74909]Any other professional, scientific and technical activities n.e.c. / 任何其他专业、科学和技术活动",
        en: "[74909]Any other professional, scientific and technical activities n.e.c.",
      },
      {
        value: "[75000]VETERINARY ACTIVITIES",
        zh: "[75000]VETERINARY ACTIVITIES / 兽医活动",
        en: "[75000]VETERINARY ACTIVITIES",
      },
      {
        value: "[77101]Renting and operational leasing of passenger cars (without driver)",
        zh: "[77101]Renting and operational leasing of passenger cars (without driver) / 乘客汽车（不含司机）的出租和经营性租赁",
        en: "[77101]Renting and operational leasing of passenger cars (without driver)",
      },
      {
        value: "[77102]Renting and operational leasing of trucks, utility trailers and recreational vehicles",
        zh: "[77102]Renting and operational leasing of trucks, utility trailers and recreational vehicles / 租赁和运营出租卡车、实用拖车和休闲车辆",
        en: "[77102]Renting and operational leasing of trucks, utility trailers and recreational vehicles",
      },
      {
        value: "[77211]Renting and leasing of pleasure boats, canoes, sailboats",
        zh: "[77211]Renting and leasing of pleasure boats, canoes, sailboats / 租赁和出租娱乐船只、独木舟、帆船",
        en: "[77211]Renting and leasing of pleasure boats, canoes, sailboats",
      },
      {
        value: "[77212]Renting and leasing of bicycles",
        zh: "[77212]Renting and leasing of bicycles / 自行车的租赁与出租",
        en: "[77212]Renting and leasing of bicycles",
      },
      {
        value: "[77213]Renting and leasing of beach chairs and umbrellas",
        zh: "[77213]Renting and leasing of beach chairs and umbrellas / 租赁和出租沙滩椅及遮阳伞",
        en: "[77213]Renting and leasing of beach chairs and umbrellas",
      },
      {
        value: "[77219]Renting and leasing of other sports equipment n.e.c.",
        zh: "[77219]Renting and leasing of other sports equipment n.e.c. / 其他体育设备租赁和出租",
        en: "[77219]Renting and leasing of other sports equipment n.e.c.",
      },
      {
        value: "[77220]Renting of video tapes, records, CDs, DVDs",
        zh: "[77220]Renting of video tapes, records, CDs, DVDs / 录像带、唱片、CD、DVD的出租",
        en: "[77220]Renting of video tapes, records, CDs, DVDs",
      },
      {
        value: "[77291]Renting and leasing of textiles, wearing apparel and footwear",
        zh: "[77291]Renting and leasing of textiles, wearing apparel and footwear / 纺织品、服装和鞋类的租赁和出租",
        en: "[77291]Renting and leasing of textiles, wearing apparel and footwear",
      },
      {
        value: "[77292]Renting and leasing of furniture, pottery and glass, kitchen and tableware, electrical appliances and house wares",
        zh: "[77292]Renting and leasing of furniture, pottery and glass, kitchen and tableware, electrical appliances and house wares / 家具、陶器和玻璃、厨房和餐具、电气设备及家居用品的租赁和出租",
        en: "[77292]Renting and leasing of furniture, pottery and glass, kitchen and tableware, electrical appliances and house wares",
      },
      {
        value: "[77293]Renting and leasing of jewellery, musical instruments, scenery and costumes",
        zh: "[77293]Renting and leasing of jewellery, musical instruments, scenery and costumes / 珠宝、乐器、布景和服装的租赁与出租",
        en: "[77293]Renting and leasing of jewellery, musical instruments, scenery and costumes",
      },
      {
        value: "[77294]Renting and leasing of books, journals and magazines",
        zh: "[77294]Renting and leasing of books, journals and magazines / 出租和租赁书籍、期刊和杂志",
        en: "[77294]Renting and leasing of books, journals and magazines",
      },
      {
        value: "[77295]Renting and leasing of machinery and equipment used by amateurs or as a hobby",
        zh: "[77295]Renting and leasing of machinery and equipment used by amateurs or as a hobby / 业余爱好者或作为爱好使用的机械和设备的租赁和出租",
        en: "[77295]Renting and leasing of machinery and equipment used by amateurs or as a hobby",
      },
      {
        value: "[77296]Renting of flowers and plants",
        zh: "[77296]Renting of flowers and plants / 花卉和植物租赁",
        en: "[77296]Renting of flowers and plants",
      },
      {
        value: "[77297]Renting and leasing of electronic equipment for household use",
        zh: "[77297]Renting and leasing of electronic equipment for household use / 家用电子设备的租赁和出租",
        en: "[77297]Renting and leasing of electronic equipment for household use",
      },
      {
        value: "[77299]Renting and leasing of other personal and household goods n.e.c.",
        zh: "[77299]Renting and leasing of other personal and household goods n.e.c. / 其他个人和家庭用品租赁和出租",
        en: "[77299]Renting and leasing of other personal and household goods n.e.c.",
      },
      {
        value: "[77301]Renting and operational leasing, without operator, of other machinery and equipment that are generally used as capital goods by industries",
        zh: "[77301]Renting and operational leasing, without operator, of other machinery and equipment that are generally used as capital goods by industries / 出租和经营性租赁，无操作员，一般作为工业资本货物使用的其他机械设备",
        en: "[77301]Renting and operational leasing, without operator, of other machinery and equipment that are generally used as capital goods by industries",
      },
      {
        value: "[77302]Renting and operational leasing of land-transport equipment (other than motor vehicles) without drivers",
        zh: "[77302]Renting and operational leasing of land-transport equipment (other than motor vehicles) without drivers / 出租和经营性租赁陆上运输设备（不包括机动车辆）",
        en: "[77302]Renting and operational leasing of land-transport equipment (other than motor vehicles) without drivers",
      },
      {
        value: "[77303]Renting and operational leasing of water-transport equipment without operator",
        zh: "[77303]Renting and operational leasing of water-transport equipment without operator / 无操作员的水上运输设备出租和经营性租赁",
        en: "[77303]Renting and operational leasing of water-transport equipment without operator",
      },
      {
        value: "[77304]Renting and operational leasing of air transport equipment without operator",
        zh: "[77304]Renting and operational leasing of air transport equipment without operator / 租赁和运营租赁航空运输设备（无操作人员）",
        en: "[77304]Renting and operational leasing of air transport equipment without operator",
      },
      {
        value: "[77305]Renting and operational leasing of agricultural and forestry machinery and equipment without operator",
        zh: "[77305]Renting and operational leasing of agricultural and forestry machinery and equipment without operator / 无操作员的农业和林业机械及设备的租赁和经营性租赁",
        en: "[77305]Renting and operational leasing of agricultural and forestry machinery and equipment without operator",
      },
      {
        value: "[77306]Renting and operational leasing of construction and civil-engineering machinery and equipment without operator",
        zh: "[77306]Renting and operational leasing of construction and civil-engineering machinery and equipment without operator / 无操作员的建筑和土木工程机械及设备出租和经营性租赁",
        en: "[77306]Renting and operational leasing of construction and civil-engineering machinery and equipment without operator",
      },
      {
        value: "[77307]Rental and operational leasing of office machinery and equipment without operator",
        zh: "[77307]Rental and operational leasing of office machinery and equipment without operator / 办公机械和设备的租赁和经营性租赁，不包括操作人员",
        en: "[77307]Rental and operational leasing of office machinery and equipment without operator",
      },
      {
        value: "[77309]Renting and leasing of other machinery, equipment and tangible goods n.e.c.",
        zh: "[77309]Renting and leasing of other machinery, equipment and tangible goods n.e.c. / 其他机械、设备和有形商品的租赁和出租",
        en: "[77309]Renting and leasing of other machinery, equipment and tangible goods n.e.c.",
      },
      {
        value: "[77400]Leasing of intellectual property and similar products, except copyrighted works",
        zh: "[77400]Leasing of intellectual property and similar products, except copyrighted works / 知识产权及相关产品的租赁，不包括版权作品",
        en: "[77400]Leasing of intellectual property and similar products, except copyrighted works",
      },
      {
        value: "[78100]Activities of employment placement agencies",
        zh: "[78100]Activities of employment placement agencies / 就业安置机构活动",
        en: "[78100]Activities of employment placement agencies",
      },
      {
        value: "[78200]Temporary employment agency activities",
        zh: "[78200]Temporary employment agency activities / 临时就业代理活动",
        en: "[78200]Temporary employment agency activities",
      },
      {
        value: "[78300]Provision of human resources for client businesses",
        zh: "[78300]Provision of human resources for client businesses / 为客户提供人力资源",
        en: "[78300]Provision of human resources for client businesses",
      },
      {
        value: "[79110]Travel agency activities",
        zh: "[79110]Travel agency activities / 旅行社活动",
        en: "[79110]Travel agency activities",
      },
      {
        value: "[79120]Tour operator activities",
        zh: "[79120]Tour operator activities / 旅行社活动",
        en: "[79120]Tour operator activities",
      },
      {
        value: "[79900]Other reservation service and related activities",
        zh: "[79900]Other reservation service and related activities / 其他预订服务及相关活动",
        en: "[79900]Other reservation service and related activities",
      },
      {
        value: "[80100]Private security activities",
        zh: "[80100]Private security activities / 私人保安活动",
        en: "[80100]Private security activities",
      },
      {
        value: "[80200]Security systems service activities",
        zh: "[80200]Security systems service activities / 安全系统服务活动",
        en: "[80200]Security systems service activities",
      },
      {
        value: "[80300]Investigation and detective activities",
        zh: "[80300]Investigation and detective activities / 调查和侦探活动",
        en: "[80300]Investigation and detective activities",
      },
      {
        value: "[81100]Combined facilities support activities",
        zh: "[81100]Combined facilities support activities / 综合设施支持活动",
        en: "[81100]Combined facilities support activities",
      },
      {
        value: "[81210]General cleaning of buildings",
        zh: "[81210]General cleaning of buildings / 建筑物的普通清洁",
        en: "[81210]General cleaning of buildings",
      },
      {
        value: "[81291]Cleaning of buildings of all types",
        zh: "[81291]Cleaning of buildings of all types / 各种类型建筑物的清洁",
        en: "[81291]Cleaning of buildings of all types",
      },
      {
        value: "[81292]Swimming pool cleaning and maintenance services",
        zh: "[81292]Swimming pool cleaning and maintenance services / 游泳池清洁与维护服务",
        en: "[81292]Swimming pool cleaning and maintenance services",
      },
      {
        value: "[81293]Cleaning of industrial machinery",
        zh: "[81293]Cleaning of industrial machinery / 工业机械清洁",
        en: "[81293]Cleaning of industrial machinery",
      },
      {
        value: "[81294]Cleaning of trains, buses, planes",
        zh: "[81294]Cleaning of trains, buses, planes / 火车、公共汽车、飞机的清洁",
        en: "[81294]Cleaning of trains, buses, planes",
      },
      {
        value: "[81295]Cleaning of pest control services not in connection with agriculture",
        zh: "[81295]Cleaning of pest control services not in connection with agriculture / 与农业无关的害虫控制服务的清洁",
        en: "[81295]Cleaning of pest control services not in connection with agriculture",
      },
      {
        value: "[81296]Disinfecting and exterminating activities",
        zh: "[81296]Disinfecting and exterminating activities / 消毒和消灭害虫活动",
        en: "[81296]Disinfecting and exterminating activities",
      },
      {
        value: "[81297]Cleaning of sea tankers",
        zh: "[81297]Cleaning of sea tankers / 海上油轮的清洁",
        en: "[81297]Cleaning of sea tankers",
      },
      {
        value: "[81299]Other building and industrial cleaning activities, n.e.c.",
        zh: "[81299]Other building and industrial cleaning activities, n.e.c. / 其他建筑和工业清洁活动",
        en: "[81299]Other building and industrial cleaning activities, n.e.c.",
      },
      {
        value: "[81300]Landscape care and maintenance service activities",
        zh: "[81300]Landscape care and maintenance service activities / 景观护理和维护服务活动",
        en: "[81300]Landscape care and maintenance service activities",
      },
      {
        value: "[82110]Combined office administrative service activities",
        zh: "[82110]Combined office administrative service activities / 综合办公行政服务活动",
        en: "[82110]Combined office administrative service activities",
      },
      {
        value: "[82191]Document preparation, editing and/or proofreading",
        zh: "[82191]Document preparation, editing and/or proofreading / 文件准备、编辑和/或校对",
        en: "[82191]Document preparation, editing and/or proofreading",
      },
      {
        value: "[82192]Typing, word processing or desktop publishing",
        zh: "[82192]Typing, word processing or desktop publishing / 打字、文字处理或桌面出版",
        en: "[82192]Typing, word processing or desktop publishing",
      },
      {
        value: "[82193]Secretarial support services",
        zh: "[82193]Secretarial support services / 秘书支持服务",
        en: "[82193]Secretarial support services",
      },
      {
        value: "[82194]Transcription of documents and other secretarial services",
        zh: "[82194]Transcription of documents and other secretarial services / 文件及其他秘书服务的抄录",
        en: "[82194]Transcription of documents and other secretarial services",
      },
      {
        value: "[82195]Provision of mailbox rental and other postal and mailing services",
        zh: "[82195]Provision of mailbox rental and other postal and mailing services / 提供邮箱租赁以及其他邮政和邮寄服务",
        en: "[82195]Provision of mailbox rental and other postal and mailing services",
      },
      {
        value: "[82196]Photocopying, duplicating, blueprinting",
        zh: "[82196]Photocopying, duplicating, blueprinting / 复印、复制、蓝图制作",
        en: "[82196]Photocopying, duplicating, blueprinting",
      },
      {
        value: "[82199]Photocopying, document preparation and other specialized office support activities n.e.c.",
        zh: "[82199]Photocopying, document preparation and other specialized office support activities n.e.c. / 复印、文件准备以及其他专业办公室支持活动",
        en: "[82199]Photocopying, document preparation and other specialized office support activities n.e.c.",
      },
      {
        value: "[82200]Activities of call centres",
        zh: "[82200]Activities of call centres / 呼叫中心活动",
        en: "[82200]Activities of call centres",
      },
      {
        value: "[82301]Organization, promotions and/or management of event",
        zh: "[82301]Organization, promotions and/or management of event / 活动的组织、促销和/或管理",
        en: "[82301]Organization, promotions and/or management of event",
      },
      {
        value: "[82302]Meeting, incentive, convention, exhibition (MICE)",
        zh: "[82302]Meeting, incentive, convention, exhibition (MICE) / 会议、激励、大会、展览（MICE）",
        en: "[82302]Meeting, incentive, convention, exhibition (MICE)",
      },
      {
        value: "[82910]Activities of collection agencies and credit bureaus",
        zh: "[82910]Activities of collection agencies and credit bureaus / 收债和信用局的活动",
        en: "[82910]Activities of collection agencies and credit bureaus",
      },
      {
        value: "[82920]Packaging activities on a fee or contract basis, whether or not these involve an automated process",
        zh: "[82920]Packaging activities on a fee or contract basis, whether or not these involve an automated process / 按费用或合同基础的包装活动，无论是否涉及自动化过程",
        en: "[82920]Packaging activities on a fee or contract basis, whether or not these involve an automated process",
      },
      {
        value: "[82990]Other business support service activities n.e.c.",
        zh: "[82990]Other business support service activities n.e.c. / 其他商业支持服务活动",
        en: "[82990]Other business support service activities n.e.c.",
      },
      {
        value: "[84111]General (overall) public administration activities",
        zh: "[84111]General (overall) public administration activities / 一般公共管理活动",
        en: "[84111]General (overall) public administration activities",
      },
      {
        value: "[84112]Ancillary service activities for the government as a whole",
        zh: "[84112]Ancillary service activities for the government as a whole / 为政府整体提供辅助服务活动",
        en: "[84112]Ancillary service activities for the government as a whole",
      },
      {
        value: "[84121]Administrative educational services",
        zh: "[84121]Administrative educational services / 行政教育服务",
        en: "[84121]Administrative educational services",
      },
      {
        value: "[84122]Administrative health care services",
        zh: "[84122]Administrative health care services / 行政医疗保健服务",
        en: "[84122]Administrative health care services",
      },
      {
        value: "[84123]Administrative housing and local government services",
        zh: "[84123]Administrative housing and local government services / 行政住宅和地方政府服务",
        en: "[84123]Administrative housing and local government services",
      },
      {
        value: "[84124]Administrative recreational, cultural, arts and sports services",
        zh: "[84124]Administrative recreational, cultural, arts and sports services / 行政、娱乐、文化、艺术及体育服务",
        en: "[84124]Administrative recreational, cultural, arts and sports services",
      },
      {
        value: "[84125]Administrative religious affairs services",
        zh: "[84125]Administrative religious affairs services / 宗教事务管理服务",
        en: "[84125]Administrative religious affairs services",
      },
      {
        value: "[84126]Administrative welfare services",
        zh: "[84126]Administrative welfare services / 行政福利服务",
        en: "[84126]Administrative welfare services",
      },
      {
        value: "[84129]Other community and social affairs services",
        zh: "[84129]Other community and social affairs services / 其他社区和社会事务服务",
        en: "[84129]Other community and social affairs services",
      },
      {
        value: "[84131]Domestic and international trade affairs",
        zh: "[84131]Domestic and international trade affairs / 国内外贸易事务",
        en: "[84131]Domestic and international trade affairs",
      },
      {
        value: "[84132]Agriculture and rural development affairs",
        zh: "[84132]Agriculture and rural development affairs / 农业和农村发展事务",
        en: "[84132]Agriculture and rural development affairs",
      },
      {
        value: "[84133]Primary industries affairs",
        zh: "[84133]Primary industries affairs / 初级产业事务",
        en: "[84133]Primary industries affairs",
      },
      {
        value: "[84134]Public works affairs",
        zh: "[84134]Public works affairs / 公共工程事务",
        en: "[84134]Public works affairs",
      },
      {
        value: "[84135]Transport affairs",
        zh: "[84135]Transport affairs / 运输事务",
        en: "[84135]Transport affairs",
      },
      {
        value: "[84136]Energy, telecommunication and postal affairs",
        zh: "[84136]Energy, telecommunication and postal affairs / 能源、电信和邮政事务",
        en: "[84136]Energy, telecommunication and postal affairs",
      },
      {
        value: "[84137]Tourism affairs",
        zh: "[84137]Tourism affairs / 旅游事务",
        en: "[84137]Tourism affairs",
      },
      {
        value: "[84138]Human resource affairs",
        zh: "[84138]Human resource affairs / 人力资源事务",
        en: "[84138]Human resource affairs",
      },
      {
        value: "[84139]Other regulation of and contribution to more efficient operation of businesses n.e.c.",
        zh: "[84139]Other regulation of and contribution to more efficient operation of businesses n.e.c. / 对商业运营效率的其他监管和贡献",
        en: "[84139]Other regulation of and contribution to more efficient operation of businesses n.e.c.",
      },
      {
        value: "[84210]Foreign affairs",
        zh: "[84210]Foreign affairs / 外交事务",
        en: "[84210]Foreign affairs",
      },
      {
        value: "[84220]Military and civil defence services",
        zh: "[84220]Military and civil defence services / 军事和民间防御服务",
        en: "[84220]Military and civil defence services",
      },
      {
        value: "[84231]Police service",
        zh: "[84231]Police service / 警察服务",
        en: "[84231]Police service",
      },
      {
        value: "[84232]Prison service",
        zh: "[84232]Prison service / 监狱服务",
        en: "[84232]Prison service",
      },
      {
        value: "[84233]Immigration service",
        zh: "[84233]Immigration service / 移民服务",
        en: "[84233]Immigration service",
      },
      {
        value: "[84234]National registration service",
        zh: "[84234]National registration service / 国家注册服务",
        en: "[84234]National registration service",
      },
      {
        value: "[84235]Judiciary and legal service",
        zh: "[84235]Judiciary and legal service / 司法和法律服务",
        en: "[84235]Judiciary and legal service",
      },
      {
        value: "[84236]Firefighting and fire prevention",
        zh: "[84236]Firefighting and fire prevention / 消防和防火",
        en: "[84236]Firefighting and fire prevention",
      },
      {
        value: "[84239]Other public order and safety affairs related services",
        zh: "[84239]Other public order and safety affairs related services / 其他公共秩序与安全事务相关服务",
        en: "[84239]Other public order and safety affairs related services",
      },
      {
        value: "[84300]Compulsory social security activities e.g. SOCSO",
        zh: "[84300]Compulsory social security activities e.g. SOCSO / 强制性社会保障活动，例如SOCSO",
        en: "[84300]Compulsory social security activities e.g. SOCSO",
      },
      {
        value: "[85101]Pre-primary education (Public)",
        zh: "[85101]Pre-primary education (Public) / 学前教育（公立）",
        en: "[85101]Pre-primary education (Public)",
      },
      {
        value: "[85102]Pre-primary education (Private)",
        zh: "[85102]Pre-primary education (Private) / 私立学前教育",
        en: "[85102]Pre-primary education (Private)",
      },
      {
        value: "[85103]Primary education (Public)",
        zh: "[85103]Primary education (Public) / 初级教育（公立）",
        en: "[85103]Primary education (Public)",
      },
      {
        value: "[85104]Primary education (Private)",
        zh: "[85104]Primary education (Private) / 私立小学教育",
        en: "[85104]Primary education (Private)",
      },
      {
        value: "[85211]General school secondary education (Public)",
        zh: "[85211]General school secondary education (Public) / 普通中学教育（公立）",
        en: "[85211]General school secondary education (Public)",
      },
      {
        value: "[85212]General school secondary education (Private)",
        zh: "[85212]General school secondary education (Private) / 普通中等教育（私立）",
        en: "[85212]General school secondary education (Private)",
      },
      {
        value: "[85221]Technical and vocational education below the level of higher education (Public)",
        zh: "[85221]Technical and vocational education below the level of higher education (Public) / 低于高等教育水平的技术和职业教育（公立）",
        en: "[85221]Technical and vocational education below the level of higher education (Public)",
      },
      {
        value: "[85222]Technical and vocational education below the level of higher education (Private)",
        zh: "[85222]Technical and vocational education below the level of higher education (Private) / 低于高等教育水平的技术和职业教育（私立）",
        en: "[85222]Technical and vocational education below the level of higher education (Private)",
      },
      {
        value: "[85301]College and university education (Public)",
        zh: "[85301]College and university education (Public) / 学院和大学教育(公立)",
        en: "[85301]College and university education (Public)",
      },
      {
        value: "[85302]College and university education (Private)",
        zh: "[85302]College and university education (Private) / 私立大学及学院教育",
        en: "[85302]College and university education (Private)",
      },
      {
        value: "[85411]Sports instruction",
        zh: "[85411]Sports instruction / 体育指导",
        en: "[85411]Sports instruction",
      },
      {
        value: "[85412]Martial arts instruction",
        zh: "[85412]Martial arts instruction / 武术教学",
        en: "[85412]Martial arts instruction",
      },
      {
        value: "[85419]Any other sports and recreation education n.e.c",
        zh: "[85419]Any other sports and recreation education n.e.c / 其他体育和娱乐教育",
        en: "[85419]Any other sports and recreation education n.e.c",
      },
      {
        value: "[85421]Music and dancing school",
        zh: "[85421]Music and dancing school / 音乐和舞蹈学校",
        en: "[85421]Music and dancing school",
      },
      {
        value: "[85429]Any other cultural education n.e.c.",
        zh: "[85429]Any other cultural education n.e.c. / 其他文化教育活动",
        en: "[85429]Any other cultural education n.e.c.",
      },
      {
        value: "[85491]Tuition centre",
        zh: "[85491]Tuition centre / 补习中心",
        en: "[85491]Tuition centre",
      },
      {
        value: "[85492]Driving school",
        zh: "[85492]Driving school / 驾驶学校",
        en: "[85492]Driving school",
      },
      {
        value: "[85493]Religious instruction",
        zh: "[85493]Religious instruction / 宗教教学",
        en: "[85493]Religious instruction",
      },
      {
        value: "[85494]Computer training",
        zh: "[85494]Computer training / 计算机培训",
        en: "[85494]Computer training",
      },
      {
        value: "[85499]Others education n.e.c",
        zh: "[85499]Others education n.e.c / 其他教育活动",
        en: "[85499]Others education n.e.c",
      },
      {
        value: "[85500]Educational support services for provision of non-instructional services",
        zh: "[85500]Educational support services for provision of non-instructional services / 提供非教学支持的教育服务",
        en: "[85500]Educational support services for provision of non-instructional services",
      },
      {
        value: "[86101]Hospital activities",
        zh: "[86101]Hospital activities / 医院活动",
        en: "[86101]Hospital activities",
      },
      {
        value: "[86102]Maternity home services (outside hospital)",
        zh: "[86102]Maternity home services (outside hospital) / 非医院的母婴家庭服务",
        en: "[86102]Maternity home services (outside hospital)",
      },
      {
        value: "[86201]General medical services",
        zh: "[86201]General medical services / 一般医疗服务",
        en: "[86201]General medical services",
      },
      {
        value: "[86202]Specialized medical services",
        zh: "[86202]Specialized medical services / 专业医疗服务",
        en: "[86202]Specialized medical services",
      },
      {
        value: "[86203]Dental services",
        zh: "[86203]Dental services / 牙科服务",
        en: "[86203]Dental services",
      },
      {
        value: "[86901]Dialysis Centres",
        zh: "[86901]Dialysis Centres / 透析中心",
        en: "[86901]Dialysis Centres",
      },
      {
        value: "[86902]Medical laboratories",
        zh: "[86902]Medical laboratories / 医学实验室",
        en: "[86902]Medical laboratories",
      },
      {
        value: "[86903]Physiotherapy and occupational therapy service",
        zh: "[86903]Physiotherapy and occupational therapy service / 物理治疗和职业治疗服务",
        en: "[86903]Physiotherapy and occupational therapy service",
      },
      {
        value: "[86904]Acupuncture services",
        zh: "[86904]Acupuncture services / 针灸服务",
        en: "[86904]Acupuncture services",
      },
      {
        value: "[86905]Herbalist and homeopathy services",
        zh: "[86905]Herbalist and homeopathy services / 草药学家和顺势疗法服务",
        en: "[86905]Herbalist and homeopathy services",
      },
      {
        value: "[86906]Ambulance services",
        zh: "[86906]Ambulance services / 救护车服务",
        en: "[86906]Ambulance services",
      },
      {
        value: "[86909]Other human health services n.e.c.",
        zh: "[86909]Other human health services n.e.c. / 其他人类健康服务（不包括在其他分类中）",
        en: "[86909]Other human health services n.e.c.",
      },
      {
        value: "[87101]Homes for the elderly with nursing care",
        zh: "[87101]Homes for the elderly with nursing care / 带护理的养老院",
        en: "[87101]Homes for the elderly with nursing care",
      },
      {
        value: "[87102]Nursing homes",
        zh: "[87102]Nursing homes / 养老院",
        en: "[87102]Nursing homes",
      },
      {
        value: "[87103]Palliative or hospices",
        zh: "[87103]Palliative or hospices / 姑息治疗或临终关怀",
        en: "[87103]Palliative or hospices",
      },
      {
        value: "[87201]Drug rehabilitation centres",
        zh: "[87201]Drug rehabilitation centres / 药物康复中心",
        en: "[87201]Drug rehabilitation centres",
      },
      {
        value: "[87209]Other residential care activities for mental retardation n.e.c.",
        zh: "[87209]Other residential care activities for mental retardation n.e.c. / 其他对智力迟钝者的居住护理活动",
        en: "[87209]Other residential care activities for mental retardation n.e.c.",
      },
      {
        value: "[87300]Residential care activities for the elderly and disabled",
        zh: "[87300]Residential care activities for the elderly and disabled / 老年人和残疾人的住宅护理活动",
        en: "[87300]Residential care activities for the elderly and disabled",
      },
      {
        value: "[87901]Orphanages",
        zh: "[87901]Orphanages / 孤儿院",
        en: "[87901]Orphanages",
      },
      {
        value: "[87902]Welfare homes services",
        zh: "[87902]Welfare homes services / 福利院服务",
        en: "[87902]Welfare homes services",
      },
      {
        value: "[87909]Other residential care activities n.e.c.",
        zh: "[87909]Other residential care activities n.e.c. / 其他未列明的住宅护理活动",
        en: "[87909]Other residential care activities n.e.c.",
      },
      {
        value: "[88101]Day-care activities for the elderly or for handicapped adults",
        zh: "[88101]Day-care activities for the elderly or for handicapped adults / 为老年人或残疾成年人提供日托服务",
        en: "[88101]Day-care activities for the elderly or for handicapped adults",
      },
      {
        value: "[88109]Others social work activities without accommodation for the elderly and disabled",
        zh: "[88109]Others social work activities without accommodation for the elderly and disabled / 其他无住宿的社会工作活动",
        en: "[88109]Others social work activities without accommodation for the elderly and disabled",
      },
      {
        value: "[88901]Counselling service",
        zh: "[88901]Counselling service / 咨询服务",
        en: "[88901]Counselling service",
      },
      {
        value: "[88902]Child day-care activities",
        zh: "[88902]Child day-care activities / 儿童日托活动",
        en: "[88902]Child day-care activities",
      },
      {
        value: "[88909]Other social work activities without accommodation n.e.c.",
        zh: "[88909]Other social work activities without accommodation n.e.c. / 其他未列明的社会工作活动（不包括住宿）",
        en: "[88909]Other social work activities without accommodation n.e.c.",
      },
      {
        value: "[90001]Theatrical producer, singer group band and orchestra entertainment services",
        zh: "[90001]Theatrical producer, singer group band and orchestra entertainment services / 剧院制作人、歌手团体乐队及管弦乐队娱乐服务",
        en: "[90001]Theatrical producer, singer group band and orchestra entertainment services",
      },
      {
        value: "[90002]Operation of concert and theatre halls and other arts facilities",
        zh: "[90002]Operation of concert and theatre halls and other arts facilities / 音乐会和剧院大厅以及其他艺术设施的运营",
        en: "[90002]Operation of concert and theatre halls and other arts facilities",
      },
      {
        value: "[90003]Activities of sculptors, painters, cartoonists, engravers, etchers",
        zh: "[90003]Activities of sculptors, painters, cartoonists, engravers, etchers / 雕塑家、画家、漫画家、雕刻家、蚀刻师等活动",
        en: "[90003]Activities of sculptors, painters, cartoonists, engravers, etchers",
      },
      {
        value: "[90004]Activities of individual writers, for all subjects",
        zh: "[90004]Activities of individual writers, for all subjects / 个人作家的所有主题写作活动",
        en: "[90004]Activities of individual writers, for all subjects",
      },
      {
        value: "[90005]Activities of independent journalists",
        zh: "[90005]Activities of independent journalists / 独立记者的活动",
        en: "[90005]Activities of independent journalists",
      },
      {
        value: "[90006]Restoring of works of art such as painting",
        zh: "[90006]Restoring of works of art such as painting / 艺术品如绘画的修复",
        en: "[90006]Restoring of works of art such as painting",
      },
      {
        value: "[90007]Activities of producers or entrepreneurs of arts live events, with or without facilities",
        zh: "[90007]Activities of producers or entrepreneurs of arts live events, with or without facilities / 艺术现场活动的生产者或企业家活动，无论是否有设施",
        en: "[90007]Activities of producers or entrepreneurs of arts live events, with or without facilities",
      },
      {
        value: "[90009]Creative, arts and entertainment activities n.e.c.",
        zh: "[90009]Creative, arts and entertainment activities n.e.c. / 创造、艺术和娱乐活动",
        en: "[90009]Creative, arts and entertainment activities n.e.c.",
      },
      {
        value: "[91011]Documentation and information activities of libraries of all kinds",
        zh: "[91011]Documentation and information activities of libraries of all kinds / 各种图书馆的文献和信息活动",
        en: "[91011]Documentation and information activities of libraries of all kinds",
      },
      {
        value: "[91012]Stock photo libraries and services",
        zh: "[91012]Stock photo libraries and services / 库存照片库和照片服务",
        en: "[91012]Stock photo libraries and services",
      },
      {
        value: "[91021]Operation of museums of all kinds",
        zh: "[91021]Operation of museums of all kinds / 各种博物馆的运营",
        en: "[91021]Operation of museums of all kinds",
      },
      {
        value: "[91022]Operation of historical sites and buildings",
        zh: "[91022]Operation of historical sites and buildings / 运营历史遗址和建筑",
        en: "[91022]Operation of historical sites and buildings",
      },
      {
        value: "[91031]Operation of botanical and zoological gardens",
        zh: "[91031]Operation of botanical and zoological gardens / 植物园和动物园的运营",
        en: "[91031]Operation of botanical and zoological gardens",
      },
      {
        value: "[91032]Operation of nature reserves, including wildlife preservation",
        zh: "[91032]Operation of nature reserves, including wildlife preservation / 自然保护区运营，包括野生动物保护",
        en: "[91032]Operation of nature reserves, including wildlife preservation",
      },
      {
        value: "[92000]GAMBLING AND BETTING ACTIVITIES",
        zh: "[92000]GAMBLING AND BETTING ACTIVITIES / 赌博和投注活动",
        en: "[92000]GAMBLING AND BETTING ACTIVITIES",
      },
      {
        value: "[93111]Football, hockey, cricket, baseball, badminton, futsal, paintball",
        zh: "[93111]Football, hockey, cricket, baseball, badminton, futsal, paintball / 足球、曲棍球、板球、棒球、羽毛球、五人制足球、彩弹射击",
        en: "[93111]Football, hockey, cricket, baseball, badminton, futsal, paintball",
      },
      {
        value: "[93112]Racetracks for auto",
        zh: "[93112]Racetracks for auto / 汽车赛道",
        en: "[93112]Racetracks for auto",
      },
      {
        value: "[93113]Equestrian clubs",
        zh: "[93113]Equestrian clubs / 马术俱乐部",
        en: "[93113]Equestrian clubs",
      },
      {
        value: "[93114]Swimming pools and stadiums, ice-skating arenas",
        zh: "[93114]Swimming pools and stadiums, ice-skating arenas / 游泳池和体育场、滑冰场",
        en: "[93114]Swimming pools and stadiums, ice-skating arenas",
      },
      {
        value: "[93115]Track and field stadium",
        zh: "[93115]Track and field stadium / 田径体育场",
        en: "[93115]Track and field stadium",
      },
      {
        value: "[93116]Golf courses",
        zh: "[93116]Golf courses / 高尔夫球场",
        en: "[93116]Golf courses",
      },
      {
        value: "[93117]Bowling centre",
        zh: "[93117]Bowling centre / 保龄球中心",
        en: "[93117]Bowling centre",
      },
      {
        value: "[93118]Fitness centres",
        zh: "[93118]Fitness centres / 健身中心",
        en: "[93118]Fitness centres",
      },
      {
        value: "[93119]Organization and operation of outdoor or indoor sports events for professionals or amateurs by organizations with own facilities",
        zh: "[93119]Organization and operation of outdoor or indoor sports events for professionals or amateurs by organizations with own facilities / 拥有设施的组织举办的专业或业余户外或室内体育赛事的组织与运营",
        en: "[93119]Organization and operation of outdoor or indoor sports events for professionals or amateurs by organizations with own facilities",
      },
      {
        value: "[93120]The operation of sports clubs such as football club, bowling club, swimming club",
        zh: "[93120]The operation of sports clubs such as football club, bowling club, swimming club / 运营体育俱乐部，如足球俱乐部、保龄球俱乐部、游泳俱乐部",
        en: "[93120]The operation of sports clubs such as football club, bowling club, swimming club",
      },
      {
        value: "[93191]Activities of producers or promoters of sports events, with or without facilities",
        zh: "[93191]Activities of producers or promoters of sports events, with or without facilities / 体育赛事组织者或推广者的活动，无论是否提供设施",
        en: "[93191]Activities of producers or promoters of sports events, with or without facilities",
      },
      {
        value: "[93192]Activities of sports leagues and regulating bodies",
        zh: "[93192]Activities of sports leagues and regulating bodies / 体育联盟和监管机构的活动",
        en: "[93192]Activities of sports leagues and regulating bodies",
      },
      {
        value: "[93193]Activities of related to promotion of sporting events",
        zh: "[93193]Activities of related to promotion of sporting events / 推广体育赛事活动",
        en: "[93193]Activities of related to promotion of sporting events",
      },
      {
        value: "[93199]Other sports activities n.e.c.",
        zh: "[93199]Other sports activities n.e.c. / 其他运动活动",
        en: "[93199]Other sports activities n.e.c.",
      },
      {
        value: "[93210]Activities of amusement parks and theme parks",
        zh: "[93210]Activities of amusement parks and theme parks / 游乐园和主题公园活动",
        en: "[93210]Activities of amusement parks and theme parks",
      },
      {
        value: "[93291]Activities of recreation parks and beaches",
        zh: "[93291]Activities of recreation parks and beaches / 娱乐公园和海滩活动",
        en: "[93291]Activities of recreation parks and beaches",
      },
      {
        value: "[93292]Operation of recreational transport facilities",
        zh: "[93292]Operation of recreational transport facilities / 休闲交通设施运营",
        en: "[93292]Operation of recreational transport facilities",
      },
      {
        value: "[93293]Renting of leisure and pleasure equipment as an integral part of recreational facilities",
        zh: "[93293]Renting of leisure and pleasure equipment as an integral part of recreational facilities / 作为娱乐设施一部分的休闲娱乐设备出租",
        en: "[93293]Renting of leisure and pleasure equipment as an integral part of recreational facilities",
      },
      {
        value: "[93294]Operation of fairs and shows of a recreational nature",
        zh: "[93294]Operation of fairs and shows of a recreational nature / 游乐性质的集市和展览的运营",
        en: "[93294]Operation of fairs and shows of a recreational nature",
      },
      {
        value: "[93295]Operation of discotheques and dance floors",
        zh: "[93295]Operation of discotheques and dance floors / 迪斯科舞厅和舞池的运营",
        en: "[93295]Operation of discotheques and dance floors",
      },
      {
        value: "[93296]Activities of producers or entrepreneurs of live events other than arts or sports events, with or without facilities",
        zh: "[93296]Activities of producers or entrepreneurs of live events other than arts or sports events, with or without facilities / 除了艺术或体育赛事以外的现场活动的生产者或创业者的活动，有或没有设施",
        en: "[93296]Activities of producers or entrepreneurs of live events other than arts or sports events, with or without facilities",
      },
      {
        value: "[93297]Cyber Café/Internet Centre",
        zh: "[93297]Cyber Café/Internet Centre / 网吧/互联网中心",
        en: "[93297]Cyber Café/Internet Centre",
      },
      {
        value: "[93299]Any other amusement and recreation activities n.e.c.",
        zh: "[93299]Any other amusement and recreation activities n.e.c. / 其他不包括在内的娱乐和休闲活动",
        en: "[93299]Any other amusement and recreation activities n.e.c.",
      },
      {
        value: "[94110]Activities of business and employers membership organizations",
        zh: "[94110]Activities of business and employers membership organizations / 商业和雇主会员组织的活动",
        en: "[94110]Activities of business and employers membership organizations",
      },
      {
        value: "[94120]Activities of professional membership organizations",
        zh: "[94120]Activities of professional membership organizations / 专业会员组织活动",
        en: "[94120]Activities of professional membership organizations",
      },
      {
        value: "[94200]Activities of trade unions",
        zh: "[94200]Activities of trade unions / 工会活动",
        en: "[94200]Activities of trade unions",
      },
      {
        value: "[94910]Activities of religious organizations",
        zh: "[94910]Activities of religious organizations / 宗教组织活动",
        en: "[94910]Activities of religious organizations",
      },
      {
        value: "[94920]Activities of political organizations",
        zh: "[94920]Activities of political organizations / 政治组织活动",
        en: "[94920]Activities of political organizations",
      },
      {
        value: "[94990]Activities of other membership organizations n.e.c.",
        zh: "[94990]Activities of other membership organizations n.e.c. / 其他会员组织活动",
        en: "[94990]Activities of other membership organizations n.e.c.",
      },
      {
        value: "[95111]Repair of electronic equipment",
        zh: "[95111]Repair of electronic equipment / 电子产品维修",
        en: "[95111]Repair of electronic equipment",
      },
      {
        value: "[95112]Repair and maintenance of computer terminals",
        zh: "[95112]Repair and maintenance of computer terminals / 计算机终端的修理和维护",
        en: "[95112]Repair and maintenance of computer terminals",
      },
      {
        value: "[95113]Repair and maintenance of hand-held computers (PDA’s)",
        zh: "[95113]Repair and maintenance of hand-held computers (PDA’s) / 手持计算机（PDA）的维修和保养",
        en: "[95113]Repair and maintenance of hand-held computers (PDA’s)",
      },
      {
        value: "[95121]Repair and maintenance of cordless telephones",
        zh: "[95121]Repair and maintenance of cordless telephones / 无线电话的修理和维护",
        en: "[95121]Repair and maintenance of cordless telephones",
      },
      {
        value: "[95122]Repair and maintenance of cellular phones",
        zh: "[95122]Repair and maintenance of cellular phones / 手机的修理和维护",
        en: "[95122]Repair and maintenance of cellular phones",
      },
      {
        value: "[95123]Repair and maintenance of carrier equipment modems",
        zh: "[95123]Repair and maintenance of carrier equipment modems / 运营商设备调制解调器的修理和维护",
        en: "[95123]Repair and maintenance of carrier equipment modems",
      },
      {
        value: "[95124]Repair and maintenance of fax machines",
        zh: "[95124]Repair and maintenance of fax machines / 传真机维修和保养",
        en: "[95124]Repair and maintenance of fax machines",
      },
      {
        value: "[95125]Repair and maintenance of communications transmission equipment",
        zh: "[95125]Repair and maintenance of communications transmission equipment / 通信传输设备的修理与维护",
        en: "[95125]Repair and maintenance of communications transmission equipment",
      },
      {
        value: "[95126]Repair and maintenance of two-way radios",
        zh: "[95126]Repair and maintenance of two-way radios / 双向无线电的修理和维护",
        en: "[95126]Repair and maintenance of two-way radios",
      },
      {
        value: "[95127]Repair and maintenance of commercial TV and video cameras",
        zh: "[95127]Repair and maintenance of commercial TV and video cameras / 商业电视和摄像机的修理与维护",
        en: "[95127]Repair and maintenance of commercial TV and video cameras",
      },
      {
        value: "[95211]Repair and maintenance of television, radio receivers",
        zh: "[95211]Repair and maintenance of television, radio receivers / 电视和无线电接收器的修理与维护",
        en: "[95211]Repair and maintenance of television, radio receivers",
      },
      {
        value: "[95212]Repair and maintenance of VCR/DVD/VCD",
        zh: "[95212]Repair and maintenance of VCR/DVD/VCD / 录像机/ DVD/ VCD的维修和保养",
        en: "[95212]Repair and maintenance of VCR/DVD/VCD",
      },
      {
        value: "[95213]Repair and maintenance of CD players",
        zh: "[95213]Repair and maintenance of CD players / CD播放器的修理和维护",
        en: "[95213]Repair and maintenance of CD players",
      },
      {
        value: "[95214]Repair and maintenance of household-type video cameras",
        zh: "[95214]Repair and maintenance of household-type video cameras / 家用型摄像机的修理和维护",
        en: "[95214]Repair and maintenance of household-type video cameras",
      },
      {
        value: "[95221]Repair and servicing of household appliances",
        zh: "[95221]Repair and servicing of household appliances / 家用电器的修理和保养",
        en: "[95221]Repair and servicing of household appliances",
      },
      {
        value: "[95222]Repair and servicing of home and garden equipment",
        zh: "[95222]Repair and servicing of home and garden equipment / 家用及园艺设备的修理和保养",
        en: "[95222]Repair and servicing of home and garden equipment",
      },
      {
        value: "[95230]Repair of footwear and leather goods",
        zh: "[95230]Repair of footwear and leather goods / 鞋类和皮革制品修理",
        en: "[95230]Repair of footwear and leather goods",
      },
      {
        value: "[95240]Repair of furniture and home furnishings",
        zh: "[95240]Repair of furniture and home furnishings / 家具及家居装饰品的修理",
        en: "[95240]Repair of furniture and home furnishings",
      },
      {
        value: "[95291]Repair of bicycles",
        zh: "[95291]Repair of bicycles / 自行车修理",
        en: "[95291]Repair of bicycles",
      },
      {
        value: "[95292]Repair and alteration of clothing",
        zh: "[95292]Repair and alteration of clothing / 衣物的修补和改形",
        en: "[95292]Repair and alteration of clothing",
      },
      {
        value: "[95293]Repair and alteration of jewellery",
        zh: "[95293]Repair and alteration of jewellery / 珠宝修理和改造",
        en: "[95293]Repair and alteration of jewellery",
      },
      {
        value: "[95294]Repair of watches, clocks and their parts",
        zh: "[95294]Repair of watches, clocks and their parts / 手表、钟表及其部件的修理",
        en: "[95294]Repair of watches, clocks and their parts",
      },
      {
        value: "[95295]Repair of sporting goods",
        zh: "[95295]Repair of sporting goods / 体育用品修理",
        en: "[95295]Repair of sporting goods",
      },
      {
        value: "[95296]Repair of musical instruments",
        zh: "[95296]Repair of musical instruments / 乐器的修理",
        en: "[95296]Repair of musical instruments",
      },
      {
        value: "[95299]Repair of other personal and household goods n.e.c.",
        zh: "[95299]Repair of other personal and household goods n.e.c. / 其他个人及家庭用品修理",
        en: "[95299]Repair of other personal and household goods n.e.c.",
      },
      {
        value: "[96011]Laundering and dry-cleaning, pressing",
        zh: "[96011]Laundering and dry-cleaning, pressing / 洗涤和干洗，熨烫",
        en: "[96011]Laundering and dry-cleaning, pressing",
      },
      {
        value: "[96012]Carpet and rug shampooing, and drapery and curtain cleaning, whether on clients’ premises or not",
        zh: "[96012]Carpet and rug shampooing, and drapery and curtain cleaning, whether on clients’ premises or not / 地毯和垫子的清洁，以及窗帘和帷幔的清洁，无论是否在客户场所进行",
        en: "[96012]Carpet and rug shampooing, and drapery and curtain cleaning, whether on clients’ premises or not",
      },
      {
        value: "[96013]Provision of linens, work uniforms and related items by laundries",
        zh: "[96013]Provision of linens, work uniforms and related items by laundries / 洗衣店提供的床单、工作制服及相关物品",
        en: "[96013]Provision of linens, work uniforms and related items by laundries",
      },
      {
        value: "[96014]Diaper supply services",
        zh: "[96014]Diaper supply services / 尿布供应服务",
        en: "[96014]Diaper supply services",
      },
      {
        value: "[96020]Hairdressing and other beauty treatment",
        zh: "[96020]Hairdressing and other beauty treatment / 美发和其他美容治疗",
        en: "[96020]Hairdressing and other beauty treatment",
      },
      {
        value: "[96031]Preparing the dead for burial or cremation and embalming and morticians’ services",
        zh: "[96031]Preparing the dead for burial or cremation and embalming and morticians’ services / 为埋葬或火化准备遗体、防腐和殡仪服务",
        en: "[96031]Preparing the dead for burial or cremation and embalming and morticians’ services",
      },
      {
        value: "[96032]Providing burial or cremation services",
        zh: "[96032]Providing burial or cremation services / 提供殡葬或火化服务",
        en: "[96032]Providing burial or cremation services",
      },
      {
        value: "[96033]Rental of equipped space in funeral parlours",
        zh: "[96033]Rental of equipped space in funeral parlours / 殡仪馆设备空间租赁",
        en: "[96033]Rental of equipped space in funeral parlours",
      },
      {
        value: "[96034]Rental or sale of graves",
        zh: "[96034]Rental or sale of graves / 墓地租赁或销售",
        en: "[96034]Rental or sale of graves",
      },
      {
        value: "[96035]Maintenance of graves and mausoleums",
        zh: "[96035]Maintenance of graves and mausoleums / 墓地和陵墓维护",
        en: "[96035]Maintenance of graves and mausoleums",
      },
      {
        value: "[96091]Activities of sauna, steam baths, massage salons",
        zh: "[96091]Activities of sauna, steam baths, massage salons / 桑拿、蒸汽浴、按摩沙龙的活动",
        en: "[96091]Activities of sauna, steam baths, massage salons",
      },
      {
        value: "[96092]Astrological and spiritualists’ activities",
        zh: "[96092]Astrological and spiritualists’ activities / 占星术和灵媒活动",
        en: "[96092]Astrological and spiritualists’ activities",
      },
      {
        value: "[96093]Social activities such as escort services, dating services, services of marriage bureaux",
        zh: "[96093]Social activities such as escort services, dating services, services of marriage bureaux / 社交活动，如陪同服务、约会服务、婚姻介绍所服务",
        en: "[96093]Social activities such as escort services, dating services, services of marriage bureaux",
      },
      {
        value: "[96094]Pet care services",
        zh: "[96094]Pet care services / 宠物护理服务",
        en: "[96094]Pet care services",
      },
      {
        value: "[96095]Genealogical organizations",
        zh: "[96095]Genealogical organizations / 家谱组织",
        en: "[96095]Genealogical organizations",
      },
      {
        value: "[96096]Shoe shiners, porters, valet car parkers",
        zh: "[96096]Shoe shiners, porters, valet car parkers / 擦鞋工、搬运工、代客泊车员",
        en: "[96096]Shoe shiners, porters, valet car parkers",
      },
      {
        value: "[96097]Concession operation of coin-operated personal service machines",
        zh: "[96097]Concession operation of coin-operated personal service machines / 硬币操作个人服务机器的特许经营",
        en: "[96097]Concession operation of coin-operated personal service machines",
      },
      {
        value: "[96099]Other service activities n.e.c.",
        zh: "[96099]Other service activities n.e.c. / 其他未列明的服务活动",
        en: "[96099]Other service activities n.e.c.",
      },
      {
        value: "[97000]Activities of households as employers of domestic personnel",
        zh: "[97000]Activities of households as employers of domestic personnel / 家庭作为家政人员雇主的活动",
        en: "[97000]Activities of households as employers of domestic personnel",
      },
      {
        value: "[98100]Undifferentiated goods-producing activities of private households for own use",
        zh: "[98100]Undifferentiated goods-producing activities of private households for own use / 私人家庭为自用的未分化的商品生产活动",
        en: "[98100]Undifferentiated goods-producing activities of private households for own use",
      },
      {
        value: "[98200]Undifferentiated service-producing activities of private households for own use",
        zh: "[98200]Undifferentiated service-producing activities of private households for own use / 私人家庭为自身使用的服务生产活动",
        en: "[98200]Undifferentiated service-producing activities of private households for own use",
      },
      {
        value: "[99000]Activities of extraterritorial organization and bodies",
        zh: "[99000]Activities of extraterritorial organization and bodies / 境外组织和机构的活动",
        en: "[99000]Activities of extraterritorial organization and bodies",
      },
    ],
  ],
};
